import { defineComponent as j, createElementBlock as C, openBlock as f, renderSlot as ue, ref as E, watch as ce, onMounted as he, computed as x, unref as D, normalizeClass as Y, createBlock as F, resolveDynamicComponent as vn, withCtx as H, createElementVNode as O, createVNode as V, createCommentVNode as A, onBeforeUnmount as je, createTextVNode as G, toDisplayString as q, mergeProps as ke, Fragment as le, withModifiers as gt, normalizeStyle as Te, renderList as ve, Transition as rt, useAttrs as ea, nextTick as Ze, getCurrentScope as dl, onScopeDispose as fl, isRef as Fn, getCurrentInstance as pn, toValue as be, shallowRef as Rt, reactive as yt, withDirectives as we, vShow as $e, onUnmounted as qa, Teleport as Ps, watchEffect as We, inject as J, provide as ge, normalizeProps as ml, guardReactiveProps as vl, resolveComponent as Cs, h as Ta, markRaw as Wa, toRef as Es, triggerRef as Tn, isReactive as Pr, mergeDefaults as As, useSlots as pl, toRefs as hl } from "vue";
const yl = { class: "ds-accordion" }, Eb = /* @__PURE__ */ j({
  __name: "ds-accordion",
  setup(e) {
    return (t, n) => (f(), C("div", yl, [
      ue(t.$slots, "default")
    ]));
  }
}), tn = /* @__PURE__ */ new Map();
function Ms(e, t, n, a, r, s = "7.0.0") {
  const i = E(""), l = `${e}-version`, o = async (m) => {
    if (tn.has(m))
      return tn.get(m);
    const p = fetch(m).then(async (y) => {
      if (y.ok) {
        const b = await y.text();
        return tn.delete(m), b;
      } else
        throw new Error("Failed to load icon");
    }).catch(() => {
      throw tn.delete(m), new Error("Failed to load icon");
    });
    return tn.set(m, p), p;
  }, u = async () => {
    const m = `${v()}/${r.value}.svg`, y = m.split("/").slice(-2).join("/"), b = `${e}|${s}|${y}`, _ = localStorage.getItem(b), P = _?.startsWith("<svg");
    if (_ && P)
      i.value = _;
    else {
      localStorage.removeItem(b);
      let I;
      try {
        I = await o(m), I && (i.value = I, localStorage.setItem(b, I));
      } catch (k) {
        console.error(k);
      }
    }
  }, c = () => window.dsConfig ? e === "ds-brand-icon" ? window.dsConfig.brandIconBasePath : window.dsConfig.iconBasePath : null, v = () => {
    const m = c();
    let p = n;
    return m && n === t && (p = m), p;
  }, h = () => {
    const m = s;
    localStorage.getItem(l) !== m && (Object.keys(localStorage).forEach((y) => {
      const b = y.startsWith("icon-"), _ = y.startsWith("brand-icon-"), P = y.startsWith(`${e}|`) && !y.includes(`|${m}|`);
      (b || P || _) && localStorage.removeItem(y);
    }), localStorage.setItem(l, m));
  };
  return ce(
    () => r.value,
    async () => {
      await u();
    }
  ), he(async () => {
    h(), await u(), a("iconLoaded");
  }), { loadIcon: u, svgContents: i };
}
const gl = ["aria-hidden", "aria-label", "role", "data-icon-name", "innerHTML"], bl = "ds-icon", kl = "/dist/shared/images/design-system-icons", ie = /* @__PURE__ */ j({
  __name: "ds-icon",
  props: {
    /** Location of the icon files (no trailing slash) */
    basePath: {
      default: "/dist/shared/images/design-system-icons",
      type: String
    },
    /** Accessibility label: set if you want a screenreader to know what this icon represents */
    label: {
      default: null,
      type: String
    },
    /** Icon name: these correspond to the icon file names, e.g. {name}.svg  */
    iconName: {
      required: !0,
      type: String
    },
    /** Size option for the icon */
    size: {
      default: "md",
      type: String
    }
  },
  emits: ["iconLoaded"],
  setup(e, { expose: t, emit: n }) {
    const a = e, r = x(() => a.iconName), s = n, { loadIcon: i, svgContents: l } = Ms(
      bl,
      kl,
      a.basePath,
      s,
      r
    );
    return t({ loadIcon: i }), (o, u) => (f(), C("span", {
      "aria-hidden": e.label ? void 0 : !0,
      "aria-label": e.label ? e.label : void 0,
      role: e.label ? "img" : void 0,
      class: Y(["ds-icon", `ds-icon--${e.size}`]),
      "data-icon-name": r.value,
      "data-testid": "ds-banner-icon",
      innerHTML: D(l)
    }, null, 10, gl));
  }
}), Q = /* @__PURE__ */ j({
  __name: "ds-text",
  props: {
    htmlElement: { default: "p" },
    textStyle: { default: "default" },
    textType: { default: "body-md" }
  },
  setup(e) {
    const t = e, n = x(
      () => `ds-text-${t.textType.toLowerCase().replace("_", "-")}`
    ), a = x(
      () => ` ds-text--${t.textStyle.toLowerCase()}`
    ), r = x(
      () => `${n.value}${a.value}`
    );
    return (s, i) => (f(), F(vn(e.htmlElement), {
      class: Y(r.value)
    }, {
      default: H(() => [
        ue(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), _l = { class: "ds-accordion-item__summary" }, wl = ["innerHTML"], Ab = /* @__PURE__ */ j({
  __name: "ds-accordion-item",
  props: {
    iconName: {},
    title: {}
  },
  setup(e) {
    const t = e, n = x(() => t.iconName ? "ds-accordion-item--has-icon" : null);
    return (a, r) => (f(), C("details", {
      class: Y(["ds-accordion-item", n.value])
    }, [
      O("summary", _l, [
        e.iconName ? (f(), F(ie, {
          key: 0,
          class: "ds-accordion-item__icon",
          "icon-name": e.iconName
        }, null, 8, ["icon-name"])) : A("", !0),
        V(Q, {
          "html-element": "span",
          "text-type": "heading-lg",
          "text-style": "medium",
          class: "ds-accordion-item__title"
        }, {
          default: H(() => [
            O("span", {
              class: "ds-accordion-item__title-text",
              innerHTML: e.title
            }, null, 8, wl)
          ]),
          _: 1
        }),
        V(ie, {
          class: "ds-accordion-item__expand-icon",
          "icon-name": "chevron-down",
          size: "lg"
        })
      ]),
      V(Q, {
        class: "ds-accordion-item__content",
        "html-element": "div",
        "text-type": "body-md"
      }, {
        default: H(() => [
          ue(a.$slots, "default")
        ]),
        _: 3
      })
    ], 2));
  }
}), Be = (e = 768) => {
  const t = E(!1);
  let n = null;
  const a = (r) => {
    t.value = !r.matches;
  };
  return he(() => {
    n = window.matchMedia(`(min-width: ${e}px)`), n.addEventListener("change", a), t.value = !n.matches;
  }), je(() => {
    n && n.removeEventListener("change", a);
  }), { isMobile: t };
}, $l = ["role"], xl = { class: "ds-alert__content" }, Il = ["innerHTML"], Sl = ["aria-label"], Tl = /* @__PURE__ */ j({
  __name: "ds-alert",
  props: {
    appearance: { default: "neutral" },
    title: {},
    text: {},
    showIcon: { type: Boolean, default: !0 },
    dismissible: { type: Boolean, default: !1 },
    dismissLabel: { default: "Close" }
  },
  setup(e) {
    const t = e, { isMobile: n } = Be(), a = x(() => n.value ? "md" : "lg"), r = x(
      () => `ds-alert--${t.appearance} ${t.showIcon ? "ds-alert--icon" : ""} ${t.dismissible ? "ds-alert--dismissable" : ""}`
    ), s = x(() => t.appearance === "attention" ? "attention-triangle" : t.appearance === "danger" ? "danger-circle" : "information-circle"), i = x(() => t.appearance === "attention" || t.appearance === "danger" ? "alert" : "status"), l = E(!1), o = () => {
      l.value = !0;
    };
    return (u, c) => l.value ? A("", !0) : (f(), C("div", {
      key: 0,
      role: i.value,
      class: Y(["ds-alert", r.value])
    }, [
      e.showIcon ? (f(), F(ie, {
        key: 0,
        size: a.value,
        "icon-name": s.value,
        class: "ds-alert__icon"
      }, null, 8, ["size", "icon-name"])) : A("", !0),
      O("div", xl, [
        e.title ? (f(), F(Q, {
          key: 0,
          "html-element": "h3",
          "text-type": "body-md",
          "text-style": "bold",
          class: "ds-alert__title"
        }, {
          default: H(() => [
            G(q(e.title), 1)
          ]),
          _: 1
        })) : A("", !0),
        V(Q, {
          "html-element": "div",
          "text-type": "body-md",
          "text-style": "regular",
          class: "ds-alert__text"
        }, {
          default: H(() => [
            O("div", { innerHTML: e.text }, null, 8, Il)
          ]),
          _: 1
        })
      ]),
      e.dismissible ? (f(), C("button", {
        key: 1,
        "aria-label": e.dismissLabel,
        class: "ds-alert__dismiss",
        onClick: o
      }, [
        V(ie, {
          "icon-name": "button-close",
          size: "sm",
          class: "ds-alert__dismiss-icon"
        })
      ], 8, Sl)) : A("", !0)
    ], 10, $l));
  }
}), Pl = { class: "ds-article-block__content-layout" }, Cl = { class: "ds-article-block__content" }, Mb = /* @__PURE__ */ j({
  __name: "ds-article-block",
  props: {
    layout: { default: "text" },
    paddingTop: { default: "default" },
    paddingBottom: { default: "default" }
  },
  setup(e) {
    const t = e, n = x(() => {
      const a = {
        [`ds-article-block--layout-${t.layout}`]: t.layout !== "text",
        [`ds-article-block--pt-${t.paddingTop}`]: t.paddingTop !== "default",
        [`ds-article-block--pb-${t.paddingBottom}`]: t.paddingBottom !== "default"
      };
      return Object.keys(a).filter((r) => a[r]);
    });
    return (a, r) => (f(), C("div", {
      class: Y(["ds-article-block", n.value])
    }, [
      O("div", Pl, [
        O("div", Cl, [
          ue(a.$slots, "default")
        ])
      ])
    ], 2));
  }
}), El = /* @__PURE__ */ j({
  __name: "ds-badge",
  props: {
    text: {},
    variant: { default: "neutral" }
  },
  setup(e) {
    const n = `ds-badge--${e.variant}`;
    return (a, r) => (f(), C("span", {
      class: Y(["ds-badge", n])
    }, q(e.text), 1));
  }
}), Cr = E(0);
function ht(e) {
  return Cr.value++, `${e}-${Cr.value}`;
}
const Al = ["aria-labelledby"], Ml = { class: "ds-banner__inner" }, Ll = { class: "ds-banner__content" }, Ol = ["id", "innerHTML"], Lb = /* @__PURE__ */ j({
  __name: "ds-banner-sm",
  props: {
    iconName: { default: "information-circle" },
    text: {},
    showIcon: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, { isMobile: n } = Be(), a = x(() => n.value ? "md" : "lg"), r = `${t.showIcon ? "ds-banner--icon" : ""}`, s = ht("banner-content");
    return (i, l) => (f(), C("section", ke({
      "aria-labelledby": D(s),
      class: ["ds-banner", r]
    }, i.$attrs), [
      O("div", Ml, [
        e.showIcon ? (f(), F(ie, {
          key: 0,
          size: a.value,
          "icon-name": e.iconName,
          class: "ds-banner__icon"
        }, null, 8, ["size", "icon-name"])) : A("", !0),
        O("div", Ll, [
          V(Q, {
            "html-element": "div",
            "text-type": "body-md",
            "text-style": "regular",
            class: "ds-banner__text"
          }, {
            default: H(() => [
              O("div", {
                id: D(s),
                innerHTML: e.text
              }, null, 8, Ol)
            ]),
            _: 1
          })
        ])
      ])
    ], 16, Al));
  }
}), Nl = { class: "ds-spinner-animation" }, Ls = /* @__PURE__ */ j({
  __name: "ds-spinner-animation",
  setup(e) {
    return (t, n) => (f(), C("div", Nl, [...n[0] || (n[0] = [
      O("svg", {
        width: "56",
        height: "56",
        viewBox: "0 0 56 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        O("rect", {
          class: "ds-spinner-animation__track",
          x: "3",
          y: "3",
          width: "50",
          height: "50",
          rx: "25",
          "stroke-width": "6"
        }),
        O("path", {
          class: "ds-spinner-animation__snake",
          d: "M4.50674 36.5508C2.95033 37.1173 1.21245 36.3169 0.815599 34.7089C-0.175426 30.6933 -0.26744 26.4951 0.562107 22.4177C1.59161 17.3575 4.00037 12.6806 7.52209 8.90405C11.0438 5.12747 15.5413 2.39833 20.5173 1.01835C24.5269 -0.0935997 28.7213 -0.294665 32.7962 0.413827C34.428 0.697543 35.3477 2.37535 34.8912 3.96749V3.96749C34.4347 5.55962 32.7738 6.45833 31.1344 6.22238C28.1328 5.79039 25.0632 5.98204 22.1202 6.79819C18.2101 7.88256 14.6761 10.0271 11.9087 12.9947C9.14142 15.9623 7.24865 19.6373 6.43968 23.6135C5.83081 26.6062 5.85375 29.6818 6.49408 32.6459C6.84381 34.2648 6.06315 35.9844 4.50674 36.5508V36.5508Z"
        })
      ], -1)
    ])]));
  }
}), Bl = [
  "button-add",
  "button-chevron-down",
  "button-chevron-left",
  "button-chevron-right",
  "button-chevron-up",
  "button-close",
  "button-delete",
  "button-document",
  "button-download",
  "button-external-link",
  "button-filter",
  "button-information",
  "button-information-circle",
  "button-menu",
  "button-more",
  "button-navigate-back",
  "button-navigate-down",
  "button-navigate-forward",
  "button-navigate-up",
  "button-pause",
  "button-play",
  "button-print",
  "button-question",
  "button-question-circle",
  "button-scan",
  "button-search",
  "button-share-ios",
  "button-shopping-basket",
  "button-zoom-in",
  "button-zoom-out"
], Ua = ({
  variant: e,
  size: t,
  selected: n = x(() => !1),
  padding: a = null,
  isValidLoadingState: r = x(() => !1)
}, s) => x(() => {
  let i = [];
  return i = nn(i, s, e.value), i = nn(i, s, t.value), i = nn(
    i,
    s,
    n.value ? "selected" : void 0
  ), i = nn(
    i,
    s,
    a,
    a !== "padding-normal"
  ), i = nn(
    i,
    s,
    "loading",
    r.value
  ), i;
}), nn = (e, t, n, a = !0) => (n && a && e.push(`${t}--${n}`), e), Pa = (e) => {
  if (!e.startsWith("button-")) {
    const t = `button-${e}`;
    if (Dl(t))
      return t;
  }
  return e;
}, Dl = (e, t = !1) => e ? Bl.includes(e) ? !0 : (t && console.warn(
  `Icon "${e}" is not part of the button icon subset. Ensure you're using a "button-" prefixed icon name or reach out to the DS team.`
), !1) : !0, Fl = ["aria-disabled", "disabled", "form", "name", "selected", "type", "value"], Rl = ["aria-disabled", "download", "href", "selected", "target"], Ce = /* @__PURE__ */ j({
  __name: "ds-button",
  props: {
    clickHandler: { type: Function, default: () => {
    } },
    disabled: { type: Boolean, default: !1 },
    download: { type: [Boolean, String, null], default: null },
    form: {},
    href: {},
    iconStart: {},
    iconEnd: {},
    labelLoading: { default: void 0 },
    name: {},
    padding: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    size: { default: "md" },
    state: { default: "default" },
    target: {},
    type: { default: "button" },
    value: {},
    variant: { default: "secondary-neutral" }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, a = t, r = x(() => n.size === "sm" ? "xs" : "sm"), s = x(() => n.selected), i = x(() => n.size), l = x(() => {
      if (n.iconStart)
        return Pa(n.iconStart);
    }), o = x(() => {
      if (n.iconEnd)
        return Pa(n.iconEnd);
    }), u = E(n.padding), c = x(() => n.variant);
    (n.variant === "link" || n.variant === "link-neutral" || n.variant === "link-inverted") && !n.padding && (u.value = "padding-none");
    const h = (y) => {
      n.state !== "loading" && (n.clickHandler(y), a("click", y));
    }, m = x(() => (n.variant === "primary" || n.variant === "primary-inverted" || n.variant === "functional") && n.state === "loading" && n.labelLoading !== void 0), p = Ua(
      {
        variant: c,
        size: i,
        padding: u.value,
        selected: s,
        isValidLoadingState: m
      },
      "ds-button"
    );
    return (y, b) => (f(), C(le, null, [
      e.href ? A("", !0) : (f(), C("button", ke({ key: 0 }, y.$attrs, {
        "aria-disabled": m.value || void 0,
        class: ["ds-button", D(p)],
        disabled: e.disabled || void 0,
        form: e.form,
        name: e.name,
        selected: e.selected || void 0,
        type: e.type,
        value: e.value,
        onClick: gt(h, ["stop"])
      }), [
        m.value ? A("", !0) : (f(), C(le, { key: 0 }, [
          l.value ? (f(), F(ie, {
            key: 0,
            class: "ds-button__icon-start",
            "icon-name": l.value,
            size: r.value
          }, null, 8, ["icon-name", "size"])) : A("", !0),
          V(Q, {
            "text-type": "label-md",
            "text-style": "medium",
            "html-element": "span"
          }, {
            default: H(() => [
              ue(y.$slots, "default")
            ]),
            _: 3
          }),
          o.value ? (f(), F(ie, {
            key: 1,
            class: "ds-button__icon-end",
            "icon-name": o.value,
            size: r.value
          }, null, 8, ["icon-name", "size"])) : A("", !0)
        ], 64)),
        m.value ? (f(), C(le, { key: 1 }, [
          V(Ls),
          V(Q, {
            "text-type": "label-md",
            "text-style": "medium",
            "html-element": "span"
          }, {
            default: H(() => [
              G(q(e.labelLoading), 1)
            ]),
            _: 1
          })
        ], 64)) : A("", !0)
      ], 16, Fl)),
      e.href ? (f(), C("a", ke({ key: 1 }, y.$attrs, {
        class: ["ds-button", D(p)],
        "aria-disabled": e.disabled || void 0,
        download: e.download === !0 ? "" : e.download,
        href: e.href,
        selected: e.selected || void 0,
        target: e.target,
        onClick: h
      }), [
        l.value ? (f(), F(ie, {
          key: 0,
          class: "ds-button__icon-start",
          "icon-name": l.value,
          size: r.value
        }, null, 8, ["icon-name", "size"])) : A("", !0),
        V(Q, {
          "text-type": "label-md",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: H(() => [
            ue(y.$slots, "default")
          ]),
          _: 3
        }),
        o.value ? (f(), F(ie, {
          key: 1,
          class: "ds-button__icon-end",
          "icon-name": o.value,
          size: r.value
        }, null, 8, ["icon-name", "size"])) : A("", !0)
      ], 16, Rl)) : A("", !0)
    ], 64));
  }
}), Hl = ["aria-label", "role", "data-icon-name"], Vl = ["innerHTML"], zl = "ds-brand-icon", jl = "/dist/shared/images/design-system-brand-icons", Os = /* @__PURE__ */ j({
  __name: "ds-brand-icon",
  props: {
    altText: {},
    basePath: { default: "/dist/shared/images/design-system-brand-icons" },
    iconName: {},
    mode: { default: "default" },
    size: { default: "md" },
    type: { default: "line" }
  },
  emits: ["iconLoaded"],
  setup(e, { expose: t, emit: n }) {
    const a = e, r = x(() => a.iconName), s = n, { loadIcon: i, svgContents: l } = Ms(
      zl,
      jl,
      a.basePath,
      s,
      r
    ), o = x(() => {
      const u = [];
      return u.push(`ds-brand-icon--${a.size}`), u.push(`ds-brand-icon--${a.type}`), a.mode !== "default" && u.push(`ds-brand-icon--mode-${a.mode}`), u;
    });
    return t({ loadIcon: i }), (u, c) => (f(), C("div", {
      "aria-label": e.altText ? e.altText : void 0,
      role: e.altText ? "img" : void 0,
      class: Y(["ds-brand-icon", o.value]),
      "data-icon-name": r.value
    }, [
      O("span", {
        class: "ds-brand-icon__svg",
        "aria-hidden": "true",
        innerHTML: D(l)
      }, null, 8, Vl)
    ], 10, Hl));
  }
}), ql = ["aria-labelledby"], Wl = {
  key: 1,
  class: "ds-banner-md__content"
}, Ul = { class: "ds-banner-md__icon-and-text" }, Ob = /* @__PURE__ */ j({
  __name: "ds-banner-md",
  props: {
    background: { default: "brand" },
    buttonClickHandler: {},
    buttonHref: {},
    buttonText: {},
    iconName: {},
    iconAltText: {},
    text: {},
    textHtmlElement: { default: "h3" },
    textWrapMode: { default: "balance" }
  },
  setup(e) {
    const t = e, n = E(!1);
    he(() => {
      n.value = !0;
    });
    const a = ht("banner-md"), r = x(() => t.background === "inverse" ? "inverse" : "default"), s = x(() => t.background === "inverse" ? "primary-inverted" : "primary"), i = x(() => {
      const l = [];
      return l.push(`ds-banner-md--bg-${t.background}`), l.push(`ds-banner-md--tw-${t.textWrapMode}`), l;
    });
    return (l, o) => (f(), C("section", ke({
      "aria-labelledby": D(a),
      class: ["ds-banner-md", i.value]
    }, l.$attrs), [
      n.value ? A("", !0) : ue(l.$slots, "default", { key: 0 }),
      n.value ? (f(), C("div", Wl, [
        O("div", Ul, [
          V(Os, {
            "alt-text": e.iconAltText,
            "icon-name": e.iconName,
            mode: r.value,
            size: "sm",
            type: "line"
          }, null, 8, ["alt-text", "icon-name", "mode"]),
          V(Q, {
            id: D(a),
            class: "ds-banner-md__text",
            "text-type": "heading-lg",
            "text-style": "medium",
            "html-element": e.textHtmlElement
          }, {
            default: H(() => [
              G(q(e.text), 1)
            ]),
            _: 1
          }, 8, ["id", "html-element"])
        ]),
        e.buttonText ? (f(), F(Ce, {
          key: 0,
          class: "ds-banner-md__cta",
          href: e.buttonHref,
          "click-handler": e.buttonClickHandler,
          variant: s.value
        }, {
          default: H(() => [
            G(q(e.buttonText), 1)
          ]),
          _: 1
        }, 8, ["href", "click-handler", "variant"])) : A("", !0)
      ])) : A("", !0)
    ], 16, ql));
  }
}), Kl = ["aria-labelledby"], Gl = {
  key: 1,
  class: "ds-banner-lg__content"
}, Yl = { class: "ds-banner-lg__media" }, Ql = ["sizes", "src", "srcset", "alt"], Nb = /* @__PURE__ */ j({
  __name: "ds-banner-lg",
  props: {
    background: { default: "brand-subtle" },
    buttonClickHandler: {},
    buttonHref: {},
    buttonText: {},
    mediaAltText: { default: "" },
    mediaFocalPoint: { default: "center" },
    mediaFocalPointMobile: {},
    mediaSrc: {},
    mediaSrcSet: {},
    mediaSizes: {},
    text: {},
    textHtmlElement: { default: "h3" },
    textWrapMode: { default: "balance" }
  },
  setup(e) {
    const t = e, n = E(!1);
    he(() => {
      n.value = !0;
    });
    const a = ht("banner-lg"), { isMobile: r } = Be(), s = x(() => r.value ? "heading-md" : "heading-3xl"), i = x(() => t.mediaFocalPointMobile && r.value ? t.mediaFocalPointMobile : t.mediaFocalPoint), l = x(() => {
      const u = [];
      return t.mediaFocalPoint !== "center" && u.push(`object-position: ${i.value};`), u;
    }), o = x(() => {
      const u = [];
      return u.push(`ds-banner-lg--bg-${t.background}`), u.push(`ds-banner-lg--tw-${t.textWrapMode}`), u;
    });
    return (u, c) => (f(), C("section", ke({
      "aria-labelledby": D(a),
      class: ["ds-banner-lg", o.value]
    }, u.$attrs), [
      n.value ? A("", !0) : ue(u.$slots, "default", { key: 0 }),
      n.value ? (f(), C("div", Gl, [
        V(Q, {
          id: D(a),
          class: "ds-banner-lg__text",
          "text-type": s.value,
          "text-style": "medium",
          "html-element": e.textHtmlElement
        }, {
          default: H(() => [
            G(q(e.text), 1)
          ]),
          _: 1
        }, 8, ["id", "text-type", "html-element"]),
        V(Ce, {
          class: "ds-banner-lg__cta",
          href: e.buttonHref,
          "click-handler": e.buttonClickHandler,
          variant: "primary"
        }, {
          default: H(() => [
            G(q(e.buttonText), 1)
          ]),
          _: 1
        }, 8, ["href", "click-handler"])
      ])) : A("", !0),
      O("figure", Yl, [
        O("img", {
          class: "ds-banner-lg__image",
          style: Te(l.value),
          sizes: e.mediaSizes,
          src: e.mediaSrc,
          srcset: e.mediaSrcSet,
          alt: e.mediaAltText
        }, null, 12, Ql)
      ])
    ], 16, Kl));
  }
}), Xl = ["aria-labelledby"], Zl = {
  key: 1,
  class: "ds-banner-xl__content"
}, Jl = { class: "ds-banner-xl__text" }, eo = ["innerHTML"], to = { class: "ds-banner-xl__media" }, no = ["sizes", "src", "srcset", "alt"], Bb = /* @__PURE__ */ j({
  __name: "ds-banner-xl",
  props: {
    background: { default: "brand-subtle" },
    buttonClickHandler: {},
    buttonHref: {},
    buttonText: {},
    description: {},
    mediaAltText: { default: "" },
    mediaPlacement: { default: "end" },
    mediaPlacementMobile: { default: "useMediaPlacementValue" },
    mediaFocalPoint: { default: "center" },
    mediaFocalPointMobile: {},
    mediaRenderMode: { default: "cover" },
    mediaRenderModeMobile: { default: "useMediaRenderModeValue" },
    mediaSrc: {},
    mediaSrcSet: {},
    mediaSizes: {},
    textWrapMode: { default: "balance" },
    titleSmall: {},
    titleSmallHtmlElement: { default: "h3" },
    titleLarge: {},
    titleLargeHtmlElement: { default: "h2" }
  },
  setup(e) {
    const t = e, n = E(!1);
    he(() => {
      n.value = !0;
    });
    const a = ht("banner-xl"), { isMobile: r } = Be(), s = x(() => t.description ? "long" : "short"), i = x(() => s.value === "long" ? "heading-3xl" : "heading-4xl"), l = x(() => t.mediaFocalPointMobile && r.value ? t.mediaFocalPointMobile : t.mediaFocalPoint), o = x(() => {
      const c = [];
      return t.mediaFocalPoint !== "center" && c.push(`--object-position: ${l.value};`), c;
    }), u = x(() => {
      const c = [];
      return c.push(`ds-banner-xl--${s.value}`), c.push(`ds-banner-xl--bg-${t.background}`), c.push(`ds-banner-xl--media-${t.mediaPlacement}`), c.push(`ds-banner-xl--media-rm-${t.mediaRenderMode}`), c.push(`ds-banner-xl--tw-${t.textWrapMode}`), t.mediaPlacementMobile !== "useMediaPlacementValue" && t.mediaPlacementMobile !== t.mediaPlacement && c.push(
        `ds-banner-xl--media-mobile-${t.mediaPlacementMobile}`
      ), t.mediaRenderModeMobile !== "useMediaRenderModeValue" && t.mediaRenderModeMobile !== t.mediaRenderMode && c.push(
        `ds-banner-xl--media-rm-mobile-${t.mediaRenderModeMobile}`
      ), c;
    });
    return (c, v) => (f(), C("section", ke({ "aria-labelledby": D(a) }, c.$attrs, {
      class: ["ds-banner-xl", u.value]
    }), [
      n.value ? A("", !0) : ue(c.$slots, "default", { key: 0 }),
      n.value ? (f(), C("div", Zl, [
        O("div", Jl, [
          s.value === "short" ? (f(), F(Q, {
            key: 0,
            class: "ds-banner-xl__title-small",
            "text-type": "heading-lg",
            "text-style": "medium",
            "html-element": e.titleSmallHtmlElement
          }, {
            default: H(() => [
              G(q(e.titleSmall), 1)
            ]),
            _: 1
          }, 8, ["html-element"])) : A("", !0),
          V(Q, {
            id: D(a),
            class: "ds-banner-xl__title-large",
            "text-type": i.value,
            "text-style": "medium",
            "html-element": e.titleLargeHtmlElement
          }, {
            default: H(() => [
              G(q(e.titleLarge), 1)
            ]),
            _: 1
          }, 8, ["id", "text-type", "html-element"]),
          s.value === "long" ? (f(), F(Q, {
            key: 1,
            class: "ds-banner-xl__description",
            "text-type": "heading-lg",
            "text-style": "medium",
            "html-element": "div"
          }, {
            default: H(() => [
              O("div", {
                class: "ds-banner-xl__description-inner",
                innerHTML: e.description
              }, null, 8, eo)
            ]),
            _: 1
          })) : A("", !0)
        ]),
        V(Ce, {
          href: e.buttonHref,
          "click-handler": e.buttonClickHandler,
          variant: "primary"
        }, {
          default: H(() => [
            G(q(e.buttonText), 1)
          ]),
          _: 1
        }, 8, ["href", "click-handler"])
      ])) : A("", !0),
      O("figure", to, [
        O("img", {
          class: "ds-banner-xl__image",
          style: Te(o.value),
          sizes: e.mediaSizes,
          src: e.mediaSrc,
          srcset: e.mediaSrcSet,
          alt: e.mediaAltText
        }, null, 12, no)
      ])
    ], 16, Xl));
  }
}), ao = { class: "ds-block__content" }, ta = /* @__PURE__ */ j({
  __name: "ds-block",
  props: {
    background: { default: "default" },
    divider: { type: Boolean, default: !1 },
    gradientSize: { default: "md" },
    grid: { type: Boolean, default: !1 },
    paddingTop: { default: "default" },
    paddingBottom: { default: "default" }
  },
  setup(e) {
    const t = e, n = x(() => {
      const a = {
        [`ds-block--bg-${t.background}`]: t.background !== "default",
        [`ds-block--gradient-size-${t.gradientSize}`]: t.gradientSize !== "md",
        [`ds-block--pt-${t.paddingTop}`]: t.paddingTop !== "default",
        [`ds-block--pb-${t.paddingBottom}`]: t.paddingBottom !== "default",
        "ds-block--divider": t.divider,
        "ds-block--grid": t.grid
      };
      return Object.keys(a).filter((r) => a[r]);
    });
    return (a, r) => (f(), C("section", {
      class: Y(["ds-block", n.value])
    }, [
      O("div", ao, [
        ue(a.$slots, "default")
      ])
    ], 2));
  }
}), ro = ["href", "aria-current", "title"], ya = /* @__PURE__ */ j({
  __name: "ds-breadcrumb-item",
  props: {
    iconStartName: {},
    item: {}
  },
  setup(e) {
    const t = e, a = t.item.name.length > 25 ? t.item.name : void 0;
    return (r, s) => (f(), C("a", {
      class: "ds-breadcrumb__link",
      href: e.item.url,
      "aria-current": e.item.isCurrentPage ? "page" : void 0,
      title: D(a),
      onClick: s[0] || (s[0] = (i) => {
        e.item.isCurrentPage && i.preventDefault();
      })
    }, [
      e.iconStartName ? (f(), F(ie, {
        key: 0,
        class: "ds-breadcrumb__icon",
        "icon-name": e.iconStartName,
        size: "xs"
      }, null, 8, ["icon-name"])) : A("", !0),
      V(Q, {
        "html-element": "span",
        "text-type": "label-sm"
      }, {
        default: H(() => [
          G(q(e.item.name), 1)
        ]),
        _: 1
      })
    ], 8, ro));
  }
});
function Ve(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Pt(e) {
  var t = Ve(e).Element;
  return e instanceof t || e instanceof Element;
}
function Ke(e) {
  var t = Ve(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Ka(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Ve(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
var St = Math.max, Rn = Math.min, Wt = Math.round;
function Ca() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Ns() {
  return !/^((?!chrome|android).)*safari/i.test(Ca());
}
function Ut(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var a = e.getBoundingClientRect(), r = 1, s = 1;
  t && Ke(e) && (r = e.offsetWidth > 0 && Wt(a.width) / e.offsetWidth || 1, s = e.offsetHeight > 0 && Wt(a.height) / e.offsetHeight || 1);
  var i = Pt(e) ? Ve(e) : window, l = i.visualViewport, o = !Ns() && n, u = (a.left + (o && l ? l.offsetLeft : 0)) / r, c = (a.top + (o && l ? l.offsetTop : 0)) / s, v = a.width / r, h = a.height / s;
  return {
    width: v,
    height: h,
    top: c,
    right: u + v,
    bottom: c + h,
    left: u,
    x: u,
    y: c
  };
}
function Ga(e) {
  var t = Ve(e), n = t.pageXOffset, a = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: a
  };
}
function so(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function io(e) {
  return e === Ve(e) || !Ke(e) ? Ga(e) : so(e);
}
function st(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function kt(e) {
  return ((Pt(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Ya(e) {
  return Ut(kt(e)).left + Ga(e).scrollLeft;
}
function ft(e) {
  return Ve(e).getComputedStyle(e);
}
function Qa(e) {
  var t = ft(e), n = t.overflow, a = t.overflowX, r = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + r + a);
}
function lo(e) {
  var t = e.getBoundingClientRect(), n = Wt(t.width) / e.offsetWidth || 1, a = Wt(t.height) / e.offsetHeight || 1;
  return n !== 1 || a !== 1;
}
function oo(e, t, n) {
  n === void 0 && (n = !1);
  var a = Ke(t), r = Ke(t) && lo(t), s = kt(t), i = Ut(e, r, n), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, o = {
    x: 0,
    y: 0
  };
  return (a || !a && !n) && ((st(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Qa(s)) && (l = io(t)), Ke(t) ? (o = Ut(t, !0), o.x += t.clientLeft, o.y += t.clientTop) : s && (o.x = Ya(s))), {
    x: i.left + l.scrollLeft - o.x,
    y: i.top + l.scrollTop - o.y,
    width: i.width,
    height: i.height
  };
}
function Xa(e) {
  var t = Ut(e), n = e.offsetWidth, a = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - a) <= 1 && (a = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: a
  };
}
function na(e) {
  return st(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Ka(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    kt(e)
  );
}
function Bs(e) {
  return ["html", "body", "#document"].indexOf(st(e)) >= 0 ? e.ownerDocument.body : Ke(e) && Qa(e) ? e : Bs(na(e));
}
function on(e, t) {
  var n;
  t === void 0 && (t = []);
  var a = Bs(e), r = a === ((n = e.ownerDocument) == null ? void 0 : n.body), s = Ve(a), i = r ? [s].concat(s.visualViewport || [], Qa(a) ? a : []) : a, l = t.concat(i);
  return r ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(on(na(i)))
  );
}
function uo(e) {
  return ["table", "td", "th"].indexOf(st(e)) >= 0;
}
function Er(e) {
  return !Ke(e) || // https://github.com/popperjs/popper-core/issues/837
  ft(e).position === "fixed" ? null : e.offsetParent;
}
function co(e) {
  var t = /firefox/i.test(Ca()), n = /Trident/i.test(Ca());
  if (n && Ke(e)) {
    var a = ft(e);
    if (a.position === "fixed")
      return null;
  }
  var r = na(e);
  for (Ka(r) && (r = r.host); Ke(r) && ["html", "body"].indexOf(st(r)) < 0; ) {
    var s = ft(r);
    if (s.transform !== "none" || s.perspective !== "none" || s.contain === "paint" || ["transform", "perspective"].indexOf(s.willChange) !== -1 || t && s.willChange === "filter" || t && s.filter && s.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function kn(e) {
  for (var t = Ve(e), n = Er(e); n && uo(n) && ft(n).position === "static"; )
    n = Er(n);
  return n && (st(n) === "html" || st(n) === "body" && ft(n).position === "static") ? t : n || co(e) || t;
}
var Fe = "top", Je = "bottom", et = "right", Re = "left", Za = "auto", _n = [Fe, Je, et, Re], Kt = "start", hn = "end", fo = "clippingParents", Ds = "viewport", an = "popper", mo = "reference", Ar = /* @__PURE__ */ _n.reduce(function(e, t) {
  return e.concat([t + "-" + Kt, t + "-" + hn]);
}, []), Fs = /* @__PURE__ */ [].concat(_n, [Za]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Kt, t + "-" + hn]);
}, []), vo = "beforeRead", po = "read", ho = "afterRead", yo = "beforeMain", go = "main", bo = "afterMain", ko = "beforeWrite", _o = "write", wo = "afterWrite", $o = [vo, po, ho, yo, go, bo, ko, _o, wo];
function xo(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), a = [];
  e.forEach(function(s) {
    t.set(s.name, s);
  });
  function r(s) {
    n.add(s.name);
    var i = [].concat(s.requires || [], s.requiresIfExists || []);
    i.forEach(function(l) {
      if (!n.has(l)) {
        var o = t.get(l);
        o && r(o);
      }
    }), a.push(s);
  }
  return e.forEach(function(s) {
    n.has(s.name) || r(s);
  }), a;
}
function Io(e) {
  var t = xo(e);
  return $o.reduce(function(n, a) {
    return n.concat(t.filter(function(r) {
      return r.phase === a;
    }));
  }, []);
}
function So(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function To(e) {
  var t = e.reduce(function(n, a) {
    var r = n[a.name];
    return n[a.name] = r ? Object.assign({}, r, a, {
      options: Object.assign({}, r.options, a.options),
      data: Object.assign({}, r.data, a.data)
    }) : a, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
function Po(e, t) {
  var n = Ve(e), a = kt(e), r = n.visualViewport, s = a.clientWidth, i = a.clientHeight, l = 0, o = 0;
  if (r) {
    s = r.width, i = r.height;
    var u = Ns();
    (u || !u && t === "fixed") && (l = r.offsetLeft, o = r.offsetTop);
  }
  return {
    width: s,
    height: i,
    x: l + Ya(e),
    y: o
  };
}
function Co(e) {
  var t, n = kt(e), a = Ga(e), r = (t = e.ownerDocument) == null ? void 0 : t.body, s = St(n.scrollWidth, n.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), i = St(n.scrollHeight, n.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), l = -a.scrollLeft + Ya(e), o = -a.scrollTop;
  return ft(r || n).direction === "rtl" && (l += St(n.clientWidth, r ? r.clientWidth : 0) - s), {
    width: s,
    height: i,
    x: l,
    y: o
  };
}
function Rs(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Ka(n)) {
    var a = t;
    do {
      if (a && e.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function Ea(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Eo(e, t) {
  var n = Ut(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Mr(e, t, n) {
  return t === Ds ? Ea(Po(e, n)) : Pt(t) ? Eo(t, n) : Ea(Co(kt(e)));
}
function Ao(e) {
  var t = on(na(e)), n = ["absolute", "fixed"].indexOf(ft(e).position) >= 0, a = n && Ke(e) ? kn(e) : e;
  return Pt(a) ? t.filter(function(r) {
    return Pt(r) && Rs(r, a) && st(r) !== "body";
  }) : [];
}
function Mo(e, t, n, a) {
  var r = t === "clippingParents" ? Ao(e) : [].concat(t), s = [].concat(r, [n]), i = s[0], l = s.reduce(function(o, u) {
    var c = Mr(e, u, a);
    return o.top = St(c.top, o.top), o.right = Rn(c.right, o.right), o.bottom = Rn(c.bottom, o.bottom), o.left = St(c.left, o.left), o;
  }, Mr(e, i, a));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function at(e) {
  return e.split("-")[0];
}
function Gt(e) {
  return e.split("-")[1];
}
function Ja(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Hs(e) {
  var t = e.reference, n = e.element, a = e.placement, r = a ? at(a) : null, s = a ? Gt(a) : null, i = t.x + t.width / 2 - n.width / 2, l = t.y + t.height / 2 - n.height / 2, o;
  switch (r) {
    case Fe:
      o = {
        x: i,
        y: t.y - n.height
      };
      break;
    case Je:
      o = {
        x: i,
        y: t.y + t.height
      };
      break;
    case et:
      o = {
        x: t.x + t.width,
        y: l
      };
      break;
    case Re:
      o = {
        x: t.x - n.width,
        y: l
      };
      break;
    default:
      o = {
        x: t.x,
        y: t.y
      };
  }
  var u = r ? Ja(r) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (s) {
      case Kt:
        o[u] = o[u] - (t[c] / 2 - n[c] / 2);
        break;
      case hn:
        o[u] = o[u] + (t[c] / 2 - n[c] / 2);
        break;
    }
  }
  return o;
}
function Vs() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function zs(e) {
  return Object.assign({}, Vs(), e);
}
function js(e, t) {
  return t.reduce(function(n, a) {
    return n[a] = e, n;
  }, {});
}
function er(e, t) {
  t === void 0 && (t = {});
  var n = t, a = n.placement, r = a === void 0 ? e.placement : a, s = n.strategy, i = s === void 0 ? e.strategy : s, l = n.boundary, o = l === void 0 ? fo : l, u = n.rootBoundary, c = u === void 0 ? Ds : u, v = n.elementContext, h = v === void 0 ? an : v, m = n.altBoundary, p = m === void 0 ? !1 : m, y = n.padding, b = y === void 0 ? 0 : y, _ = zs(typeof b != "number" ? b : js(b, _n)), P = h === an ? mo : an, I = e.rects.popper, k = e.elements[p ? P : h], T = Mo(Pt(k) ? k : k.contextElement || kt(e.elements.popper), o, c, i), g = Ut(e.elements.reference), $ = Hs({
    reference: g,
    element: I,
    placement: r
  }), S = Ea(Object.assign({}, I, $)), L = h === an ? S : g, B = {
    top: T.top - L.top + _.top,
    bottom: L.bottom - T.bottom + _.bottom,
    left: T.left - L.left + _.left,
    right: L.right - T.right + _.right
  }, N = e.modifiersData.offset;
  if (h === an && N) {
    var d = N[r];
    Object.keys(B).forEach(function(w) {
      var M = [et, Je].indexOf(w) >= 0 ? 1 : -1, z = [Fe, Je].indexOf(w) >= 0 ? "y" : "x";
      B[w] += d[z] * M;
    });
  }
  return B;
}
var Lr = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Or() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function Lo(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, a = n === void 0 ? [] : n, r = t.defaultOptions, s = r === void 0 ? Lr : r;
  return function(l, o, u) {
    u === void 0 && (u = s);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Lr, s),
      modifiersData: {},
      elements: {
        reference: l,
        popper: o
      },
      attributes: {},
      styles: {}
    }, v = [], h = !1, m = {
      state: c,
      setOptions: function(_) {
        var P = typeof _ == "function" ? _(c.options) : _;
        y(), c.options = Object.assign({}, s, c.options, P), c.scrollParents = {
          reference: Pt(l) ? on(l) : l.contextElement ? on(l.contextElement) : [],
          popper: on(o)
        };
        var I = Io(To([].concat(a, c.options.modifiers)));
        return c.orderedModifiers = I.filter(function(k) {
          return k.enabled;
        }), p(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var _ = c.elements, P = _.reference, I = _.popper;
          if (Or(P, I)) {
            c.rects = {
              reference: oo(P, kn(I), c.options.strategy === "fixed"),
              popper: Xa(I)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(B) {
              return c.modifiersData[B.name] = Object.assign({}, B.data);
            });
            for (var k = 0; k < c.orderedModifiers.length; k++) {
              if (c.reset === !0) {
                c.reset = !1, k = -1;
                continue;
              }
              var T = c.orderedModifiers[k], g = T.fn, $ = T.options, S = $ === void 0 ? {} : $, L = T.name;
              typeof g == "function" && (c = g({
                state: c,
                options: S,
                name: L,
                instance: m
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: So(function() {
        return new Promise(function(b) {
          m.forceUpdate(), b(c);
        });
      }),
      destroy: function() {
        y(), h = !0;
      }
    };
    if (!Or(l, o))
      return m;
    m.setOptions(u).then(function(b) {
      !h && u.onFirstUpdate && u.onFirstUpdate(b);
    });
    function p() {
      c.orderedModifiers.forEach(function(b) {
        var _ = b.name, P = b.options, I = P === void 0 ? {} : P, k = b.effect;
        if (typeof k == "function") {
          var T = k({
            state: c,
            name: _,
            instance: m,
            options: I
          }), g = function() {
          };
          v.push(T || g);
        }
      });
    }
    function y() {
      v.forEach(function(b) {
        return b();
      }), v = [];
    }
    return m;
  };
}
var Pn = {
  passive: !0
};
function Oo(e) {
  var t = e.state, n = e.instance, a = e.options, r = a.scroll, s = r === void 0 ? !0 : r, i = a.resize, l = i === void 0 ? !0 : i, o = Ve(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return s && u.forEach(function(c) {
    c.addEventListener("scroll", n.update, Pn);
  }), l && o.addEventListener("resize", n.update, Pn), function() {
    s && u.forEach(function(c) {
      c.removeEventListener("scroll", n.update, Pn);
    }), l && o.removeEventListener("resize", n.update, Pn);
  };
}
const No = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Oo,
  data: {}
};
function Bo(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Hs({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const Do = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Bo,
  data: {}
};
var Fo = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Ro(e, t) {
  var n = e.x, a = e.y, r = t.devicePixelRatio || 1;
  return {
    x: Wt(n * r) / r || 0,
    y: Wt(a * r) / r || 0
  };
}
function Nr(e) {
  var t, n = e.popper, a = e.popperRect, r = e.placement, s = e.variation, i = e.offsets, l = e.position, o = e.gpuAcceleration, u = e.adaptive, c = e.roundOffsets, v = e.isFixed, h = i.x, m = h === void 0 ? 0 : h, p = i.y, y = p === void 0 ? 0 : p, b = typeof c == "function" ? c({
    x: m,
    y
  }) : {
    x: m,
    y
  };
  m = b.x, y = b.y;
  var _ = i.hasOwnProperty("x"), P = i.hasOwnProperty("y"), I = Re, k = Fe, T = window;
  if (u) {
    var g = kn(n), $ = "clientHeight", S = "clientWidth";
    if (g === Ve(n) && (g = kt(n), ft(g).position !== "static" && l === "absolute" && ($ = "scrollHeight", S = "scrollWidth")), g = g, r === Fe || (r === Re || r === et) && s === hn) {
      k = Je;
      var L = v && g === T && T.visualViewport ? T.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        g[$]
      );
      y -= L - a.height, y *= o ? 1 : -1;
    }
    if (r === Re || (r === Fe || r === Je) && s === hn) {
      I = et;
      var B = v && g === T && T.visualViewport ? T.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        g[S]
      );
      m -= B - a.width, m *= o ? 1 : -1;
    }
  }
  var N = Object.assign({
    position: l
  }, u && Fo), d = c === !0 ? Ro({
    x: m,
    y
  }, Ve(n)) : {
    x: m,
    y
  };
  if (m = d.x, y = d.y, o) {
    var w;
    return Object.assign({}, N, (w = {}, w[k] = P ? "0" : "", w[I] = _ ? "0" : "", w.transform = (T.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + y + "px)" : "translate3d(" + m + "px, " + y + "px, 0)", w));
  }
  return Object.assign({}, N, (t = {}, t[k] = P ? y + "px" : "", t[I] = _ ? m + "px" : "", t.transform = "", t));
}
function Ho(e) {
  var t = e.state, n = e.options, a = n.gpuAcceleration, r = a === void 0 ? !0 : a, s = n.adaptive, i = s === void 0 ? !0 : s, l = n.roundOffsets, o = l === void 0 ? !0 : l, u = {
    placement: at(t.placement),
    variation: Gt(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: r,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Nr(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: i,
    roundOffsets: o
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Nr(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: o
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Vo = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Ho,
  data: {}
};
function zo(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var a = t.styles[n] || {}, r = t.attributes[n] || {}, s = t.elements[n];
    !Ke(s) || !st(s) || (Object.assign(s.style, a), Object.keys(r).forEach(function(i) {
      var l = r[i];
      l === !1 ? s.removeAttribute(i) : s.setAttribute(i, l === !0 ? "" : l);
    }));
  });
}
function jo(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(a) {
      var r = t.elements[a], s = t.attributes[a] || {}, i = Object.keys(t.styles.hasOwnProperty(a) ? t.styles[a] : n[a]), l = i.reduce(function(o, u) {
        return o[u] = "", o;
      }, {});
      !Ke(r) || !st(r) || (Object.assign(r.style, l), Object.keys(s).forEach(function(o) {
        r.removeAttribute(o);
      }));
    });
  };
}
const qo = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: zo,
  effect: jo,
  requires: ["computeStyles"]
};
var Wo = [No, Do, Vo, qo], Uo = /* @__PURE__ */ Lo({
  defaultModifiers: Wo
});
function Ko(e) {
  return e === "x" ? "y" : "x";
}
function un(e, t, n) {
  return St(e, Rn(t, n));
}
function Go(e, t, n) {
  var a = un(e, t, n);
  return a > n ? n : a;
}
function Yo(e) {
  var t = e.state, n = e.options, a = e.name, r = n.mainAxis, s = r === void 0 ? !0 : r, i = n.altAxis, l = i === void 0 ? !1 : i, o = n.boundary, u = n.rootBoundary, c = n.altBoundary, v = n.padding, h = n.tether, m = h === void 0 ? !0 : h, p = n.tetherOffset, y = p === void 0 ? 0 : p, b = er(t, {
    boundary: o,
    rootBoundary: u,
    padding: v,
    altBoundary: c
  }), _ = at(t.placement), P = Gt(t.placement), I = !P, k = Ja(_), T = Ko(k), g = t.modifiersData.popperOffsets, $ = t.rects.reference, S = t.rects.popper, L = typeof y == "function" ? y(Object.assign({}, t.rects, {
    placement: t.placement
  })) : y, B = typeof L == "number" ? {
    mainAxis: L,
    altAxis: L
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, L), N = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, d = {
    x: 0,
    y: 0
  };
  if (g) {
    if (s) {
      var w, M = k === "y" ? Fe : Re, z = k === "y" ? Je : et, R = k === "y" ? "height" : "width", W = g[k], re = W + b[M], K = W - b[z], ee = m ? -S[R] / 2 : 0, oe = P === Kt ? $[R] : S[R], se = P === Kt ? -S[R] : -$[R], pe = t.elements.arrow, Se = m && pe ? Xa(pe) : {
        width: 0,
        height: 0
      }, X = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Vs(), Z = X[M], fe = X[z], ye = un(0, $[R], Se[R]), tt = I ? $[R] / 2 - ee - ye - Z - B.mainAxis : oe - ye - Z - B.mainAxis, it = I ? -$[R] / 2 + ee + ye + fe + B.mainAxis : se + ye + fe + B.mainAxis, en = t.elements.arrow && kn(t.elements.arrow), ma = en ? k === "y" ? en.clientTop || 0 : en.clientLeft || 0 : 0, Sn = (w = N?.[k]) != null ? w : 0, va = W + tt - Sn - ma, pa = W + it - Sn, U = un(m ? Rn(re, va) : re, W, m ? St(K, pa) : K);
      g[k] = U, d[k] = U - W;
    }
    if (l) {
      var te, _e = k === "x" ? Fe : Re, De = k === "x" ? Je : et, Pe = g[T], nt = T === "y" ? "height" : "width", At = Pe + b[_e], $r = Pe - b[De], ha = [Fe, Re].indexOf(_) !== -1, xr = (te = N?.[T]) != null ? te : 0, Ir = ha ? At : Pe - $[nt] - S[nt] - xr + B.altAxis, Sr = ha ? Pe + $[nt] + S[nt] - xr - B.altAxis : $r, Tr = m && ha ? Go(Ir, Pe, Sr) : un(m ? Ir : At, Pe, m ? Sr : $r);
      g[T] = Tr, d[T] = Tr - Pe;
    }
    t.modifiersData[a] = d;
  }
}
const Qo = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Yo,
  requiresIfExists: ["offset"]
};
var Xo = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function En(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Xo[t];
  });
}
var Zo = {
  start: "end",
  end: "start"
};
function Br(e) {
  return e.replace(/start|end/g, function(t) {
    return Zo[t];
  });
}
function Jo(e, t) {
  t === void 0 && (t = {});
  var n = t, a = n.placement, r = n.boundary, s = n.rootBoundary, i = n.padding, l = n.flipVariations, o = n.allowedAutoPlacements, u = o === void 0 ? Fs : o, c = Gt(a), v = c ? l ? Ar : Ar.filter(function(p) {
    return Gt(p) === c;
  }) : _n, h = v.filter(function(p) {
    return u.indexOf(p) >= 0;
  });
  h.length === 0 && (h = v);
  var m = h.reduce(function(p, y) {
    return p[y] = er(e, {
      placement: y,
      boundary: r,
      rootBoundary: s,
      padding: i
    })[at(y)], p;
  }, {});
  return Object.keys(m).sort(function(p, y) {
    return m[p] - m[y];
  });
}
function eu(e) {
  if (at(e) === Za)
    return [];
  var t = En(e);
  return [Br(e), t, Br(t)];
}
function tu(e) {
  var t = e.state, n = e.options, a = e.name;
  if (!t.modifiersData[a]._skip) {
    for (var r = n.mainAxis, s = r === void 0 ? !0 : r, i = n.altAxis, l = i === void 0 ? !0 : i, o = n.fallbackPlacements, u = n.padding, c = n.boundary, v = n.rootBoundary, h = n.altBoundary, m = n.flipVariations, p = m === void 0 ? !0 : m, y = n.allowedAutoPlacements, b = t.options.placement, _ = at(b), P = _ === b, I = o || (P || !p ? [En(b)] : eu(b)), k = [b].concat(I).reduce(function(Se, X) {
      return Se.concat(at(X) === Za ? Jo(t, {
        placement: X,
        boundary: c,
        rootBoundary: v,
        padding: u,
        flipVariations: p,
        allowedAutoPlacements: y
      }) : X);
    }, []), T = t.rects.reference, g = t.rects.popper, $ = /* @__PURE__ */ new Map(), S = !0, L = k[0], B = 0; B < k.length; B++) {
      var N = k[B], d = at(N), w = Gt(N) === Kt, M = [Fe, Je].indexOf(d) >= 0, z = M ? "width" : "height", R = er(t, {
        placement: N,
        boundary: c,
        rootBoundary: v,
        altBoundary: h,
        padding: u
      }), W = M ? w ? et : Re : w ? Je : Fe;
      T[z] > g[z] && (W = En(W));
      var re = En(W), K = [];
      if (s && K.push(R[d] <= 0), l && K.push(R[W] <= 0, R[re] <= 0), K.every(function(Se) {
        return Se;
      })) {
        L = N, S = !1;
        break;
      }
      $.set(N, K);
    }
    if (S)
      for (var ee = p ? 3 : 1, oe = function(X) {
        var Z = k.find(function(fe) {
          var ye = $.get(fe);
          if (ye)
            return ye.slice(0, X).every(function(tt) {
              return tt;
            });
        });
        if (Z)
          return L = Z, "break";
      }, se = ee; se > 0; se--) {
        var pe = oe(se);
        if (pe === "break") break;
      }
    t.placement !== L && (t.modifiersData[a]._skip = !0, t.placement = L, t.reset = !0);
  }
}
const nu = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: tu,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function au(e, t, n) {
  var a = at(e), r = [Re, Fe].indexOf(a) >= 0 ? -1 : 1, s = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, i = s[0], l = s[1];
  return i = i || 0, l = (l || 0) * r, [Re, et].indexOf(a) >= 0 ? {
    x: l,
    y: i
  } : {
    x: i,
    y: l
  };
}
function ru(e) {
  var t = e.state, n = e.options, a = e.name, r = n.offset, s = r === void 0 ? [0, 0] : r, i = Fs.reduce(function(c, v) {
    return c[v] = au(v, t.rects, s), c;
  }, {}), l = i[t.placement], o = l.x, u = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += o, t.modifiersData.popperOffsets.y += u), t.modifiersData[a] = i;
}
const su = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: ru
};
var iu = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, zs(typeof t != "number" ? t : js(t, _n));
};
function lu(e) {
  var t, n = e.state, a = e.name, r = e.options, s = n.elements.arrow, i = n.modifiersData.popperOffsets, l = at(n.placement), o = Ja(l), u = [Re, et].indexOf(l) >= 0, c = u ? "height" : "width";
  if (!(!s || !i)) {
    var v = iu(r.padding, n), h = Xa(s), m = o === "y" ? Fe : Re, p = o === "y" ? Je : et, y = n.rects.reference[c] + n.rects.reference[o] - i[o] - n.rects.popper[c], b = i[o] - n.rects.reference[o], _ = kn(s), P = _ ? o === "y" ? _.clientHeight || 0 : _.clientWidth || 0 : 0, I = y / 2 - b / 2, k = v[m], T = P - h[c] - v[p], g = P / 2 - h[c] / 2 + I, $ = un(k, g, T), S = o;
    n.modifiersData[a] = (t = {}, t[S] = $, t.centerOffset = $ - g, t);
  }
}
function ou(e) {
  var t = e.state, n = e.options, a = n.element, r = a === void 0 ? "[data-popper-arrow]" : a;
  r != null && (typeof r == "string" && (r = t.elements.popper.querySelector(r), !r) || Rs(t.elements.popper, r) && (t.elements.arrow = r));
}
const uu = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: lu,
  effect: ou,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function qs({
  targetNode: e,
  tooltipNode: t,
  placement: n,
  strategy: a,
  showArrow: r = !0
}) {
  const s = E(null), i = E(!1), l = () => {
    i.value = !i.value;
  };
  return je(() => {
    s.value?.destroy();
  }), he(() => {
    const o = [
      Qo,
      nu,
      su,
      { name: "offset", options: { offset: [0, 10] } },
      ...r ? [uu, { name: "arrow", options: { padding: 8 } }] : []
    ];
    e.value && t.value && (s.value = Uo(
      e.value,
      t.value,
      {
        placement: n,
        strategy: a,
        modifiers: o
      }
    ));
  }), ce(i, (o) => {
    o && s.value?.update();
  }), {
    toggle: l,
    isOpen: i
  };
}
const cu = ["data-show"], du = ["id"], fu = { class: "ds-tooltip__content" }, mu = ["innerHTML"], vu = /* @__PURE__ */ j({
  __name: "ds-tooltip",
  props: {
    placement: { default: "auto" },
    strategy: { default: "absolute" },
    text: {},
    title: {},
    titleElement: { default: "h3" }
  },
  setup(e) {
    const t = e, n = E(null), a = E(null), r = E(null), s = ht("tooltip"), i = ["A", "BUTTON", "INPUT", "SELECT", "TEXTAREA"], l = (h) => {
      const m = h.target;
      return m ? i.includes(m.tagName) : !1;
    }, o = (h) => {
      l(h) && (v.value = !0);
    }, u = (h) => {
      l(h) && h.target !== document.activeElement && (v.value = !1);
    }, c = (h) => {
      if (l(h)) {
        const m = h.target;
        m && ["BUTTON", "A"].includes(m.tagName) && (h.preventDefault(), m?.click());
      }
    };
    he(() => {
      const m = a.value?.querySelector("a, button, input, select, textarea");
      if (m)
        n.value = m, n.value.setAttribute("aria-describedby", s);
      else
        throw new Error(
          "The tooltip can only be applied to interactive elements"
        );
    });
    const { isOpen: v } = qs({
      targetNode: n,
      tooltipNode: r,
      placement: t.placement,
      strategy: t.strategy
    });
    return (h, m) => (f(), C("div", {
      class: "ds-tooltip",
      "data-show": D(v)
    }, [
      O("div", {
        ref_key: "targetWrapper",
        ref: a,
        class: "ds-tooltip__target-wrapper",
        onFocusin: o,
        onFocusout: u,
        onMouseover: o,
        onMouseout: u,
        onTouchend: c
      }, [
        ue(h.$slots, "default")
      ], 544),
      O("div", {
        id: D(s),
        ref_key: "tooltip",
        ref: r,
        class: "ds-tooltip__tooltip",
        "data-testid": "tooltip"
      }, [
        O("div", fu, [
          e.title ? (f(), F(vn(e.titleElement), {
            key: 0,
            class: "ds-tooltip__title"
          }, {
            default: H(() => [
              G(q(e.title), 1)
            ]),
            _: 1
          })) : A("", !0),
          V(Q, {
            "text-type": "label-sm",
            "html-element": "div"
          }, {
            default: H(() => [
              O("div", { innerHTML: e.text }, null, 8, mu)
            ]),
            _: 1
          })
        ]),
        m[0] || (m[0] = O("div", {
          class: "ds-tooltip__arrow",
          "data-popper-arrow": ""
        }, null, -1))
      ], 8, du)
    ], 8, cu));
  }
}), pu = ["aria-label"], hu = {
  key: 0,
  class: "ds-breadcrumb__mobile"
}, yu = {
  key: 1,
  class: "ds-breadcrumb__list"
}, gu = {
  key: 1,
  class: "ds-breadcrumb__item ds-breadcrumb__item--expand"
}, Db = /* @__PURE__ */ j({
  __name: "ds-breadcrumb",
  props: {
    ariaLabel: {},
    items: {},
    overflowMenuTooltipText: {}
  },
  setup(e) {
    const t = e, n = E(!1), { isMobile: a } = Be(), r = x(() => {
      const h = t.items[0];
      return h ? { ...h, itemClass: "ds-breadcrumb__item" } : null;
    }), s = t.items.slice(1), i = x(() => t.items.length > 3), l = x(
      () => t.items.findIndex((h) => h.isCurrentPage)
    ), o = x(
      () => l.value > 0 ? l.value - 1 : -1
    ), u = x(() => {
      if (o.value < 0) return null;
      const h = t.items[o.value];
      return h ? { ...h, itemClass: "ds-breadcrumb__item" } : null;
    }), c = x(() => s.map((h, m) => {
      const p = i.value && m < t.items.length - 3;
      return {
        ...h,
        itemClass: p ? "ds-breadcrumb__item ds-breadcrumb__item--initially-hidden" : "ds-breadcrumb__item"
      };
    })), v = x(() => {
      const h = ["ds-breadcrumb"];
      return n.value && h.push("ds-breadcrumb--expanded"), h;
    });
    return (h, m) => e.items.length > 1 ? (f(), C("nav", {
      key: 0,
      class: Y(v.value),
      "aria-label": e.ariaLabel
    }, [
      u.value && D(a) ? (f(), C("div", hu, [
        V(ya, {
          "icon-start-name": "navigate-back",
          item: u.value
        }, null, 8, ["item"])
      ])) : A("", !0),
      D(a) ? A("", !0) : (f(), C("ol", yu, [
        r.value ? (f(), C("li", {
          key: 0,
          class: Y(r.value.itemClass)
        }, [
          V(ya, { item: r.value }, null, 8, ["item"]),
          c.value.length ? (f(), F(ie, {
            key: 0,
            class: "ds-breadcrumb__divider",
            "icon-name": "chevron-right",
            size: "xs"
          })) : A("", !0)
        ], 2)) : A("", !0),
        i.value ? (f(), C("li", gu, [
          V(vu, {
            ref: "tooltip",
            text: e.overflowMenuTooltipText,
            placement: "top"
          }, {
            default: H(() => [
              O("button", {
                class: "ds-breadcrumb__expand",
                onClick: m[0] || (m[0] = () => n.value = !0)
              }, [
                V(Q, {
                  "text-type": "label-sm",
                  "html-element": "span"
                }, {
                  default: H(() => [...m[1] || (m[1] = [
                    G("…", -1)
                  ])]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["text"]),
          c.value.length ? (f(), F(ie, {
            key: 0,
            class: "ds-breadcrumb__divider",
            "icon-name": "chevron-right",
            size: "xs"
          })) : A("", !0)
        ])) : A("", !0),
        (f(!0), C(le, null, ve(c.value, (p, y) => (f(), C("li", {
          key: p.url,
          class: Y(p.itemClass)
        }, [
          V(ya, { item: p }, null, 8, ["item"]),
          y < c.value.length - 1 ? (f(), F(ie, {
            key: 0,
            class: "ds-breadcrumb__divider",
            "icon-name": "chevron-right",
            size: "xs"
          })) : A("", !0)
        ], 2))), 128))
      ]))
    ], 10, pu)) : A("", !0);
  }
}), Ws = /* @__PURE__ */ j({
  __name: "ds-button-group",
  props: {
    buttonSize: { default: "md" },
    desktopAlignment: { default: "end" },
    desktopDirection: { default: "row" },
    mobileAlignment: { default: "stretch" },
    mobileDirection: { default: "column-reverse" }
  },
  setup(e) {
    const t = e, n = x(() => [
      `ds-button-group--${t.buttonSize}`,
      `ds-button-group--${t.desktopAlignment}`,
      `ds-button-group--${t.desktopDirection}`,
      `ds-button-group--m-${t.mobileAlignment}`,
      `ds-button-group--m-${t.mobileDirection}`
    ]);
    return (a, r) => (f(), C("div", {
      class: Y(["ds-button-group", n.value])
    }, [
      ue(a.$slots, "default", { buttonSize: e.buttonSize })
    ], 2));
  }
}), bu = ["aria-label", "disabled"], Fb = /* @__PURE__ */ j({
  __name: "ds-button-play",
  props: {
    ariaLabelPlay: {},
    ariaLabelPause: {},
    disabled: { type: Boolean, default: !1 },
    initialState: { default: "play" },
    pauseHandler: {},
    playHandler: {},
    size: { default: "md" },
    variant: { default: "primary" }
  },
  setup(e) {
    const t = e, n = x(() => t.playHandler && t.pauseHandler), a = x(() => i.value === "play" && t.playHandler), r = x(() => i.value === "pause" && t.pauseHandler), s = x(() => {
      if (a.value)
        return t.ariaLabelPlay;
      if (r.value)
        return t.ariaLabelPause;
    }), i = E(t.initialState), l = (h) => {
      a.value ? o(h) : r.value && u(h);
    }, o = (h) => {
      n.value && (i.value = "pause");
      try {
        t.playHandler && t.playHandler(h);
      } catch (m) {
        i.value = "play", console.error(m);
      }
    }, u = (h) => {
      n.value && (i.value = "play");
      try {
        t.pauseHandler && t.pauseHandler(h);
      } catch (m) {
        i.value = "pause", console.error(m);
      }
    }, c = x(() => [
      `ds-button-play--${t.variant}`,
      `ds-button-play--${t.size}`
    ]);
    let v = !0;
    return t.playHandler && !t.ariaLabelPlay && (v = !1), t.pauseHandler && !t.ariaLabelPause && (v = !1), v || console.error("The play button requires an accessible label"), (h, m) => (f(), C("button", {
      "aria-label": s.value,
      class: Y(["ds-button-play", c.value]),
      disabled: e.disabled || void 0,
      onClick: l
    }, [
      m[0] || (m[0] = O("span", { class: "ds-button-play__bg" }, null, -1)),
      V(rt, {
        mode: "out-in",
        name: "swap"
      }, {
        default: H(() => [
          (f(), F(ie, {
            key: i.value,
            "icon-name": i.value,
            size: e.size
          }, null, 8, ["icon-name", "size"]))
        ]),
        _: 1
      })
    ], 10, bu));
  }
}), ku = ["aria-label", "disabled"], _u = {
  class: "ds-button-play-progress__progress",
  viewBox: "0 0 36 36"
}, wu = ["stroke-dasharray", "stroke-dashoffset"], $u = 16, xu = /* @__PURE__ */ j({
  __name: "ds-button-play-progress",
  props: {
    ariaLabelPlay: {},
    ariaLabelPause: {},
    disabled: { type: Boolean, default: !1 },
    initialState: { default: "play" },
    pauseHandler: {},
    playHandler: {},
    progress: { default: 0 },
    loop: { type: Boolean, default: !0 },
    size: { default: "responsive" },
    variant: { default: "on-dark" }
  },
  setup(e, { expose: t }) {
    const n = e, a = x(() => {
      const k = [];
      return k.push(`ds-button-play-progress--${n.variant}`), k.push(`ds-button-play-progress--${s.value}`), k;
    }), { isMobile: r } = Be(), s = x(() => n.size === "responsive" ? r.value ? "md" : "sm" : n.size), i = x(() => s.value === "md" ? "sm" : "xs"), l = x(() => n.playHandler && n.pauseHandler), o = x(() => v.value === "play" && n.playHandler), u = x(() => v.value === "pause" && n.pauseHandler), c = x(() => {
      if (o.value)
        return n.ariaLabelPlay;
      if (u.value)
        return n.ariaLabelPause;
    }), v = E(n.initialState), h = x(() => v.value === "play" ? "button-play" : "button-pause");
    t({
      /**
       * Allows parent components to set the play state
       * @param isPlaying - Boolean to indicate whether the media is currently playing
       */
      setButtonState: (k) => {
        v.value = k ? "pause" : "play";
      }
    });
    const p = (k) => {
      o.value ? y(k) : u.value && b(k);
    }, y = (k) => {
      l.value && (v.value = "pause");
      try {
        n.playHandler && n.playHandler(k);
      } catch (T) {
        v.value = "play", console.error(T);
      }
    }, b = (k) => {
      l.value && (v.value = "play");
      try {
        n.pauseHandler && n.pauseHandler(k);
      } catch (T) {
        v.value = "pause", console.error(T);
      }
    };
    let _ = !0;
    n.playHandler && !n.ariaLabelPlay && (_ = !1), n.pauseHandler && !n.ariaLabelPause && (_ = !1);
    const P = x(() => 2 * Math.PI * $u), I = x(() => {
      const k = Math.min(Math.max(n.progress || 0, 0), 1);
      return P.value * (1 - k);
    });
    return n.loop || ce(
      () => n.progress,
      (k) => {
        k >= 1 && (v.value = "play");
      }
    ), _ || console.error("The play button requires an accessible label"), (k, T) => (f(), C("button", {
      "aria-label": c.value,
      class: Y(["ds-button-play-progress", a.value]),
      disabled: e.disabled || void 0,
      onClick: p
    }, [
      (f(), C("svg", _u, [
        T[0] || (T[0] = O("circle", {
          class: "ds-button-play-progress__progress-bg",
          cx: "18",
          cy: "18",
          r: "16"
        }, null, -1)),
        O("circle", {
          class: "ds-button-play-progress__progress-indicator",
          cx: "18",
          cy: "18",
          r: "16",
          "stroke-dasharray": P.value,
          "stroke-dashoffset": I.value
        }, null, 8, wu)
      ])),
      V(rt, {
        mode: "out-in",
        name: "swap"
      }, {
        default: H(() => [
          (f(), F(ie, {
            key: h.value,
            "icon-name": h.value,
            size: i.value
          }, null, 8, ["icon-name", "size"]))
        ]),
        _: 1
      })
    ], 10, ku));
  }
}), Iu = ["aria-label", "disabled", "form", "name", "type", "value"], Su = {
  key: 1,
  class: "ds-icon-button__notification"
}, Tu = ["aria-disabled", "aria-label", "download", "href", "target"], Ie = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "ds-icon-button",
  props: {
    ariaLabel: {},
    clickHandler: { type: Function, default: () => {
    } },
    disabled: { type: Boolean, default: !1 },
    download: { type: [Boolean, String, null], default: null },
    form: {},
    href: {},
    iconName: { default: "button-add" },
    name: {},
    notificationCount: {},
    size: { default: "md" },
    target: {},
    type: { default: "button" },
    value: {},
    variant: { default: "secondary-neutral" }
  },
  setup(e) {
    const t = e, n = ea(), a = x(
      () => t.ariaLabel ?? n["aria-label"] ?? ""
    ), r = x(() => {
      const { ["aria-label"]: c, ...v } = n;
      return v;
    }), s = x(() => t.size === "sm" ? "xs" : "sm"), i = x(() => t.size), l = x(() => t.variant), o = Ua(
      {
        variant: l,
        size: i
      },
      "ds-icon-button"
    ), u = x(() => {
      if (t.iconName)
        return Pa(t.iconName);
    });
    return (c, v) => (f(), C(le, null, [
      e.href ? A("", !0) : (f(), C("button", ke({ key: 0 }, r.value, {
        class: ["ds-icon-button", D(o)],
        "aria-label": a.value,
        disabled: e.disabled || void 0,
        form: e.form,
        name: e.name,
        type: e.type,
        value: e.value,
        onClick: v[0] || (v[0] = //@ts-ignore
        (...h) => e.clickHandler && e.clickHandler(...h))
      }), [
        u.value ? (f(), F(ie, {
          key: 0,
          "icon-name": u.value,
          size: s.value
        }, null, 8, ["icon-name", "size"])) : A("", !0),
        e.notificationCount ? (f(), C("span", Su, q(e.notificationCount), 1)) : A("", !0)
      ], 16, Iu)),
      e.href ? (f(), C("a", ke({ key: 1 }, r.value, {
        class: ["ds-icon-button", D(o)],
        "aria-disabled": e.disabled || void 0,
        "aria-label": a.value,
        download: e.download === !0 ? "" : e.download,
        href: e.href,
        target: e.target,
        onClick: v[1] || (v[1] = //@ts-ignore
        (...h) => e.clickHandler && e.clickHandler(...h))
      }), [
        u.value ? (f(), F(ie, {
          key: 0,
          "icon-name": u.value,
          size: s.value
        }, null, 8, ["icon-name", "size"])) : A("", !0)
      ], 16, Tu)) : A("", !0)
    ], 64));
  }
}), Rb = /* @__PURE__ */ j({
  __name: "ds-card-action",
  props: {
    action: { default: "favourite" },
    actionFn: {},
    actionLabel: {},
    actionState: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = async () => {
      t.actionFn && (a.value = t.actionFn());
    }, a = E(t.actionState), r = x(() => t.action === "favourite" ? a.value ? "heart-filled" : "heart" : null), { isMobile: s } = Be(), i = x(() => s.value ? "md" : "sm");
    return (l, o) => e.action && e.actionLabel && r.value ? (f(), F(Ie, {
      key: 0,
      class: "ds-card-action",
      type: "button",
      variant: "secondary-neutral",
      "click-handler": n,
      "aria-label": e.actionLabel,
      "icon-name": r.value,
      size: i.value
    }, null, 8, ["aria-label", "icon-name", "size"])) : A("", !0);
  }
}), Pu = {
  key: 0,
  class: "ds-card-colours"
}, Cu = { class: "ds-card-colours__list" }, Eu = ["title"], Au = { class: "ds-visually-hidden" }, Mu = {
  key: 0,
  class: "ds-card-colours__additional"
}, Lu = { class: "ds-visually-hidden" }, ga = 4, Ou = /* @__PURE__ */ j({
  __name: "ds-card-colours",
  props: {
    colours: { default: () => [] },
    coloursLabel: {}
  },
  setup(e) {
    const t = e, n = t.colours.slice(0, ga), a = t.colours.length > ga ? t.colours.length - ga : 0, r = a ? `+${a}` : null;
    return (s, i) => D(n).length ? (f(), C("div", Pu, [
      O("ul", Cu, [
        (f(!0), C(le, null, ve(D(n), (l) => (f(), C("li", {
          key: l.value,
          class: "ds-card-colours__option",
          style: Te(`--colour-bg: ${l.value}`),
          title: l.label
        }, [
          O("span", Au, q(l.label), 1)
        ], 12, Eu))), 128)),
        D(a) ? (f(), C("li", Mu, [
          V(Q, {
            class: "ds-card-colours__label",
            "html-element": "span",
            "text-type": "body-xs",
            "text-style": "regular"
          }, {
            default: H(() => [
              G(q(D(r)) + " ", 1),
              O("span", Lu, q(e.coloursLabel), 1)
            ]),
            _: 1
          })
        ])) : A("", !0)
      ])
    ])) : A("", !0);
  }
}), Nu = ["href"], Bu = { class: "ds-visually-hidden" }, Du = { class: "ds-card-product__image-container" }, Fu = ["src", "alt"], Ru = { class: "ds-card-product__content" }, Hu = ["src", "alt"], Vu = {
  key: 1,
  class: "ds-card-product__brow-placeholder"
}, zu = ["src", "alt"], ju = { class: "ds-card-product__footer" }, qu = { class: "ds-card-product__labels" }, Hb = /* @__PURE__ */ j({
  __name: "ds-card-product",
  props: {
    badgeText: {},
    badgeVariant: { default: "highlight" },
    browLogo: {},
    browLogoDark: {},
    browLogoAlt: {},
    browText: {},
    colours: {},
    coloursLabel: {},
    description: {},
    image: {},
    imageAlt: {},
    layout: { default: "responsive" },
    mediumLabel: {},
    smallLabel: {},
    title: {},
    url: {}
  },
  setup(e) {
    const t = e, n = x(() => {
      const a = [`ds-card-product--${t.layout}`];
      return t.badgeText && a.push("ds-card-product--badge"), a;
    });
    return (a, r) => (f(), C("article", {
      class: Y(["ds-card-product", n.value])
    }, [
      O("a", {
        class: "ds-card-product__link",
        href: e.url
      }, [
        O("span", Bu, q(e.title), 1)
      ], 8, Nu),
      e.badgeText ? (f(), F(El, {
        key: e.badgeVariant,
        class: "ds-card-product__badge",
        text: e.badgeText,
        variant: e.badgeVariant
      }, null, 8, ["text", "variant"])) : A("", !0),
      O("div", Du, [
        O("img", {
          class: "ds-card-product__image",
          src: e.image,
          alt: e.imageAlt
        }, null, 8, Fu),
        ue(a.$slots, "action")
      ]),
      O("div", Ru, [
        e.browLogo && e.browLogoAlt ? (f(), C("img", {
          key: 0,
          class: "ds-card-product__brow-image ds-card-product__brow-image--light",
          src: e.browLogo,
          alt: e.browLogoAlt
        }, null, 8, Hu)) : A("", !0),
        !e.browLogo && !e.browLogoDark && !e.browText ? (f(), C("span", Vu)) : A("", !0),
        e.browLogoDark && e.browLogoAlt ? (f(), C("img", {
          key: 2,
          class: "ds-card-product__brow-image ds-card-product__brow-image--dark",
          src: e.browLogoDark,
          alt: e.browLogoAlt
        }, null, 8, zu)) : A("", !0),
        e.browText && !e.browLogo ? (f(), F(Q, {
          key: 3,
          class: "ds-card-product__brow-text",
          "text-type": "body-xs",
          "text-style": "regular"
        }, {
          default: H(() => [
            G(q(e.browText), 1)
          ]),
          _: 1
        })) : A("", !0),
        V(Q, {
          class: "ds-card-product__title",
          "html-element": "h2",
          "text-type": "heading-md",
          "text-style": "medium"
        }, {
          default: H(() => [
            G(q(e.title), 1)
          ]),
          _: 1
        }),
        e.description ? (f(), F(Q, {
          key: 4,
          class: "ds-card-product__description",
          "text-type": "body-sm",
          "text-style": "regular"
        }, {
          default: H(() => [
            G(q(e.description), 1)
          ]),
          _: 1
        })) : A("", !0),
        O("footer", ju, [
          O("div", qu, [
            e.smallLabel ? (f(), F(Q, {
              key: 0,
              class: "ds-card-product__small-label",
              "text-type": "body-sm",
              "text-style": "bold"
            }, {
              default: H(() => [
                G(q(e.smallLabel), 1)
              ]),
              _: 1
            })) : A("", !0),
            e.colours ? (f(), F(Ou, {
              key: 1,
              "colours-label": e.coloursLabel,
              colours: e.colours
            }, null, 8, ["colours-label", "colours"])) : A("", !0)
          ]),
          e.mediumLabel ? (f(), F(Q, {
            key: 0,
            class: "ds-card-product__medium-label",
            "text-type": "label-md",
            "text-style": "bold"
          }, {
            default: H(() => [
              G(q(e.mediumLabel), 1)
            ]),
            _: 1
          })) : A("", !0)
        ])
      ])
    ], 2));
  }
});
function Us(e) {
  const t = E("ltr"), n = () => {
    if (e.value) {
      const a = window.getComputedStyle(e.value);
      t.value = a.direction;
    }
  };
  return ce(
    e,
    () => {
      n();
    },
    { immediate: !0 }
  ), { direction: t };
}
function aa(e) {
  return dl() ? (fl(e), !0) : !1;
}
const Ks = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Gs = (e) => e != null, Wu = Object.prototype.toString, Uu = (e) => Wu.call(e) === "[object Object]", Me = () => {
}, Ku = /* @__PURE__ */ Gu();
function Gu() {
  var e, t;
  return Ks && ((e = window?.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window?.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window?.navigator.userAgent));
}
function Ys(e, t) {
  function n(...a) {
    return new Promise((r, s) => {
      Promise.resolve(e(() => t.apply(this, a), { fn: t, thisArg: this, args: a })).then(r).catch(s);
    });
  }
  return n;
}
function Yu(e, t = {}) {
  let n, a, r = Me;
  const s = (o) => {
    clearTimeout(o), r(), r = Me;
  };
  let i;
  return (o) => {
    const u = be(e), c = be(t.maxWait);
    return n && s(n), u <= 0 || c !== void 0 && c <= 0 ? (a && (s(a), a = void 0), Promise.resolve(o())) : new Promise((v, h) => {
      r = t.rejectOnCancel ? h : v, i = o, c && !a && (a = setTimeout(() => {
        n && s(n), a = void 0, v(i());
      }, c)), n = setTimeout(() => {
        a && s(a), a = void 0, v(o());
      }, u);
    });
  };
}
function Qu(...e) {
  let t = 0, n, a = !0, r = Me, s, i, l, o, u;
  !Fn(e[0]) && typeof e[0] == "object" ? { delay: i, trailing: l = !0, leading: o = !0, rejectOnCancel: u = !1 } = e[0] : [i, l = !0, o = !0, u = !1] = e;
  const c = () => {
    n && (clearTimeout(n), n = void 0, r(), r = Me);
  };
  return (h) => {
    const m = be(i), p = Date.now() - t, y = () => s = h();
    return c(), m <= 0 ? (t = Date.now(), y()) : (p > m && (o || !a) ? (t = Date.now(), y()) : l && (s = new Promise((b, _) => {
      r = u ? _ : b, n = setTimeout(() => {
        t = Date.now(), a = !0, b(y()), c();
      }, Math.max(0, m - p));
    })), !o && !n && (n = setTimeout(() => a = !0, m)), a = !1, s);
  };
}
function cn(e) {
  return Array.isArray(e) ? e : [e];
}
function Xu(e) {
  return pn();
}
// @__NO_SIDE_EFFECTS__
function tr(e, t = 200, n = {}) {
  return Ys(
    Yu(t, n),
    e
  );
}
// @__NO_SIDE_EFFECTS__
function Qs(e, t = 200, n = !1, a = !0, r = !1) {
  return Ys(
    Qu(t, n, a, r),
    e
  );
}
function Zu(e, t = !0, n) {
  Xu() ? he(e, n) : t ? e() : Ze(e);
}
function Ju(e, t, n) {
  return ce(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
function ec(e, t, n) {
  return ce(
    e,
    t,
    {
      ...n,
      once: !0
    }
  );
}
const _t = Ks ? window : void 0;
function Ue(e) {
  var t;
  const n = be(e);
  return (t = n?.$el) != null ? t : n;
}
function dn(...e) {
  const t = [], n = () => {
    t.forEach((l) => l()), t.length = 0;
  }, a = (l, o, u, c) => (l.addEventListener(o, u, c), () => l.removeEventListener(o, u, c)), r = x(() => {
    const l = cn(be(e[0])).filter((o) => o != null);
    return l.every((o) => typeof o != "string") ? l : void 0;
  }), s = Ju(
    () => {
      var l, o;
      return [
        (o = (l = r.value) == null ? void 0 : l.map((u) => Ue(u))) != null ? o : [_t].filter((u) => u != null),
        cn(be(r.value ? e[1] : e[0])),
        cn(D(r.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        be(r.value ? e[3] : e[2])
      ];
    },
    ([l, o, u, c]) => {
      if (n(), !l?.length || !o?.length || !u?.length)
        return;
      const v = Uu(c) ? { ...c } : c;
      t.push(
        ...l.flatMap(
          (h) => o.flatMap(
            (m) => u.map((p) => a(h, m, p, v))
          )
        )
      );
    },
    { flush: "post" }
  ), i = () => {
    s(), n();
  };
  return aa(n), i;
}
let Dr = !1;
function ra(e, t, n = {}) {
  const { window: a = _t, ignore: r = [], capture: s = !0, detectIframe: i = !1, controls: l = !1 } = n;
  if (!a)
    return l ? { stop: Me, cancel: Me, trigger: Me } : Me;
  if (Ku && !Dr) {
    Dr = !0;
    const b = { passive: !0 };
    Array.from(a.document.body.children).forEach((_) => _.addEventListener("click", Me, b)), a.document.documentElement.addEventListener("click", Me, b);
  }
  let o = !0;
  const u = (b) => be(r).some((_) => {
    if (typeof _ == "string")
      return Array.from(a.document.querySelectorAll(_)).some((P) => P === b.target || b.composedPath().includes(P));
    {
      const P = Ue(_);
      return P && (b.target === P || b.composedPath().includes(P));
    }
  });
  function c(b) {
    const _ = be(b);
    return _ && _.$.subTree.shapeFlag === 16;
  }
  function v(b, _) {
    const P = be(b), I = P.$.subTree && P.$.subTree.children;
    return I == null || !Array.isArray(I) ? !1 : I.some((k) => k.el === _.target || _.composedPath().includes(k.el));
  }
  const h = (b) => {
    const _ = Ue(e);
    if (b.target != null && !(!(_ instanceof Element) && c(e) && v(e, b)) && !(!_ || _ === b.target || b.composedPath().includes(_))) {
      if ("detail" in b && b.detail === 0 && (o = !u(b)), !o) {
        o = !0;
        return;
      }
      t(b);
    }
  };
  let m = !1;
  const p = [
    dn(a, "click", (b) => {
      m || (m = !0, setTimeout(() => {
        m = !1;
      }, 0), h(b));
    }, { passive: !0, capture: s }),
    dn(a, "pointerdown", (b) => {
      const _ = Ue(e);
      o = !u(b) && !!(_ && !b.composedPath().includes(_));
    }, { passive: !0 }),
    i && dn(a, "blur", (b) => {
      setTimeout(() => {
        var _;
        const P = Ue(e);
        ((_ = a.document.activeElement) == null ? void 0 : _.tagName) === "IFRAME" && !P?.contains(a.document.activeElement) && t(b);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), y = () => p.forEach((b) => b());
  return l ? {
    stop: y,
    cancel: () => {
      o = !1;
    },
    trigger: (b) => {
      o = !0, h(b), o = !1;
    }
  } : y;
}
// @__NO_SIDE_EFFECTS__
function tc() {
  const e = Rt(!1), t = pn();
  return t && he(() => {
    e.value = !0;
  }, t), e;
}
// @__NO_SIDE_EFFECTS__
function nr(e) {
  const t = /* @__PURE__ */ tc();
  return x(() => (t.value, !!e()));
}
function nc(e, t, n = {}) {
  const { window: a = _t, ...r } = n;
  let s;
  const i = /* @__PURE__ */ nr(() => a && "MutationObserver" in a), l = () => {
    s && (s.disconnect(), s = void 0);
  }, o = x(() => {
    const h = be(e), m = cn(h).map(Ue).filter(Gs);
    return new Set(m);
  }), u = ce(
    o,
    (h) => {
      l(), i.value && h.size && (s = new MutationObserver(t), h.forEach((m) => s.observe(m, r)));
    },
    { immediate: !0, flush: "post" }
  ), c = () => s?.takeRecords(), v = () => {
    u(), l();
  };
  return aa(v), {
    isSupported: i,
    stop: v,
    takeRecords: c
  };
}
function Hn(e, t, n = {}) {
  const { window: a = _t, ...r } = n;
  let s;
  const i = /* @__PURE__ */ nr(() => a && "ResizeObserver" in a), l = () => {
    s && (s.disconnect(), s = void 0);
  }, o = x(() => {
    const v = be(e);
    return Array.isArray(v) ? v.map((h) => Ue(h)) : [Ue(v)];
  }), u = ce(
    o,
    (v) => {
      if (l(), i.value && a) {
        s = new ResizeObserver(t);
        for (const h of v)
          h && s.observe(h, r);
      }
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), u();
  };
  return aa(c), {
    isSupported: i,
    stop: c
  };
}
function Dt(e, t, n = {}) {
  const {
    root: a,
    rootMargin: r = "0px",
    threshold: s = 0,
    window: i = _t,
    immediate: l = !0
  } = n, o = /* @__PURE__ */ nr(() => i && "IntersectionObserver" in i), u = x(() => {
    const p = be(e);
    return cn(p).map(Ue).filter(Gs);
  });
  let c = Me;
  const v = Rt(l), h = o.value ? ce(
    () => [u.value, Ue(a), v.value],
    ([p, y]) => {
      if (c(), !v.value || !p.length)
        return;
      const b = new IntersectionObserver(
        t,
        {
          root: Ue(y),
          rootMargin: r,
          threshold: s
        }
      );
      p.forEach((_) => _ && b.observe(_)), c = () => {
        b.disconnect(), c = Me;
      };
    },
    { immediate: l, flush: "post" }
  ) : Me, m = () => {
    c(), h(), v.value = !1;
  };
  return aa(m), {
    isSupported: o,
    isActive: v,
    pause() {
      c(), v.value = !1;
    },
    resume() {
      v.value = !0;
    },
    stop: m
  };
}
function Fr(e, t = {}) {
  const {
    window: n = _t,
    scrollTarget: a,
    threshold: r = 0,
    rootMargin: s,
    once: i = !1
  } = t, l = Rt(!1), { stop: o } = Dt(
    e,
    (u) => {
      let c = l.value, v = 0;
      for (const h of u)
        h.time >= v && (v = h.time, c = h.isIntersecting);
      l.value = c, i && ec(l, () => {
        o();
      });
    },
    {
      root: a,
      window: n,
      threshold: r,
      rootMargin: be(s)
    }
  );
  return l;
}
const Rr = 1;
function ar(e, t = {}) {
  const {
    throttle: n = 0,
    idle: a = 200,
    onStop: r = Me,
    onScroll: s = Me,
    offset: i = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    observe: l = {
      mutation: !1
    },
    eventListenerOptions: o = {
      capture: !1,
      passive: !0
    },
    behavior: u = "auto",
    window: c = _t,
    onError: v = (L) => {
      console.error(L);
    }
  } = t, h = typeof l == "boolean" ? {
    mutation: l
  } : l, m = Rt(0), p = Rt(0), y = x({
    get() {
      return m.value;
    },
    set(L) {
      _(L, void 0);
    }
  }), b = x({
    get() {
      return p.value;
    },
    set(L) {
      _(void 0, L);
    }
  });
  function _(L, B) {
    var N, d, w, M;
    if (!c)
      return;
    const z = be(e);
    if (!z)
      return;
    (w = z instanceof Document ? c.document.body : z) == null || w.scrollTo({
      top: (N = be(B)) != null ? N : b.value,
      left: (d = be(L)) != null ? d : y.value,
      behavior: be(u)
    });
    const R = ((M = z?.document) == null ? void 0 : M.documentElement) || z?.documentElement || z;
    y != null && (m.value = R.scrollLeft), b != null && (p.value = R.scrollTop);
  }
  const P = Rt(!1), I = yt({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), k = yt({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), T = (L) => {
    P.value && (P.value = !1, k.left = !1, k.right = !1, k.top = !1, k.bottom = !1, r(L));
  }, g = /* @__PURE__ */ tr(T, n + a), $ = (L) => {
    var B;
    if (!c)
      return;
    const N = ((B = L?.document) == null ? void 0 : B.documentElement) || L?.documentElement || Ue(L), { display: d, flexDirection: w, direction: M } = getComputedStyle(N), z = M === "rtl" ? -1 : 1, R = N.scrollLeft;
    k.left = R < m.value, k.right = R > m.value;
    const W = Math.abs(R * z) <= (i.left || 0), re = Math.abs(R * z) + N.clientWidth >= N.scrollWidth - (i.right || 0) - Rr;
    d === "flex" && w === "row-reverse" ? (I.left = re, I.right = W) : (I.left = W, I.right = re), m.value = R;
    let K = N.scrollTop;
    L === c.document && !K && (K = c.document.body.scrollTop), k.top = K < p.value, k.bottom = K > p.value;
    const ee = Math.abs(K) <= (i.top || 0), oe = Math.abs(K) + N.clientHeight >= N.scrollHeight - (i.bottom || 0) - Rr;
    d === "flex" && w === "column-reverse" ? (I.top = oe, I.bottom = ee) : (I.top = ee, I.bottom = oe), p.value = K;
  }, S = (L) => {
    var B;
    if (!c)
      return;
    const N = (B = L.target.documentElement) != null ? B : L.target;
    $(N), P.value = !0, g(L), s(L);
  };
  return dn(
    e,
    "scroll",
    n ? /* @__PURE__ */ Qs(S, n, !0, !1) : S,
    o
  ), Zu(() => {
    try {
      const L = be(e);
      if (!L)
        return;
      $(L);
    } catch (L) {
      v(L);
    }
  }), h?.mutation && e != null && e !== c && e !== document && nc(
    e,
    () => {
      const L = be(e);
      L && $(L);
    },
    {
      attributes: !0,
      childList: !0,
      subtree: !0
    }
  ), dn(
    e,
    "scrollend",
    T,
    o
  ), {
    x: y,
    y: b,
    isScrolling: P,
    arrivedState: I,
    directions: k,
    measure() {
      const L = be(e);
      c && L && $(L);
    }
  };
}
function ac(e = {}) {
  const { window: t = _t, ...n } = e;
  return ar(t, n);
}
const rc = {
  class: /* @__PURE__ */ Y(["ds-carousel__buttons"])
}, sc = /* @__PURE__ */ j({
  __name: "ds-carousel-buttons",
  props: {
    ariaLabelNext: {},
    ariaLabelPrev: {},
    prevClick: { type: Function },
    nextClick: { type: Function },
    previousButtonDisabled: { type: Boolean },
    nextButtonDisabled: { type: Boolean }
  },
  setup(e) {
    return (t, n) => we((f(), C("div", rc, [
      V(Ie, {
        "aria-label": e.ariaLabelPrev,
        "click-handler": e.prevClick,
        disabled: e.previousButtonDisabled,
        "icon-name": "button-chevron-left",
        variant: "secondary-neutral"
      }, null, 8, ["aria-label", "click-handler", "disabled"]),
      V(Ie, {
        "aria-label": e.ariaLabelNext,
        "click-handler": e.nextClick,
        disabled: e.nextButtonDisabled,
        "icon-name": "button-chevron-right",
        variant: "secondary-neutral"
      }, null, 8, ["aria-label", "click-handler", "disabled"])
    ], 512)), [
      [$e, !(e.previousButtonDisabled && e.nextButtonDisabled)]
    ]);
  }
}), ic = {
  key: 0,
  class: "ds-tag__dot"
}, Xs = /* @__PURE__ */ j({
  __name: "ds-tag",
  props: {
    dot: { type: Boolean, default: !0 },
    text: {},
    type: { default: "ghost" }
  },
  setup(e) {
    const t = e;
    return (n, a) => (f(), F(Q, {
      class: Y(["ds-tag", `ds-tag--${t.type}`]),
      "html-element": "p",
      "text-type": "body-sm",
      "text-style": "medium"
    }, {
      default: H(() => [
        e.dot ? (f(), C("span", ic)) : A("", !0),
        G(q(e.text), 1)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), lc = { class: "ds-carousel__header" }, oc = { class: "ds-carousel__header-text" }, uc = {
  key: 0,
  class: "ds-carousel__link"
}, Vb = /* @__PURE__ */ j({
  __name: "ds-carousel",
  props: {
    ariaLabelNext: {},
    ariaLabelPrev: {},
    description: {},
    headingLevel: { default: "h2" },
    linkTarget: {},
    linkText: {},
    linkUrl: {},
    maxItemsPerView: { default: 4 },
    scrollMode: { default: "page" },
    title: {},
    tag: {}
  },
  setup(e) {
    const t = e, a = window.matchMedia("(prefers-reduced-motion: reduce)").matches === !0 ? "auto" : "smooth", r = E(null), s = E(null), i = E(null), l = E(0), o = E(0), u = E(t.maxItemsPerView), c = E(0), v = E(!0), h = E(!0), { direction: m } = Us(s), p = x(() => t.linkUrl && t.linkText), y = x(
      () => `ds-carousel--items-${u.value} ds-carousel--max-items-${b.value}`
    ), b = x(() => t.maxItemsPerView);
    let _;
    const P = () => {
      i.value && (l.value = 0, o.value = i.value.length - 1, c.value = i.value.length, [...i.value].forEach((d, w) => {
        d.dataset.index = w.toString();
      }));
    }, I = () => {
      if (!s.value || !i.value) return;
      const d = i?.value[l.value], w = i?.value[o.value];
      _ = new IntersectionObserver(
        (M) => {
          M.forEach((z) => {
            const R = z.target;
            R.dataset.inView = z.isIntersecting ? "true" : "false", z.target === d && (v.value = z.isIntersecting), z.target === w && (h.value = z.isIntersecting);
          });
        },
        {
          threshold: 1,
          root: s.value,
          rootMargin: "4px"
        }
      );
    }, k = () => {
      const d = r.value?.querySelectorAll("[data-in-view='true']");
      d && d.length > 0 && (u.value = d.length || 0);
    }, T = /* @__PURE__ */ tr(() => {
      k();
    }, 200);
    he(() => {
      s.value && s.value.addEventListener(
        "scroll",
        () => {
          T();
        },
        {
          passive: !0
        }
      );
    }), ce(
      r,
      (d) => {
        d !== null && typeof d < "u" && (i.value = d.children);
      },
      { immediate: !0 }
    ), ce(
      i,
      (d, w) => {
        _ && w && Array.from(w).forEach((M) => {
          _.unobserve(M);
        }), d && (P(), I(), Array.from(d).forEach((M) => {
          _.observe(M);
        }), k());
      },
      { immediate: !0 }
    ), je(() => {
      _ && _.disconnect(), s.value && s.value.removeEventListener("scroll", () => {
        T();
      });
    });
    const g = (d) => m.value === "rtl" ? r.value ? -1 * Math.abs(r.value.offsetWidth) + d.offsetLeft + d.offsetWidth : 0 : d.offsetLeft, $ = (d) => {
      if (!r.value) return;
      const w = r.value.querySelector(
        `[data-index='${d}']`
      );
      w && s.value && s.value.scrollTo({
        left: g(w),
        behavior: a
      });
    }, S = (d) => {
      if (t.scrollMode === "item") {
        const R = d.length > 1 ? d[1] : d[0];
        return Number(R.dataset.index);
      }
      const w = d[d.length - 1], M = Number(
        w.dataset.index
      );
      return Math.min(M + 1, c.value);
    }, L = () => {
      const d = r.value?.querySelectorAll(
        "[data-in-view='true']"
      );
      if (d && d.length > 0) {
        const M = S(d);
        $(M);
      }
    }, B = (d) => {
      const w = d[0], M = Number(
        w.dataset.index
      );
      return t.scrollMode === "item" ? Math.max(M - 1, 0) : Math.max(
        M - u.value,
        0
      );
    }, N = () => {
      const d = r.value?.querySelectorAll(
        "[data-in-view='true']"
      );
      if (d && d.length > 0) {
        const M = B(d);
        $(M);
      }
    };
    return (d, w) => (f(), C("section", {
      class: Y(["ds-carousel", y.value])
    }, [
      O("header", lc, [
        O("div", oc, [
          ue(d.$slots, "header", {}, () => [
            e.tag || e.title || e.description ? (f(), C(le, { key: 0 }, [
              e.tag ? (f(), F(Xs, {
                key: 0,
                class: "ds-carousel__tag",
                text: e.tag
              }, null, 8, ["text"])) : A("", !0),
              e.title ? (f(), F(Q, {
                key: 1,
                class: "ds-carousel__title",
                "text-type": "heading-3xl",
                "html-element": e.headingLevel
              }, {
                default: H(() => [
                  G(q(e.title), 1)
                ]),
                _: 1
              }, 8, ["html-element"])) : A("", !0),
              e.description ? (f(), F(Q, {
                key: 2,
                class: "ds-carousel__description",
                "text-type": "body-md",
                "text-style": "regular",
                "html-element": "p"
              }, {
                default: H(() => [
                  G(q(e.description), 1)
                ]),
                _: 1
              })) : A("", !0)
            ], 64)) : A("", !0)
          ])
        ]),
        p.value ? (f(), C("div", uc, [
          V(Ce, {
            variant: "link",
            target: e.linkTarget,
            href: e.linkUrl,
            size: "sm",
            "icon-end": "navigate-forward"
          }, {
            default: H(() => [
              G(q(e.linkText), 1)
            ]),
            _: 1
          }, 8, ["target", "href"])
        ])) : A("", !0)
      ]),
      O("div", {
        ref_key: "scroll",
        ref: s,
        class: "ds-carousel__scroll"
      }, [
        O("div", {
          ref_key: "itemContainer",
          ref: r,
          class: "ds-carousel__items"
        }, [
          ue(d.$slots, "default")
        ], 512)
      ], 512),
      V(sc, {
        "aria-label-next": e.ariaLabelNext,
        "aria-label-prev": e.ariaLabelPrev,
        "prev-click": N,
        "next-click": L,
        "previous-button-disabled": v.value,
        "next-button-disabled": h.value
      }, null, 8, ["aria-label-next", "aria-label-prev", "previous-button-disabled", "next-button-disabled"])
    ], 2));
  }
}), cc = /* @__PURE__ */ j({
  __name: "ds-icon-attention",
  props: {
    ariaLabel: {},
    iconName: { default: "checkmark" },
    size: { default: "md" }
  },
  setup(e) {
    const t = e, n = x(() => {
      const s = [];
      return t.iconName === "error" && s.push("ds-icon-attention--error"), s.push(`ds-icon-attention--${t.size}`), s;
    }), a = x(() => t.iconName === "error" ? "close" : t.iconName), r = x(() => t.size == "md" ? "xl" : "lg");
    return (s, i) => (f(), C("div", {
      class: Y(["ds-icon-attention", n.value])
    }, [
      V(ie, {
        class: "ds-icon-attention__icon",
        "icon-name": a.value,
        label: e.ariaLabel,
        size: r.value
      }, null, 8, ["icon-name", "label", "size"])
    ], 2));
  }
}), dc = ["aria-labelledby"], fc = { class: "ds-modal__container" }, mc = {
  key: 0,
  class: "ds-modal__attention"
}, vc = {
  key: 1,
  class: "ds-modal__header"
}, pc = 1e3, hc = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "ds-modal",
  props: {
    attentionIcon: {},
    backdrop: { default: "default" },
    closeLabel: {},
    isOpen: { type: Boolean, default: !1 },
    overflow: { default: "page" },
    size: { default: "md" },
    teleportSelector: {},
    title: {},
    type: { default: "default" }
  },
  emits: ["close-modal"],
  setup(e, { expose: t, emit: n }) {
    const a = e, r = E(null), s = E(null), i = E(null), l = E(!1), { arrivedState: o } = ar(i, {}), { isMobile: u } = Be(), c = x(
      () => a.type === "attention" ? "center" : "end"
    ), v = x(() => u.value || a.size === "sm" ? "sm" : "md"), h = x(() => {
      let B = [];
      return !o.top && p.value && B.push("ds-modal__content-inner--fade-top"), !o.bottom && p.value && B.push("ds-modal__content-inner--fade-bottom"), B;
    }), m = ht("modal-title"), p = E(!1), y = () => {
      i.value && (p.value = i.value.scrollHeight > i.value.clientHeight);
    };
    t({ checkOverflow: y }), ra(r, () => _());
    const b = n, _ = () => {
      a.isOpen && P();
    }, P = () => {
      b("close-modal");
    }, k = ea()["data-dialog"] ? "heading-2xl" : "heading-3xl", T = x(() => {
      const B = [];
      return a.backdrop === "blur" && B.push("ds-modal--blur"), B.push(`ds-modal--${a.type}`), B.push(`ds-modal--${a.size}`), B.push(`ds-modal--overflow-${a.overflow}`), B;
    });
    he(() => {
      window.addEventListener("resize", y), y();
    }), qa(() => {
      window.removeEventListener("resize", y), L();
    });
    let g = null, $ = null, S = null;
    const L = () => {
      g && clearTimeout(g), $ && clearTimeout($), S && clearTimeout(S);
    };
    return ce(
      () => a.isOpen,
      (B, N, d) => {
        if (g = window.setTimeout(() => {
          l.value = B;
        }, 10), s.value) {
          const w = s.value;
          if (B) {
            w.showModal();
            const M = w.querySelector("button");
            $ = window.setTimeout(() => {
              M?.focus(), y();
            }, 10);
          } else
            S = window.setTimeout(() => {
              w.close();
            }, 700);
        }
        d(L);
      },
      { immediate: !0 }
    ), (B, N) => (f(), F(Ps, {
      to: e.teleportSelector,
      disabled: !e.teleportSelector
    }, [
      V(rt, {
        name: "modal",
        duration: pc
      }, {
        default: H(() => [
          we(O("dialog", ke({
            ref_key: "dialog",
            ref: s,
            "aria-labelledby": D(m),
            class: [T.value, "ds-modal"]
          }, B.$attrs, {
            tabindex: "-1",
            onCancel: gt(P, ["prevent"])
          }), [
            O("div", fc, [
              O("div", {
                ref_key: "content",
                ref: r,
                class: "ds-modal__content"
              }, [
                V(Ie, {
                  "aria-label": e.closeLabel,
                  class: "ds-modal__close",
                  "click-handler": P,
                  "icon-name": "button-close",
                  variant: "ghost"
                }, null, 8, ["aria-label"]),
                e.type === "attention" ? (f(), C("div", mc, [
                  V(cc, {
                    size: v.value,
                    "icon-name": e.attentionIcon
                  }, null, 8, ["size", "icon-name"])
                ])) : A("", !0),
                e.title ? (f(), C("header", vc, [
                  e.title ? (f(), F(Q, {
                    key: 0,
                    id: D(m),
                    class: "ds-modal__title",
                    "text-type": D(k),
                    "text-style": "regular",
                    "html-element": "h2"
                  }, {
                    default: H(() => [
                      G(q(e.title), 1)
                    ]),
                    _: 1
                  }, 8, ["id", "text-type"])) : A("", !0)
                ])) : A("", !0),
                O("div", {
                  ref_key: "scrollContainer",
                  ref: i,
                  class: Y(["ds-modal__content-inner", h.value])
                }, [
                  V(Q, {
                    class: "ds-modal__body",
                    "html-element": "div",
                    "text-type": "body-md"
                  }, {
                    default: H(() => [
                      ue(B.$slots, "default")
                    ]),
                    _: 3
                  })
                ], 2),
                V(Ws, {
                  class: "ds-modal__actions",
                  "desktop-alignment": c.value,
                  "desktop-direction": "row",
                  "mobile-alignment": "stretch",
                  "mobile-direction": "column"
                }, {
                  default: H(() => [
                    ue(B.$slots, "actions")
                  ]),
                  _: 3
                }, 8, ["desktop-alignment"])
              ], 512)
            ])
          ], 16, dc), [
            [$e, l.value]
          ])
        ]),
        _: 3
      })
    ], 8, ["to", "disabled"]));
  }
}), zb = /* @__PURE__ */ j({
  __name: "ds-dialog",
  props: {
    closeLabel: {},
    isOpen: { type: Boolean, default: !1 },
    overflow: { default: "page" },
    teleportSelector: {},
    title: {},
    type: { default: "default" }
  },
  setup(e) {
    const t = e, n = ea();
    return (a, r) => (f(), F(hc, ke({
      class: ["ds-dialog", e.type === "progressive" ? "ds-dialog--progressive" : ""]
    }, D(n), {
      backdrop: "default",
      "close-label": t.closeLabel,
      "data-dialog": "true",
      "is-open": t.isOpen,
      overflow: t.overflow,
      size: "sm",
      "teleport-selector": t.teleportSelector,
      title: t.title,
      type: t.type === "progressive" ? "default" : t.type
    }), {
      actions: H(() => [
        ue(a.$slots, "actions")
      ]),
      default: H(() => [
        ue(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["class", "close-label", "is-open", "overflow", "teleport-selector", "title", "type"]));
  }
}), yc = (e, t, n, a, r, s) => ({
  accept: e,
  fileList: t,
  maxFileSize: n,
  validationMessageDuplicate: a,
  validationMessageFileSize: r,
  validationMessageType: s
}), rr = (e = !0, t = "") => ({
  message: t,
  valid: e
}), sr = (e, t) => e.replace(/\$\{(\w+)\}/g, (n, a) => t[a] ?? n), gc = (e, t) => {
  const n = t.fileList.value.filter(
    (r) => r.name === e.name
  ), a = sr(
    t.validationMessageDuplicate,
    { filename: e.name }
  );
  return rr(n.length === 0, a);
}, bc = (e) => e / 1024 / 1024, kc = (e) => e * 1024 * 1024, _c = (e) => Number(e.toFixed(2)), wc = (e, t) => {
  const n = bc(e.size), a = _c(n), r = kc(t.maxFileSize), s = sr(
    t.validationMessageFileSize,
    {
      filename: e.name,
      filesize: a.toString(),
      maxsize: t.maxFileSize.toString()
    }
  );
  return rr(e.size < r, s);
}, $c = (e, t) => {
  const [n] = t.split("/");
  return n ? e.startsWith(n) : !1;
}, xc = (e, t) => e === t, Ic = (e, t) => {
  const n = t.toLowerCase();
  return e.slice(e.lastIndexOf(".")).toLowerCase() === n;
}, Sc = (e, t) => e.type === "" ? !1 : t ? t.split(",").map((a) => a.trim()).some((a) => /^[a-zA-Z]+\/\*$/.test(a) ? $c(e.type, a) : a.includes("/") ? xc(e.type, a) : a.startsWith(".") ? Ic(e.name, a) : !1) : !0, Tc = (e, t) => {
  const n = Sc(e, t.accept), a = sr(t.validationMessageType, {
    filename: e.name
  });
  return rr(n, a);
}, Pc = [gc, wc, Tc], Cc = ["src", "width", "height"], Ec = /* @__PURE__ */ j({
  __name: "ds-file-thumbnail",
  props: {
    file: {},
    width: { default: 100 },
    height: { default: 100 }
  },
  setup(e) {
    const t = e, n = E("");
    return We(() => {
      if (t.file) {
        const a = new FileReader();
        a.onload = (r) => {
          n.value = r.target?.result;
        }, a.readAsDataURL(t.file);
      }
    }), (a, r) => (f(), C("div", {
      class: "ds-file-thumbnail",
      style: Te({
        width: e.width + "px",
        height: e.height + "px",
        minWidth: e.width + "px"
      }),
      "aria-hidden": "true"
    }, [
      O("img", {
        class: "ds-file-thumbnail__image",
        src: n.value,
        width: e.width * 2,
        height: e.height * 2,
        alt: ""
      }, null, 8, Cc)
    ], 4));
  }
}), Ac = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [a, r] of t)
    n[a] = r;
  return n;
}, Mc = /* @__PURE__ */ Ac(Ec, [["__scopeId", "data-v-30aa5ce2"]]), Lc = { class: "ds-file-upload" }, Oc = ["id", "accept", "aria-describedby", "capture", "disabled", "name", "multiple"], Nc = ["id"], Bc = {
  key: 0,
  class: "ds-file-upload__list"
}, Dc = {
  key: 1,
  class: "ds-file-upload__errors"
}, jb = /* @__PURE__ */ j({
  __name: "ds-file-upload",
  props: {
    context: {}
  },
  setup(e) {
    const t = e, n = ht("mobileButton"), { isMobile: a } = Be(), r = E(null), s = E([]), i = E([]), l = E(!1), o = E(!1), u = E(
      t.context?.accept || void 0
    ), c = E(
      t.context?.maxFileSize || 10
    ), v = E(
      t.context?.multiple || void 0
    ), h = E(
      t.context?.labelAddFilesButton
    ), m = E(
      t.context?.labelDropFiles
    ), p = E(t.context?.labelRemove), y = E(t.context?.labelTapToAdd), b = E(
      t.context?.listMode
    ), _ = E(
      t.context?.validationMessageFileSize
    ), P = E(
      t.context?.validationMessageDuplicate
    ), I = E(
      t.context?.validationMessageType
    ), k = (Z) => {
      if (Z)
        return T[Z];
    }, T = {
      true: !0,
      false: !1,
      user: "user",
      environment: "environment"
    }, g = x(
      () => k(t.context?.capture)
    ), $ = x(
      () => o.value || t.context?.disabled
    ), S = x(() => $.value || L.value), L = x(
      () => t.context?.multiple !== !0 && s.value.length > 0
    ), B = x(
      () => $.value || L.value
    ), N = x(() => {
      const Z = [];
      return l.value && Z.push("ds-file-upload__target--focus"), o.value && Z.push("ds-file-upload__target--dragging"), L.value && Z.push("ds-file-upload__target--disabled"), Z;
    }), d = x(() => `ds-help-${t.context?.id}`);
    he(() => {
      s.value = t.context?.value ?? [];
    });
    const w = () => {
      const Z = r.value?.files ?? [];
      for (const fe of Array.from(Z))
        K(fe);
      se();
    }, M = () => {
      o.value = !0;
    }, z = () => {
      o.value = !1;
    }, R = (Z) => {
      o.value = !1;
      const fe = Z.dataTransfer.files;
      if (fe)
        for (const ye of fe)
          K(ye);
    }, W = () => {
      l.value = !0;
    }, re = () => {
      l.value = !1, t.context?.handlers.blur();
    }, K = (Z) => {
      const fe = {
        name: Z.name,
        file: Z
      };
      X(Z) && s.value.push(fe);
    }, ee = (Z) => {
      Se(), s.value = s.value.filter(
        (fe) => fe.name !== Z.name
      ), se();
    }, oe = () => {
      r.value && r.value?.click();
    }, se = () => {
      t.context?.node.input(s.value);
    }, pe = (Z) => Z.length > 30 ? `...${Z.slice(-27)}` : Z, Se = () => {
      i.value = [];
    }, X = (Z) => {
      const fe = [];
      for (const ye of Pc) {
        const tt = yc(
          u.value,
          s,
          c.value,
          P.value,
          _.value,
          I.value
        ), it = ye(Z, tt);
        it.valid || (fe.push(it), i.value.push(it));
      }
      return fe.length === 0;
    };
    return (Z, fe) => (f(), C("div", Lc, [
      O("div", {
        class: Y(["ds-file-upload__target", N.value]),
        onDragover: gt(M, ["prevent"]),
        onDragleave: z,
        onDrop: gt(R, ["prevent"])
      }, [
        D(a) ? A("", !0) : (f(), F(ie, {
          key: 0,
          class: "ds-file-upload__icon",
          "icon-name": "upload"
        })),
        D(a) ? A("", !0) : (f(), F(Q, {
          key: 1,
          class: "ds-file-upload__drop-label",
          "text-type": "label-md"
        }, {
          default: H(() => [
            G(q(m.value), 1)
          ]),
          _: 1
        })),
        O("input", ke(Z.$attrs, {
          id: e.context?.id,
          ref_key: "fileInput",
          ref: r,
          class: "ds-file-upload__input",
          accept: u.value,
          "aria-describedby": d.value,
          capture: g.value || void 0,
          disabled: S.value,
          name: e.context?.node?.name,
          multiple: v.value || void 0,
          type: "file",
          onBlur: re,
          onClick: Se,
          onFocus: W,
          onInput: w
        }), null, 16, Oc),
        D(a) ? A("", !0) : (f(), F(Ce, {
          key: 2,
          class: "ds-file-upload__button",
          disabled: B.value,
          size: "sm",
          variant: "secondary",
          "click-handler": oe
        }, {
          default: H(() => [
            G(q(h.value), 1)
          ]),
          _: 1
        }, 8, ["disabled"])),
        D(a) ? (f(), F(Ie, {
          key: 3,
          id: D(n),
          "aria-label": y.value,
          class: "ds-file-upload__icon-button",
          disabled: B.value,
          "icon-name": "upload",
          variant: "secondary",
          onClick: oe
        }, null, 8, ["id", "aria-label", "disabled"])) : A("", !0),
        D(a) ? (f(), F(Q, {
          key: 4,
          "text-type": "label-lg",
          "html-element": "label",
          for: D(n)
        }, {
          default: H(() => [
            G(q(y.value), 1)
          ]),
          _: 1
        }, 8, ["for"])) : A("", !0)
      ], 34),
      O("div", {
        id: d.value,
        class: "formkit-help formkit-help--fileupload"
      }, q(e.context?.help), 9, Nc),
      s.value && s.value.length ? (f(), C("ul", Bc, [
        (f(!0), C(le, null, ve(s.value, (ye) => (f(), C("li", {
          key: ye.name,
          class: "ds-file-upload__item"
        }, [
          b.value === "icon" ? (f(), F(ie, {
            key: 0,
            class: "ds-file-upload__item-icon",
            "icon-name": "document"
          })) : A("", !0),
          b.value === "thumbnail" ? (f(), F(Mc, {
            key: 1,
            file: ye.file,
            height: 28,
            width: 28
          }, null, 8, ["file"])) : A("", !0),
          V(Q, {
            class: "ds-file-upload__item-label",
            "html-element": "span",
            "text-type": "label-md",
            title: ye.name
          }, {
            default: H(() => [
              G(q(pe(ye.name)), 1)
            ]),
            _: 2
          }, 1032, ["title"]),
          V(Ce, {
            variant: "link",
            size: "sm",
            class: "ds-file-upload__item-action",
            disabled: $.value,
            onClick: (tt) => ee(ye)
          }, {
            default: H(() => [
              G(q(p.value), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]))), 128))
      ])) : A("", !0),
      i.value.length ? (f(), C("div", Dc, [
        (f(!0), C(le, null, ve(i.value, (ye) => (f(), F(Tl, {
          key: ye.message,
          appearance: "danger",
          text: ye.message
        }, null, 8, ["text"]))), 128))
      ])) : A("", !0)
    ]));
  }
}), Fc = /* @__PURE__ */ j({
  __name: "ds-grid",
  props: {
    columns: {},
    columnsSm: {},
    columnsMd: {},
    columnsLg: {},
    columnsXl: {},
    columns2xl: {},
    htmlElement: { default: "div" },
    queryType: { default: "media" }
  },
  setup(e) {
    const t = e, n = x(() => {
      const a = t.queryType === "media" ? "mq-" : "cq-", r = [], s = (l, o) => {
        l && r.push(o);
      };
      return (() => {
        Object.entries({
          columns: "",
          columnsSm: "sm",
          columnsMd: "md",
          columnsLg: "lg",
          columnsXl: "xl",
          columns2xl: "2xl"
        }).forEach(([o, u]) => {
          const c = o, v = u ? `${a}${u}:` : "";
          s(
            !!t[c],
            `${v}ds-grid--cols-${t[c]}`
          );
        });
      })(), r;
    });
    return (a, r) => e.queryType === "media" ? (f(), F(vn(e.htmlElement), {
      key: 0,
      class: Y(["ds-grid", n.value])
    }, {
      default: H(() => [
        ue(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"])) : e.queryType === "container" ? (f(), F(vn(e.htmlElement), {
      key: 1,
      class: "ds-grid-container"
    }, {
      default: H(() => [
        O("div", {
          class: Y(["ds-grid", n.value])
        }, [
          ue(a.$slots, "default")
        ], 2)
      ]),
      _: 3
    })) : A("", !0);
  }
}), Rc = ["aria-label", "disabled", "form", "name", "type", "value"], Hc = ["aria-disabled", "aria-label", "download", "href", "target"], Vc = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "ds-button-initials",
  props: {
    ariaLabel: {},
    clickHandler: { type: Function, default: () => {
    } },
    disabled: { type: Boolean, default: !1 },
    download: { type: [Boolean, String, null], default: null },
    form: {},
    href: {},
    name: {},
    size: { default: "md" },
    target: {},
    type: { default: "button" },
    value: {},
    variant: { default: "secondary-neutral" }
  },
  setup(e) {
    const t = e, n = ea();
    x(
      () => t.ariaLabel ?? n["aria-label"] ?? ""
    );
    const a = x(() => {
      const { ["aria-label"]: l, ...o } = n;
      return o;
    }), r = x(() => t.size), s = x(() => t.variant), i = Ua(
      {
        variant: s,
        size: r
      },
      "ds-button-initials"
    );
    return (l, o) => (f(), C(le, null, [
      e.href ? A("", !0) : (f(), C("button", ke({ key: 0 }, a.value, {
        class: ["ds-button-initials", D(i)],
        "aria-label": e.ariaLabel,
        disabled: e.disabled || void 0,
        form: e.form,
        name: e.name,
        type: e.type,
        value: e.value,
        onClick: o[0] || (o[0] = //@ts-ignore
        (...u) => e.clickHandler && e.clickHandler(...u))
      }), [
        V(Q, {
          "html-element": "span",
          "text-style": "medium",
          "text-type": "label-md"
        }, {
          default: H(() => [
            ue(l.$slots, "default")
          ]),
          _: 3
        })
      ], 16, Rc)),
      e.href ? (f(), C("a", ke({ key: 1 }, a.value, {
        class: ["ds-button-initials", D(i)],
        "aria-disabled": e.disabled || void 0,
        "aria-label": e.ariaLabel,
        download: e.download === !0 ? "" : e.download,
        href: e.href,
        target: e.target,
        onClick: o[1] || (o[1] = //@ts-ignore
        (...u) => e.clickHandler && e.clickHandler(...u))
      }), [
        V(Q, {
          "html-element": "span",
          "text-style": "medium",
          "text-type": "label-md"
        }, {
          default: H(() => [
            ue(l.$slots, "default")
          ]),
          _: 3
        })
      ], 16, Hc)) : A("", !0)
    ], 64));
  }
}), zc = ["href"], jc = { class: "ds-logo__picture" }, qc = ["src", "alt"], Wc = ["src", "alt"], Zs = /* @__PURE__ */ j({
  __name: "ds-logo",
  props: {
    href: { default: "/" },
    altText: {},
    imageSrc: {},
    imageSrcDark: {},
    clickHandler: {},
    isCompact: { type: Boolean, default: !0 },
    isInverted: { type: Boolean, default: !1 },
    size: { default: "md" }
  },
  setup(e) {
    const t = e, n = x(() => {
      const a = [];
      return a.push(`ds-logo--${t.size}`), t.isCompact && a.push("ds-logo--compact"), a;
    });
    return (a, r) => (f(), C("div", {
      class: Y(["ds-logo", n.value])
    }, [
      O("a", {
        class: "ds-logo__link",
        href: e.href,
        onClick: r[0] || (r[0] = //@ts-ignore
        (...s) => e.clickHandler && e.clickHandler(...s))
      }, [
        O("picture", jc, [
          O("img", {
            class: "ds-logo__image ds-logo__image--light",
            src: e.imageSrc,
            alt: e.altText,
            fetchpriority: "high"
          }, null, 8, qc),
          e.imageSrcDark ? (f(), C("img", {
            key: 0,
            class: "ds-logo__image ds-logo__image--dark",
            src: e.imageSrcDark,
            alt: e.altText,
            fetchpriority: "high"
          }, null, 8, Wc)) : A("", !0)
        ])
      ], 8, zc)
    ], 2));
  }
}), Js = (e) => e ? "checkVisibility" in e && typeof e.checkVisibility == "function" ? e.checkVisibility() : e instanceof HTMLElement && !!e.offsetParent : !1, Uc = ["href", "target"], Kc = ["id", "aria-expanded", "aria-controls"], Gc = ["id", "aria-expanded", "aria-controls"], Yc = /* @__PURE__ */ j({
  __name: "ds-nav-item",
  props: {
    navItem: {}
  },
  setup(e) {
    const t = e, n = E(!1), a = E(null), r = E(null), s = x(() => {
      const p = [];
      return t.navItem.isActive && p.push("ds-nav-item--active"), p;
    }), i = x(() => {
      const p = [];
      return n.value && p.push("ds-nav-item-dropdown--open"), p;
    }), l = J("activeMegaMenuId", E("")), o = x(() => l ? l?.value === t.navItem.itemId : !1), u = (p) => {
      o.value && (p.key === "Escape" && v(t.navItem.itemId, a), p.key === "Tab" && !p.shiftKey && (p.preventDefault(), c()));
    }, c = () => {
      const p = document.getElementById(
        l.value
      );
      if (p) {
        const b = [...p.querySelectorAll("a[href], button")].find((_) => Js(_));
        b && b.focus();
      }
    }, v = J(
      "togglePrimaryMegaNav",
      (p, y) => {
        console.warn(
          "Missing open mega nav function for ",
          p,
          y
        );
      }
    ), h = () => {
      n.value = !n.value;
    }, m = () => {
      t.navItem.type === "mega" && v(t.navItem.itemId, a), t.navItem.type === "drilldown" && v(t.navItem.itemId, r), t.navItem.type === "dropdown" && h();
    };
    return (p, y) => (f(), C(le, null, [
      e.navItem.type === "link" ? (f(), C("a", {
        key: 0,
        class: Y(["ds-nav-item", s.value]),
        href: e.navItem.linkUrl,
        target: e.navItem.linkTarget
      }, q(e.navItem.text), 11, Uc)) : A("", !0),
      e.navItem.type === "drilldown" ? (f(), C("button", {
        key: 1,
        id: `button-${e.navItem.itemId}`,
        ref_key: "primaryDrilldownItem",
        ref: r,
        "aria-expanded": o.value,
        "aria-controls": e.navItem.itemId,
        class: Y(["ds-nav-item", s.value]),
        onClick: m,
        onKeydown: u
      }, [
        G(q(e.navItem.text) + " ", 1),
        A("", !0)
      ], 42, Kc)) : A("", !0),
      e.navItem.type === "mega" ? (f(), C("button", {
        key: 2,
        id: `button-${e.navItem.itemId}`,
        ref_key: "primaryMegaItem",
        ref: a,
        "aria-expanded": o.value,
        "aria-controls": e.navItem.itemId,
        class: Y(["ds-nav-item", s.value]),
        onClick: m,
        onKeydown: u
      }, [
        G(q(e.navItem.text) + " ", 1),
        A("", !0)
      ], 42, Gc)) : A("", !0),
      e.navItem.type === "dropdown" ? (f(), C("div", {
        key: 3,
        class: Y(["ds-nav-item-dropdown", i.value])
      }, [
        O("button", {
          class: Y(["ds-nav-item ds-nav-item--mega", s.value]),
          onClick: m
        }, [
          G(q(e.navItem.text) + " ", 1),
          V(ie, {
            class: "ds-nav-item__icon",
            "icon-name": "chevron-down",
            size: "sm"
          })
        ], 2),
        y[0] || (y[0] = O("div", { class: "ds-nav-item__dropdown" }, null, -1))
      ], 2)) : A("", !0)
    ], 64));
  }
}), Qc = ["aria-label"], Xc = { class: "ds-nav-primary__list" }, Hr = /* @__PURE__ */ j({
  __name: "ds-nav-primary",
  props: {
    navItems: {}
  },
  setup(e) {
    const t = J("labels", {});
    return (n, a) => (f(), C("nav", {
      class: "ds-nav-primary",
      "aria-label": D(t)?.primaryNavLandmark ?? "Primary"
    }, [
      O("ul", Xc, [
        (f(!0), C(le, null, ve(e.navItems, (r) => (f(), C("li", {
          key: r.text,
          class: "ds-nav-primary__list-item"
        }, [
          V(Yc, { "nav-item": r }, null, 8, ["nav-item"])
        ]))), 128))
      ])
    ], 8, Qc));
  }
}), Zc = ["id", "aria-expanded", "data-trigger-id"], Jc = /* @__PURE__ */ j({
  __name: "ds-nav-secondary-item",
  props: {
    id: {},
    isActive: { type: Boolean, default: !1 },
    isLink: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = J("activeMegaMenuId", null), a = J("activePrimaryId", void 0), r = x(() => {
      const o = [];
      return t.isActive && o.push("ds-nav-secondary-item--active"), o;
    }), s = E(null), i = J(
      "openSecondaryMegaNav",
      (o, u) => {
        console.warn(
          "Missing open secondary mega nav function for ",
          o,
          u
        );
      }
    ), l = (o) => {
      i && i(o, s);
    };
    return (o, u) => e.isLink ? A("", !0) : (f(), C("button", {
      key: 0,
      id: `trigger-${e.id}`,
      ref_key: "secondaryNavItem",
      ref: s,
      "aria-expanded": D(n) === D(a),
      "aria-controls": "megaNav",
      "data-trigger-id": e.id,
      class: Y(["ds-nav-secondary-item", r.value]),
      onClick: u[0] || (u[0] = () => l(e.id))
    }, [
      V(Q, {
        "html-element": "span",
        "text-type": "label-md"
      }, {
        default: H(() => [
          ue(o.$slots, "default")
        ]),
        _: 3
      }),
      V(ie, {
        class: "ds-nav-secondary-item__icon",
        "icon-name": "chevron-down",
        size: "xs"
      })
    ], 10, Zc));
  }
}), ed = ["aria-label"], td = { class: "ds-nav-secondary__list" }, nd = /* @__PURE__ */ j({
  __name: "ds-nav-secondary",
  props: {
    navItems: {}
  },
  setup(e) {
    const t = J("labels", {});
    return (n, a) => (f(), C("nav", {
      class: "ds-nav-secondary",
      "aria-label": D(t)?.secondaryNavLandmark ?? "Secondary"
    }, [
      O("ul", td, [
        (f(!0), C(le, null, ve(e.navItems, (r) => (f(), C("li", {
          key: `nav-${r.itemId}`,
          class: "ds-nav-secondary__list-item"
        }, [
          V(Jc, {
            id: r.itemId,
            "is-active": r.isActive
          }, {
            default: H(() => [
              G(q(r.text), 1)
            ]),
            _: 2
          }, 1032, ["id", "is-active"])
        ]))), 128))
      ])
    ], 8, ed));
  }
});
function ir(e) {
  const t = J("labels", {}), n = J("hideBackdrop", () => {
  });
  return {
    ariaLabel: x(() => `${e.itemLabel} ${t?.megaMenuNavLandmark ?? "Navigation"}`),
    handleKeydown: (s) => {
      s.key === "Escape" && typeof n == "function" && n();
    },
    hideBackdrop: n
  };
}
const ad = ["href", "target", "rel"], rd = ["innerHTML"], sd = /* @__PURE__ */ j({
  __name: "ds-nav-mega-link",
  props: {
    megaMenuLink: {}
  },
  setup(e) {
    const t = e, n = J("labels", {}), a = x(() => !!t.megaMenuLink.linkIsExternal), r = x(() => {
      if (a.value)
        return "noopener noreferrer";
    }), s = x(() => t.megaMenuLink.linkTarget === "_blank" && n?.opensNewWindowLabel ? `${t.megaMenuLink.linkText} <span class="ds-visually-hidden">(${n.opensNewWindowLabel})</span>` : t.megaMenuLink.linkText);
    return (i, l) => (f(), C("a", {
      class: "ds-nav-mega-link",
      href: e.megaMenuLink.linkUrl,
      target: e.megaMenuLink.linkTarget,
      rel: r.value
    }, [
      V(Q, {
        "html-element": "span",
        "text-type": "label-md",
        "text-style": "medium"
      }, {
        default: H(() => [
          O("span", { innerHTML: s.value }, null, 8, rd)
        ]),
        _: 1
      }),
      a.value ? (f(), F(ie, {
        key: 0,
        class: "ds-nav-mega-link__external",
        "icon-name": "external-link",
        size: "xs"
      })) : A("", !0)
    ], 8, ad));
  }
}), id = { class: "ds-nav-mega-link-list" }, ld = ["aria-labelledby"], od = /* @__PURE__ */ j({
  __name: "ds-nav-mega-link-list",
  props: {
    categoryTitle: {},
    links: {}
  },
  setup(e) {
    const t = ht("megamenu-linklist");
    return (n, a) => (f(), C("div", id, [
      V(Q, {
        id: D(t),
        "html-element": "h2",
        "text-type": "label-sm",
        "text-style": "medium",
        class: "ds-nav-mega-link-list__category"
      }, {
        default: H(() => [
          G(q(e.categoryTitle), 1)
        ]),
        _: 1
      }, 8, ["id"]),
      O("ul", {
        class: "ds-nav-mega-link-list__list",
        "aria-labelledby": D(t)
      }, [
        (f(!0), C(le, null, ve(e.links, (r) => (f(), C("li", {
          key: `${r.linkText}${r.linkUrl}`,
          class: "ds-nav-mega-link-list__item"
        }, [
          V(sd, { "mega-menu-link": r }, null, 8, ["mega-menu-link"])
        ]))), 128))
      ], 8, ld)
    ]));
  }
}), ud = { class: "ds-nav-mega-title" }, cd = /* @__PURE__ */ j({
  __name: "ds-nav-mega-title",
  props: {
    title: {},
    linkText: {},
    linkUrl: {}
  },
  setup(e) {
    return (t, n) => (f(), C("div", ud, [
      V(Q, {
        "text-type": "heading-2xl",
        "text-style": "regular",
        class: "ds-nav-mega-title__title"
      }, {
        default: H(() => [
          G(q(e.title), 1)
        ]),
        _: 1
      }),
      e.linkText ? (f(), F(Ce, {
        key: 0,
        "icon-end": "button-navigate-forward",
        variant: "link",
        href: e.linkUrl
      }, {
        default: H(() => [
          G(q(e.linkText), 1)
        ]),
        _: 1
      }, 8, ["href"])) : A("", !0)
    ]));
  }
}), dd = ["href", "target"], fd = { class: "ds-nav-card__figure" }, md = ["src", "alt"], vd = ["innerHTML"], Vn = /* @__PURE__ */ j({
  __name: "ds-nav-card",
  props: {
    title: {},
    description: {},
    linkUrl: {},
    linkIsExternal: { type: Boolean },
    linkTarget: {},
    imageSrc: {},
    imageAltText: {}
  },
  setup(e) {
    const t = e, n = x(() => t.linkUrl && t.imageSrc && t.title);
    return (a, r) => n.value ? (f(), C("a", {
      key: 0,
      class: "ds-nav-card",
      href: e.linkUrl,
      target: e.linkTarget
    }, [
      O("figure", fd, [
        O("img", {
          class: "ds-nav-card__image",
          src: e.imageSrc,
          alt: e.imageAltText
        }, null, 8, md)
      ]),
      V(Q, {
        class: "ds-nav-card__title",
        "html-element": "h3",
        "text-style": "medium",
        "text-type": "label-md"
      }, {
        default: H(() => [
          G(q(e.title) + " ", 1),
          e.linkIsExternal ? (f(), F(ie, {
            key: 0,
            class: "ds-nav-card__icon",
            "icon-name": "button-external-link",
            size: "xs"
          })) : A("", !0)
        ]),
        _: 1
      }),
      e.description ? (f(), F(Q, {
        key: 0,
        class: "ds-nav-card__description",
        "html-element": "p",
        "text-type": "label-sm"
      }, {
        default: H(() => [
          O("span", { innerHTML: e.description }, null, 8, vd)
        ]),
        _: 1
      })) : A("", !0)
    ], 8, dd)) : A("", !0);
  }
}), pd = { class: "ds-nav-mega-column ds-nav-mega-column--cards" }, hd = /* @__PURE__ */ j({
  __name: "ds-nav-mega-cards",
  props: {
    cards: {}
  },
  setup(e) {
    return (t, n) => (f(), C("div", pd, [
      (f(!0), C(le, null, ve(e.cards, (a) => (f(), F(Vn, ke({
        key: a.title
      }, { ref_for: !0 }, a), null, 16))), 128))
    ]));
  }
}), lr = /* @__PURE__ */ j({
  __name: "ds-nav-mega-column",
  props: {
    megaNavColumn: {}
  },
  setup(e) {
    return (t, n) => e.megaNavColumn.type === "linkList" ? (f(), F(od, {
      key: 0,
      "category-title": e.megaNavColumn.content.categoryTitle,
      links: e.megaNavColumn.content.links
    }, null, 8, ["category-title", "links"])) : e.megaNavColumn.type === "titleBlock" ? (f(), F(cd, {
      key: 1,
      title: e.megaNavColumn.content.title,
      "link-text": e.megaNavColumn.content.linkText,
      "link-url": e.megaNavColumn.content.linkUrl
    }, null, 8, ["title", "link-text", "link-url"])) : e.megaNavColumn.type === "promo" ? (f(), F(hd, {
      key: 2,
      cards: e.megaNavColumn.content.cards
    }, null, 8, ["cards"])) : A("", !0);
  }
});
function or(e, t = E(null)) {
  const n = E([]), a = E([]), r = E(null), s = E(null), i = E(null), l = J("hideBackdrop"), o = J(
    "lastFocusedSecondaryNavItem",
    E(null)
  ), u = J(
    "lastFocusedPrimaryNavItem",
    E(null)
  ), c = J(
    "primaryNextPrev",
    x(() => ({
      nextItem: ""
    }))
  ), v = () => {
    e.value && e.value !== null && (a.value = [
      ...e.value.querySelectorAll(
        'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
      )
    ].filter((d) => Js(d)), r.value = a.value[0] || null, i.value = a.value[a.value.length - 1] || null);
  }, h = () => {
    t.value && (n.value = [
      ...t.value.querySelectorAll(
        'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
      )
    ], s.value = n.value[0] || null);
  }, m = () => {
    v(), h();
  }, p = (d) => {
    document.activeElement === r.value && (d.preventDefault(), L.value ? B.value?.focus() : _());
  }, y = (d, w, M = !1) => {
    M && w == B.value && (r.value?.focus(), d.preventDefault());
  }, b = () => {
    typeof l == "function" && l();
  }, _ = () => {
    L.value && N.value ? (o.value = N.value, b()) : !L.value && c.value.nextItem && b();
  }, P = (d, w, M) => {
    if (w === M) {
      d.preventDefault();
      const z = document.querySelector(
        `.ds-nav-item[aria-controls='${c.value.nextItem}']`
      );
      u.value = z, _();
    }
  }, I = (d, w = !1) => {
    const M = document.activeElement, z = i.value;
    y(d, M, w), P(d, M, z);
  }, k = (d) => {
    !t.value || d.key !== "Tab" || (d.shiftKey ? p(d) : I(d, !0));
  }, T = (d) => {
    !e.value || d.key !== "Tab" || (d.shiftKey ? p(d) : I(d));
  };
  he(() => {
    t.value && t.value.addEventListener("keydown", k), e.value && e.value.addEventListener(
      "keydown",
      T
    ), m();
  }), je(() => {
    t.value && t.value.removeEventListener("keydown", k), e.value && e.value.removeEventListener(
      "keydown",
      T
    );
  });
  const g = () => {
    const d = n.value.find(
      (w) => w.className.includes("ds-nav-mega-tab--active")
    );
    d && d.focus();
  }, $ = (d, w = null) => {
    d && w ? w.focus() : d && !w && g();
  }, S = async (d, w = null) => {
    await Ze(), m(), $(d, w);
  }, L = x(() => t.value !== null), B = x(() => n.value.find(
    (d) => d.className.includes("ds-nav-mega-tab--active")
  )), N = x(() => {
    if (L.value) {
      const d = B.value?.getAttribute("data-next-id");
      return document.querySelector(
        `.ds-nav-secondary-item[data-trigger-id='${d}']`
      );
    }
    return null;
  });
  return {
    focusableContent: a,
    focusableTabs: n,
    setLastFocusedElement: _,
    updateFocusableElements: S
  };
}
const yd = ["id", "aria-labelledby"], gd = { class: "ds-nav-mega__content" }, bd = /* @__PURE__ */ j({
  __name: "ds-nav-mega",
  props: {
    itemLabel: {},
    itemId: {},
    megaNavColumns: {}
  },
  setup(e) {
    const t = J("activeOverlayType", E("none")), n = J("labels", {}), a = e, r = E(null), s = J("activeMegaMenuId", E("")), i = x(() => t.value === "primaryMega" && s?.value === a.itemId), { handleKeydown: l, hideBackdrop: o } = ir({
      itemLabel: a.itemLabel
    }), u = J(
      "lastFocusedPrimaryNavItem",
      E(null)
    ), c = (h) => {
      typeof o == "function" && o();
    }, { updateFocusableElements: v } = or(r);
    return ce(i, async (h) => {
      h && r.value !== null ? v(!1) : u && u.value && (await Ze(), u.value.focus());
    }), (h, m) => we((f(), C("section", {
      id: e.itemId,
      ref_key: "megaMenu",
      ref: r,
      "aria-labelledby": `button-${e.itemId}`,
      class: "ds-nav-mega",
      onKeydown: m[0] || (m[0] = //@ts-ignore
      (...p) => D(l) && D(l)(...p))
    }, [
      O("div", gd, [
        V(Ie, {
          class: "ds-nav-mega-close",
          "aria-label": D(n).megaMenuCloseButtonLabel ?? "Close menu",
          "icon-name": "button-close",
          "click-handler": c,
          variant: "tertiary"
        }, null, 8, ["aria-label"]),
        O("div", {
          class: Y(["ds-nav-mega-panel ds-nav-mega-columns", `ds-nav-mega-columns--${e.megaNavColumns.length}`])
        }, [
          (f(!0), C(le, null, ve(e.megaNavColumns, (p, y) => (f(), C("div", {
            key: `panel-${e.itemId}-col-${y}`,
            class: Y(["ds-nav-mega-column", `ds-nav-mega-column--${p.type}`])
          }, [
            V(lr, { "mega-nav-column": p }, null, 8, ["mega-nav-column"])
          ], 2))), 128))
        ], 2)
      ])
    ], 40, yd)), [
      [$e, i.value]
    ]);
  }
}), kd = ["aria-label"], _d = { class: "ds-nav-drilldown-item__label" }, wd = ["href", "target"], $d = { class: "ds-nav-drilldown-item__label" }, Vr = "submenu", xd = /* @__PURE__ */ j({
  __name: "ds-nav-drilldown-item",
  props: {
    isActive: { type: Boolean },
    level: { default: 0 },
    navItem: {}
  },
  setup(e) {
    const t = e, n = x(() => typeof t.navItem.children > "u" ? !1 : t.navItem.children.length > 0), a = x(() => !!(n.value && t.level < 2)), r = x(() => !!t.navItem.linkIsExternal), s = J(
      "clickDrilldownNavItem",
      (l, o) => {
        console.warn("No click handler attached to", l, o);
      }
    ), i = J("labels", { submenuLabel: Vr });
    return (l, o) => e.navItem && a.value ? (f(), C("button", {
      key: 0,
      "aria-label": `${e.navItem.text} ${D(i).submenuLabel || Vr}`,
      class: Y(["ds-nav-drilldown-item", e.isActive ? "ds-nav-drilldown-item--active" : null]),
      onClick: o[0] || (o[0] = (u) => D(s)(e.navItem, e.level))
    }, [
      O("span", _d, [
        V(Q, {
          "text-type": "label-md",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: H(() => [
            G(q(e.navItem.text), 1)
          ]),
          _: 1
        })
      ]),
      a.value ? (f(), F(ie, {
        key: 0,
        class: "ds-nav-drilldown-item__chevron",
        size: "sm",
        "icon-name": "chevron-right"
      })) : A("", !0)
    ], 10, kd)) : e.navItem && "linkUrl" in e.navItem && !n.value ? (f(), C("a", {
      key: 1,
      class: "ds-nav-drilldown-item",
      href: e.navItem.linkUrl,
      target: e.navItem.linkTarget
    }, [
      O("span", $d, [
        V(Q, {
          "text-type": "label-md",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: H(() => [
            G(q(e.navItem.text), 1)
          ]),
          _: 1
        }),
        r.value ? (f(), F(ie, {
          key: 0,
          class: "ds-nav-drilldown-item__external",
          "icon-name": "button-external-link",
          size: "xs"
        })) : A("", !0)
      ])
    ], 8, wd)) : A("", !0);
  }
}), Id = ["aria-label"], Sd = { class: "ds-nav-drilldown__list" }, ba = /* @__PURE__ */ j({
  __name: "ds-nav-drilldown",
  props: {
    activeItems: {},
    item: {},
    level: {}
  },
  setup(e) {
    const t = e, n = x(() => i.submenuLabel ? `${t.item?.text} ${i.submenuLabel}` : t.item?.text), a = x(() => t.activeItems[t.level]), r = x(
      () => a.value ? a.value?.itemId : null
    ), s = x(
      () => t.item?.children
    ), i = J("labels", { submenuLabel: "submenu" });
    return (l, o) => (f(), F(rt, { name: "drillfade" }, {
      default: H(() => [
        e.item && s.value ? (f(), C("section", {
          key: 0,
          "aria-label": n.value,
          class: Y(["ds-nav-mega-column", `ds-nav-mega-column--level-${e.level}`])
        }, [
          O("ul", Sd, [
            (f(!0), C(le, null, ve(s.value, (u) => (f(), C("li", {
              key: u.itemId,
              class: "ds-nav-drilldown__list-item"
            }, [
              u ? (f(), F(xd, {
                key: 0,
                "nav-item": u,
                level: e.level,
                "is-active": u.itemId === r.value
              }, null, 8, ["nav-item", "level", "is-active"])) : A("", !0)
            ]))), 128))
          ])
        ], 10, Id)) : A("", !0)
      ]),
      _: 1
    }));
  }
}), Td = ["id", "aria-labelledby"], Pd = { class: "ds-nav-mega__content" }, Cd = { class: "ds-nav-mega-panel" }, Ed = /* @__PURE__ */ j({
  __name: "ds-nav-mega-drilldown",
  props: {
    item: {}
  },
  setup(e, { expose: t }) {
    const n = J("activeOverlayType", E("none")), a = J("labels", {}), r = E([]);
    ge("clickDrilldownNavItem", (T, g) => {
      const $ = r.value[g]?.itemId === T?.itemId, S = r.value.slice(0, g);
      $ || (S[g] = T), r.value = S, k(!1);
    });
    const i = e, l = E(null), o = E(!0), u = J("activeMegaMenuId", E("")), c = x(() => n.value === "primaryMega" && u?.value === i.item.itemId), v = x(() => typeof i.item.titleBlock < "u"), h = (T) => !T.children || T.children.length === 0 ? 0 : 1 + Math.max(...T.children.map(h)), m = x(() => h(i.item)), p = x(() => 4 - m.value - 1), y = x(() => `drilldown--card-slots-${p.value} drilldown--cards-${i.item.cards?.length ?? "0"}`), { handleKeydown: b, hideBackdrop: _ } = ir({
      itemLabel: i.item.text
    }), P = J(
      "lastFocusedPrimaryNavItem",
      E(null)
    ), I = (T) => {
      typeof _ == "function" && _();
    }, { updateFocusableElements: k } = or(l);
    return ce(r, (T) => {
      T.length === 0 ? setTimeout(() => {
        o.value = !0;
      }, 200) : o.value = !1;
    }), ce(c, async (T) => {
      T && l.value !== null ? k(!1) : P && P.value && (await Ze(), P.value.focus());
    }), t({
      activeItems: r,
      navDepth: m,
      dedicatedCardSlots: p
    }), (T, g) => we((f(), C("section", {
      id: e.item.itemId,
      ref_key: "megaMenu",
      ref: l,
      "aria-labelledby": `button-${e.item.itemId}`,
      class: "ds-nav-mega ds-nav-mega--drilldown",
      onKeydown: g[0] || (g[0] = //@ts-ignore
      (...$) => D(b) && D(b)(...$))
    }, [
      O("div", Pd, [
        V(Ie, {
          class: "ds-nav-mega-close",
          "aria-label": D(a).megaMenuCloseButtonLabel ?? "Close menu",
          "icon-name": "button-close",
          "click-handler": I,
          variant: "tertiary"
        }, null, 8, ["aria-label"]),
        O("div", Cd, [
          O("div", {
            class: Y(["ds-nav-mega-drilldown-cols", y.value])
          }, [
            v.value ? (f(), C("div", {
              key: 0,
              class: Y(["ds-nav-mega-column", `ds-nav-mega-column--${e.item.titleBlock?.type}`])
            }, [
              e.item.titleBlock ? (f(), F(lr, {
                key: 0,
                "mega-nav-column": e.item.titleBlock
              }, null, 8, ["mega-nav-column"])) : A("", !0)
            ], 2)) : A("", !0),
            V(ba, {
              "active-items": r.value,
              item: e.item,
              level: 0
            }, null, 8, ["active-items", "item"]),
            we(V(ba, {
              "active-items": r.value,
              item: r.value[0],
              level: 1
            }, null, 8, ["active-items", "item"]), [
              [$e, r.value.length]
            ]),
            we(V(ba, {
              "active-items": r.value,
              item: r.value[1],
              level: 2
            }, null, 8, ["active-items", "item"]), [
              [$e, r.value.length === 2]
            ]),
            V(rt, {
              name: "card",
              appear: ""
            }, {
              default: H(() => [
                e.item.cards && e.item.cards.length > 0 ? we((f(), F(Vn, ke({
                  key: 0,
                  class: "ds-nav-card--1"
                }, e.item.cards[0]), null, 16)), [
                  [$e, o.value || p.value === 1]
                ]) : A("", !0)
              ]),
              _: 1
            }),
            V(rt, {
              name: "card",
              appear: ""
            }, {
              default: H(() => [
                e.item.cards && e.item.cards.length > 1 ? we((f(), F(Vn, ke({
                  key: 0,
                  class: "ds-nav-card--2"
                }, e.item.cards[1]), null, 16)), [
                  [$e, o.value || p.value === 2]
                ]) : A("", !0)
              ]),
              _: 1
            })
          ], 2)
        ])
      ])
    ], 40, Td)), [
      [$e, c.value]
    ]);
  }
}), Ad = { class: "ds-nav-mega-tabs__nav-wrapper" }, Md = { class: "ds-nav-mega-tabs__list" }, Ld = ["id", "data-itemid", "aria-controls", "data-next-id", "data-prev-id", "data-first-id", "data-last-id", "onClick"], Od = ["id", "aria-labelledby", "aria-hidden"], Nd = /* @__PURE__ */ j({
  __name: "ds-nav-mega-tabs",
  props: {
    activeTabLabel: {},
    itemLabel: {},
    isVisible: { type: Boolean },
    tabs: { default: () => [] }
  },
  setup(e) {
    const t = e, n = E(null), a = E([]), { handleKeydown: r, hideBackdrop: s } = ir({
      itemLabel: t.itemLabel
    }), { direction: i } = Us(n), l = E(null), o = E(null), { updateFocusableElements: u } = or(o, l), c = (I) => {
      p.value !== I ? p.value = I : typeof s == "function" && s();
    }, v = (I) => {
      typeof s == "function" && s();
    }, h = J("labels", {}), m = J(
      "lastFocusedSecondaryNavItem",
      E(null)
    ), p = J("activeTabId", E(null)), y = x(() => {
      let I = null;
      return a.value && (I = a.value.find(
        (k) => k.getAttribute("data-itemid") === p.value
      )), I;
    }), b = E({
      "--scale-factor": "0px",
      "--translate-x": "0px"
    }), _ = (I) => i.value === "rtl" ? l.value ? I.offsetLeft - l.value?.offsetWidth : 0 : I.offsetLeft, P = async () => {
      const I = y.value;
      await Ze(), await u(!0), b.value = {
        "--scale-factor": `${I?.getBoundingClientRect().width}px`,
        "--translate-x": `${_(I)}px`
      };
    };
    return ce(
      () => t.isVisible,
      async (I) => {
        I && await P(), I || m && m.value && (await Ze(), m.value.focus());
      }
    ), ce(y, async (I) => {
      I && await P();
    }), (I, k) => (f(), C("div", {
      ref_key: "megaMenu",
      ref: n,
      class: "ds-nav-mega-tabs",
      style: Te(b.value),
      onKeydown: k[0] || (k[0] = //@ts-ignore
      (...T) => D(r) && D(r)(...T))
    }, [
      O("div", Ad, [
        V(Ie, {
          class: "ds-nav-mega-close",
          "aria-label": D(h).megaMenuCloseButtonLabel ?? "Close menu",
          "icon-name": "button-close",
          "click-handler": v,
          variant: "tertiary"
        }, null, 8, ["aria-label"]),
        O("div", {
          ref_key: "tablist",
          ref: l,
          class: "ds-nav-mega-tabs__nav"
        }, [
          O("ul", Md, [
            (f(!0), C(le, null, ve(e.tabs, ({ itemId: T, text: g }, $) => (f(), C("li", {
              key: `${T}-button`,
              class: "ds-nav-mega-tabs__list-item"
            }, [
              O("button", {
                id: `${T}-button`,
                ref_for: !0,
                ref_key: "tabButtons",
                ref: a,
                class: Y([
                  "ds-nav-mega-tab",
                  D(p) === T ? "ds-nav-mega-tab--active" : ""
                ]),
                "data-itemid": T,
                "aria-controls": `panel-${T}`,
                "data-next-id": e.tabs[($ + 1) % e.tabs.length]?.itemId,
                "data-prev-id": e.tabs[($ - 1 + e.tabs.length) % e.tabs.length]?.itemId,
                "data-first-id": e.tabs[0]?.itemId,
                "data-last-id": e.tabs[e.tabs.length - 1]?.itemId,
                onClick: () => c(T)
              }, [
                V(Q, {
                  class: "ds-nav-mega-tab__text",
                  "html-element": "span",
                  "text-type": "label-md"
                }, {
                  default: H(() => [
                    G(q(g), 1)
                  ]),
                  _: 2
                }, 1024),
                V(ie, {
                  class: "ds-nav-mega-tab__icon",
                  "icon-name": "chevron-down",
                  size: "xs"
                })
              ], 10, Ld)
            ]))), 128))
          ])
        ], 512),
        k[1] || (k[1] = O("div", { class: "ds-nav-mega-tabs__indicator" }, [
          O("div", { class: "ds-nav-mega-tabs__active-line" })
        ], -1))
      ]),
      O("div", {
        ref_key: "tabpanel",
        ref: o,
        class: "ds-nav-mega-tabs__panels"
      }, [
        (f(!0), C(le, null, ve(e.tabs, (T) => we((f(), C("section", {
          id: `panel-${T.itemId}`,
          key: T.itemId,
          class: "ds-nav-mega-panel ds-nav-mega-columns",
          "aria-labelledby": `trigger-${T.itemId}`,
          "aria-hidden": T.itemId !== D(p)
        }, [
          (f(!0), C(le, null, ve(T.megaNavColumns, (g, $) => (f(), C("div", {
            key: `panel-${T.itemId}-col-${$}`,
            class: Y(["ds-nav-mega-column", `ds-nav-mega-column--${g.type}`])
          }, [
            V(lr, { "mega-nav-column": g }, null, 8, ["mega-nav-column"])
          ], 2))), 128))
        ], 8, Od)), [
          [$e, T.itemId === D(p)]
        ])), 128))
      ], 512)
    ], 36));
  }
}), Bd = { class: "ds-nav-mega ds-nav-mega--secondary" }, Dd = /* @__PURE__ */ j({
  __name: "ds-nav-mega-secondary",
  props: {
    itemLabel: {},
    navItems: {}
  },
  setup(e) {
    const t = J("activeOverlayType", E("none")), n = x(() => t.value === "secondaryMega");
    return (a, r) => we((f(), C("div", Bd, [
      V(Nd, {
        "is-visible": n.value,
        "item-label": e.itemLabel,
        tabs: e.navItems
      }, null, 8, ["is-visible", "item-label", "tabs"])
    ], 512)), [
      [$e, n.value]
    ]);
  }
}), Fd = { class: "ds-nav-mega-search" }, Rd = { class: "ds-nav-mega-search__content" }, Hd = /* @__PURE__ */ j({
  __name: "ds-nav-mega-search",
  setup(e) {
    const t = J("activeOverlayType", E("none"));
    return (n, a) => we((f(), C("div", Fd, [
      O("div", Rd, [
        ue(n.$slots, "default")
      ])
    ], 512)), [
      [$e, D(t) === "search"]
    ]);
  }
});
function ei(e, t, n, a) {
  const r = E(!1), s = E("0px"), i = E("unset"), l = x(() => {
    const h = [];
    return e.enableSticky && h.push(`${a}--sticky`), r.value && h.push(`${a}--show`), h;
  }), { y: o } = ac();
  let u = 0;
  ce(o, () => {
    const h = document.documentElement.scrollHeight - window.innerHeight, m = Math.min(Math.max(o.value, 0), h);
    m >= u ? r.value = !1 : r.value = !0, u = m;
  });
  const v = (h) => `${h}px`;
  return t !== null && Hn(t, (h) => {
    const m = h[0];
    if (!m) return;
    const { height: p } = m.contentRect;
    s.value = v(p);
  }), n !== null && Hn(n, (h) => {
    const m = h[0];
    if (!m) return;
    const { height: p } = m.contentRect;
    p !== 0 && (i.value = v(p));
  }), he(() => {
    t.value && (s.value = v(
      t.value?.clientHeight
    )), n.value && (i.value = v(
      n.value?.clientHeight
    ));
  }), {
    dynamicClasses: l,
    headerHeight: s,
    secondaryHeight: i
  };
}
const Vd = { class: "ds-header__inner" }, zd = { class: "ds-header__logo" }, jd = { class: "ds-header__tools" }, qd = { class: "ds-header__icons" }, Wd = {
  key: 0,
  class: "ds-header__cta"
}, Ud = {
  key: 0,
  class: "ds-header__primary-stacked"
}, Kd = { class: "ds-header__inner" }, Gd = { class: "ds-header__nav" }, Yd = /* @__PURE__ */ j({
  __name: "ds-header-desktop",
  props: {
    basketCount: {},
    basketFn: {},
    enableBasket: { type: Boolean },
    enableSearch: { type: Boolean },
    enableSticky: { type: Boolean, default: !0 },
    navItems: {},
    searchFn: {}
  },
  setup(e) {
    const t = e, n = E(0), a = E(null), r = E(null), s = E(!1), i = E(null), l = E(null), o = E(null), u = E("none"), c = E(null), v = E(null), h = E(null), m = E(0), p = E(!1), y = E(null), { dynamicClasses: b, headerHeight: _, secondaryHeight: P } = ei(
      {
        enableSticky: t.enableSticky
      },
      y,
      r,
      "ds-header"
    ), I = x(() => `--header-top-height: ${_.value}; --secondary-height: ${P.value}`), k = x(() => m.value < n.value), T = x(() => t.navItems.find((X) => X.isActive)), g = x(() => {
      const X = t.navItems.findIndex(
        (it) => it.itemId === l.value?.getAttribute("aria-controls")
      ), Z = (t.navItems.length + X - 1) % t.navItems.length, fe = (X + 1) % t.navItems.length, ye = t.navItems[Z]?.itemId, tt = t.navItems[fe]?.itemId;
      return { prevItem: ye, nextItem: tt };
    }), $ = x(() => {
      const X = T.value;
      return !X || X.type === "mega" || X.type === "drilldown" ? !1 : !!X.children?.length;
    }), S = x(() => $.value && T.value?.type === "link" ? T.value?.children : []), L = x(() => t.navItems.filter(
      (X) => X.type === "mega"
    )), B = x(() => t.navItems.filter(
      (X) => X.type === "drilldown"
    )), N = x(() => {
      const X = [...b.value];
      return $.value && X.push("ds-header--secondary"), u.value === "secondaryMega" && X.push("ds-header--secondary-expanded"), u.value === "primaryMega" && X.push("ds-header--mega"), X;
    }), d = (X) => {
      X.key === "Escape" && w();
    }, w = () => {
      s.value = !1, M();
    }, M = () => {
      u.value = "none", o.value = null, i.value = null;
    }, z = () => {
      s.value = !0;
    }, R = (X, Z) => {
      z(), o.value = X, u.value = "primaryMega", c.value = Z.value;
    }, W = (X, Z) => {
      o.value === X ? w() : (R(X, Z), l.value = Z.value);
    }, re = (X, Z) => {
      z(), o.value = T.value?.itemId ?? null, i.value = X, u.value = "secondaryMega", Z?.value && (v.value = Z.value);
    }, K = () => {
      u.value != "search" ? (z(), u.value = "search", t.searchFn && t.searchFn(!0)) : u.value === "search" && (w(), t.searchFn && t.searchFn(!1));
    }, ee = J("labels", {}), oe = J("loggedIn", E(!1)), se = J("ctaButtons"), pe = J("logo", {
      href: "/",
      altText: "Coloplast",
      imageSrc: "",
      clickHandler: () => {
      }
    }), Se = () => {
      const X = a.value?.parentElement;
      p.value = X?.dataset?.stickyMount === "true";
    };
    return he(() => {
      const X = h.value?.querySelectorAll(".ds-nav-item");
      if (X && X.length) {
        let Z = 0;
        for (const fe of X)
          Z += fe.clientWidth;
        n.value = Z;
      }
      Se();
    }), Hn(h, (X) => {
      const Z = X[0];
      if (!Z) return;
      const { width: fe } = Z.contentRect;
      m.value = fe;
    }), ce(I, (X) => {
      p.value && a.value && a.value.parentElement && a.value.parentElement.setAttribute("style", X);
    }), ge("activeMegaMenuId", o), ge("activePrimaryId", T.value?.itemId), ge("activeTabId", i), ge("activeOverlayType", u), ge("primaryNextPrev", g), ge("hideBackdrop", w), ge("showBackdrop", z), ge("togglePrimaryMegaNav", W), ge("openSecondaryMegaNav", re), ge("lastFocusedPrimaryNavItem", c), ge("lastFocusedSecondaryNavItem", v), (X, Z) => (f(), C(le, null, [
      O("header", {
        ref_key: "header",
        ref: a,
        class: Y(["ds-header", N.value]),
        style: Te(I.value),
        onShowBackdrop: z,
        onKeydown: d
      }, [
        O("div", {
          ref_key: "headerTop",
          ref: y,
          class: "ds-header__top"
        }, [
          O("div", Vd, [
            O("div", zd, [
              V(Zs, ml(vl(D(pe))), null, 16)
            ]),
            O("div", {
              ref_key: "primaryInline",
              ref: h,
              class: "ds-header__primary-inline"
            }, [
              k.value ? A("", !0) : (f(), F(Hr, {
                key: 0,
                "nav-items": e.navItems
              }, null, 8, ["nav-items"]))
            ], 512),
            O("div", jd, [
              O("div", qd, [
                e.enableSearch ? (f(), F(Ie, {
                  key: 0,
                  class: "ds-header-search",
                  "aria-label": D(ee)?.searchButtonLabel ?? "Search",
                  "icon-name": "button-search",
                  variant: "ghost",
                  onClick: K
                }, null, 8, ["aria-label"])) : A("", !0),
                e.enableBasket ? (f(), F(Ie, {
                  key: 1,
                  class: "ds-header-basket",
                  "aria-label": D(ee)?.basketButtonLabel ?? "Basket",
                  "click-handler": e.basketFn,
                  "icon-name": "button-shopping-basket",
                  "notification-count": e.basketCount,
                  variant: "ghost"
                }, null, 8, ["aria-label", "click-handler", "notification-count"])) : A("", !0)
              ]),
              D(se) ? (f(), C("div", Wd, [
                D(oe) && D(se).myAccountButtonNavItem?.initials && D(se).myAccountButtonNavItem?.initials.length ? (f(), F(Vc, {
                  key: 0,
                  "aria-label": `'${D(se).myAccountButtonNavItem.text} - ${D(se).myAccountButtonInitials}`,
                  href: D(se).myAccountButtonNavItem.linkUrl,
                  size: "md",
                  variant: "primary",
                  onClick: D(se).myAccountButtonFn
                }, {
                  default: H(() => [
                    G(q(D(se).myAccountButtonNavItem.initials), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "href", "onClick"])) : D(oe) && D(se).myAccountButtonNavItem?.text ? (f(), F(Ce, {
                  key: 1,
                  href: D(se).myAccountButtonNavItem.linkUrl,
                  size: "sm",
                  variant: "primary",
                  onClick: D(se).myAccountButtonFn
                }, {
                  default: H(() => [
                    G(q(D(se).myAccountButtonNavItem?.text), 1)
                  ]),
                  _: 1
                }, 8, ["href", "onClick"])) : A("", !0),
                !D(oe) && D(se).loginButtonLabel ? (f(), F(Ce, {
                  key: 2,
                  href: D(se).loginButtonLink,
                  size: "sm",
                  variant: "primary",
                  onClick: D(se).loginButtonFn
                }, {
                  default: H(() => [
                    G(q(D(se).loginButtonLabel), 1)
                  ]),
                  _: 1
                }, 8, ["href", "onClick"])) : A("", !0)
              ])) : A("", !0)
            ]),
            k.value ? (f(), C("div", Ud, [
              V(Hr, { "nav-items": e.navItems }, null, 8, ["nav-items"])
            ])) : A("", !0)
          ])
        ], 512),
        $.value ? we((f(), C("div", {
          key: 0,
          ref_key: "secondary",
          ref: r,
          class: "ds-header__bottom"
        }, [
          O("div", Kd, [
            O("div", Gd, [
              V(nd, {
                "nav-items": S.value ?? []
              }, null, 8, ["nav-items"])
            ])
          ])
        ], 512)), [
          [$e, !s.value]
        ]) : A("", !0),
        we(O("div", {
          id: "meganav",
          class: "ds-header__mega",
          onClick: gt(w, ["self"])
        }, [
          (f(!0), C(le, null, ve(L.value, (fe) => (f(), F(bd, {
            key: fe.text,
            "item-id": fe.itemId,
            "item-label": fe.text,
            "mega-nav-columns": fe.megaNavColumns
          }, null, 8, ["item-id", "item-label", "mega-nav-columns"]))), 128)),
          (f(!0), C(le, null, ve(B.value, (fe) => (f(), F(Ed, {
            key: fe.text,
            item: fe
          }, null, 8, ["item"]))), 128)),
          $.value ? (f(), F(Dd, {
            key: 0,
            "item-label": T.value?.text ?? "",
            "nav-items": S.value ?? []
          }, null, 8, ["item-label", "nav-items"])) : A("", !0),
          V(Hd, null, {
            default: H(() => [
              ue(X.$slots, "searchDesktop")
            ]),
            _: 3
          })
        ], 512), [
          [$e, s.value]
        ])
      ], 38),
      (f(), F(Ps, { to: "body" }, [
        we(O("div", {
          class: "ds-header-backdrop",
          onClick: gt(w, ["self"])
        }, null, 512), [
          [$e, s.value]
        ])
      ]))
    ], 64));
  }
}), Qd = { class: "ds-header-mobile__bar" }, Xd = {
  key: 0,
  class: "ds-header-mobile__logo"
}, Zd = {
  key: 1,
  class: "ds-header-mobile__title-bar"
}, Jd = { class: "ds-header-mobile__icons" }, ef = /* @__PURE__ */ j({
  __name: "ds-header-mobile-bar",
  props: {
    isTopLevel: { type: Boolean },
    logo: {},
    enableSearch: { type: Boolean },
    enableBasket: { type: Boolean },
    basketCount: {},
    basketFn: { type: Function },
    onSearchClick: { type: Function },
    onToggleClick: { type: Function },
    onBackClick: { type: Function },
    labels: {},
    menuState: {},
    menuButtonLabel: {}
  },
  setup(e) {
    return (t, n) => (f(), C("div", Qd, [
      e.isTopLevel ? (f(), C("div", Xd, [
        V(Zs, ke(e.logo, { size: "sm" }), null, 16)
      ])) : (f(), C("div", Zd, [
        V(Ie, {
          "aria-label": e.labels?.mobileMenuBackButtonLabel ?? "Back",
          "click-handler": e.onBackClick,
          variant: "secondary-neutral",
          size: "md",
          "icon-name": "button-chevron-left"
        }, null, 8, ["aria-label", "click-handler"])
      ])),
      O("div", Jd, [
        e.enableSearch && e.isTopLevel ? (f(), F(Ie, {
          key: 0,
          class: "ds-header-mobile__icon-button",
          "click-handler": e.onSearchClick,
          "aria-label": e.labels?.searchButtonLabel ?? "Search",
          "data-testid": "searchButton",
          "icon-name": "button-search",
          variant: "ghost"
        }, null, 8, ["click-handler", "aria-label"])) : A("", !0),
        e.enableBasket && e.isTopLevel ? (f(), F(Ie, {
          key: 1,
          class: "ds-header-mobile__icon-button",
          "aria-label": e.labels?.basketButtonLabel ?? "Basket",
          "click-handler": e.basketFn,
          "icon-name": "button-shopping-basket",
          "notification-count": e.basketCount,
          variant: "ghost"
        }, null, 8, ["aria-label", "click-handler", "notification-count"])) : A("", !0),
        V(Ie, {
          class: "ds-header-mobile__toggle",
          "click-handler": e.onToggleClick,
          "aria-label": e.menuButtonLabel,
          "icon-name": e.menuState === "open" || e.menuState === "search" ? "button-close" : "button-menu",
          variant: "ghost"
        }, null, 8, ["click-handler", "aria-label", "icon-name"])
      ])
    ]));
  }
}), tf = ["aria-label"], nf = { class: "ds-nav-mobile-item__label" }, af = ["href", "target"], rf = { class: "ds-nav-mobile-item__label" }, sf = {
  key: 2,
  class: "ds-nav-mobile-item ds-nav-mobile-item--section"
}, lf = { class: "ds-nav-mobile-item__label" }, of = 3, Tt = /* @__PURE__ */ j({
  __name: "ds-nav-mobile-item",
  props: {
    isSectionPage: { type: Boolean, default: !1 },
    level: {},
    navItem: {}
  },
  setup(e) {
    const t = e, n = J("labels", {}), a = n.submenuLabel ? n.submenuLabel : "submenu", r = x(() => t.navItem && "linkUrl" in t.navItem && t.navItem.linkUrl !== null && typeof t.navItem.linkUrl < "u"), s = x(() => !!("linkIsExternal" in t.navItem && t.navItem.linkIsExternal)), i = x(() => r.value ? t.isSectionPage ? !0 : !(!t.isSectionPage && l.value) : !1), l = x(() => !!("children" in t.navItem && t.navItem.children?.length)), o = x(() => !!("megaNavColumns" in t.navItem && t.navItem?.megaNavColumns.length)), u = x(() => o.value || l.value && t.level < of), c = x(() => {
      const m = [];
      return t.isSectionPage && m.push("ds-nav-mobile-item--section"), t.navItem.isActive && m.push("ds-nav-mobile-item--active"), m;
    }), v = J("navigateLevel", (m, p = 0) => {
      console.warn("navigateLevel not implemented", { navItem: m, level: p });
    }), h = x(() => t.isSectionPage && t.navItem.mobilePageLabel && t.navItem.mobilePageLabel || t.navItem.text);
    return (m, p) => e.navItem && u.value && !e.isSectionPage ? (f(), C("button", {
      key: 0,
      "aria-label": `${e.navItem.text} ${D(a)}`,
      class: "ds-nav-mobile-item",
      onClick: p[0] || (p[0] = (y) => D(v)(e.navItem, e.level + 1))
    }, [
      O("span", nf, [
        e.navItem.iconName ? (f(), F(ie, {
          key: 0,
          class: "ds-nav-mobile-item__icon",
          size: "lg",
          "icon-name": e.navItem.iconName
        }, null, 8, ["icon-name"])) : A("", !0),
        e.navItem.initials ? (f(), F(Q, {
          key: 1,
          class: "ds-nav-mobile-item__initials",
          "html-element": "span",
          "text-style": "medium",
          "text-type": "label-sm"
        }, {
          default: H(() => [
            G(q(e.navItem.initials), 1)
          ]),
          _: 1
        })) : A("", !0),
        V(Q, {
          "text-type": "label-lg",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: H(() => [
            G(q(e.navItem.text), 1)
          ]),
          _: 1
        })
      ]),
      u.value ? (f(), F(ie, {
        key: 0,
        class: "ds-nav-mobile-item__chevron",
        size: "md",
        "icon-name": "chevron-right"
      })) : A("", !0)
    ], 8, tf)) : e.navItem && "linkUrl" in e.navItem && i.value ? (f(), C("a", {
      key: 1,
      class: Y(["ds-nav-mobile-item", c.value]),
      href: e.navItem.linkUrl,
      target: e.navItem.linkTarget
    }, [
      O("span", rf, [
        e.navItem.iconName ? (f(), F(ie, {
          key: 0,
          class: "ds-nav-mobile-item__icon",
          size: "lg",
          "icon-name": e.navItem.iconName
        }, null, 8, ["icon-name"])) : A("", !0),
        e.navItem.initials && !e.isSectionPage ? (f(), F(Q, {
          key: 1,
          class: "ds-nav-mobile-item__initials",
          "html-element": "span",
          "text-style": "medium",
          "text-type": "label-sm"
        }, {
          default: H(() => [
            G(q(e.navItem.initials), 1)
          ]),
          _: 1
        })) : A("", !0),
        V(Q, {
          "text-type": "label-lg",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: H(() => [
            G(q(h.value), 1)
          ]),
          _: 1
        }),
        !e.isSectionPage && s.value ? (f(), F(ie, {
          key: 2,
          class: "ds-nav-mobile-item__external",
          "icon-name": "button-external-link",
          size: "md"
        })) : A("", !0),
        e.isSectionPage ? (f(), F(ie, {
          key: 3,
          class: "ds-nav-mobile-item__navigate",
          "icon-name": "button-navigate-forward",
          size: "md"
        })) : A("", !0)
      ])
    ], 10, af)) : e.navItem && e.isSectionPage ? (f(), C("div", sf, [
      O("span", lf, [
        e.navItem.iconName ? (f(), F(ie, {
          key: 0,
          class: "ds-nav-mobile-item__icon",
          size: "lg",
          "icon-name": e.navItem.iconName
        }, null, 8, ["icon-name"])) : A("", !0),
        V(Q, {
          "text-type": "label-lg",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: H(() => [
            G(q(h.value), 1)
          ]),
          _: 1
        })
      ])
    ])) : A("", !0);
  }
}), uf = ["aria-label"], cf = { class: "ds-nav-mobile__group" }, df = {
  key: 0,
  class: "ds-nav-mobile__filter"
}, ff = {
  key: 2,
  class: "ds-nav-mobile__cards"
}, ka = /* @__PURE__ */ j({
  __name: "ds-nav-mobile-level",
  props: {
    activeParent: {},
    level: {}
  },
  setup(e) {
    const t = e, n = [
      "link",
      "dropdown",
      "service",
      "drilldown",
      "popover"
    ], a = (u) => !!u && n.includes(u.type) && "children" in u && !!u.children?.length, r = x(() => a(t.activeParent) ? t.activeParent : null), s = E(""), i = x(() => t.activeParent?.type === "popover" && t.activeParent?.filterEnabled ? t.activeParent.children.filter(
      (u) => u.text.toLowerCase().indexOf(s.value.toLowerCase()) > -1 || u.textAlternative && u.textAlternative?.toLowerCase().indexOf(s.value.toLowerCase()) > -1
    ) : t.activeParent && "children" in t.activeParent ? t.activeParent?.children : []), l = x(() => r.value !== null && "titleBlock" in r.value && typeof r.value.titleBlock < "u" && r.value.titleBlock !== null), o = x(() => {
      if (l.value) {
        const u = r.value;
        return {
          itemId: `${u.itemId}-title`,
          linkUrl: u.titleBlock?.content.linkUrl ?? "#",
          text: u.titleBlock?.content.linkText ?? "",
          type: "link"
        };
      }
      return null;
    });
    return (u, c) => {
      const v = Cs("FormKit");
      return f(), F(rt, { name: "persist" }, {
        default: H(() => [
          e.activeParent ? (f(), C("div", {
            key: 0,
            class: Y(`ds-nav-mobile__level ds-nav-mobile__level${e.level}`)
          }, [
            c[1] || (c[1] = O("div", { class: "ds-nav-mobile__title-bar" }, null, -1)),
            a(e.activeParent) ? (f(), C("section", {
              key: 0,
              "aria-label": e.activeParent.text,
              class: "ds-nav-mobile__nav"
            }, [
              o.value ? (f(), F(Tt, {
                key: 0,
                level: e.level,
                "nav-item": o.value,
                "is-section-page": !0
              }, null, 8, ["level", "nav-item"])) : r.value !== null ? (f(), F(Tt, {
                key: 1,
                level: e.level,
                "nav-item": r.value,
                "is-section-page": !0
              }, null, 8, ["level", "nav-item"])) : A("", !0),
              O("div", cf, [
                e.activeParent.type === "popover" && e.activeParent.filterEnabled ? (f(), C("div", df, [
                  V(v, {
                    modelValue: s.value,
                    "onUpdate:modelValue": c[0] || (c[0] = (h) => s.value = h),
                    type: "search",
                    "prefix-icon": "search",
                    placeholder: e.activeParent.filterPlaceholder
                  }, null, 8, ["modelValue", "placeholder"]),
                  e.activeParent.filterNoResultsLabel && i.value && i.value.length === 0 ? (f(), F(Q, {
                    key: 0,
                    class: "ds-nav-popover__no-results",
                    "html-element": "div",
                    "text-type": "label-sm"
                  }, {
                    default: H(() => [
                      G(q(e.activeParent.filterNoResultsLabel), 1)
                    ]),
                    _: 1
                  })) : A("", !0)
                ])) : A("", !0),
                (f(!0), C(le, null, ve(i.value, (h) => (f(), F(Tt, {
                  key: h.text,
                  level: e.level,
                  "nav-item": h
                }, null, 8, ["level", "nav-item"]))), 128))
              ]),
              "cards" in e.activeParent ? (f(), C("div", ff, [
                (f(!0), C(le, null, ve(e.activeParent.cards?.slice(0, 2), (h) => (f(), F(Vn, ke({ ref_for: !0 }, h, {
                  key: h.title
                }), null, 16))), 128))
              ])) : A("", !0)
            ], 8, uf)) : A("", !0)
          ], 2)) : A("", !0)
        ]),
        _: 1
      });
    };
  }
}), mf = {
  key: 0,
  class: "ds-nav-mobile-service"
}, vf = /* @__PURE__ */ j({
  __name: "ds-nav-mobile-service",
  setup(e) {
    const t = J("loggedIn", !1), n = J("countrySelector"), a = J("ctaButtons"), r = J("serviceNavItems", []), s = a && a.myAccountButtonNavItem ? {
      ...a.myAccountButtonNavItem,
      type: "service"
    } : null, i = x(
      () => {
        if (n && "countryList" in n && "headline" in n)
          return {
            iconName: "globe",
            itemId: "select-country",
            children: n?.countryList?.map(
              (l, o) => ({
                itemId: l.language || `country-${o}`,
                linkUrl: l.url,
                text: l.name,
                type: "service"
              })
            ),
            text: n?.headline,
            type: "service"
          };
      }
    );
    return (l, o) => D(t) || D(r) && D(r)?.length || i.value ? (f(), C("div", mf, [
      D(t) && D(a) && D(s) ? (f(), F(Tt, {
        key: 0,
        level: 0,
        "nav-item": D(s)
      }, null, 8, ["nav-item"])) : A("", !0),
      i.value ? (f(), F(Tt, {
        key: 1,
        level: 0,
        "nav-item": i.value
      }, null, 8, ["nav-item"])) : A("", !0),
      (f(!0), C(le, null, ve(D(r), (u) => (f(), F(Tt, {
        key: u?.text,
        level: 0,
        "nav-item": u
      }, null, 8, ["nav-item"]))), 128))
    ])) : A("", !0);
  }
}), pf = { class: "ds-nav-mobile" }, hf = ["inert"], yf = { class: "ds-nav-mobile__nav" }, gf = { class: "ds-nav-mobile__group" }, bf = { class: "ds-nav-mobile__service" }, kf = {
  key: 0,
  class: "ds-nav-mobile__cta"
}, _f = /* @__PURE__ */ j({
  __name: "ds-nav-mobile",
  props: {
    navItems: {}
  },
  setup(e) {
    const t = E(null), n = J("mobileMenuLevel", E(0)), a = J("activeItems", E([])), r = J("ctaButtons"), s = J("loggedIn", !1), i = x(
      () => r?.loginButtonLabel || r?.logoutButtonLabel || !1
    );
    return ce(a.value, () => {
      t.value && t.value.scrollTo(0, 0);
    }), (l, o) => (f(), C("div", pf, [
      O("div", {
        ref_key: "scroll",
        ref: t,
        class: "ds-nav-mobile__scroll"
      }, [
        O("div", {
          class: Y(["ds-nav-mobile__levels", `ds-nav-mobile__levels--level${D(n)}`])
        }, [
          O("div", {
            class: "ds-nav-mobile__level ds-nav-mobile__level0",
            inert: D(n) !== 0 ? "true" : void 0
          }, [
            O("div", yf, [
              O("div", gf, [
                (f(!0), C(le, null, ve(e.navItems, (u) => (f(), F(Tt, {
                  key: u.text,
                  level: 0,
                  "nav-item": u
                }, null, 8, ["nav-item"]))), 128))
              ])
            ]),
            O("div", bf, [
              V(vf)
            ])
          ], 8, hf),
          V(ka, {
            "active-parent": D(a)[0],
            inert: D(n) !== 1 ? "true" : void 0,
            level: 1
          }, null, 8, ["active-parent", "inert"]),
          V(ka, {
            "active-parent": D(a)[1],
            inert: D(n) !== 2 ? "true" : void 0,
            level: 2
          }, null, 8, ["active-parent", "inert"]),
          V(ka, {
            "active-parent": D(a)[2],
            inert: D(n) !== 3 ? "true" : void 0,
            level: 3
          }, null, 8, ["active-parent", "inert"])
        ], 2)
      ], 512),
      i.value && D(r) ? (f(), C("div", kf, [
        V(Ws, null, {
          default: H(() => [
            !D(s) && D(r).loginButtonLabel ? (f(), F(Ce, {
              key: 0,
              "click-handler": D(r).loginButtonFn,
              href: D(r).loginButtonLink,
              variant: "primary"
            }, {
              default: H(() => [
                G(q(D(r).loginButtonLabel), 1)
              ]),
              _: 1
            }, 8, ["click-handler", "href"])) : A("", !0),
            D(s) && D(r).logoutButtonLabel ? (f(), F(Ce, {
              key: 1,
              "click-handler": D(r).logoutButtonFn,
              href: D(r).logoutButtonLink,
              variant: "secondary"
            }, {
              default: H(() => [
                G(q(D(r).logoutButtonLabel), 1)
              ]),
              _: 1
            }, 8, ["click-handler", "href"])) : A("", !0)
          ]),
          _: 1
        })
      ])) : A("", !0)
    ]));
  }
}), wf = (e, t) => e.flatMap(
  (n) => n.type === "linkList" ? [
    {
      itemId: `${t}-${n.content.categoryTitle}`,
      text: n.content.categoryTitle,
      linkUrl: void 0,
      type: "link",
      children: n.content.links.map((a) => ({
        itemId: `${t}-${a.linkText}`,
        linkUrl: a.linkUrl,
        linkIsExternal: a.linkIsExternal,
        linkTarget: a.linkTarget,
        text: a.linkText,
        type: "link"
      }))
    }
  ] : []
), $f = (e) => e?.content.cards ?? [], ti = (e) => {
  const t = wf(e.megaNavColumns, e.itemId), n = e.megaNavColumns.find(
    (r) => r.type === "titleBlock"
  ), a = e.megaNavColumns.find(
    (r) => r.type === "promo"
  );
  return {
    itemId: e.itemId,
    text: e.text,
    type: "drilldown",
    mobilePageLabel: "mobilePageLabel" in e ? e.mobilePageLabel : void 0,
    children: t,
    titleBlock: n,
    cards: $f(a)
  };
}, xf = (e) => ti(e), If = (e) => ti(e), Sf = ["aria-label"], Tf = {
  key: 0,
  class: "ds-header-mobile__nav"
}, Pf = { class: "ds-header-mobile__search" }, Cf = /* @__PURE__ */ j({
  __name: "ds-header-mobile",
  props: {
    basketCount: {},
    basketFn: {},
    countrySelector: {},
    enableBasket: { type: Boolean },
    enableSearch: { type: Boolean },
    enableSticky: { type: Boolean, default: !0 },
    inertTargetSelector: {},
    navItems: {},
    searchFn: {}
  },
  setup(e) {
    const t = e, n = J("logo", {
      href: "/",
      altText: "Coloplast",
      imageSrc: "",
      clickHandler: () => {
      }
    }), a = E(null), r = E(!1), s = E("closed"), { dynamicClasses: i, headerHeight: l } = ei(
      {
        enableSticky: t.enableSticky
      },
      a,
      E(null),
      "ds-header-mobile"
    ), o = x(() => `--header-height: ${l.value};`), u = x(() => s.value === "open" ? I?.mobileMenuButtonCloseLabel ?? "Close menu" : I?.mobileMenuButtonOpenLabel ?? "Open menu"), c = x(() => {
      const $ = [];
      s.value === "open" && $.push("ds-header-mobile--open"), s.value === "search" && $.push("ds-header-mobile--search");
      for (const S of i.value)
        $.push(S);
      return $;
    }), v = x(() => t.navItems.map(($) => {
      const S = { ...$ };
      return S.type === "mega" ? xf(S) : (S.type === "link" && S.children?.some((L) => L.type === "secondary") && (S.children = S.children.map((L) => L.type === "secondary" ? If(
        L
      ) : L)), S);
    })), h = async ($) => {
      if ($.key === "Escape" && (s.value = "closed", y(), a.value)) {
        const S = a.value.querySelector(
          ".ds-header-mobile__toggle"
        );
        S && (await Ze(), S.focus());
      }
    }, m = () => {
      s.value !== "search" ? (s.value = "search", t.searchFn && t.searchFn(!0)) : s.value === "search" && (s.value = "closed", t.searchFn && t.searchFn(!1));
    }, p = () => {
      s.value === "closed" ? s.value = "open" : (s.value === "open" || s.value === "search") && (s.value = "closed"), y();
    }, y = () => {
      _.value = 0, b.value = [];
    }, b = E([]), _ = E(0), P = ($, S = 0) => {
      b.value.length < S && $ ? b.value.push($) : b.value.pop(), _.value = S;
    }, I = J("labels", {}), k = I.mobileMenuLabel ? I.mobileMenuLabel : "Mobile menu";
    ge("navigateLevel", P), ge("mobileMenuLevel", _), ge("activeItems", b), ge("countrySelector", t.countrySelector);
    const T = () => {
      a.value?.parentElement && a.value?.parentElement?.getAttribute("data-sticky-mount") === "true" && (r.value = !0);
    }, g = ($) => {
      const S = document.querySelectorAll(
        t.inertTargetSelector
      );
      $ ? S.forEach((L) => {
        L.setAttribute("inert", "true");
      }) : S.forEach((L) => {
        L.removeAttribute("inert");
      });
    };
    return he(() => {
      T();
    }), je(() => {
      document.documentElement.classList.remove("ds-nav-open"), g(!1);
    }), ce(s, ($) => {
      $ === "open" || $ === "search" ? (document.documentElement.classList.add("ds-nav-open"), g(!0)) : (document.documentElement.classList.remove("ds-nav-open"), g(!1));
    }), ce(o, ($) => {
      r.value && a.value && a.value.parentElement && a.value.parentElement.setAttribute("style", $);
    }), ($, S) => (f(), C("header", {
      ref_key: "header",
      ref: a,
      "aria-label": D(k),
      class: Y(["ds-header-mobile", c.value]),
      style: Te(o.value),
      onKeydown: h
    }, [
      V(ef, {
        "is-top-level": _.value === 0,
        logo: D(n),
        "enable-search": e.enableSearch,
        "enable-basket": e.enableBasket,
        "basket-count": e.basketCount,
        "basket-fn": e.basketFn,
        "on-search-click": m,
        "on-toggle-click": p,
        "on-back-click": () => P(null, _.value - 1),
        labels: D(I),
        "menu-state": s.value,
        "menu-button-label": u.value
      }, null, 8, ["is-top-level", "logo", "enable-search", "enable-basket", "basket-count", "basket-fn", "on-back-click", "labels", "menu-state", "menu-button-label"]),
      s.value === "open" ? (f(), C("div", Tf, [
        V(_f, { "nav-items": v.value }, null, 8, ["nav-items"])
      ])) : A("", !0),
      we(O("div", Pf, [
        ue($.$slots, "searchMobile")
      ], 512), [
        [$e, s.value === "search"]
      ])
    ], 46, Sf));
  }
}), qb = /* @__PURE__ */ j({
  __name: "ds-header",
  props: {
    basketCount: { default: 0 },
    basketFn: {},
    ctaButtons: {},
    enableBasket: { type: Boolean, default: !0 },
    enableSearch: { type: Boolean, default: !0 },
    enableSticky: { type: Boolean, default: !0 },
    inertTargetSelector: { default: "body > main" },
    labels: {},
    logo: {},
    loggedIn: { type: Boolean, default: !1 },
    navItems: {},
    searchFn: {},
    serviceNavItems: {},
    countrySelector: {}
  },
  setup(e) {
    const t = e, n = E(!1);
    he(() => {
      n.value = !0;
    }), ge("ctaButtons", t.ctaButtons), ge("labels", t.labels), ge("loggedIn", t.loggedIn), ge("serviceNavItems", t.serviceNavItems), ge("logo", t.logo);
    const { isMobile: a } = Be();
    return (r, s) => (f(), C(le, null, [
      !D(a) && n.value ? (f(), F(Yd, {
        key: 0,
        "basket-count": e.basketCount,
        "basket-fn": e.basketFn,
        "enable-basket": e.enableBasket,
        "enable-search": e.enableSearch,
        "enable-sticky": e.enableSticky,
        "nav-items": e.navItems,
        "search-fn": e.searchFn
      }, {
        searchDesktop: H(() => [
          ue(r.$slots, "searchDesktop")
        ]),
        _: 3
      }, 8, ["basket-count", "basket-fn", "enable-basket", "enable-search", "enable-sticky", "nav-items", "search-fn"])) : A("", !0),
      D(a) && n.value ? (f(), F(Cf, {
        key: 1,
        "basket-count": e.basketCount,
        "basket-fn": e.basketFn,
        "country-selector": e.countrySelector,
        "enable-basket": e.enableBasket,
        "enable-search": e.enableSearch,
        "inert-target-selector": e.inertTargetSelector,
        "nav-items": e.navItems,
        "search-fn": e.searchFn
      }, {
        searchMobile: H(() => [
          ue(r.$slots, "searchMobile")
        ]),
        _: 3
      }, 8, ["basket-count", "basket-fn", "country-selector", "enable-basket", "enable-search", "inert-target-selector", "nav-items", "search-fn"])) : A("", !0),
      n.value ? A("", !0) : ue(r.$slots, "default", { key: 2 })
    ], 64));
  }
});
var ni = [
  "__key",
  "__init",
  "__shim",
  "__original",
  "__index",
  "__prevKey"
];
function Jt() {
  return Math.random().toString(36).substring(2, 15);
}
function Ef(e, t) {
  return [...e instanceof Set ? e : new Set(e)];
}
function ae(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function Le(e, t, n = !0, a = ["__key"]) {
  if (e === t)
    return !0;
  if (typeof t == "object" && typeof e == "object") {
    if (e instanceof Map || e instanceof Set)
      return !1;
    if (e instanceof Date && t instanceof Date)
      return e.getTime() === t.getTime();
    if (e instanceof RegExp && t instanceof RegExp)
      return Af(e, t);
    if (e === null || t === null || Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (const r of a)
      if ((r in e || r in t) && e[r] !== t[r])
        return !1;
    for (const r in e)
      if (!(r in t) || e[r] !== t[r] && !n || n && !Le(e[r], t[r], n, a))
        return !1;
    return !0;
  }
  return !1;
}
function Af(e, t) {
  return e.source === t.source && e.flags.split("").sort().join("") === t.flags.split("").sort().join("");
}
function Ge(e) {
  const t = typeof e;
  if (t === "number")
    return !1;
  if (e === void 0)
    return !0;
  if (t === "string")
    return e === "";
  if (t === "object") {
    if (e === null)
      return !0;
    for (const n in e)
      return !1;
    return !(e instanceof RegExp || e instanceof Date);
  }
  return !1;
}
function Mf(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Lf(e) {
  const t = `^${Mf(e)}$`, n = {
    MM: "(0[1-9]|1[012])",
    M: "([1-9]|1[012])",
    DD: "([012][0-9]|3[01])",
    D: "([012]?[0-9]|3[01])",
    YYYY: "\\d{4}",
    YY: "\\d{2}"
  }, a = Object.keys(n);
  return new RegExp(
    a.reduce((r, s) => r.replace(s, n[s]), t)
  );
}
function zn(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function fn(e) {
  return zn(e) || Array.isArray(e);
}
function Yt(e) {
  if (zn(e) === !1 || e.__FKNode__ || e.__POJO__ === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(zn(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1);
}
var bt = /* @__NO_SIDE_EFFECTS__ */ (e, t, n = !1, a = !1) => {
  if (t === null)
    return null;
  const r = {};
  if (typeof t == "string")
    return t;
  for (const s in e)
    if (ae(t, s) && (t[s] !== void 0 || !a)) {
      if (n && Array.isArray(e[s]) && Array.isArray(t[s])) {
        r[s] = e[s].concat(t[s]);
        continue;
      }
      if (t[s] === void 0)
        continue;
      Yt(e[s]) && Yt(t[s]) ? r[s] = /* @__PURE__ */ bt(
        e[s],
        t[s],
        n,
        a
      ) : r[s] = t[s];
    } else
      r[s] = e[s];
  for (const s in t)
    !ae(r, s) && t[s] !== void 0 && (r[s] = t[s]);
  return r;
};
function Of(e) {
  if (e[0] !== '"' && e[0] !== "'" || e[0] !== e[e.length - 1])
    return !1;
  const t = e[0];
  for (let n = 1; n < e.length; n++)
    if (e[n] === t && (n === 1 || e[n - 1] !== "\\") && n !== e.length - 1)
      return !1;
  return !0;
}
function Nf(e) {
  if (!e.length)
    return "";
  let t = "", n = "";
  for (let a = 0; a < e.length; a++) {
    const r = e.charAt(a);
    (r !== "\\" || n === "\\") && (t += r), n = r;
  }
  return t;
}
function Mt(...e) {
  return e.reduce((t, n) => {
    const { value: a, name: r, modelValue: s, config: i, plugins: l, ...o } = n;
    return Object.assign(t, o);
  }, {});
}
function Bf(e) {
  const t = [];
  let n = "", a = 0, r = "", s = "";
  for (let i = 0; i < e.length; i++) {
    const l = e.charAt(i);
    l === r && s !== "\\" ? r = "" : (l === "'" || l === '"') && !r && s !== "\\" ? r = l : l === "(" && !r ? a++ : l === ")" && !r && a--, l === "," && !r && a === 0 ? (t.push(n), n = "") : (l !== " " || r) && (n += l), s = l;
  }
  return n && t.push(n), t;
}
function zr(e, t) {
  const n = {}, a = t.filter((s) => s instanceof RegExp), r = new Set(t);
  for (const s in e)
    !r.has(s) && !a.some((i) => i.test(s)) && (n[s] = e[s]);
  return n;
}
function jr(e, t) {
  const n = {}, a = t.filter((r) => r instanceof RegExp);
  return t.forEach((r) => {
    r instanceof RegExp || (n[r] = e[r]);
  }), Object.keys(e).forEach((r) => {
    a.some((s) => s.test(r)) && (n[r] = e[r]);
  }), n;
}
function Ht(e) {
  return e.replace(
    /-([a-z0-9])/gi,
    (t, n) => n.toUpperCase()
  );
}
function ai(e) {
  return e.replace(
    /([a-z0-9])([A-Z])/g,
    (t, n, a) => n + "-" + a.toLowerCase()
  ).replace(" ", "-").toLowerCase();
}
function Aa(e, t = ni) {
  if (e !== null && typeof e == "object") {
    let n;
    if (Array.isArray(e) ? n = [...e] : Yt(e) && (n = { ...e }), n)
      return Ff(e, n, t), n;
  }
  return e;
}
function Qt(e, t = ni) {
  if (e === null || e instanceof RegExp || e instanceof Date || e instanceof Map || e instanceof Set || typeof File == "function" && e instanceof File)
    return e;
  let n;
  Array.isArray(e) ? n = e.map((a) => typeof a == "object" ? Qt(a, t) : a) : n = Object.keys(e).reduce((a, r) => (a[r] = typeof e[r] == "object" ? Qt(e[r], t) : e[r], a), {});
  for (const a of t)
    a in e && Object.defineProperty(n, a, {
      enumerable: !1,
      value: e[a]
    });
  return n;
}
function Qe(e) {
  return typeof e == "object" ? Qt(e) : e;
}
function Df(e, t) {
  if (!e || typeof e != "object")
    return null;
  const n = t.split(".");
  let a = e;
  for (const r in n) {
    const s = n[r];
    if (ae(a, s) && (a = a[s]), +r === n.length - 1)
      return a;
    if (!a || typeof a != "object")
      return null;
  }
  return null;
}
function Xe(e) {
  return e !== void 0 && e !== "false" && e !== !1 ? !0 : void 0;
}
function Xt(e) {
  return Object.isFrozen(e) ? e : Object.defineProperty(e, "__init", {
    enumerable: !1,
    value: !0
  });
}
function ur(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, " ").trim().replace(/\s+/g, "-");
}
function Ff(e, t, n) {
  for (const a of n)
    a in e && Object.defineProperty(t, a, {
      enumerable: !1,
      value: e[a]
    });
  return t;
}
function Rf(e) {
  let t = !1;
  return (...n) => {
    if (!t)
      return t = !0, queueMicrotask(() => t = !1), e(...n);
  };
}
function Hf(e) {
  if (!(e === "false" || e === !1))
    return !0;
}
function cr() {
  const e = [];
  let t = 0;
  const n = (r) => e.push(r), a = (r) => {
    const s = e[t];
    return typeof s == "function" ? s(r, (i) => (t++, a(i))) : (t = 0, r);
  };
  return n.dispatch = a, n.unshift = (r) => e.unshift(r), n.remove = (r) => {
    const s = e.indexOf(r);
    s > -1 && e.splice(s, 1);
  }, n;
}
function ri() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let n;
  const a = (r, s) => {
    if (n) {
      n.set(s.name, [r, s]);
      return;
    }
    e.has(s.name) && e.get(s.name).forEach((i) => {
      (s.origin === r || i.modifiers.includes("deep")) && i.listener(s);
    }), s.bubble && r.bubble(s);
  };
  return a.flush = () => {
    e.clear(), t.clear(), n?.clear();
  }, a.on = (r, s, i = "push") => {
    const [l, ...o] = r.split("."), u = s.receipt || Jt(), c = {
      modifiers: o,
      event: l,
      listener: s,
      receipt: u
    };
    return e.has(l) ? e.get(l)[i](c) : e.set(l, [c]), t.has(u) ? t.get(u)[i](l) : t.set(u, [l]), u;
  }, a.off = (r) => {
    t.has(r) && (t.get(r)?.forEach((s) => {
      const i = e.get(s);
      Array.isArray(i) && e.set(
        s,
        i.filter((l) => l.receipt !== r)
      );
    }), t.delete(r));
  }, a.pause = (r) => {
    n || (n = /* @__PURE__ */ new Map()), r && r.walk((s) => s._e.pause());
  }, a.play = (r) => {
    if (!n)
      return;
    const s = n;
    n = void 0, s.forEach(([i, l]) => a(i, l)), r && r.walk((i) => i._e.play());
  }, a;
}
function Vf(e, t, n, a, r = !0, s) {
  return t._e(e, {
    payload: a,
    name: n,
    bubble: r,
    origin: e,
    meta: s
  }), e;
}
function zf(e, t, n) {
  return $n(e.parent) && e.parent._e(e.parent, n), e;
}
function jf(e, t, n, a, r) {
  return t._e.on(n, a, r);
}
function qf(e, t, n) {
  return t._e.off(n), e;
}
var dr = cr();
dr((e, t) => (e.message || (e.message = `E${e.code}`), t(e)));
var fr = cr();
fr((e, t) => {
  e.message || (e.message = `W${e.code}`);
  const n = t(e);
  return console && typeof console.warn == "function" && console.warn(n.message), n;
});
function wn(e, t = {}) {
  fr.dispatch({ code: e, data: t });
}
function He(e, t = {}) {
  throw Error(dr.dispatch({ code: e, data: t }).message);
}
function ze(e, t) {
  return {
    blocking: !1,
    key: Jt(),
    meta: {},
    type: "state",
    visible: !0,
    ...e
  };
}
var qr = {
  apply: Qf,
  set: Uf,
  remove: si,
  filter: Gf,
  reduce: Yf,
  release: Jf,
  touch: Kf
};
function Wf(e = !1) {
  const t = {};
  let n, a = e, r = [];
  const s = /* @__PURE__ */ new Map();
  let i;
  const l = new Proxy(t, {
    get(...o) {
      const [u, c] = o;
      return c === "buffer" ? a : c === "_b" ? r : c === "_m" ? s : c === "_r" ? i : ae(qr, c) ? qr[c].bind(
        null,
        t,
        l,
        n
      ) : Reflect.get(...o);
    },
    set(o, u, c) {
      return u === "_n" ? (n = c, i === "__n" && ii(n, l), !0) : u === "_b" ? (r = c, !0) : u === "buffer" ? (a = c, !0) : u === "_r" ? (i = c, !0) : (He(101, n), !1);
    }
  });
  return l;
}
function Uf(e, t, n, a) {
  if (t.buffer)
    return t._b.push([[a]]), t;
  if (e[a.key] !== a) {
    if (typeof a.value == "string" && a.meta.localize !== !1) {
      const s = a.value;
      a.value = n.t(a), a.value !== s && (a.meta.locale = n.props.locale);
    }
    const r = `message-${ae(e, a.key) ? "updated" : "added"}`;
    e[a.key] = Object.freeze(
      n.hook.message.dispatch(a)
    ), n.emit(r, a);
  }
  return t;
}
function Kf(e, t) {
  for (const n in e) {
    const a = { ...e[n] };
    t.set(a);
  }
}
function si(e, t, n, a) {
  if (ae(e, a)) {
    const r = e[a];
    delete e[a], n.emit("message-removed", r);
  }
  return t.buffer === !0 && (t._b = t._b.filter((r) => (r[0] = r[0].filter((s) => s.key !== a), r[1] || r[0].length))), t;
}
function Gf(e, t, n, a, r) {
  for (const s in e) {
    const i = e[s];
    (!r || i.type === r) && !a(i) && si(e, t, n, s);
  }
}
function Yf(e, t, n, a, r) {
  for (const s in e) {
    const i = e[s];
    r = a(r, i);
  }
  return r;
}
function Qf(e, t, n, a, r) {
  if (Array.isArray(a)) {
    if (t.buffer) {
      t._b.push([a, r]);
      return;
    }
    const s = new Set(
      a.map((i) => (t.set(i), i.key))
    );
    typeof r == "string" ? t.filter(
      (i) => i.type !== r || s.has(i.key)
    ) : typeof r == "function" && t.filter((i) => !r(i) || s.has(i.key));
  } else
    for (const s in a) {
      const i = n.at(s);
      i ? i.store.apply(a[s], r) : Zf(n, t, s, a[s], r);
    }
}
function Xf(e, ...t) {
  const n = `${e.name}-set`, a = (r) => /* @__PURE__ */ ze({
    key: ur(r),
    type: "error",
    value: r,
    meta: { source: n, autoClear: !0 }
  });
  return t.filter((r) => !!r).map((r) => {
    if (typeof r == "string" && (r = [r]), Array.isArray(r))
      return r.map((s) => a(s));
    {
      const s = {};
      for (const i in r)
        Array.isArray(r[i]) ? s[i] = r[i].map(
          (l) => a(l)
        ) : s[i] = [a(r[i])];
      return s;
    }
  });
}
function Zf(e, t, n, a, r) {
  const s = t._m;
  s.has(n) || s.set(n, []), t._r || (t._r = ii(e, t)), s.get(n)?.push([a, r]);
}
function ii(e, t) {
  return e.on(
    "child.deep",
    ({ payload: n }) => {
      t._m.forEach((a, r) => {
        e.at(r) === n && (a.forEach(([s, i]) => {
          n.store.apply(s, i);
        }), t._m.delete(r));
      }), t._m.size === 0 && t._r && (e.off(t._r), t._r = void 0);
    }
  );
}
function Jf(e, t) {
  t.buffer = !1, t._b.forEach(([n, a]) => t.apply(n, a)), t._b = [];
}
function em() {
  const e = {};
  let t;
  return {
    count: (...n) => tm(t, e, ...n),
    init(n) {
      t = n, n.on("message-added.deep", Wr(e, 1)), n.on("message-removed.deep", Wr(e, -1));
    },
    merge: (n) => Ur(t, e, n),
    settled(n) {
      return ae(e, n) ? e[n].promise : Promise.resolve();
    },
    unmerge: (n) => Ur(t, e, n, !0),
    value(n) {
      return ae(e, n) ? e[n].count : 0;
    }
  };
}
function tm(e, t, n, a, r = 0) {
  if (a = nm(a || n), !ae(t, n)) {
    const s = {
      condition: a,
      count: 0,
      name: n,
      node: e,
      promise: Promise.resolve(),
      resolve: () => {
      }
      // eslint-disable-line @typescript-eslint/no-empty-function
    };
    t[n] = s, r = e.store.reduce(
      (i, l) => i + s.condition(l) * 1,
      r
    ), e.each((i) => {
      i.ledger.count(s.name, s.condition), r += i.ledger.value(s.name);
    });
  }
  return li(t[n], r).promise;
}
function nm(e) {
  return typeof e == "function" ? e : (t) => t.type === e;
}
function li(e, t) {
  const n = e.count, a = e.count + t;
  return e.count = a, n === 0 && a !== 0 ? (e.node.emit(`unsettled:${e.name}`, e.count, !1), e.promise = new Promise((r) => e.resolve = r)) : n !== 0 && a === 0 && (e.node.emit(`settled:${e.name}`, e.count, !1), e.resolve()), e.node.emit(`count:${e.name}`, e.count, !1), e;
}
function Wr(e, t) {
  return (n) => {
    for (const a in e) {
      const r = e[a];
      r.condition(n.payload) && li(r, t);
    }
  };
}
function Ur(e, t, n, a = !1) {
  const r = e;
  for (const s in t) {
    const i = t[s].condition;
    a || n.ledger.count(s, i);
    const l = n.ledger.value(s) * (a ? -1 : 1);
    if (e) {
      do
        e.ledger.count(s, i, l), e = e.parent;
      while (e);
      e = r;
    }
  }
}
var mr = /* @__PURE__ */ new Map(), An = /* @__PURE__ */ new Map(), vr = ri();
function am(e) {
  e.props.id && (mr.set(e.props.id, e), An.set(e, e.props.id), vr(e, {
    payload: e,
    name: e.props.id,
    bubble: !1,
    origin: e
  }));
}
function rm(e) {
  if (An.has(e)) {
    const t = An.get(e);
    An.delete(e), mr.delete(t), vr(e, {
      payload: null,
      name: t,
      bubble: !1,
      origin: e
    });
  }
}
function oi(e) {
  return mr.get(e);
}
function sm(e, t) {
  return vr.on(e, t);
}
function Kr(e, t, n) {
  let a = !0;
  return t in e.config._t ? a = !1 : e.emit(`config:${t}`, n, !1), t in e.props || (e.emit("prop", { prop: t, value: n }), e.emit(`prop:${t}`, n)), a;
}
function im(e, t) {
  const n = (t || document).getElementById(e);
  if (n instanceof HTMLFormElement) {
    const a = new Event("submit", { cancelable: !0, bubbles: !0 });
    n.dispatchEvent(a);
    return;
  }
  wn(151, e);
}
function lm(e) {
  const t = (n) => {
    for (const a in n.store) {
      const r = n.store[a];
      r.type === "error" || r.type === "ui" && a === "incomplete" ? n.store.remove(a) : r.type === "state" && n.store.set({ ...r, value: !1 });
    }
  };
  t(e), e.walk(t);
}
function om(e, t) {
  const n = typeof e == "string" ? oi(e) : e;
  if (n) {
    const a = (i) => {
      const l = Qe(i.props.initial);
      return l !== void 0 ? l : i.type === "group" ? {} : i.type === "list" ? [] : void 0;
    };
    n._e.pause(n);
    const r = Qe(t);
    return t && !Ge(t) && (n.props.initial = fn(r) ? Xt(r) : r, n.props._init = n.props.initial), n.input(a(n), !1), n.walk((i) => {
      i.type === "list" && i.sync || i.input(a(i), !1);
    }), n.input(
      Ge(r) && r ? r : a(n),
      !1
    ), n.type !== "input" && t && !Ge(t) && fn(t) && n.walk((i) => {
      i.props.initial = fn(i.value) ? Xt(i.value) : i.value, i.props._init = i.props.initial;
    }), n._e.play(n), lm(n), n.emit("reset", n), n;
  }
  wn(152, e);
}
var um = {
  delimiter: ".",
  delay: 0,
  locale: "en",
  rootClasses: (e) => ({ [`formkit-${ai(e)}`]: !0 })
}, ui = Symbol("index"), Ma = Symbol("removed"), La = Symbol("moved"), ci = Symbol("inserted");
function cm(e) {
  return e.type === "list" && Array.isArray(e._value);
}
function $n(e) {
  return e && typeof e == "object" && e.__FKNode__ === !0;
}
var Mn = (e, t, n) => {
  He(102, [e, n]);
}, dm = {
  _c: me(Mm, Mn, !1),
  add: me(xm),
  addProps: me($m),
  address: me(Om, Mn, !1),
  at: me(Nm),
  bubble: me(zf),
  clearErrors: me(qm),
  calm: me(km),
  config: me(!1),
  define: me(wm),
  disturb: me(bm),
  destroy: me(_m),
  extend: me(Um),
  hydrate: me(ym),
  index: me(Am, Em, !1),
  input: me(mi),
  each: me(Tm),
  emit: me(Vf),
  find: me(Dm),
  on: me(jf),
  off: me(qf),
  parent: me(!1, Im),
  plugins: me(!1),
  remove: me(Sm),
  root: me(Rm, Mn, !1),
  reset: me(zm),
  resetConfig: me(Cm),
  setErrors: me(jm),
  submit: me(Vm),
  t: me(Hm),
  use: me(pr),
  name: me(Lm, !1, !1),
  walk: me(Pm)
};
function fm() {
  return new Map(Object.entries(dm));
}
function me(e, t, n = !0) {
  return {
    get: e ? (a, r) => n ? (...s) => e(a, r, ...s) : e(a, r) : !1,
    set: t !== void 0 ? t : Mn.bind(null)
  };
}
function mm() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(e, {
    get(t, n) {
      return e.has(n) || e.set(n, cr()), e.get(n);
    }
  });
}
var di = 0, vm = 0;
function pm(e) {
  return e.parent?.type === "list" ? ui : e.name || `${e.props?.type || "input"}_${++di}`;
}
function fi(e) {
  return e.type === "group" ? Xt(
    e.value && typeof e.value == "object" && !Array.isArray(e.value) ? e.value : {}
  ) : e.type === "list" ? Xt(Array.isArray(e.value) ? e.value : []) : e.value;
}
function mi(e, t, n, a = !0) {
  return t._value = hm(e, e.hook.input.dispatch(n)), e.emit("input", t._value), e.isCreated && e.type === "input" && Le(t._value, t.value) && !e.props.mergeStrategy ? (e.emit("commitRaw", t.value), t.settled) : (t.isSettled && e.disturb(), a ? (t._tmo && clearTimeout(t._tmo), t._tmo = setTimeout(
    jn,
    e.props.delay,
    e,
    t
  )) : jn(e, t), t.settled);
}
function hm(e, t) {
  switch (e.type) {
    case "input":
      break;
    case "group":
      (!t || typeof t != "object") && He(107, [e, t]);
      break;
    case "list":
      Array.isArray(t) || He(108, [e, t]);
      break;
  }
  return t;
}
function jn(e, t, n = !0, a = !0) {
  t._value = t.value = e.hook.commit.dispatch(t._value), e.type !== "input" && a && e.hydrate(), e.emit("commitRaw", t.value), e.emit("commit", t.value), n && e.calm();
}
function vi(e, { name: t, value: n, from: a }) {
  if (!Object.isFrozen(e._value)) {
    if (cm(e)) {
      const r = n === Ma ? [] : n === La && typeof a == "number" ? e._value.splice(a, 1) : [n];
      e._value.splice(
        t,
        n === La || a === ci ? 0 : 1,
        ...r
      );
      return;
    }
    n !== Ma ? e._value[t] = n : delete e._value[t];
  }
}
function ym(e, t) {
  const n = t._value;
  return e.type === "list" && e.sync && gm(e, t), t.children.forEach((a) => {
    if (typeof n == "object")
      if (a.name in n) {
        const r = a.type !== "input" || n[a.name] && typeof n[a.name] == "object" ? Xt(n[a.name]) : n[a.name];
        if (!a.isSettled || (!fn(r) || a.props.mergeStrategy) && Le(r, a._value))
          return;
        a.input(r, !1);
      } else
        (e.type !== "list" || typeof a.name == "number") && vi(t, { name: a.name, value: a.value }), n.__init || (a.type === "group" ? a.input({}, !1) : a.type === "list" ? a.input([], !1) : a.input(void 0, !1));
  }), e;
}
function gm(e, t) {
  const n = e._value;
  if (!Array.isArray(n))
    return;
  const a = [], r = new Set(t.children), s = /* @__PURE__ */ new Map();
  n.forEach((l, o) => {
    if (t.children[o] && t.children[o]._value === l)
      a.push(t.children[o]), r.delete(t.children[o]);
    else {
      a.push(null);
      const u = s.get(l) || [];
      u.push(o), s.set(l, u);
    }
  }), r.size && s.size && r.forEach((l) => {
    if (s.has(l._value)) {
      const o = s.get(l._value), u = o.shift();
      a[u] = l, r.delete(l), o.length || s.delete(l._value);
    }
  });
  const i = [];
  for (s.forEach((l) => {
    i.push(...l);
  }); r.size && i.length; ) {
    const l = r.values().next().value, o = i.shift();
    if (o === void 0)
      break;
    a[o] = l, r.delete(l);
  }
  i.forEach((l, o) => {
    a[l] = Qm({ value: o });
  }), r.size && r.forEach((l) => {
    if (!("__FKP" in l)) {
      const o = l._c.parent;
      if (!o || Xm(o))
        return;
      o.ledger.unmerge(l), l._c.parent = null, l.destroy();
    }
  }), t.children = a;
}
function bm(e, t) {
  return t._d <= 0 && (t.isSettled = !1, e.emit("settled", !1, !1), t.settled = new Promise((n) => {
    t._resolve = n;
  }), e.parent && e.parent?.disturb()), t._d++, e;
}
function km(e, t, n) {
  if (n !== void 0 && e.type !== "input") {
    vi(t, n);
    const a = !!(e.config.mergeStrategy && e.config.mergeStrategy[n.name]);
    return jn(e, t, !0, a);
  }
  t._d > 0 && t._d--, t._d === 0 && (t.isSettled = !0, e.emit("settled", !0, !1), e.parent && e.parent?.calm({ name: e.name, value: t.value }), t._resolve && t._resolve(t.value));
}
function _m(e, t) {
  e.emit("destroying", e), e.store.filter(() => !1), e.parent && e.parent.remove(e), rm(e), e.emit("destroyed", e), t._e.flush(), t._value = t.value = void 0;
  for (const n in t.context)
    delete t.context[n];
  t.plugins.clear(), t.context = null;
}
function wm(e, t, n) {
  t.type = n.type;
  const a = Qt(n);
  e.props.__propDefs = pi(
    e.props.__propDefs ?? [],
    a?.props || []
  ), a.props = e.props.__propDefs, t.props.definition = a, t.value = t._value = fi({
    type: e.type,
    value: t.value
  }), n.forceTypeProp && (e.props.type && (e.props.originalType = e.props.type), t.props.type = n.forceTypeProp), n.family && (t.props.family = n.family), n.features && n.features.forEach((r) => r(e)), n.props && e.addProps(n.props), e.emit("defined", n);
}
function $m(e, t, n) {
  const a = Array.isArray(n) ? n : Object.keys(n), r = Array.isArray(n) ? {} : a.reduce((i, l) => ("default" in n[l] && (i[l] = n[l].default), i), {});
  if (e.props.attrs) {
    const i = { ...e.props.attrs };
    e.props._emit = !1;
    for (const o in i) {
      const u = Ht(o);
      a.includes(u) && (e.props[u] = i[o], delete i[o]);
    }
    Array.isArray(n) || a.forEach((o) => {
      "default" in n[o] && e.props[o] === void 0 && (e.props[o] = r[o]);
    });
    const l = Qe(t._value);
    e.props.initial = e.type !== "input" ? Xt(l) : l, e.props._emit = !0, e.props.attrs = i;
  }
  const s = pi(e.props.__propDefs ?? [], n);
  return e.props.definition && (e.props.definition.props = s), e.props.__propDefs = s, e.emit("added-props", n), e;
}
function Oa(e) {
  return Array.isArray(e) ? e.reduce((t, n) => (t[n] = {}, t), {}) : e;
}
function pi(e, t) {
  return Array.isArray(e) && Array.isArray(t) ? e.concat(t) : bt(Oa(e), Oa(t));
}
function xm(e, t, n, a) {
  if (e.type === "input" && He(100, e), n.parent && n.parent !== e && n.parent.remove(n), !t.children.includes(n)) {
    if (a !== void 0 && e.type === "list") {
      const r = t.children[a];
      r && "__FKP" in r ? (n._c.uid = r.uid, t.children.splice(a, 1, n)) : t.children.splice(a, 0, n), Array.isArray(e.value) && e.value.length < t.children.length && e.disturb().calm({
        name: a,
        value: n.value,
        from: ci
      });
    } else
      t.children.push(n);
    n.isSettled || e.disturb();
  }
  if (n.parent !== e) {
    if (n.parent = e, n.parent !== e)
      return e.remove(n), n.parent.add(n), e;
  } else
    n.use(e.plugins);
  return jn(e, t, !1), e.ledger.merge(n), e.emit("child", n), e;
}
function Im(e, t, n, a) {
  return $n(a) ? (e.parent && e.parent !== a && e.parent.remove(e), t.parent = a, e.resetConfig(), a.children.includes(e) ? e.use(a.plugins) : a.add(e), !0) : a === null ? (t.parent = null, !0) : !1;
}
function Sm(e, t, n) {
  const a = t.children.indexOf(n);
  if (a !== -1) {
    n.isSettled && e.disturb(), t.children.splice(a, 1);
    let r = Xe(n.props.preserve), s = n.parent;
    for (; r === void 0 && s; )
      r = Xe(s.props.preserve), s = s.parent;
    r ? e.calm() : e.calm({
      name: e.type === "list" ? a : n.name,
      value: Ma
    }), n.parent = null, n.config._rmn = n;
  }
  return e.ledger.unmerge(n), e.emit("childRemoved", n), e;
}
function Tm(e, t, n) {
  t.children.forEach((a) => !("__FKP" in a) && n(a));
}
function Pm(e, t, n, a = !1, r = !1) {
  t.children.some((s) => {
    if ("__FKP" in s)
      return !1;
    const i = n(s);
    return a && i === !1 ? !0 : r && i === !1 ? !1 : s.walk(n, a, r);
  });
}
function Cm(e, t) {
  const n = e.parent || void 0;
  t.config = hi(e.config._t, n), e.walk((a) => a.resetConfig());
}
function pr(e, t, n, a = !0, r = !0) {
  return Array.isArray(n) || n instanceof Set ? (n.forEach((s) => pr(e, t, s)), e) : (t.plugins.has(n) || (r && typeof n.library == "function" && n.library(e), a && n(e) !== !1 && (t.plugins.add(n), e.children.forEach((s) => s.use(n)))), e);
}
function Em(e, t, n, a) {
  if ($n(e.parent)) {
    const r = e.parent.children, s = a >= r.length ? r.length - 1 : a < 0 ? 0 : a, i = r.indexOf(e);
    return i === -1 ? !1 : (r.splice(i, 1), r.splice(s, 0, e), e.parent.children = r, e.parent.type === "list" && e.parent.disturb().calm({ name: s, value: La, from: i }), !0);
  }
  return !1;
}
function Am(e) {
  if (e.parent) {
    const t = [...e.parent.children].indexOf(e);
    return t === -1 ? e.parent.children.length : t;
  }
  return -1;
}
function Mm(e, t) {
  return t;
}
function Lm(e, t) {
  return e.parent?.type === "list" ? e.index : t.name !== ui ? t.name : e.index;
}
function Om(e, t) {
  return t.parent ? t.parent.address.concat([e.name]) : [e.name];
}
function Nm(e, t, n) {
  const a = typeof n == "string" ? n.split(e.config.delimiter) : n;
  if (!a.length)
    return;
  const r = a[0];
  let s = e.parent;
  for (s || (String(a[0]) === String(e.name) && a.shift(), s = e), r === "$parent" && a.shift(); s && a.length; ) {
    const i = a.shift();
    switch (i) {
      case "$root":
        s = e.root;
        break;
      case "$parent":
        s = s.parent;
        break;
      case "$self":
        s = e;
        break;
      default:
        s = s.children.find(
          (l) => !("__FKP" in l) && String(l.name) === String(i)
        ) || Bm(s, i);
    }
  }
  return s || void 0;
}
function Bm(e, t) {
  const n = String(t).match(/^(find)\((.*)\)$/);
  if (n) {
    const [, a, r] = n, s = r.split(",").map((i) => i.trim());
    switch (a) {
      case "find":
        return e.find(s[0], s[1]);
      default:
        return;
    }
  }
}
function Dm(e, t, n, a) {
  return Fm(e, n, a);
}
function Fm(e, t, n = "name") {
  const a = typeof n == "string" ? (s) => s[n] == t : n, r = [e];
  for (; r.length; ) {
    const s = r.shift();
    if (!("__FKP" in s)) {
      if (a(s, t))
        return s;
      r.push(...s.children);
    }
  }
}
function Rm(e) {
  let t = e;
  for (; t.parent; )
    t = t.parent;
  return t;
}
function hi(e = {}, t) {
  let n;
  return new Proxy(e, {
    get(...a) {
      const r = a[1];
      if (r === "_t")
        return e;
      const s = Reflect.get(...a);
      if (s !== void 0)
        return s;
      if (t) {
        const i = t.config[r];
        if (i !== void 0)
          return i;
      }
      if (e.rootConfig && typeof r == "string") {
        const i = e.rootConfig[r];
        if (i !== void 0)
          return i;
      }
      return r === "delay" && n?.type === "input" ? 20 : um[r];
    },
    set(...a) {
      const r = a[1], s = a[2];
      if (r === "_n")
        return n = s, e.rootConfig && e.rootConfig._add(n), !0;
      if (r === "_rmn")
        return e.rootConfig && e.rootConfig._rm(n), n = void 0, !0;
      if (!Le(e[r], s, !1)) {
        const i = Reflect.set(...a);
        return n && (n.emit(`config:${r}`, s, !1), Kr(n, r, s), n.walk((l) => Kr(l, r, s), !1, !0)), i;
      }
      return !0;
    }
  });
}
function Hm(e, t, n, a = "ui") {
  const r = typeof n == "string" ? { key: n, value: n, type: a } : n, s = e.hook.text.dispatch(r);
  return e.emit("text", s, !1), s.value;
}
function Vm(e) {
  const t = e.name;
  do {
    if (e.props.isForm === !0)
      break;
    e.parent || He(106, t), e = e.parent;
  } while (e);
  e.props.id && im(e.props.id, e.props.__root);
}
function zm(e, t, n) {
  return om(e, n);
}
function jm(e, t, n, a) {
  const r = `${e.name}-set`, s = e.hook.setErrors.dispatch({ localErrors: n, childErrors: a });
  return Xf(e, s.localErrors, s.childErrors).forEach(
    (i) => {
      e.store.apply(i, (l) => l.meta.source === r);
    }
  ), e;
}
function qm(e, t, n = !0, a) {
  return e.store.filter((r) => !(a === void 0 || r.meta.source === a), "error"), n && (a = a || `${e.name}-set`, e.walk((r) => {
    r.store.filter((s) => !(s.type === "error" && s.meta && s.meta.source === a));
  })), e;
}
function Wm(e) {
  const t = {
    initial: typeof e == "object" ? Qe(e) : e
  };
  let n, a = !0, r = {};
  return new Proxy(t, {
    get(...s) {
      const [i, l] = s;
      let o;
      ae(t, l) ? (o = Reflect.get(...s), r[l]?.boolean && (o = Hf(o))) : n && typeof l == "string" && n.config[l] !== void 0 ? (o = n.config[l], l === "mergeStrategy" && n?.type === "input" && zn(o) && n.name in o && (o = o[n.name])) : o = r[l]?.default;
      const u = r[l]?.getter;
      return r[l]?.boolean && (o = !!o), u ? u(o, n) : o;
    },
    set(s, i, l, o) {
      if (i === "_n")
        return n = l, !0;
      if (i === "_emit")
        return a = l, !0;
      let { prop: u, value: c } = n.hook.prop.dispatch({
        prop: i,
        value: l
      });
      const v = r[u]?.setter;
      if (c = v ? v(c, n) : c, !Le(t[u], c, !1) || typeof c == "object") {
        const h = Reflect.set(s, u, c, o);
        return u === "__propDefs" && (r = Oa(c)), a && (n.emit("prop", { prop: u, value: c }), typeof u == "string" && n.emit(`prop:${u}`, c)), h;
      }
      return !0;
    }
  });
}
function Um(e, t, n, a) {
  return t.traps.set(n, a), e;
}
function Km(e, t) {
  if (e.props.definition)
    return e.define(e.props.definition);
  for (const n of t) {
    if (e.props.definition)
      return;
    typeof n.library == "function" && n.library(e);
  }
}
function Gm(e) {
  const t = fi(e), n = hi(e.config || {}, e.parent);
  return {
    _d: 0,
    _e: ri(),
    uid: Symbol(),
    _resolve: !1,
    _tmo: !1,
    _value: t,
    children: Ef(e.children || []),
    config: n,
    hook: mm(),
    isCreated: !1,
    isSettled: !0,
    ledger: em(),
    name: pm(e),
    parent: e.parent || null,
    plugins: /* @__PURE__ */ new Set(),
    props: Wm(t),
    settled: Promise.resolve(t),
    store: Wf(!0),
    sync: e.sync || !1,
    traps: fm(),
    type: e.type || "input",
    value: t
  };
}
function Ym(e, t) {
  const n = t.props?.id;
  if (n || delete t.props?.id, e.ledger.init(e.store._n = e.props._n = e.config._n = e), e.props._emit = !1, Object.assign(
    e.props,
    n ? {} : { id: `input_${vm++}` },
    t.props ?? {}
  ), e.props._emit = !0, Km(
    e,
    /* @__PURE__ */ new Set([
      ...t.plugins || [],
      ...e.parent ? e.parent.plugins : []
    ])
  ), t.plugins)
    for (const a of t.plugins)
      pr(e, e._c, a, !0, !1);
  return e.each((a) => e.add(a)), e.parent && e.parent.add(e, t.index), e.type === "input" && e.children.length && He(100, e), mi(e, e._c, e._value, !1), e.store.release(), n && am(e), e.emit("created", e), e.isCreated = !0, e;
}
function Qm(e) {
  return {
    __FKP: !0,
    uid: Symbol(),
    name: e?.name ?? `p_${di++}`,
    value: e?.value ?? null,
    _value: e?.value ?? null,
    type: e?.type ?? "input",
    props: {},
    use: () => {
    },
    input(t) {
      return this._value = t, this.value = t, Promise.resolve();
    },
    isSettled: !0
  };
}
function Xm(e) {
  return "__FKP" in e;
}
function Zm(e) {
  const t = e || {}, n = Gm(t), a = new Proxy(n, {
    get(...r) {
      const [, s] = r;
      if (s === "__FKNode__")
        return !0;
      const i = n.traps.get(s);
      return i && i.get ? i.get(a, n) : Reflect.get(...r);
    },
    set(...r) {
      const [, s, i] = r, l = n.traps.get(s);
      return l && l.set ? l.set(a, n, s, i) : Reflect.set(...r);
    }
  });
  return Ym(a, t);
}
function Na(e) {
  return typeof e != "string" && ae(e, "$el");
}
function Ba(e) {
  return typeof e != "string" && ae(e, "$cmp");
}
function Bt(e) {
  return !e || typeof e == "string" ? !1 : ae(e, "if") && ae(e, "then");
}
function Jm(e) {
  return typeof e != "string" && "$formkit" in e;
}
function ev(e) {
  if (typeof e == "string")
    return {
      $el: "text",
      children: e
    };
  if (Jm(e)) {
    const {
      $formkit: t,
      for: n,
      if: a,
      children: r,
      bind: s,
      ...i
    } = e;
    return Object.assign(
      {
        $cmp: "FormKit",
        props: { ...i, type: t }
      },
      a ? { if: a } : {},
      n ? { for: n } : {},
      r ? { children: r } : {},
      s ? { bind: s } : {}
    );
  }
  return e;
}
function Ye(e) {
  let t;
  const n = /* @__PURE__ */ new Set(), a = function(b, _) {
    return typeof b == "function" ? b(_) : b;
  }, r = [
    {
      "&&": (y, b, _) => a(y, _) && a(b, _),
      "||": (y, b, _) => a(y, _) || a(b, _)
    },
    {
      "===": (y, b, _) => a(y, _) === a(b, _),
      "!==": (y, b, _) => a(y, _) !== a(b, _),
      "==": (y, b, _) => a(y, _) == a(b, _),
      "!=": (y, b, _) => a(y, _) != a(b, _),
      ">=": (y, b, _) => a(y, _) >= a(b, _),
      "<=": (y, b, _) => a(y, _) <= a(b, _),
      ">": (y, b, _) => a(y, _) > a(b, _),
      "<": (y, b, _) => a(y, _) < a(b, _)
    },
    {
      "+": (y, b, _) => a(y, _) + a(b, _),
      "-": (y, b, _) => a(y, _) - a(b, _)
    },
    {
      "*": (y, b, _) => a(y, _) * a(b, _),
      "/": (y, b, _) => a(y, _) / a(b, _),
      "%": (y, b, _) => a(y, _) % a(b, _)
    }
  ], s = r.reduce((y, b) => y.concat(Object.keys(b)), []), i = new Set(s.map((y) => y.charAt(0)));
  function l(y, b, _, P) {
    const I = y.filter((k) => k.startsWith(b));
    return I.length ? I.find((k) => P.length >= _ + k.length && P.substring(_, _ + k.length) === k ? k : !1) : !1;
  }
  function o(y, b, _ = 1) {
    let P = _ ? b.substring(y + 1).trim() : b.substring(0, y).trim();
    if (!P.length)
      return -1;
    if (!_) {
      const k = P.split("").reverse(), T = k.findIndex((g) => i.has(g));
      P = k.slice(T).join("");
    }
    const I = P[0];
    return r.findIndex((k) => {
      const T = Object.keys(k);
      return !!l(T, I, 0, P);
    });
  }
  function u(y, b) {
    let _ = "";
    const P = b.length;
    let I = 0;
    for (let k = y; k < P; k++) {
      const T = b.charAt(k);
      if (T === "(")
        I++;
      else if (T === ")")
        I--;
      else if (I === 0 && T === " ")
        continue;
      if (I === 0 && l(s, T, k, b))
        return [_, k - 1];
      _ += T;
    }
    return [_, b.length - 1];
  }
  function c(y, b = 0) {
    const _ = r[b], P = y.length, I = Object.keys(_);
    let k = 0, T = !1, g = null, $ = "", S = null, L, B = "", N = "", d = "", w = "", M = 0;
    const z = (R, W) => {
      R ? d += W : $ += W;
    };
    for (let R = 0; R < P; R++)
      if (B = N, N = y.charAt(R), (N === "'" || N === '"') && B !== "\\" && (k === 0 && !T || k && !w)) {
        k ? w = N : T = N, z(k, N);
        continue;
      } else if (T && (N !== T || B === "\\") || w && (N !== w || B === "\\")) {
        z(k, N);
        continue;
      } else if (T === N) {
        T = !1, z(k, N);
        continue;
      } else if (w === N) {
        w = !1, z(k, N);
        continue;
      } else {
        if (N === " ")
          continue;
        if (N === "(")
          k === 0 ? M = R : d += N, k++;
        else if (N === ")")
          if (k--, k === 0) {
            const W = typeof $ == "string" && $.startsWith("$") ? $ : void 0, re = W && y.charAt(R + 1) === ".";
            let K = "";
            re && ([K, R] = u(R + 2, y));
            const ee = g ? b : o(M, y, 0), oe = o(R, y);
            ee === -1 && oe === -1 ? ($ = v(d, -1, W, K), typeof $ == "string" && ($ = d)) : g && (ee >= oe || oe === -1) && b === ee ? (S = g.bind(null, v(d, -1, W, K)), g = null, $ = "") : oe > ee && b === oe ? $ = v(d, -1, W, K) : $ += `(${d})${re ? `.${K}` : ""}`, d = "";
          } else
            d += N;
        else if (k === 0 && (L = l(I, N, R, y))) {
          R === 0 && He(103, [L, y]), R += L.length - 1, R === y.length - 1 && He(104, [L, y]), g ? $ && (S = g.bind(null, v($, b)), g = _[L].bind(null, S), $ = "") : S ? (g = _[L].bind(null, v(S, b)), S = null) : (g = _[L].bind(null, v($, b)), $ = "");
          continue;
        } else
          z(k, N);
      }
    return $ && g && (g = g.bind(null, v($, b))), g = !g && S ? S : g, !g && $ && (g = (R, W) => typeof R == "function" ? R(W) : R, g = g.bind(null, v($, b))), !g && !$ && He(105, y), g;
  }
  function v(y, b, _, P) {
    if (_) {
      const I = v(_, r.length);
      let k, T = P ? Ye(`$${P}`) : !1;
      if (typeof I == "function") {
        const g = Bf(String(y)).map(
          ($) => v($, -1)
        );
        return ($) => {
          const S = I($);
          return typeof S != "function" ? (wn(150, _), S) : (k = S(
            ...g.map(
              (L) => typeof L == "function" ? L($) : L
            )
          ), T && (T = T.provide((L) => {
            const B = t(L);
            return L.reduce(
              (d, w) => {
                if (w === P || P?.startsWith(`${w}(`)) {
                  const z = Df(k, w);
                  d[w] = () => z;
                } else
                  d[w] = B[w];
                return d;
              },
              {}
            );
          })), T ? T() : k);
        };
      }
    } else if (typeof y == "string") {
      if (y === "true")
        return !0;
      if (y === "false")
        return !1;
      if (y === "undefined")
        return;
      if (Of(y))
        return Nf(y.substring(1, y.length - 1));
      if (!isNaN(+y))
        return Number(y);
      if (b < r.length - 1)
        return c(y, b + 1);
      if (y.startsWith("$")) {
        const I = y.substring(1);
        return n.add(I), function(T) {
          return I in T ? T[I]() : void 0;
        };
      }
      return y;
    }
    return y;
  }
  const h = c(
    e.startsWith("$:") ? e.substring(2) : e
  ), m = Array.from(n);
  function p(y) {
    return t = y, Object.assign(
      // @ts-ignore - @rollup/plugin-typescript doesn't like this
      h.bind(null, y(m)),
      { provide: p }
    );
  }
  return Object.assign(h, {
    provide: p
  });
}
function Ln(e, t, n) {
  return n ? typeof n == "string" ? n.split(" ").reduce(
    (r, s) => Object.assign(r, { [s]: !0 }),
    {}
  ) : typeof n == "function" ? Ln(
    e,
    t,
    n(t, e)
  ) : n : {};
}
function tv(e, t, ...n) {
  const a = n.reduce((r, s) => {
    if (!s)
      return _a(r);
    const { $reset: i, ...l } = s;
    return _a(i ? l : Object.assign(r, l));
  }, {});
  return Object.keys(
    e.hook.classes.dispatch({ property: t, classes: a }).classes
  ).filter((r) => a[r]).join(" ") || null;
}
function _a(e) {
  const t = "$remove:";
  let n = !1;
  const a = Object.keys(e).filter((r) => (e[r] && r.startsWith(t) && (n = !0), e[r]));
  return a.length > 1 && n && a.filter((s) => s.startsWith(t)).map((s) => {
    const i = s.substring(t.length);
    e[i] = !1, e[s] = !1;
  }), e;
}
var qn = "1.6.9", yi = /* @__PURE__ */ new WeakSet();
function sa(e, t) {
  const n = t || Object.assign(/* @__PURE__ */ new Map(), { active: !1 }), a = /* @__PURE__ */ new Map(), r = function(c) {
    n.active && (n.has(e) || n.set(e, /* @__PURE__ */ new Set()), n.get(e)?.add(c));
  }, s = function(c) {
    return new Proxy(c, {
      get(...v) {
        return typeof v[1] == "string" && r(`prop:${v[1]}`), Reflect.get(...v);
      }
    });
  }, i = function(c) {
    return new Proxy(c, {
      get(...v) {
        return v[1] === "value" ? (h) => (r(`count:${h}`), c.value(h)) : Reflect.get(...v);
      }
    });
  }, l = function(c, v) {
    return $n(c) ? sa(c, n) : (v === "value" && r("commit"), v === "_value" && r("input"), v === "props" ? s(c) : v === "ledger" ? i(c) : (v === "children" && (r("child"), r("childRemoved")), c));
  }, {
    proxy: o,
    revoke: u
  } = Proxy.revocable(e, {
    get(...c) {
      switch (c[1]) {
        case "_node":
          return e;
        case "deps":
          return n;
        case "watch":
          return (h, m, p) => ki(o, h, m, p);
        case "observe":
          return () => {
            const h = new Map(n);
            return n.clear(), n.active = !0, h;
          };
        case "stopObserve":
          return () => {
            const h = new Map(n);
            return n.active = !1, h;
          };
        case "receipts":
          return a;
        case "kill":
          return () => {
            bi(a), yi.add(c[2]), u();
          };
      }
      const v = Reflect.get(...c);
      return typeof v == "function" ? (...h) => {
        const m = v(...h);
        return l(m, c[1]);
      } : l(v, c[1]);
    }
  });
  return o;
}
function gi(e, [t, n], a, r) {
  t.forEach((s, i) => {
    s.forEach((l) => {
      e.receipts.has(i) || e.receipts.set(i, {});
      const o = e.receipts.get(i) ?? {};
      o[l] = o[l] ?? [], o[l].push(i.on(l, a, r)), e.receipts.set(i, o);
    });
  }), n.forEach((s, i) => {
    s.forEach((l) => {
      if (e.receipts.has(i)) {
        const o = e.receipts.get(i);
        o && ae(o, l) && (o[l].map(i.off), delete o[l], e.receipts.set(i, o));
      }
    });
  });
}
function bi(e) {
  e.forEach((t, n) => {
    for (const a in t)
      t[a].map(n.off);
  }), e.clear();
}
function ki(e, t, n, a) {
  const r = (l) => {
    const o = e.stopObserve();
    gi(
      e,
      _i(s, o),
      () => ki(e, t, n, a),
      a
    ), n && n(l);
  }, s = new Map(e.deps);
  e.observe();
  const i = t(e);
  i instanceof Promise ? i.then((l) => r(l)) : r(i);
}
function _i(e, t) {
  const n = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  return t.forEach((r, s) => {
    if (!e.has(s))
      n.set(s, r);
    else {
      const i = /* @__PURE__ */ new Set(), l = e.get(s);
      r.forEach(
        (o) => !l?.has(o) && i.add(o)
      ), n.set(s, i);
    }
  }), e.forEach((r, s) => {
    if (!t.has(s))
      a.set(s, r);
    else {
      const i = /* @__PURE__ */ new Set(), l = t.get(s);
      r.forEach(
        (o) => !l?.has(o) && i.add(o)
      ), a.set(s, i);
    }
  }), [n, a];
}
function hr(e) {
  return yi.has(e);
}
var wi = function({ value: t }) {
  return ["yes", "on", "1", 1, !0, "true"].includes(t);
};
wi.skipEmpty = !1;
var nv = wi, av = function({ value: e }, t = !1) {
  const n = Date.parse(t || /* @__PURE__ */ new Date()), a = Date.parse(String(e));
  return isNaN(a) ? !1 : a > n;
}, rv = av, sv = function({ value: e }, t = !1) {
  const n = Date.parse(t || /* @__PURE__ */ new Date()), a = Date.parse(String(e));
  return isNaN(a) ? !1 : a > n || a === n;
}, iv = sv, lv = function(e, t) {
  if (!t)
    return !1;
  const n = Date.parse(String(e.value)), a = Date.parse(String(e.at(t)?.value));
  return isNaN(a) ? !0 : isNaN(n) ? !1 : n > a;
}, ov = lv, uv = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("^\\p{L}+$", "u"),
    latin: /^[a-z]+$/i
  }, a = ae(n, t) ? t : "default";
  return n[a].test(String(e));
}, cv = uv, dv = function({ value: e }, t = "default") {
  const n = {
    default: /^[\p{L} ]+$/u,
    latin: /^[a-z ]+$/i
  }, a = ae(n, t) ? t : "default";
  return n[a].test(String(e));
}, fv = dv, mv = function({ value: e }, t = "default") {
  const n = {
    default: /^[0-9\p{L}]+$/u,
    latin: /^[0-9a-z]+$/i
  }, a = ae(n, t) ? t : "default";
  return n[a].test(String(e));
}, vv = mv, pv = function({ value: e }, t = !1) {
  const n = Date.parse(t || /* @__PURE__ */ new Date()), a = Date.parse(String(e));
  return isNaN(a) ? !1 : a < n;
}, hv = pv, yv = function(e, t) {
  if (!t)
    return !1;
  const n = Date.parse(String(e.value)), a = Date.parse(String(e.at(t)?.value));
  return isNaN(a) ? !0 : isNaN(n) ? !1 : n < a;
}, gv = yv, bv = function({ value: e }, t = !1) {
  const n = Date.parse(t || /* @__PURE__ */ new Date()), a = Date.parse(String(e));
  return isNaN(a) ? !1 : a < n || a === n;
}, kv = bv, _v = function({ value: t }, n, a) {
  if (!isNaN(t) && !isNaN(n) && !isNaN(a)) {
    const r = 1 * t;
    n = Number(n), a = Number(a);
    const [s, i] = n <= a ? [n, a] : [a, n];
    return r >= 1 * s && r <= 1 * i;
  }
  return !1;
}, wv = _v, Gr = /(_confirm(?:ed)?)$/, $v = function(t, n, a = "loose") {
  n || (n = Gr.test(t.name) ? t.name.replace(Gr, "") : `${t.name}_confirm`);
  const r = t.at(n)?.value;
  return a === "strict" ? t.value === r : t.value == r;
}, xv = $v, Iv = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("\\p{L}", "u"),
    latin: /[a-z]/i
  }, a = ae(n, t) ? t : "default";
  return n[a].test(String(e));
}, Sv = Iv, Tv = function({ value: e }, t = "default") {
  const n = {
    default: /[\p{L} ]/u,
    latin: /[a-z ]/i
  }, a = ae(n, t) ? t : "default";
  return n[a].test(String(e));
}, Pv = Tv, Cv = function({ value: e }, t = "default") {
  const n = {
    default: /[0-9\p{L}]/u,
    latin: /[0-9a-z]/i
  }, a = ae(n, t) ? t : "default";
  return n[a].test(String(e));
}, Ev = Cv, Av = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("\\p{Ll}", "u"),
    latin: /[a-z]/
  }, a = ae(n, t) ? t : "default";
  return n[a].test(String(e));
}, Mv = Av, Lv = function({ value: t }) {
  return /[0-9]/.test(String(t));
}, Ov = Lv, Nv = function({ value: e }) {
  return /[!-/:-@[-`{-~]/.test(String(e));
}, Bv = Nv, Dv = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("\\p{Lu}", "u"),
    latin: /[A-Z]/
  }, a = ae(n, t) ? t : "default";
  return n[a].test(String(e));
}, Fv = Dv, Rv = function({ value: t }, n, a) {
  n = n instanceof Date ? n.getTime() : Date.parse(n), a = a instanceof Date ? a.getTime() : Date.parse(a);
  const r = t instanceof Date ? t.getTime() : Date.parse(String(t));
  if (n && !a)
    a = n, n = Date.now();
  else if (!n || !r)
    return !1;
  return r >= n && r <= a;
}, Hv = Rv, Vv = function({ value: t }, n) {
  return n && typeof n == "string" ? Lf(n).test(String(t)) : !isNaN(Date.parse(String(t)));
}, zv = Vv, jv = function({ value: t }) {
  return /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(String(t));
}, qv = jv, Wv = function({ value: t }, ...n) {
  return typeof t == "string" && n.length ? n.some((a) => t.endsWith(a)) : typeof t == "string" && n.length === 0;
}, Uv = Wv, Kv = function({ value: t }, ...n) {
  return n.some((a) => typeof a == "object" ? Le(a, t) : a == t);
}, Gv = Kv, Yv = function({ value: t }, n = 0, a = 1 / 0) {
  n = parseInt(n), a = isNaN(parseInt(a)) ? 1 / 0 : parseInt(a);
  const r = n <= a ? n : a, s = a >= n ? a : n;
  if (typeof t == "string" || Array.isArray(t))
    return t.length >= r && t.length <= s;
  if (t && typeof t == "object") {
    const i = Object.keys(t).length;
    return i >= r && i <= s;
  }
  return !1;
}, Qv = Yv, Xv = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("^\\p{Ll}+$", "u"),
    allow_non_alpha: /^[0-9\p{Ll}!-/:-@[-`{-~]+$/u,
    allow_numeric: /^[0-9\p{Ll}]+$/u,
    allow_numeric_dashes: /^[0-9\p{Ll}-]+$/u,
    latin: /^[a-z]+$/
  }, a = ae(n, t) ? t : "default";
  return n[a].test(String(e));
}, Zv = Xv, Jv = function({ value: t }, ...n) {
  return n.some((a) => (typeof a == "string" && a.substr(0, 1) === "/" && a.substr(-1) === "/" && (a = new RegExp(a.substr(1, a.length - 2))), a instanceof RegExp ? a.test(String(t)) : a === t));
}, ep = Jv, tp = function({ value: t }, n = 10) {
  return Array.isArray(t) ? t.length <= n : Number(t) <= Number(n);
}, np = tp, ap = function({ value: t }, n = 1) {
  return Array.isArray(t) ? t.length >= n : Number(t) >= Number(n);
}, rp = ap, sp = function({ value: t }, ...n) {
  return !n.some((a) => typeof a == "object" ? Le(a, t) : a === t);
}, ip = sp, lp = function({ value: t }) {
  return !isNaN(t);
}, op = lp, $i = function(e, ...t) {
  return Ge(e.value) ? t.map((a) => e.at(a)?.value).some((a) => !Ge(a)) : !0;
};
$i.skipEmpty = !1;
var up = $i, xi = function({ value: t }, n = "default") {
  return n === "trim" && typeof t == "string" ? !Ge(t.trim()) : !Ge(t);
};
xi.skipEmpty = !1;
var cp = xi, dp = function({ value: t }, ...n) {
  return typeof t == "string" && n.length ? n.some((a) => t.startsWith(a)) : typeof t == "string" && n.length === 0;
}, fp = dp, mp = function({ value: e }) {
  return /^[!-/:-@[-`{-~]+$/.test(String(e));
}, vp = mp, pp = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("^\\p{Lu}+$", "u"),
    latin: /^[A-Z]+$/
  }, a = ae(n, t) ? t : "default";
  return n[a].test(String(e));
}, hp = pp, yp = function({ value: t }, ...n) {
  try {
    const a = n.length ? n : ["http:", "https:"], r = new URL(String(t));
    return a.includes(r.protocol);
  } catch {
    return !1;
  }
}, gp = yp;
const bp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  accepted: nv,
  alpha: cv,
  alpha_spaces: fv,
  alphanumeric: vv,
  between: wv,
  confirm: xv,
  contains_alpha: Sv,
  contains_alpha_spaces: Pv,
  contains_alphanumeric: Ev,
  contains_lowercase: Mv,
  contains_numeric: Ov,
  contains_symbol: Bv,
  contains_uppercase: Fv,
  date_after: rv,
  date_after_node: ov,
  date_after_or_equal: iv,
  date_before: hv,
  date_before_node: gv,
  date_before_or_equal: kv,
  date_between: Hv,
  date_format: zv,
  email: qv,
  ends_with: Uv,
  is: Gv,
  length: Qv,
  lowercase: Zv,
  matches: ep,
  max: np,
  min: rp,
  not: ip,
  number: op,
  require_one: up,
  required: cp,
  starts_with: fp,
  symbol: vp,
  uppercase: hp,
  url: gp
}, Symbol.toStringTag, { value: "Module" }));
var Da = /* @__PURE__ */ ze({
  type: "state",
  blocking: !0,
  visible: !1,
  value: !0,
  key: "validating"
});
function kp(e = {}) {
  return function(n) {
    let a = Qe(n.props.validationRules || {}), r = { ...e, ...a };
    const s = { input: Jt(), rerun: null, isPassing: !0 };
    let i = Qe(n.props.validation);
    n.on("prop:validation", ({ payload: o }) => l(o, a)), n.on(
      "prop:validationRules",
      ({ payload: o }) => l(i, o)
    );
    function l(o, u) {
      Le(Object.keys(a || {}), Object.keys(u || {})) && Le(i, o) || (a = Qe(u), i = Qe(o), r = { ...e, ...a }, n.props.parsedRules?.forEach((c) => {
        Ii(c), bi(c.observer.receipts), c.observer.kill();
      }), n.store.filter(() => !1, "validation"), n.props.parsedRules = Qr(o, r, n), s.isPassing = !0, Fa(n, n.props.parsedRules, s));
    }
    n.props.parsedRules = Qr(i, r, n), Fa(n, n.props.parsedRules, s);
  };
}
function Fa(e, t, n) {
  hr(e) || (n.input = Jt(), e.store.set(
    /* @__PURE__ */ ze({
      key: "failing",
      value: !n.isPassing,
      visible: !1
    })
  ), n.isPassing = !0, e.store.filter((a) => !a.meta.removeImmediately, "validation"), t.forEach(
    (a) => a.debounce && clearTimeout(a.timer)
  ), t.length && (e.store.set(Da), Ra(0, t, n, !1, () => {
    e.store.remove(Da.key), e.store.set(
      /* @__PURE__ */ ze({
        key: "failing",
        value: !n.isPassing,
        visible: !1
      })
    );
  })));
}
function Ra(e, t, n, a, r) {
  const s = t[e];
  if (!s)
    return r();
  const i = s.observer;
  if (hr(i))
    return;
  const l = n.input;
  s.state = null;
  function o(u, c) {
    if (n.input !== l)
      return;
    n.isPassing = n.isPassing && !!c, s.queued = !1;
    const v = i.stopObserve(), h = _i(s.deps, v);
    if (gi(
      i,
      h,
      function() {
        try {
          i.store.set(Da);
        } catch {
        }
        s.queued = !0, n.rerun && clearTimeout(n.rerun), n.rerun = setTimeout(
          Fa,
          0,
          i,
          t,
          n
        );
      },
      "unshift"
      // We want these listeners to run before other events are emitted so the 'state.validating' will be reliable.
    ), s.deps = v, s.state = c, c === !1 ? wp(s, a || u) : Ii(s), t.length > e + 1) {
      const m = t[e + 1];
      (c || m.force || !m.skipEmpty) && m.state === null && (m.queued = !0), Ra(e + 1, t, n, a || u, r);
    } else
      r();
  }
  (!Ge(i.value) || !s.skipEmpty) && (n.isPassing || s.force) ? s.queued ? _p(s, i, (u) => {
    u instanceof Promise ? u.then((c) => o(!0, c)) : o(!1, u);
  }) : Ra(e + 1, t, n, a, r) : Ge(i.value) && s.skipEmpty && n.isPassing ? (i.observe(), i.value, o(!1, n.isPassing)) : o(!1, null);
}
function _p(e, t, n) {
  e.debounce ? e.timer = setTimeout(() => {
    t.observe(), n(e.rule(t, ...e.args));
  }, e.debounce) : (t.observe(), n(e.rule(t, ...e.args)));
}
function Ii(e) {
  const t = `rule_${e.name}`;
  e.messageObserver && (e.messageObserver = e.messageObserver.kill()), ae(e.observer.store, t) && e.observer.store.remove(t);
}
function wp(e, t) {
  const n = e.observer;
  hr(n) || (e.messageObserver || (e.messageObserver = sa(n._node)), e.messageObserver.watch(
    (a) => xp(
      a,
      e
    ),
    (a) => {
      const r = $p(n, e, a), s = /* @__PURE__ */ ze({
        blocking: e.blocking,
        key: `rule_${e.name}`,
        meta: {
          /**
           * Use this key instead of the message root key to produce i18n validation
           * messages.
           */
          messageKey: e.name,
          /**
           * For messages that were created *by or after* a debounced or async
           * validation rule — we make note of it so we can immediately remove them
           * as soon as the next commit happens.
           */
          removeImmediately: t,
          /**
           * Determines if this message should be passed to localization.
           */
          localize: !r,
          /**
           * The arguments that will be passed to the validation rules
           */
          i18nArgs: a
        },
        type: "validation",
        value: r || "This field is not valid."
      });
      n.store.set(s);
    }
  ));
}
function $p(e, t, n) {
  const a = e.props.validationMessages && ae(e.props.validationMessages, t.name) ? e.props.validationMessages[t.name] : void 0;
  return typeof a == "function" ? a(...n) : a;
}
function xp(e, t) {
  return [
    {
      node: e,
      name: Si(e),
      args: t.args
    }
  ];
}
function Si(e) {
  return typeof e.props.validationLabel == "function" ? e.props.validationLabel(e) : e.props.validationLabel || e.props.label || e.props.name || String(e.name);
}
var Ti = "(?:[\\*+?()0-9]+)", Pi = "[a-zA-Z][a-zA-Z0-9_]+", Ip = new RegExp(
  `^(${Ti}?${Pi})(?:\\:(.*)+)?$`,
  "i"
), Sp = new RegExp(`^(${Ti})(${Pi})$`, "i"), Tp = /([\*+?]+)?(\(\d+\))([\*+?]+)?/, Yr = /\(\d+\)/, Pp = {
  blocking: !0,
  debounce: 0,
  force: !1,
  skipEmpty: !0,
  name: ""
};
function Qr(e, t, n) {
  return e ? (typeof e == "string" ? Cp(e) : Qt(e)).reduce((r, s) => {
    let i = s.shift();
    const l = {};
    if (typeof i == "string") {
      const [o, u] = Ap(i);
      ae(t, o) && (i = t[o], Object.assign(l, u));
    }
    return typeof i == "function" && r.push({
      observer: sa(n),
      rule: i,
      args: s,
      timer: 0,
      state: null,
      queued: !0,
      deps: /* @__PURE__ */ new Map(),
      ...Pp,
      ...Mp(l, i)
    }), r;
  }, []) : [];
}
function Cp(e) {
  return e.split("|").reduce((t, n) => {
    const a = Ep(n);
    return a && t.push(a), t;
  }, []);
}
function Ep(e) {
  const t = e.trim();
  if (t) {
    const n = t.match(Ip);
    if (n && typeof n[1] == "string") {
      const a = n[1].trim(), r = n[2] && typeof n[2] == "string" ? n[2].split(",").map((s) => s.trim()) : [];
      return [a, ...r];
    }
  }
  return !1;
}
function Ap(e) {
  const t = e.match(Sp);
  if (!t)
    return [e, { name: e }];
  const n = {
    "*": { force: !0 },
    "+": { skipEmpty: !1 },
    "?": { blocking: !1 }
  }, [, a, r] = t, s = Yr.test(a) ? a.match(Tp) || [] : [, a];
  return [
    r,
    [s[1], s[2], s[3]].reduce(
      (i, l) => (l && (Yr.test(l) ? i.debounce = parseInt(l.substr(1, l.length - 1)) : l.split("").forEach(
        (o) => ae(n, o) && Object.assign(i, n[o])
      )), i),
      { name: r }
    )
  ];
}
function Mp(e, t) {
  return e.name || (e.name = t.ruleName || t.name), ["skipEmpty", "force", "debounce", "blocking"].reduce(
    (n, a) => (ae(t, a) && !ae(n, a) && Object.assign(n, {
      [a]: t[a]
    }), n),
    e
  );
}
function de(e) {
  return e[0].toUpperCase() + e.substr(1);
}
function Xr(e, t = "or") {
  return e.reduce((n, a, r) => (n += a, r <= e.length - 2 && e.length > 2 && (n += ", "), r === e.length - 2 && (n += `${e.length === 2 ? " " : ""}${t} `), n), "");
}
function Cn(e) {
  const t = typeof e == "string" ? new Date(Date.parse(e)) : e;
  return t instanceof Date ? new Intl.DateTimeFormat(void 0, {
    dateStyle: "medium",
    timeZone: "UTC"
  }).format(t) : "(unknown)";
}
function Lp(e, t) {
  return Number(e) >= Number(t) ? [t, e] : [e, t];
}
var Op = {
  /**
   * Shown on a button for adding additional items.
   */
  add: "Add",
  /**
   * Shown when a button to remove items is visible.
   */
  remove: "Remove",
  /**
   * Shown when there are multiple items to remove at the same time.
   */
  removeAll: "Remove all",
  /**
   * Shown when all fields are not filled out correctly.
   */
  incomplete: "Sorry, not all fields are filled out correctly.",
  /**
   * Shown in a button inside a form to submit the form.
   */
  submit: "Submit",
  /**
   * Shown when no files are selected.
   */
  noFiles: "No file chosen",
  /**
   * Shown on buttons that move fields up in a list.
   */
  moveUp: "Move up",
  /**
   * Shown on buttons that move fields down in a list.
   */
  moveDown: "Move down",
  /**
   * Shown when something is actively loading.
   */
  isLoading: "Loading...",
  /**
   * Shown when there is more to load.
   */
  loadMore: "Load more",
  /**
   * Show on buttons that navigate state forward
   */
  next: "Next",
  /**
   * Show on buttons that navigate state backward
   */
  prev: "Previous",
  /**
   * Shown when adding all values.
   */
  addAllValues: "Add all values",
  /**
   * Shown when adding selected values.
   */
  addSelectedValues: "Add selected values",
  /**
   * Shown when removing all values.
   */
  removeAllValues: "Remove all values",
  /**
   * Shown when removing selected values.
   */
  removeSelectedValues: "Remove selected values",
  /**
   * Shown when there is a date to choose.
   */
  chooseDate: "Choose date",
  /**
   * Shown when there is a date to change.
   */
  changeDate: "Change date",
  /**
   * Shown above error summaries when someone attempts to submit a form with
   * errors and the developer has implemented `<FormKitSummary />`.
   */
  summaryHeader: "There were errors in your form.",
  /*
   * Shown when there is something to close
   */
  close: "Close",
  /**
   * Shown when there is something to open.
   */
  open: "Open"
}, Np = {
  /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */
  accepted({ name: e }) {
    return `Please accept the ${e}.`;
  },
  /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */
  date_after({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${de(e)} must be after ${Cn(t[0])}.` : `${de(e)} must be in the future.`;
  },
  /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */
  alpha({ name: e }) {
    return `${de(e)} can only contain alphabetical characters.`;
  },
  /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */
  alphanumeric({ name: e }) {
    return `${de(e)} can only contain letters and numbers.`;
  },
  /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */
  alpha_spaces({ name: e }) {
    return `${de(e)} can only contain letters and spaces.`;
  },
  /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */
  contains_alpha({ name: e }) {
    return `${de(e)} must contain alphabetical characters.`;
  },
  /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */
  contains_alphanumeric({ name: e }) {
    return `${de(e)} must contain letters or numbers.`;
  },
  /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */
  contains_alpha_spaces({ name: e }) {
    return `${de(e)} must contain letters or spaces.`;
  },
  /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */
  contains_symbol({ name: e }) {
    return `${de(e)} must contain a symbol.`;
  },
  /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */
  contains_uppercase({ name: e }) {
    return `${de(e)} must contain an uppercase letter.`;
  },
  /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */
  contains_lowercase({ name: e }) {
    return `${de(e)} must contain a lowercase letter.`;
  },
  /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */
  contains_numeric({ name: e }) {
    return `${de(e)} must contain numbers.`;
  },
  /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */
  symbol({ name: e }) {
    return `${de(e)} must be a symbol.`;
  },
  /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */
  uppercase({ name: e }) {
    return `${de(e)} can only contain uppercase letters.`;
  },
  /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */
  lowercase({ name: e, args: t }) {
    let n = "";
    return Array.isArray(t) && t.length && (t[0] === "allow_non_alpha" && (n = ", numbers and symbols"), t[0] === "allow_numeric" && (n = " and numbers"), t[0] === "allow_numeric_dashes" && (n = ", numbers and dashes")), `${de(e)} can only contain lowercase letters${n}.`;
  },
  /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */
  date_before({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${de(e)} must be before ${Cn(t[0])}.` : `${de(e)} must be in the past.`;
  },
  /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */
  between({ name: e, args: t }) {
    if (isNaN(t[0]) || isNaN(t[1]))
      return "This field was configured incorrectly and can’t be submitted.";
    const [n, a] = Lp(t[0], t[1]);
    return `${de(e)} must be between ${n} and ${a}.`;
  },
  /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */
  confirm({ name: e }) {
    return `${de(e)} does not match.`;
  },
  /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */
  date_format({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${de(e)} is not a valid date, please use the format ${t[0]}` : "This field was configured incorrectly and can’t be submitted";
  },
  /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */
  date_between({ name: e, args: t }) {
    return `${de(e)} must be between ${Cn(t[0])} and ${Cn(t[1])}`;
  },
  /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */
  email: "Please enter a valid email address.",
  /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */
  ends_with({ name: e, args: t }) {
    return `${de(e)} doesn’t end with ${Xr(t)}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */
  is({ name: e }) {
    return `${de(e)} is not an allowed value.`;
  },
  /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */
  length({ name: e, args: [t = 0, n = 1 / 0] }) {
    const a = Number(t) <= Number(n) ? t : n, r = Number(n) >= Number(t) ? n : t;
    return a == 1 && r === 1 / 0 ? `${de(e)} must be at least one character.` : a == 0 && r ? `${de(e)} must be less than or equal to ${r} characters.` : a === r ? `${de(e)} should be ${r} characters long.` : a && r === 1 / 0 ? `${de(e)} must be greater than or equal to ${a} characters.` : `${de(e)} must be between ${a} and ${r} characters.`;
  },
  /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */
  matches({ name: e }) {
    return `${de(e)} is not an allowed value.`;
  },
  /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */
  max({ name: e, node: { value: t }, args: n }) {
    return Array.isArray(t) ? `Cannot have more than ${n[0]} ${e}.` : `${de(e)} must be no more than ${n[0]}.`;
  },
  /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */
  mime({ name: e, args: t }) {
    return t[0] ? `${de(e)} must be of the type: ${t[0]}` : "No file formats allowed.";
  },
  /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */
  min({ name: e, node: { value: t }, args: n }) {
    return Array.isArray(t) ? `Cannot have fewer than ${n[0]} ${e}.` : `${de(e)} must be at least ${n[0]}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */
  not({ name: e, node: { value: t } }) {
    return `“${t}” is not an allowed ${e}.`;
  },
  /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */
  number({ name: e }) {
    return `${de(e)} must be a number.`;
  },
  /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */
  require_one: ({ name: e, node: t, args: n }) => {
    const a = n.map((r) => {
      const s = t.at(r);
      return s ? Si(s) : !1;
    }).filter((r) => !!r);
    return a.unshift(e), `${a.join(" or ")} is required.`;
  },
  /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */
  required({ name: e }) {
    return `${de(e)} is required.`;
  },
  /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */
  starts_with({ name: e, args: t }) {
    return `${de(e)} doesn’t start with ${Xr(t)}.`;
  },
  /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */
  url() {
    return "Please enter a valid URL.";
  },
  /**
   * Shown when the date is invalid.
   */
  invalidDate: "The selected date is invalid."
}, Bp = { ui: Op, validation: Np }, Zr = /* @__PURE__ */ new Set();
function Dp(e) {
  return function(n) {
    Zr.add(n), n.on("destroying", () => Zr.delete(n));
    let a = Jr(n.config.locale, e), r = a ? e[a] : {};
    n.on("prop:locale", ({ payload: s }) => {
      a = Jr(s, e), r = a ? e[a] : {}, n.store.touch();
    }), n.on("prop:label", () => n.store.touch()), n.on("prop:validationLabel", () => n.store.touch()), n.hook.text((s, i) => {
      const l = s.meta?.messageKey || s.key;
      if (ae(r, s.type) && ae(r[s.type], l)) {
        const o = r[s.type][l];
        typeof o == "function" ? s.value = Array.isArray(s.meta?.i18nArgs) ? o(...s.meta.i18nArgs) : o(s) : s.value = o;
      }
      return i(s);
    });
  };
}
function Jr(e, t) {
  if (ae(t, e))
    return e;
  const [n] = e.split("-");
  if (ae(t, n))
    return n;
  for (const a in t)
    return a;
  return !1;
}
function Fp(...e) {
  const t = e.reduce(
    (a, r) => bt(a, r),
    {}
  ), n = () => {
  };
  return n.library = function(a) {
    const r = Ht(a.props.type);
    ae(t, r) && a.define(t[r]);
  }, n;
}
var Rp = [
  "classes",
  "config",
  "delay",
  "errors",
  "id",
  "index",
  "inputErrors",
  "library",
  "modelValue",
  "onUpdate:modelValue",
  "name",
  "number",
  "parent",
  "plugins",
  "sectionsSchema",
  "type",
  "validation",
  "validationLabel",
  "validationMessages",
  "validationRules",
  // Runtime event props:
  "onInput",
  "onInputRaw",
  "onUpdate:modelValue",
  "onNode",
  "onSubmit",
  "onSubmitInvalid",
  "onSubmitRaw"
];
function ia(e) {
  return e && typeof e == "object" && "group" in e && Array.isArray(e.options);
}
function Ci(e, t = { count: 1 }) {
  return Array.isArray(e) ? e.map(
    (n) => {
      if (typeof n == "string" || typeof n == "number")
        return {
          label: String(n),
          value: String(n)
        };
      if (typeof n == "object") {
        if ("group" in n)
          return n.options = Ci(n.options || [], t), n;
        "value" in n && typeof n.value != "string" && Object.assign(n, {
          value: `__mask_${t.count++}`,
          __original: n.value
        });
      }
      return n;
    }
  ) : Object.keys(e).map((n) => ({
    label: e[n],
    value: n
  }));
}
function Ct(e, t, n = !1) {
  if (Array.isArray(e)) {
    for (const a of e)
      if (!(typeof a != "object" && a)) {
        if (ia(a)) {
          const r = Ct(a.options, t, !0);
          if (r !== void 0)
            return r;
        } else if (t == a.value)
          return "__original" in a ? a.__original : a.value;
      }
  }
  return n ? void 0 : t;
}
function Zt(e, t) {
  return e === null && t === void 0 || e === void 0 && t === null ? !1 : e == t ? !0 : Yt(e) && Yt(t) ? Le(e, t) : !1;
}
function yr(e) {
  e.hook.prop((t, n) => {
    var a;
    return t.prop === "options" && (typeof t.value == "function" ? (e.props.optionsLoader = t.value, t.value = []) : ((a = e.props)._normalizeCounter ?? (a._normalizeCounter = { count: 1 }), t.value = Ci(t.value, e.props._normalizeCounter))), n(t);
  });
}
// @__NO_SIDE_EFFECTS__
function ne(e, t, n = !1) {
  return (...a) => {
    const r = (s) => {
      const i = !t || typeof t == "string" ? { $el: t } : t();
      return (Na(i) || Ba(i)) && (i.meta ? i.meta.section = e : i.meta = { section: e }, a.length && !i.children && (i.children = [
        ...a.map(
          (l) => typeof l == "function" ? l(s) : l
        )
      ]), Na(i) && (i.attrs = {
        class: `$classes.${e}`,
        ...i.attrs || {}
      })), {
        if: `$slots.${e}`,
        then: `$slots.${e}`,
        else: e in s ? /* @__PURE__ */ sn(i, s[e]) : i
      };
    };
    return r._s = e, n ? /* @__PURE__ */ Hp(r) : r;
  };
}
// @__NO_SIDE_EFFECTS__
function Hp(e) {
  return (t) => [e(t)];
}
function Wn(e) {
  return !!(e && typeof e == "object" && ("$el" in e || "$cmp" in e || "$formkit" in e));
}
// @__NO_SIDE_EFFECTS__
function sn(e, t = {}) {
  return typeof e == "string" ? Wn(t) || typeof t == "string" ? t : e : Array.isArray(e) ? Wn(t) ? t : e : bt(e, t);
}
var Vp = /* @__PURE__ */ ne("actions", () => ({
  $el: "div",
  if: "$actions"
})), Un = /* @__PURE__ */ ne("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "$type",
    name: "$node.props.altName || $node.name",
    disabled: "$option.attrs.disabled || $disabled",
    onInput: "$handlers.toggleChecked",
    checked: "$fns.eq($_value, $onValue)",
    onBlur: "$handlers.blur",
    value: "$: true",
    id: "$id",
    "aria-describedby": {
      if: "$options.length",
      then: {
        if: "$option.help",
        then: '$: "help-" + $option.attrs.id',
        else: void 0
      },
      else: {
        if: "$help",
        then: '$: "help-" + $id',
        else: void 0
      }
    }
  }
})), Ei = /* @__PURE__ */ ne("optionHelp", () => ({
  $el: "div",
  if: "$option.help",
  attrs: {
    id: '$: "help-" + $option.attrs.id'
  }
})), Kn = /* @__PURE__ */ ne("inner", "span"), Gn = /* @__PURE__ */ ne("label", "span"), Ai = /* @__PURE__ */ ne("option", () => ({
  $el: "li",
  for: ["option", "$options"],
  attrs: {
    "data-disabled": "$option.attrs.disabled || $disabled || undefined"
  }
})), Mi = /* @__PURE__ */ ne("options", "ul"), Yn = /* @__PURE__ */ ne("wrapper", () => ({
  $el: "label",
  attrs: {
    "data-disabled": {
      if: "$options.length",
      then: void 0,
      else: "$disabled || undefined"
    },
    "data-checked": {
      if: "$options == undefined",
      then: "$fns.eq($_value, $onValue) || undefined",
      else: "$fns.isChecked($option.value) || undefined"
    }
  }
})), zp = /* @__PURE__ */ ne("input", () => ({
  $el: "button",
  bind: "$attrs",
  attrs: {
    type: "$type",
    disabled: "$disabled",
    name: "$node.name",
    id: "$id"
  }
})), jp = /* @__PURE__ */ ne("default", null), Qn = /* @__PURE__ */ ne("decorator", () => ({
  $el: "span",
  attrs: {
    "aria-hidden": "true"
  }
})), Li = /* @__PURE__ */ ne("fieldset", () => ({
  $el: "fieldset",
  attrs: {
    id: "$id",
    "aria-describedby": {
      if: "$help",
      then: '$: "help-" + $id',
      else: void 0
    }
  }
})), qp = /* @__PURE__ */ ne("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "file",
    disabled: "$disabled",
    name: "$node.name",
    onChange: "$handlers.files",
    onBlur: "$handlers.blur",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), Wp = /* @__PURE__ */ ne("fileItem", () => ({
  $el: "li",
  for: ["file", "$value"]
})), Up = /* @__PURE__ */ ne("fileList", () => ({
  $el: "ul",
  if: "$value.length",
  attrs: {
    "data-has-multiple": "$_hasMultipleFiles"
  }
})), Kp = /* @__PURE__ */ ne("fileName", () => ({
  $el: "span",
  attrs: {
    class: "$classes.fileName"
  }
})), es = /* @__PURE__ */ ne("fileRemove", () => ({
  $el: "button",
  attrs: {
    type: "button",
    onClick: "$handlers.resetFiles"
  }
})), Gp = /* @__PURE__ */ ne("form", () => ({
  $el: "form",
  bind: "$attrs",
  meta: {
    autoAnimate: !0
  },
  attrs: {
    id: "$id",
    name: "$node.name",
    onSubmit: "$handlers.submit",
    "data-loading": "$state.loading || undefined"
  }
})), gr = /* @__PURE__ */ ne("wrapper", null, !0), mt = /* @__PURE__ */ ne("help", () => ({
  $el: "div",
  if: "$help",
  attrs: {
    id: '$: "help-" + $id'
  }
})), xe = (e, t) => (/* @__PURE__ */ ne(`${e}Icon`, () => {
  const n = `_raw${e.charAt(0).toUpperCase()}${e.slice(1)}Icon`;
  return {
    if: `$${e}Icon && $${n}`,
    $el: `${t || "span"}`,
    attrs: {
      class: `$classes.${e}Icon + " " + $classes.icon`,
      innerHTML: `$${n}`,
      onClick: `$handlers.iconClick(${e})`,
      role: `$fns.iconRole(${e})`,
      tabindex: `$fns.iconRole(${e}) === "button" && "0" || undefined`,
      for: {
        if: `${t === "label"}`,
        then: "$id"
      }
    }
  };
}))(), la = /* @__PURE__ */ ne("inner", "div"), oa = /* @__PURE__ */ ne("label", () => ({
  $el: "label",
  if: "$label",
  attrs: {
    for: "$id"
  }
})), Oi = /* @__PURE__ */ ne("legend", () => ({
  $el: "legend",
  if: "$label"
})), wt = /* @__PURE__ */ ne("message", () => ({
  $el: "li",
  for: ["message", "$messages"],
  attrs: {
    key: "$message.key",
    id: "$id + '-' + $message.key",
    "data-message-type": "$message.type"
  }
})), $t = /* @__PURE__ */ ne("messages", () => ({
  $el: "ul",
  if: "$defaultMessagePlacement && $fns.length($messages)"
})), Yp = /* @__PURE__ */ ne("noFiles", () => ({
  $el: "span",
  if: "$value == null || $value.length == 0"
})), Qp = /* @__PURE__ */ ne("optGroup", () => ({
  $el: "optgroup",
  bind: "$option.attrs",
  attrs: {
    label: "$option.group"
  }
})), ts = /* @__PURE__ */ ne("option", () => ({
  $el: "option",
  bind: "$option.attrs",
  attrs: {
    class: "$classes.option",
    value: "$option.value",
    selected: "$fns.isSelected($option)"
  }
})), ns = /* @__PURE__ */ ne("options", () => ({
  $el: null,
  if: "$options.length",
  for: ["option", "$option.options || $options"]
})), Et = /* @__PURE__ */ ne("outer", () => ({
  $el: "div",
  meta: {
    autoAnimate: !0
  },
  attrs: {
    key: "$id",
    "data-family": "$family || undefined",
    "data-type": "$type",
    "data-multiple": '$attrs.multiple || ($type != "select" && $options != undefined) || undefined',
    "data-has-multiple": "$_hasMultipleFiles",
    "data-disabled": '$: ($disabled !== "false" && $disabled) || undefined',
    "data-empty": "$state.empty || undefined",
    "data-complete": "$state.complete || undefined",
    "data-invalid": "$state.invalid || undefined",
    "data-errors": "$state.errors || undefined",
    "data-submitted": "$state.submitted || undefined",
    "data-prefix-icon": "$_rawPrefixIcon !== undefined || undefined",
    "data-suffix-icon": "$_rawSuffixIcon !== undefined || undefined",
    "data-prefix-icon-click": "$onPrefixIconClick !== undefined || undefined",
    "data-suffix-icon-click": "$onSuffixIconClick !== undefined || undefined"
  }
})), vt = /* @__PURE__ */ ne("prefix", null), Xp = /* @__PURE__ */ ne("input", () => ({
  $el: "select",
  bind: "$attrs",
  attrs: {
    id: "$id",
    "data-placeholder": "$fns.showPlaceholder($_value, $placeholder)",
    disabled: "$disabled",
    class: "$classes.input",
    name: "$node.name",
    onChange: "$handlers.onChange",
    onInput: "$handlers.selectInput",
    onBlur: "$handlers.blur",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), Zp = /* @__PURE__ */ ne("submit", () => ({
  $cmp: "FormKit",
  bind: "$submitAttrs",
  props: {
    type: "submit",
    label: "$submitLabel"
  }
})), pt = /* @__PURE__ */ ne("suffix", null), Ni = /* @__PURE__ */ ne("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "$type",
    disabled: "$disabled",
    name: "$node.name",
    onInput: "$handlers.DOMInput",
    onBlur: "$handlers.blur",
    value: "$_value",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), Jp = /* @__PURE__ */ ne("input", () => ({
  $el: "textarea",
  bind: "$attrs",
  attrs: {
    disabled: "$disabled",
    name: "$node.name",
    onInput: "$handlers.DOMInput",
    onBlur: "$handlers.blur",
    value: "$_value",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  },
  children: "$initialValue"
})), xn = /* @__PURE__ */ ne("wrapper", "div"), eh = 0;
function Bi(e) {
  (e.type === "group" || e.type === "list") && e.plugins.add(th);
}
function th(e) {
  e.props.type === "radio" && (e.addProps(["altName"]), e.props.altName = `${e.name}_${eh++}`);
}
function Di(e) {
  return function(t, n) {
    return t.prop === "options" && Array.isArray(t.value) && (t.value = t.value.map((a) => a.attrs?.id ? a : bt(a, {
      attrs: {
        id: `${e.props.id}-option-${ur(String(a.value))}`
      }
    })), e.props.type === "checkbox" && !Array.isArray(e.value) && (e.isCreated ? e.input([], !1) : e.on("created", () => {
      Array.isArray(e.value) || e.input([], !1);
    }))), n(t);
  };
}
function nh(e, t) {
  const n = t.target;
  if (n instanceof HTMLInputElement) {
    const a = Array.isArray(e.props.options) ? Ct(e.props.options, n.value) : n.value;
    Array.isArray(e.props.options) && e.props.options.length ? Array.isArray(e._value) ? e._value.some((r) => Zt(a, r)) ? e.input(
      e._value.filter(
        (r) => !Zt(a, r)
      )
    ) : e.input([...e._value, a]) : e.input([a]) : n.checked ? e.input(e.props.onValue) : e.input(e.props.offValue);
  }
}
function ah(e, t) {
  return e.context?.value, e.context?._value, Array.isArray(e._value) ? e._value.some(
    (n) => Zt(Ct(e.props.options, t), n)
  ) : !1;
}
function rh(e) {
  e.on("created", () => {
    e.context?.handlers && (e.context.handlers.toggleChecked = nh.bind(null, e)), e.context?.fns && (e.context.fns.isChecked = ah.bind(null, e)), ae(e.props, "onValue") || (e.props.onValue = !0), ae(e.props, "offValue") || (e.props.offValue = !1);
  }), e.hook.prop(Di(e));
}
function Vt(e, t) {
  return (n) => {
    n.props[`${e}Icon`] === void 0 && (n.props[`${e}Icon`] = t.startsWith("<svg") ? t : `default:${t}`);
  };
}
function br(e) {
  e.on("created", () => {
    "disabled" in e.props && (e.props.disabled = Xe(e.props.disabled), e.config.disabled = Xe(e.props.disabled));
  }), e.hook.prop(({ prop: t, value: n }, a) => (n = t === "disabled" ? Xe(n) : n, a({ prop: t, value: n }))), e.on("prop:disabled", ({ payload: t }) => {
    e.config.disabled = Xe(t);
  });
}
function On(e, t) {
  return (n) => {
    n.store.set(
      /* @__PURE__ */ ze({
        key: e,
        type: "ui",
        value: t || e,
        meta: {
          localize: !0,
          i18nArgs: [n]
        }
      })
    );
  };
}
var wa = typeof window < "u";
function Fi(e) {
  e.target instanceof HTMLElement && e.target.hasAttribute("data-file-hover") && e.target.removeAttribute("data-file-hover");
}
function as(e, t) {
  t.target instanceof HTMLInputElement ? e === "dragover" && t.target.setAttribute("data-file-hover", "true") : t.preventDefault(), e === "drop" && Fi(t);
}
function sh(e) {
  On("noFiles", "Select file")(e), On("removeAll", "Remove all")(e), On("remove")(e), e.addProps(["_hasMultipleFiles"]), wa && (window._FormKit_File_Drop || (window.addEventListener(
    "dragover",
    as.bind(null, "dragover")
  ), window.addEventListener("drop", as.bind(null, "drop")), window.addEventListener("dragleave", Fi), window._FormKit_File_Drop = !0)), e.hook.input((t, n) => n(Array.isArray(t) ? t : [])), e.on("input", ({ payload: t }) => {
    e.props._hasMultipleFiles = Array.isArray(t) && t.length > 1 ? !0 : void 0;
  }), e.on("reset", () => {
    if (e.props.id && wa) {
      const t = document.getElementById(e.props.id);
      t && (t.value = "");
    }
  }), e.on("created", () => {
    Array.isArray(e.value) || e.input([], !1), e.context && (e.context.handlers.resetFiles = (t) => {
      if (t.preventDefault(), e.input([]), e.props.id && wa) {
        const n = document.getElementById(e.props.id);
        n && (n.value = ""), n?.focus();
      }
    }, e.context.handlers.files = (t) => {
      const n = [];
      if (t.target instanceof HTMLInputElement && t.target.files) {
        for (let a = 0; a < t.target.files.length; a++) {
          let r;
          (r = t.target.files.item(a)) && n.push({ name: r.name, file: r });
        }
        e.input(n);
      }
      e.context && (e.context.files = n), typeof e.props.attrs?.onChange == "function" && e.props.attrs?.onChange(t);
    });
  });
}
var rs = /* @__PURE__ */ ze({
  key: "loading",
  value: !0,
  visible: !1
});
async function ih(e, t) {
  const n = Math.random();
  if (e.props._submitNonce = n, t.preventDefault(), await e.settled, e.ledger.value("validating") && (e.store.set(rs), await e.ledger.settled("validating"), e.store.remove("loading"), e.props._submitNonce !== n))
    return;
  const a = (r) => r.store.set(
    /* @__PURE__ */ ze({
      key: "submitted",
      value: !0,
      visible: !1
    })
  );
  if (e.walk(a), a(e), e.emit("submit-raw"), typeof e.props.onSubmitRaw == "function" && e.props.onSubmitRaw(t, e), e.ledger.value("blocking"))
    typeof e.props.onSubmitInvalid == "function" && e.props.onSubmitInvalid(e), e.props.incompleteMessage !== !1 && Ri(e);
  else if (typeof e.props.onSubmit == "function") {
    const r = e.props.onSubmit(
      e.hook.submit.dispatch(Qt(e.value)),
      e
    );
    if (r instanceof Promise) {
      const s = e.props.disabled === void 0 && e.props.submitBehavior !== "live";
      s && (e.props.disabled = !0), e.store.set(rs), await r, s && (e.props.disabled = !1), e.store.remove("loading");
    }
  } else
    t.target instanceof HTMLFormElement && t.target.submit();
}
function Ri(e) {
  e.store.set(
    /* @__PURE__ */ ze({
      blocking: !1,
      key: "incomplete",
      meta: {
        localize: e.props.incompleteMessage === void 0,
        i18nArgs: [{ node: e }],
        showAsMessage: !0
      },
      type: "ui",
      value: e.props.incompleteMessage || "Form incomplete."
    })
  );
}
function lh(e) {
  var t;
  e.props.isForm = !0, e.ledger.count("validating", (n) => n.key === "validating"), (t = e.props).submitAttrs ?? (t.submitAttrs = {
    disabled: e.props.disabled
  }), e.on("prop:disabled", ({ payload: n }) => {
    e.props.submitAttrs = { ...e.props.submitAttrs, disabled: n };
  }), e.on("created", () => {
    e.context?.handlers && (e.context.handlers.submit = ih.bind(null, e)), ae(e.props, "actions") || (e.props.actions = !0);
  }), e.on("prop:incompleteMessage", () => {
    e.store.incomplete && Ri(e);
  }), e.on("settled:blocking", () => e.store.remove("incomplete"));
}
function oh(e) {
  e.props.ignore === void 0 && (e.props.ignore = !0, e.parent = null);
}
function uh(e) {
  e.on("created", () => {
    e.context && (e.context.initialValue = e.value || "");
  });
}
function Hi(e) {
  if (typeof e.props.number > "u")
    return;
  const t = ["number", "range", "hidden"].includes(e.props.type);
  e.hook.input((n, a) => {
    if (n === "")
      return a(void 0);
    const r = e.props.number === "integer" ? parseInt(n) : parseFloat(n);
    return Number.isFinite(r) ? a(r) : a(t ? void 0 : n);
  });
}
function ch(e, t) {
  t.target instanceof HTMLInputElement && e.input(Ct(e.props.options, t.target.value));
}
function dh(e, t) {
  return e.context?.value, e.context?._value, Zt(Ct(e.props.options, t), e._value);
}
function fh(e) {
  e.on("created", () => {
    Array.isArray(e.props.options) || wn(350, {
      node: e,
      inputType: "radio"
    }), e.context?.handlers && (e.context.handlers.toggleChecked = ch.bind(null, e)), e.context?.fns && (e.context.fns.isChecked = dh.bind(null, e));
  }), e.hook.prop(Di(e));
}
function mh(e, t) {
  if (ia(t))
    return !1;
  e.context && e.context.value;
  const n = "__original" in t ? t.__original : t.value;
  return Array.isArray(e._value) ? e._value.some((a) => Zt(a, n)) : (e._value === void 0 || e._value === null && !Vi(e.props.options, null)) && t.attrs && t.attrs["data-is-placeholder"] ? !0 : Zt(n, e._value);
}
function Vi(e, t) {
  return e.some((n) => ia(n) ? Vi(n.options, t) : ("__original" in n ? n.__original : n.value) === t);
}
async function vh(e, t) {
  typeof e.props.attrs?.onChange == "function" && (await new Promise((n) => setTimeout(n, 0)), await e.settled, e.props.attrs.onChange(t));
}
function ph(e, t) {
  const n = t.target, a = n.hasAttribute("multiple") ? Array.from(n.selectedOptions).map(
    (r) => Ct(e.props.options, r.value)
  ) : Ct(e.props.options, n.value);
  e.input(a);
}
function ss(e, t) {
  return e.some(
    (n) => n.attrs && n.attrs["data-is-placeholder"]
  ) ? e : [
    {
      label: t,
      value: "",
      attrs: {
        hidden: !0,
        disabled: !0,
        "data-is-placeholder": "true"
      }
    },
    ...e
  ];
}
function zi(e) {
  const t = e.length > 0 ? e[0] : void 0;
  if (t)
    return ia(t) ? zi(t.options) : "__original" in t ? t.__original : t.value;
}
function hh(e) {
  e.on("created", () => {
    const t = Xe(e.props.attrs?.multiple);
    !t && e.props.placeholder && Array.isArray(e.props.options) && (e.hook.prop(({ prop: n, value: a }, r) => (n === "options" && (a = ss(a, e.props.placeholder)), r({ prop: n, value: a }))), e.props.options = ss(
      e.props.options,
      e.props.placeholder
    )), t ? e.value === void 0 && e.input([], !1) : e.context && !e.context.options && (e.props.attrs = Object.assign({}, e.props.attrs, {
      value: e._value
    }), e.on("input", ({ payload: n }) => {
      e.props.attrs = Object.assign({}, e.props.attrs, {
        value: n
      });
    })), e.context?.handlers && (e.context.handlers.selectInput = ph.bind(null, e), e.context.handlers.onChange = vh.bind(null, e)), e.context?.fns && (e.context.fns.isSelected = mh.bind(null, e), e.context.fns.showPlaceholder = (n, a) => {
      if (!Array.isArray(e.props.options))
        return !1;
      const r = e.props.options.some(
        (s) => {
          if (s.attrs && "data-is-placeholder" in s.attrs)
            return !1;
          const i = "__original" in s ? s.__original : s.value;
          return Le(n, i);
        }
      );
      return a && !r ? !0 : void 0;
    });
  }), e.hook.input((t, n) => (!e.props.placeholder && t === void 0 && Array.isArray(e.props?.options) && e.props.options.length && !Xe(e.props?.attrs?.multiple) && (t = zi(e.props.options)), n(t)));
}
// @__NO_SIDE_EFFECTS__
function Ha(e) {
  return !!(Bt(e) && e.if && e.if.startsWith("$slots.") && typeof e.then == "string" && e.then.startsWith("$slots.") && "else" in e);
}
// @__NO_SIDE_EFFECTS__
function ot(e, t, n) {
  const a = (r) => {
    const s = t(r);
    if (n || Wn(s) && "if" in s || /* @__PURE__ */ Ha(s)) {
      const i = {
        if: e,
        then: s
      };
      return n && (i.else = n(r)), i;
    } else /* @__PURE__ */ Ha(s) ? Object.assign(s.else, { if: e }) : Wn(s) && Object.assign(s, { if: e });
    return s;
  };
  return a._s = Jt(), a;
}
// @__NO_SIDE_EFFECTS__
function zt(e, t) {
  const n = (a) => {
    const r = e({});
    return /* @__PURE__ */ Ha(r) ? (Array.isArray(r.else) || (r.else = /* @__PURE__ */ sn(
      /* @__PURE__ */ sn(r.else, t),
      e._s ? a[e._s] : {}
    )), r) : /* @__PURE__ */ sn(
      /* @__PURE__ */ sn(r, t),
      e._s ? a[e._s] : {}
    );
  };
  return n._s = e._s, n;
}
var is = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Et(
    /* @__PURE__ */ $t(/* @__PURE__ */ wt("$message.value")),
    /* @__PURE__ */ xn(
      /* @__PURE__ */ zp(
        /* @__PURE__ */ xe("prefix"),
        /* @__PURE__ */ vt(),
        /* @__PURE__ */ jp("$label || $ui.submit.value"),
        /* @__PURE__ */ pt(),
        /* @__PURE__ */ xe("suffix")
      )
    ),
    /* @__PURE__ */ mt("$help")
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "button",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [On("submit"), oh],
  /**
   * A key to use for memoizing the schema. This is used to prevent the schema
   * from needing to be stringified when performing a memo lookup.
   */
  schemaMemoKey: "h6st4epl3j8"
}, yh = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Et(
    /* @__PURE__ */ ot(
      "$options == undefined",
      /**
       * Single checkbox structure.
       */
      /* @__PURE__ */ Yn(
        /* @__PURE__ */ Kn(/* @__PURE__ */ vt(), /* @__PURE__ */ Un(), /* @__PURE__ */ Qn(/* @__PURE__ */ xe("decorator")), /* @__PURE__ */ pt()),
        /* @__PURE__ */ zt(/* @__PURE__ */ Gn("$label"), {
          if: "$label"
        })
      ),
      /**
       * Multi checkbox structure.
       */
      /* @__PURE__ */ Li(
        /* @__PURE__ */ Oi("$label"),
        /* @__PURE__ */ mt("$help"),
        /* @__PURE__ */ Mi(
          /* @__PURE__ */ Ai(
            /* @__PURE__ */ Yn(
              /* @__PURE__ */ Kn(
                /* @__PURE__ */ vt(),
                /* @__PURE__ */ zt(/* @__PURE__ */ Un(), {
                  bind: "$option.attrs",
                  attrs: {
                    id: "$option.attrs.id",
                    value: "$option.value",
                    checked: "$fns.isChecked($option.value)"
                  }
                }),
                /* @__PURE__ */ Qn(/* @__PURE__ */ xe("decorator")),
                /* @__PURE__ */ pt()
              ),
              /* @__PURE__ */ zt(/* @__PURE__ */ Gn("$option.label"), {
                if: "$option.label"
              })
            ),
            /* @__PURE__ */ Ei("$option.help")
          )
        )
      )
    ),
    // Help text only goes under the input when it is a single.
    /* @__PURE__ */ ot("$options == undefined && $help", /* @__PURE__ */ mt("$help")),
    /* @__PURE__ */ $t(/* @__PURE__ */ wt("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "box",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "onValue", "offValue", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [
    yr,
    rh,
    Vt("decorator", "checkboxDecorator")
  ],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "qje02tb3gu8"
}, gh = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Et(
    /* @__PURE__ */ xn(
      /* @__PURE__ */ oa("$label"),
      /* @__PURE__ */ la(
        /* @__PURE__ */ xe("prefix", "label"),
        /* @__PURE__ */ vt(),
        /* @__PURE__ */ qp(),
        /* @__PURE__ */ Up(
          /* @__PURE__ */ Wp(
            /* @__PURE__ */ xe("fileItem"),
            /* @__PURE__ */ Kp("$file.name"),
            /* @__PURE__ */ ot(
              "$value.length === 1",
              /* @__PURE__ */ es(
                /* @__PURE__ */ xe("fileRemove"),
                '$ui.remove.value + " " + $file.name'
              )
            )
          )
        ),
        /* @__PURE__ */ ot("$value.length > 1", /* @__PURE__ */ es("$ui.removeAll.value")),
        /* @__PURE__ */ Yp(/* @__PURE__ */ xe("noFiles"), "$ui.noFiles.value"),
        /* @__PURE__ */ pt(),
        /* @__PURE__ */ xe("suffix")
      )
    ),
    /* @__PURE__ */ mt("$help"),
    /* @__PURE__ */ $t(/* @__PURE__ */ wt("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "text",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [
    sh,
    Vt("fileItem", "fileItem"),
    Vt("fileRemove", "fileRemove"),
    Vt("noFiles", "noFiles")
  ],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "9kqc4852fv8"
}, bh = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Gp(
    "$slots.default",
    /* @__PURE__ */ $t(/* @__PURE__ */ wt("$message.value")),
    /* @__PURE__ */ Vp(/* @__PURE__ */ Zp())
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "group",
  /**
   * An array of extra props to accept for this input.
   */
  props: [
    "actions",
    "submit",
    "submitLabel",
    "submitAttrs",
    "submitBehavior",
    "incompleteMessage"
  ],
  /**
   * Additional features that should be added to your input
   */
  features: [lh, br],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "5bg016redjo"
}, kh = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ gr("$slots.default"),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "group",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [br, Bi]
}, _h = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Ni(),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [Hi]
}, wh = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ gr("$slots.default"),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "list",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["sync", "dynamic"],
  /**
   * Additional features that should be added to your input
   */
  features: [br, Bi]
}, $h = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ gr(),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: []
}, xh = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Et(
    /* @__PURE__ */ ot(
      "$options == undefined",
      /**
       * Single radio structure.
       */
      /* @__PURE__ */ Yn(
        /* @__PURE__ */ Kn(/* @__PURE__ */ vt(), /* @__PURE__ */ Un(), /* @__PURE__ */ Qn(/* @__PURE__ */ xe("decorator")), /* @__PURE__ */ pt()),
        /* @__PURE__ */ zt(/* @__PURE__ */ Gn("$label"), {
          if: "$label"
        })
      ),
      /**
       * Multi radio structure.
       */
      /* @__PURE__ */ Li(
        /* @__PURE__ */ Oi("$label"),
        /* @__PURE__ */ mt("$help"),
        /* @__PURE__ */ Mi(
          /* @__PURE__ */ Ai(
            /* @__PURE__ */ Yn(
              /* @__PURE__ */ Kn(
                /* @__PURE__ */ vt(),
                /* @__PURE__ */ zt(/* @__PURE__ */ Un(), {
                  bind: "$option.attrs",
                  attrs: {
                    id: "$option.attrs.id",
                    value: "$option.value",
                    checked: "$fns.isChecked($option.value)"
                  }
                }),
                /* @__PURE__ */ Qn(/* @__PURE__ */ xe("decorator")),
                /* @__PURE__ */ pt()
              ),
              /* @__PURE__ */ zt(/* @__PURE__ */ Gn("$option.label"), {
                if: "$option.label"
              })
            ),
            /* @__PURE__ */ Ei("$option.help")
          )
        )
      )
    ),
    // Help text only goes under the input when it is a single.
    /* @__PURE__ */ ot("$options == undefined && $help", /* @__PURE__ */ mt("$help")),
    /* @__PURE__ */ $t(/* @__PURE__ */ wt("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "box",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "onValue", "offValue", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [yr, fh, Vt("decorator", "radioDecorator")],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "qje02tb3gu8"
}, Ih = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Et(
    /* @__PURE__ */ xn(
      /* @__PURE__ */ oa("$label"),
      /* @__PURE__ */ la(
        /* @__PURE__ */ xe("prefix"),
        /* @__PURE__ */ vt(),
        /* @__PURE__ */ Xp(
          /* @__PURE__ */ ot(
            "$slots.default",
            () => "$slots.default",
            /* @__PURE__ */ ns(
              /* @__PURE__ */ ot(
                "$option.group",
                /* @__PURE__ */ Qp(/* @__PURE__ */ ns(/* @__PURE__ */ ts("$option.label"))),
                /* @__PURE__ */ ts("$option.label")
              )
            )
          )
        ),
        /* @__PURE__ */ ot("$attrs.multiple !== undefined", () => "", /* @__PURE__ */ xe("select")),
        /* @__PURE__ */ pt(),
        /* @__PURE__ */ xe("suffix")
      )
    ),
    /* @__PURE__ */ mt("$help"),
    /* @__PURE__ */ $t(/* @__PURE__ */ wt("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "placeholder", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [yr, hh, Vt("select", "select")],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "cb119h43krg"
}, Sh = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Et(
    /* @__PURE__ */ xn(
      /* @__PURE__ */ oa("$label"),
      /* @__PURE__ */ la(
        /* @__PURE__ */ xe("prefix", "label"),
        /* @__PURE__ */ vt(),
        /* @__PURE__ */ Jp(),
        /* @__PURE__ */ pt(),
        /* @__PURE__ */ xe("suffix")
      )
    ),
    /* @__PURE__ */ mt("$help"),
    /* @__PURE__ */ $t(/* @__PURE__ */ wt("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [uh],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "b1n0td79m9g"
}, Oe = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Et(
    /* @__PURE__ */ xn(
      /* @__PURE__ */ oa("$label"),
      /* @__PURE__ */ la(
        /* @__PURE__ */ xe("prefix", "label"),
        /* @__PURE__ */ vt(),
        /* @__PURE__ */ Ni(),
        /* @__PURE__ */ pt(),
        /* @__PURE__ */ xe("suffix")
      )
    ),
    /* @__PURE__ */ mt("$help"),
    /* @__PURE__ */ $t(/* @__PURE__ */ wt("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "text",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [Hi],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "c3cc4kflsg"
}, Th = {
  button: is,
  submit: is,
  checkbox: yh,
  file: gh,
  form: bh,
  group: kh,
  hidden: _h,
  list: wh,
  meta: $h,
  radio: xh,
  select: Ih,
  textarea: Sh,
  text: Oe,
  color: Oe,
  date: Oe,
  datetimeLocal: Oe,
  email: Oe,
  month: Oe,
  number: Oe,
  password: Oe,
  search: Oe,
  tel: Oe,
  time: Oe,
  url: Oe,
  week: Oe,
  range: Oe
}, yn = void 0, Lt = null, Xn, ji = !1, ln = !1, Ph = /* @__PURE__ */ new Promise((e) => {
  Xn = () => {
    ji = !0, e();
  };
}), ut = typeof window < "u" && typeof fetch < "u";
yn = ut ? /* @__PURE__ */ getComputedStyle(document.documentElement) : void 0;
var Ft = {}, $a = {};
function Ch(e, t, n, a) {
  t && Object.assign(Ft, t), ut && !ln && yn?.getPropertyValue("--formkit-theme") ? (Xn(), ln = !0) : e && !ln && ut ? Eh(e) : !ln && ut && Xn();
  const r = function(i) {
    i.addProps(["iconLoader", "iconLoaderUrl"]), i.props.iconHandler = ls(
      i.props?.iconLoader ? i.props.iconLoader : a,
      i.props?.iconLoaderUrl ? i.props.iconLoaderUrl : n
    ), Lh(i, i.props.iconHandler), i.on("created", () => {
      i?.context?.handlers && (i.context.handlers.iconClick = (l) => {
        const o = `on${l.charAt(0).toUpperCase()}${l.slice(1)}IconClick`, u = i.props[o];
        if (u && typeof u == "function")
          return (c) => u(i, c);
      }), i?.context?.fns && (i.context.fns.iconRole = (l) => {
        const o = `on${l.charAt(0).toUpperCase()}${l.slice(1)}IconClick`;
        return typeof i.props[o] == "function" ? "button" : null;
      });
    });
  };
  return r.iconHandler = ls(a, n), r;
}
function Eh(e) {
  if (!(!e || !ut || typeof getComputedStyle != "function") && (ln = !0, Lt = document.getElementById("formkit-theme"), e && // if we have a window object
  ut && // we don't have an existing theme OR the theme being set up is different
  (!yn?.getPropertyValue("--formkit-theme") && !Lt || Lt?.getAttribute("data-theme") && Lt?.getAttribute("data-theme") !== e))) {
    const n = `https://cdn.jsdelivr.net/npm/@formkit/themes@${qn.startsWith("__") ? "latest" : qn}/dist/${e}/theme.css`, a = document.createElement("link");
    a.type = "text/css", a.rel = "stylesheet", a.id = "formkit-theme", a.setAttribute("data-theme", e), a.onload = () => {
      yn = getComputedStyle(document.documentElement), Xn();
    }, document.head.appendChild(a), a.href = n, Lt && Lt.remove();
  }
}
function ls(e, t) {
  return (n) => {
    if (typeof n != "string")
      return;
    if (n.startsWith("<svg"))
      return n;
    const a = n.startsWith("default:");
    n = a ? n.split(":")[1] : n;
    const r = n in Ft;
    let s;
    if (r)
      return Ft[n];
    if (!$a[n]) {
      if (s = Ah(n), s = ut && typeof s > "u" ? Promise.resolve(s) : s, s instanceof Promise)
        $a[n] = s.then((i) => !i && typeof n == "string" && !a ? s = typeof e == "function" ? e(n) : Mh(n, t) : i).then((i) => (typeof n == "string" && (Ft[a ? `default:${n}` : n] = i), i));
      else if (typeof s == "string")
        return Ft[a ? `default:${n}` : n] = s, s;
    }
    return $a[n];
  };
}
function Ah(e) {
  if (ut)
    return ji ? os(e) : Ph.then(() => os(e));
}
function os(e) {
  const t = yn?.getPropertyValue(`--fk-icon-${e}`);
  if (t) {
    const n = atob(t);
    if (n.startsWith("<svg"))
      return Ft[e] = n, n;
  }
}
function Mh(e, t) {
  const n = qn.startsWith("__") ? "latest" : qn, a = typeof t == "function" ? t(e) : `https://cdn.jsdelivr.net/npm/@formkit/icons@${n}/dist/icons/${e}.svg`;
  if (ut)
    return fetch(`${a}`).then(async (r) => {
      const s = await r.text();
      if (s.startsWith("<svg"))
        return s;
    }).catch((r) => {
      console.error(r);
    });
}
function Lh(e, t) {
  const n = /^[a-zA-Z-]+(?:-icon|Icon)$/;
  Object.keys(e.props).filter((r) => n.test(r)).forEach((r) => Oh(e, t, r));
}
function Oh(e, t, n) {
  const a = e.props[n], r = t(a), s = `_raw${n.charAt(0).toUpperCase()}${n.slice(1)}`, i = `on${n.charAt(0).toUpperCase()}${n.slice(1)}Click`;
  if (e.addProps([s, i]), e.on(`prop:${n}`, Nh), r instanceof Promise)
    return r.then((l) => {
      e.props[s] = l;
    });
  e.props[s] = r;
}
function Nh(e) {
  const t = e.origin, n = e.payload, a = t?.props?.iconHandler, r = e.name.split(":")[1], s = `_raw${r.charAt(0).toUpperCase()}${r.slice(1)}`;
  if (a && typeof a == "function") {
    const i = a(n);
    if (i instanceof Promise)
      return i.then((l) => {
        t.props[s] = l;
      });
    t.props[s] = i;
  }
}
var us = {
  /**
   * FormKit errors:
   */
  100: ({ data: e }) => `Only groups, lists, and forms can have children (${e.name}).`,
  101: ({ data: e }) => `You cannot directly modify the store (${e.name}). See: https://formkit.com/advanced/core#message-store`,
  102: ({
    data: [e, t]
  }) => `You cannot directly assign node.${t} (${e.name})`,
  103: ({ data: [e] }) => `Schema expressions cannot start with an operator (${e})`,
  104: ({ data: [e, t] }) => `Schema expressions cannot end with an operator (${e} in "${t}")`,
  105: ({ data: e }) => `Invalid schema expression: ${e}`,
  106: ({ data: e }) => `Cannot submit because (${e}) is not in a form.`,
  107: ({ data: [e, t] }) => `Cannot set ${e.name} to non object value: ${t}`,
  108: ({ data: [e, t] }) => `Cannot set ${e.name} to non array value: ${t}`,
  /**
   * Input specific errors:
   */
  300: ({ data: [e] }) => `Cannot set behavior prop to overscroll (on ${e.name} input) when options prop is a function.`,
  /**
   * FormKit vue errors:
   */
  600: ({ data: e }) => `Unknown input type${typeof e.props.type == "string" ? ' "' + e.props.type + '"' : ""} ("${e.name}")`,
  601: ({ data: e }) => `Input definition${typeof e.props.type == "string" ? ' "' + e.props.type + '"' : ""} is missing a schema or component property (${e.name}).`
}, cs = {
  /**
   * Core warnings:
   */
  150: ({ data: e }) => `Schema function "${e}()" is not a valid function.`,
  151: ({ data: e }) => `No form element with id: ${e}`,
  152: ({ data: e }) => `No input element with id: ${e}`,
  /**
   * Input specific warnings:
   */
  350: ({
    data: { node: e, inputType: t }
  }) => `Invalid options prop for ${e.name} input (${t}). See https://formkit.com/inputs/${t}`,
  /**
   * Vue warnings:
   */
  650: 'Schema "$get()" must use the id of an input to access.',
  651: ({ data: e }) => `Cannot setErrors() on "${e}" because no such id exists.`,
  652: ({ data: e }) => `Cannot clearErrors() on "${e}" because no such id exists.`,
  /**
   * Deprecation warnings:
   */
  800: ({ data: e }) => `${e} is deprecated.`
}, Bh = (e, t) => {
  if (e.code in us) {
    const n = us[e.code];
    e.message = typeof n == "function" ? n(e) : n;
  }
  return t(e);
}, ds = !1;
function Dh() {
  ds || (dr(Bh), fr(Fh), ds = !0);
}
var Fh = (e, t) => {
  if (e.code in cs) {
    const n = cs[e.code];
    e.message = typeof n == "function" ? n(e) : n;
  }
  return t(e);
}, Rh = Object.defineProperty, Hh = Object.getOwnPropertyNames, qi = (e, t) => function() {
  return e && (t = (0, e[Hh(e)[0]])(e = 0)), t;
}, Vh = (e, t) => {
  for (var n in t)
    Rh(e, n, { get: t[n], enumerable: !0 });
}, fs, Wi, Ui = qi({
  "packages/vue/src/bindings.ts"() {
    fs = function(t) {
      t.ledger.count("blocking", (d) => d.blocking);
      const n = E(!t.ledger.value("blocking"));
      t.ledger.count("errors", (d) => d.type === "error");
      const a = E(!!t.ledger.value("errors"));
      let r = !1;
      Ze(() => {
        r = !0;
      });
      const s = yt(
        t.store.reduce((d, w) => (w.visible && (d[w.key] = w), d), {})
      ), i = E(
        t.props.validationVisibility || (t.props.type === "checkbox" ? "dirty" : "blur")
      );
      t.on("prop:validationVisibility", ({ payload: d }) => {
        i.value = d;
      });
      const l = E(i.value === "live"), o = E(!1), u = (d) => {
        o.value = (d ?? []).some(
          (w) => w.name === "required"
        );
      };
      u(t.props.parsedRules), t.on("prop:parsedRules", ({ payload: d }) => u(d));
      const c = E(t.children.map((d) => d.uid)), v = x(() => {
        if (!$.state)
          return !1;
        if ($.state.submitted)
          return !0;
        if (!l.value && !$.state.settled)
          return !1;
        switch (i.value) {
          case "live":
            return !0;
          case "blur":
            return $.state.blurred;
          case "dirty":
            return $.state.dirty;
          default:
            return !1;
        }
      }), h = x(() => $.state.failing && v.value), m = x(() => $ && p.value ? n.value && !a.value : $.state.dirty && !Ge($.value)), p = E(
        Array.isArray(t.props.parsedRules) && t.props.parsedRules.length > 0
      );
      t.on("prop:parsedRules", ({ payload: d }) => {
        p.value = Array.isArray(d) && d.length > 0;
      });
      const y = x(() => {
        const d = {};
        for (const w in s) {
          const M = s[w];
          (M.type !== "validation" || v.value) && (d[w] = M);
        }
        return d;
      }), b = yt(
        t.store.reduce((d, w) => (w.type === "ui" && w.visible && (d[w.key] = w), d), {})
      ), _ = x(() => !$.state.failing), P = yt({}), I = new Proxy(P, {
        get(...d) {
          if (!t)
            return "";
          const [w, M] = d;
          let z = Reflect.get(...d);
          return !z && typeof M == "string" && !ae(w, M) && !M.startsWith("__v") && sa(t).watch((W) => {
            const re = typeof W.config.rootClasses == "function" ? W.config.rootClasses(M, W) : {}, K = W.config.classes ? Ln(M, W, W.config.classes[M]) : {}, ee = Ln(
              M,
              W,
              W.props[`_${M}Class`]
            ), oe = Ln(
              M,
              W,
              W.props[`${M}Class`]
            );
            z = tv(
              W,
              M,
              re,
              K,
              ee,
              oe
            ), w[M] = z ?? "";
          }), z;
        }
      });
      t.on("prop:rootClasses", () => {
        const d = Object.keys(P);
        for (const w of d)
          delete P[w];
      });
      const k = x(() => {
        if (!t)
          return;
        const d = [];
        $.help && d.push(`help-${t.props.id}`);
        for (const w in y.value)
          d.push(`${t.props.id}-${w}`);
        return d.length ? d.join(" ") : void 0;
      }), T = E(t.value), g = E(t.value), $ = yt({
        _value: g,
        attrs: t.props.attrs,
        disabled: t.props.disabled,
        describedBy: k,
        fns: {
          length: (d) => Object.keys(d).length,
          number: (d) => Number(d),
          string: (d) => String(d),
          json: (d) => JSON.stringify(d),
          eq: Le
        },
        handlers: {
          blur: (d) => {
            t && (t.store.set(
              /* @__PURE__ */ ze({ key: "blurred", visible: !1, value: !0 })
            ), typeof t.props.attrs.onBlur == "function" && t.props.attrs.onBlur(d));
          },
          touch: () => {
            const d = $.dirtyBehavior === "compare";
            if (t.store.dirty?.value && !d)
              return;
            const w = !Le(t.props._init, t._value);
            !w && !d || t.store.set(
              /* @__PURE__ */ ze({ key: "dirty", visible: !1, value: w })
            );
          },
          DOMInput: (d) => {
            t.input(d.target.value), t.emit("dom-input-event", d);
          }
        },
        help: t.props.help,
        id: t.props.id,
        items: c,
        label: t.props.label,
        messages: y,
        didMount: !1,
        node: Wa(t),
        options: t.props.options,
        defaultMessagePlacement: !0,
        slots: t.props.__slots,
        state: {
          blurred: !1,
          complete: m,
          dirty: !1,
          empty: Ge(T),
          submitted: !1,
          settled: t.isSettled,
          valid: n,
          invalid: h,
          errors: a,
          rules: p,
          validationVisible: v,
          required: o,
          failing: !1,
          passing: _
        },
        type: t.props.type,
        family: t.props.family,
        ui: b,
        value: T,
        classes: I
      });
      t.on("created", () => {
        Le($.value, t.value) || (g.value = t.value, T.value = t.value, Tn(T), Tn(g)), (async () => (await t.settled, t && (t.props._init = Qe(t.value))))();
      }), t.on("mounted", () => {
        $.didMount = !0;
      }), t.on("settled", ({ payload: d }) => {
        $.state.settled = d;
      });
      function S(d) {
        (Array.isArray(d) ? d : Object.keys(d)).forEach((M) => {
          M = Ht(M), ae($, M) || ($[M] = t.props[M]), t.on(`prop:${M}`, ({ payload: z }) => {
            $[M] = z;
          });
        });
      }
      S((() => {
        const d = [
          "__root",
          "help",
          "label",
          "disabled",
          "options",
          "type",
          "attrs",
          "preserve",
          "preserveErrors",
          "id",
          "dirtyBehavior"
        ], w = /^[a-zA-Z-]+(?:-icon|Icon)$/, M = Object.keys(t.props).filter((z) => w.test(z));
        return d.concat(M);
      })());
      function B(d) {
        d.props && S(d.props);
      }
      t.props.definition && B(t.props.definition), t.on("added-props", ({ payload: d }) => S(d)), t.on("input", ({ payload: d }) => {
        t.type !== "input" && !Fn(d) && !Pr(d) ? g.value = Aa(d) : (g.value = d, Tn(g));
      }), t.on("commitRaw", ({ payload: d }) => {
        t.type !== "input" && !Fn(d) && !Pr(d) ? T.value = g.value = Aa(d) : (T.value = g.value = d, Tn(T)), t.emit("modelUpdated");
      }), t.on("commit", ({ payload: d }) => {
        if ((!$.state.dirty || $.dirtyBehavior === "compare") && t.isCreated && r)
          if (!t.store.validating?.value)
            $.handlers.touch();
          else {
            const w = t.on("message-removed", ({ payload: M }) => {
              M.key === "validating" && ($.handlers.touch(), t.off(w));
            });
          }
        m && t.type === "input" && a.value && !Xe(t.props.preserveErrors) && t.store.filter(
          (w) => !(w.type === "error" && w.meta?.autoClear === !0)
        ), t.type === "list" && t.sync && (c.value = t.children.map((w) => w.uid)), $.state.empty = Ge(d);
      });
      const N = async (d) => {
        d.type === "ui" && d.visible && !d.meta.showAsMessage ? b[d.key] = d : d.visible ? s[d.key] = d : d.type === "state" && ($.state[d.key] = !!d.value);
      };
      t.on("message-added", (d) => N(d.payload)), t.on("message-updated", (d) => N(d.payload)), t.on("message-removed", ({ payload: d }) => {
        delete b[d.key], delete s[d.key], delete $.state[d.key];
      }), t.on("settled:blocking", () => {
        n.value = !0;
      }), t.on("unsettled:blocking", () => {
        n.value = !1;
      }), t.on("settled:errors", () => {
        a.value = !1;
      }), t.on("unsettled:errors", () => {
        a.value = !0;
      }), ce(v, (d) => {
        d && (l.value = !0);
      }), t.context = $, t.emit("context", t, !1), t.on("destroyed", () => {
        t.context = void 0, t = null;
      });
    }, Wi = fs;
  }
}), zh = {};
Vh(zh, {
  defaultConfig: () => Ki
});
var Ki, jh = qi({
  "packages/vue/src/defaultConfig.ts"() {
    Ui(), Ki = (e = {}) => {
      Dh();
      const {
        rules: t = {},
        locales: n = {},
        inputs: a = {},
        messages: r = {},
        locale: s = void 0,
        theme: i = void 0,
        iconLoaderUrl: l = void 0,
        iconLoader: o = void 0,
        icons: u = {},
        ...c
      } = e, v = kp({
        ...bp,
        ...t || {}
      }), h = Dp(
        bt({ en: Bp, ...n || {} }, r)
      ), m = Fp(Th, a), p = Ch(i, u, l, o);
      return bt(
        {
          plugins: [m, p, Wi, h, v],
          ...s ? { config: { locale: s } } : {}
        },
        c || {},
        !0
      );
    };
  }
}), qh = typeof window > "u", xa = /* @__PURE__ */ new Map();
function Wh(e, t) {
  !qh || !e || (xa.has(e) || xa.set(e, /* @__PURE__ */ new Set()), xa.get(e)?.add(t));
}
var Gi = typeof window > "u", mn = {}, jt = {}, Ae, lt = /* @__PURE__ */ new WeakMap(), Uh = "__raw__", Kh = /[a-zA-Z0-9\-][cC]lass$/;
function Gh(e, t) {
  const n = E(null);
  if (e === "get") {
    const r = {};
    return n.value = Yh.bind(null, r), n;
  }
  const a = e.split(".");
  return We(() => {
    n.value = kr(
      Fn(t) ? t.value : t,
      a
    );
  }), n;
}
function kr(e, t) {
  if (Array.isArray(e)) {
    for (const r of e) {
      const s = r !== !1 && kr(r, t);
      if (s !== void 0)
        return s;
    }
    return;
  }
  let n, a = e;
  for (const r in t) {
    const s = t[r];
    if (typeof a != "object" || a === null) {
      n = void 0;
      break;
    }
    const i = a[s];
    if (Number(r) === t.length - 1 && i !== void 0) {
      n = typeof i == "function" ? i.bind(a) : i;
      break;
    }
    a = i;
  }
  return n;
}
function Yh(e, t) {
  if (typeof t != "string")
    return wn(650);
  if (t in e || (e[t] = E(void 0)), e[t].value === void 0) {
    e[t].value = null;
    const n = oi(t);
    n && (e[t].value = n.context), sm(t, ({ payload: a }) => {
      e[t].value = $n(a) ? a.context : a;
    });
  }
  return e[t].value;
}
function ms(e, t, n) {
  function a(m, p) {
    const y = v(Ye(p.if), { if: !0 }), b = u(m, p.then), _ = p.else ? u(m, p.else) : null;
    return [y, b, _];
  }
  function r(m, p) {
    const y = v(Ye(m.if));
    let b = () => p, _ = () => p;
    return typeof m.then == "object" ? _ = s(m.then, void 0) : typeof m.then == "string" && m.then?.startsWith("$") ? _ = v(Ye(m.then)) : _ = () => m.then, ae(m, "else") && (typeof m.else == "object" ? b = s(m.else) : typeof m.else == "string" && m.else?.startsWith("$") ? b = v(Ye(m.else)) : b = () => m.else), () => y() ? _() : b();
  }
  function s(m, p, y = {}) {
    const b = new Set(Object.keys(m || {})), _ = p ? v(Ye(p)) : () => ({}), P = [
      (I) => {
        const k = _();
        for (const T in k)
          b.has(T) || (I[T] = k[T]);
      }
    ];
    if (m) {
      if (Bt(m))
        return r(
          m,
          y
        );
      for (let I in m) {
        const k = m[I];
        let T;
        const g = typeof k == "string";
        I.startsWith(Uh) ? (I = I.substring(7), T = () => k) : g && k.startsWith("$") && k.length > 1 && !(k.startsWith("$reset") && Kh.test(I)) ? T = v(Ye(k)) : typeof k == "object" && Bt(k) ? T = r(k, void 0) : typeof k == "object" && Yt(k) ? T = s(k) : T = () => k, P.push(($) => {
          $[I] = T();
        });
      }
    }
    return () => {
      const I = Array.isArray(m) ? [] : {};
      return P.forEach((k) => k(I)), I;
    };
  }
  function i(m, p) {
    let y = null, b = () => null, _ = !1, P = null, I = null, k = null, T = !1;
    const g = ev(p);
    if (Na(g) ? (y = g.$el, b = g.$el !== "text" ? s(g.attrs, g.bind) : () => null) : Ba(g) ? (typeof g.$cmp == "string" ? ae(m, g.$cmp) ? y = m[g.$cmp] : (y = g.$cmp, T = !0) : y = g.$cmp, b = s(g.props, g.bind)) : Bt(g) && ([_, P, I] = a(m, g)), !Bt(g) && "if" in g ? _ = v(Ye(g.if)) : !Bt(g) && y === null && (_ = () => !0), "children" in g && g.children)
      if (typeof g.children == "string")
        if (g.children.startsWith("$slots."))
          y = y === "text" ? "slot" : y, P = v(Ye(g.children));
        else if (g.children.startsWith("$") && g.children.length > 1) {
          const $ = v(Ye(g.children));
          P = () => String($());
        } else
          P = () => String(g.children);
      else if (Array.isArray(g.children))
        P = u(m, g.children);
      else {
        const [$, S, L] = a(m, g.children);
        P = (B) => $ && $() ? S && S(B) : L && L(B);
      }
    if (Ba(g))
      if (P) {
        const $ = P;
        P = (S) => ({
          default(L, B) {
            const N = Ae;
            B && (Ae = B), L && lt.get(Ae)?.unshift(L), S && lt.get(Ae)?.unshift(S);
            const d = $(S);
            return L && lt.get(Ae)?.shift(), S && lt.get(Ae)?.shift(), Ae = N, d;
          }
        }), P.slot = !0;
      } else
        P = () => ({});
    if ("for" in g && g.for) {
      const $ = g.for.length === 3 ? g.for[2] : g.for[1];
      k = [
        typeof $ == "string" && $.startsWith("$") ? v(Ye($)) : () => $,
        g.for[0],
        g.for.length === 3 ? String(g.for[1]) : null
      ];
    }
    return [_, y, b, P, I, k, T];
  }
  function l(m, p) {
    const y = m(p), b = Ae;
    return Object.keys(y).reduce((_, P) => {
      const I = y && y[P];
      return _[P] = (k) => I && I(k, b) || null, _;
    }, {});
  }
  function o(m, p) {
    const [y, b, _, P, I, k, T] = i(m, p);
    let g = ($) => {
      if (y && b === null && P)
        return y() ? P($) : I && I($);
      if (b && (!y || y())) {
        if (b === "text" && P)
          return G(String(P()));
        if (b === "slot" && P)
          return P($);
        const S = T ? Cs(b) : b, L = P?.slot ? l(P, $) : null;
        return Ta(
          S,
          _(),
          L || (P ? P($) : [])
        );
      }
      return typeof I == "function" ? I($) : I;
    };
    if (k) {
      const $ = g, [S, L, B] = k;
      g = () => {
        const N = S(), d = Number.isFinite(N) ? Array(Number(N)).fill(0).map((R, W) => W) : N, w = [];
        if (typeof d != "object")
          return null;
        const M = lt.get(Ae) || [], z = Array.isArray(d);
        for (const R in d) {
          if (z && R in Array.prototype)
            continue;
          const W = Object.defineProperty(
            {
              ...M.reduce(
                (re, K) => re.__idata ? { ...re, ...K } : K,
                {}
              ),
              [L]: d[R],
              ...B !== null ? { [B]: z ? Number(R) : R } : {}
            },
            "__idata",
            { enumerable: !1, value: !0 }
          );
          M.unshift(W), w.push($.bind(null, W)()), M.shift();
        }
        return w;
      };
    }
    return g;
  }
  function u(m, p) {
    if (Array.isArray(p)) {
      const b = p.map(o.bind(null, m));
      return (_) => b.map((P) => P(_));
    }
    const y = o(m, p);
    return (b) => y(b);
  }
  const c = [];
  function v(m, p = {}) {
    const y = /* @__PURE__ */ new WeakMap();
    return c.push((b, _) => {
      y.set(
        _,
        m.provide((P) => b(P, p))
      );
    }), () => y.get(Ae)();
  }
  function h(m, p) {
    n ?? (n = Qi(t));
    const [y, b] = ae(mn, n) ? mn[n] : [u(e, t), c];
    return Gi || (jt[n] ?? (jt[n] = 0), jt[n]++, mn[n] = [y, b]), b.forEach((_) => {
      _(m, p);
    }), () => (Ae = p, y());
  }
  return h;
}
function Yi(e, t) {
  const n = lt.get(Ae) || [];
  let a;
  return n.length && (a = kr(n, e.split("."))), a === void 0 ? t : a;
}
function Qh(e, t) {
  return new Proxy(e, {
    get(...n) {
      let a;
      const r = n[1];
      if (typeof r == "string") {
        const s = Ae;
        Ae = t, a = Yi(r, void 0), Ae = s;
      }
      return a !== void 0 ? a : Reflect.get(...n);
    }
  });
}
function vs(e, t, n) {
  return e(
    (a, r = {}) => a.reduce((s, i) => {
      if (i.startsWith("slots.")) {
        const l = i.substring(6), o = () => t.slots && ae(t.slots, l) && typeof t.slots[l] == "function";
        if (r.if)
          s[i] = o;
        else if (t.slots) {
          const u = Qh(t, n);
          s[i] = () => o() ? t.slots[l](u) : null;
        }
      } else {
        const l = Gh(i, t);
        s[i] = () => Yi(i, l.value);
      }
      return s;
    }, {}),
    n
  );
}
function ps(e, t, n) {
  if (t ?? (t = Qi(e)), jt[t]--, jt[t] === 0) {
    delete jt[t];
    const [, a] = mn[t];
    delete mn[t], a.length = 0;
  }
  lt.delete(n);
}
function Qi(e) {
  return JSON.stringify(e, (t, n) => typeof n == "function" ? n.toString() : n);
}
var Xh = /* @__PURE__ */ j({
  name: "FormKitSchema",
  props: {
    schema: {
      type: [Array, Object],
      required: !0
    },
    data: {
      type: Object,
      default: () => ({})
    },
    library: {
      type: Object,
      default: () => ({})
    },
    memoKey: {
      type: String,
      required: !1
    }
  },
  emits: ["mounted"],
  setup(e, t) {
    const n = pn();
    let a = {};
    lt.set(a, []);
    const r = { FormKit: Wa(Zi), ...e.library };
    let s = ms(r, e.schema, e.memoKey), i, l;
    Gi || ce(
      () => e.schema,
      (u, c) => {
        const v = a;
        a = {}, lt.set(a, []), s = ms(r, e.schema, e.memoKey), i = vs(s, l, a), u === c && (n?.proxy?.$forceUpdate)(), ps(e.schema, e.memoKey, v);
      },
      { deep: !0 }
    ), We(() => {
      l = Object.assign(yt(e.data ?? {}), {
        slots: t.slots
      }), t.slots, i = vs(s, l, a);
    });
    function o() {
      ps(e.schema, e.memoKey, a), l && (l.node && l.node.destroy(), l.slots = null, l = null), i = null;
    }
    return he(() => t.emit("mounted")), qa(o), Wh(pn()?.appContext.app, o), () => i ? i() : null;
  }
}), Zh = typeof window > "u", hs = Symbol("FormKitParent"), Jh = Symbol("FormKitComponentCallback");
function ey(e, t) {
  const n = iy(e, t);
  if (n.props.definition || He(600, n), n.props.definition.component)
    return () => Ta(
      n.props.definition?.component,
      {
        context: n.context
      },
      { ...t.slots }
    );
  const a = E([]);
  let r = n.props.definition.schemaMemoKey;
  const s = () => {
    const u = n.props?.definition?.schema;
    u || He(601, n), typeof u == "function" ? (a.value = u({ ...e.sectionsSchema || {} }), (r && e.sectionsSchema || "memoKey" in u && typeof u.memoKey == "string") && (r = (r ?? u?.memoKey) + JSON.stringify(e.sectionsSchema))) : a.value = u;
  };
  s(), Zh || n.on("schema", () => {
    r += "♻️", s();
  }), t.emit("node", n);
  const i = n.props.definition.library, l = {
    FormKit: Wa(Xi),
    ...i,
    ...e.library ?? {}
  };
  function o() {
    n.emit("mounted");
  }
  return t.expose({ node: n }), () => Ta(
    Xh,
    {
      schema: a.value,
      data: n.context,
      onMounted: o,
      library: l,
      memoKey: r
    },
    { ...t.slots }
  );
}
var Xi = /* @__PURE__ */ j(
  ey,
  {
    props: Rp,
    inheritAttrs: !1
  }
), Zi = Xi, ty = Symbol(), ny = Symbol.for("FormKitOptions"), ay = typeof window < "u", Ia = [
  // Boolean props
  "ignore",
  "disabled",
  "preserve",
  // String props
  "help",
  "label",
  /^preserve(-e|E)rrors/,
  /^[a-z]+(?:-visibility|Visibility|-behavior|Behavior)$/,
  /^[a-zA-Z-]+(?:-class|Class)$/,
  "prefixIcon",
  "suffixIcon",
  /^[a-zA-Z-]+(?:-icon|Icon)$/
], ry = ["disabled", "ignore", "preserve"];
function ys(e, t) {
  t.classes && Object.keys(t.classes).forEach(
    (n) => {
      typeof n == "string" && (e.props[`_${n}Class`] = t.classes[n], fn(t.classes[n]) && n === "inner" && Object.values(t.classes[n]));
    }
  );
}
function sy(e) {
  return e ? ["Submit", "SubmitRaw", "SubmitInvalid"].reduce(
    (n, a) => {
      const r = `on${a}`;
      return r in e && typeof e[r] == "function" && (n[r] = e[r]), n;
    },
    {}
  ) : {};
}
function iy(e, t, n = {}) {
  const a = Object.assign({}, J(ny) || {}, n), r = J(ty, E(ay ? document : void 0)), s = J(Jh, () => {
  }), i = pn(), l = sy(i?.vnode.props), o = ["modelValue", "model-value"].some(
    (g) => g in (i?.vnode.props ?? {})
  );
  let u = !1;
  he(() => {
    u = !0;
  });
  const c = e.modelValue !== void 0 ? e.modelValue : Qe(t.attrs.value);
  function v() {
    const g = {
      ...Mt(e),
      ...l,
      type: e.type ?? "text",
      __root: r.value,
      __slots: t.slots
    }, $ = zr(Mt(t.attrs), Ia);
    $.key || ($.key = Jt()), g.attrs = $;
    const S = jr(Mt(t.attrs), Ia);
    for (const B in S)
      ry.includes(B) && S[B] === "" && (S[B] = !0), g[Ht(B)] = S[B];
    const L = { props: {} };
    return ys(L, e), Object.assign(g, L.props), typeof g.type != "string" && (g.definition = g.type, delete g.type), g;
  }
  const h = v(), m = h.ignore ? null : e.parent || J(hs, null), p = Zm(
    bt(
      a || {},
      {
        name: e.name || void 0,
        value: c,
        parent: m,
        plugins: (a.plugins || []).concat(e.plugins ?? []),
        config: e.config || {},
        props: h,
        index: e.index,
        sync: !!Xe(t.attrs.sync || t.attrs.dynamic)
      },
      !1,
      !0
    )
  );
  s(p), p.props.definition || He(600, p);
  const y = E(
    new Set(
      Array.isArray(p.props.__propDefs) ? p.props.__propDefs : Object.keys(p.props.__propDefs ?? {})
    )
  );
  p.on(
    "added-props",
    ({ payload: g }) => {
      (Array.isArray(g) ? g : Object.keys(g ?? {})).forEach((S) => y.value.add(S));
    }
  );
  const b = x(
    () => Ia.concat([...y.value]).reduce((g, $) => (typeof $ == "string" ? (g.push(Ht($)), g.push(ai($))) : g.push($), g), [])
  );
  We(() => ys(p, e));
  const _ = Mt(e);
  for (const g in _)
    ce(
      () => e[g],
      () => {
        e[g] !== void 0 && (p.props[g] = e[g]);
      }
    );
  We(() => {
    p.props.__root = r.value;
  });
  const P = /* @__PURE__ */ new Set(), I = Mt(t.attrs);
  We(() => {
    k(jr(I, b.value));
  });
  function k(g) {
    P.forEach(($) => {
      $(), P.delete($);
    });
    for (const $ in g) {
      const S = Ht($);
      P.add(
        ce(
          () => t.attrs[$],
          () => {
            p.props[S] = t.attrs[$];
          }
        )
      );
    }
  }
  if (We(() => {
    const g = zr(Mt(t.attrs), b.value);
    "multiple" in g && (g.multiple = Xe(g.multiple)), typeof g.onBlur == "function" && (g.onBlur = Rf(g.onBlur)), p.props.attrs = Object.assign({}, p.props.attrs || {}, g);
  }), We(() => {
    const g = (e.errors ?? []).map(
      ($) => /* @__PURE__ */ ze({
        key: ur($),
        type: "error",
        value: $,
        meta: { source: "prop" }
      })
    );
    p.store.apply(
      g,
      ($) => $.type === "error" && $.meta.source === "prop"
    );
  }), p.type !== "input") {
    const g = `${p.name}-prop`;
    We(() => {
      const $ = e.inputErrors ?? {}, S = Object.keys($);
      S.length || p.clearErrors(!0, g);
      const L = S.reduce((B, N) => {
        let d = $[N];
        return typeof d == "string" && (d = [d]), Array.isArray(d) && (B[N] = d.map(
          (w) => /* @__PURE__ */ ze({
            key: w,
            type: "error",
            value: w,
            meta: { source: g }
          })
        )), B;
      }, {});
      p.store.apply(
        L,
        (B) => B.type === "error" && B.meta.source === g
      );
    });
  }
  We(() => Object.assign(p.config, e.config)), p.type !== "input" && ge(hs, p);
  let T;
  return p.on("modelUpdated", () => {
    t.emit("inputRaw", p.context?.value, p), u && t.emit("input", p.context?.value, p), o && p.context && (T = Qe(p.value), t.emit("update:modelValue", Aa(p.value)));
  }), o && (ce(
    Es(e, "modelValue"),
    (g) => {
      Le(T, g) || p.input(g, !1);
    },
    { deep: !0 }
  ), p.value !== c && p.emit("modelUpdated")), je(() => p.destroy()), p;
}
var ly = /* @__PURE__ */ ne("messages", () => ({
  $el: "ul",
  if: "$fns.length($messages)"
})), oy = /* @__PURE__ */ ne("message", () => ({
  $el: "li",
  for: ["message", "$messages"],
  attrs: {
    key: "$message.key",
    id: "$id + '-' + $message.key",
    "data-message-type": "$message.type"
  }
}));
ly(oy("$message.value"));
var uy = /* @__PURE__ */ ne("summary", () => ({
  $el: "div",
  attrs: {
    "aria-live": "polite"
  }
})), cy = /* @__PURE__ */ ne("summaryInner", () => ({
  $el: "div",
  if: "$summaries.length && $showSummaries"
})), dy = /* @__PURE__ */ ne("messages", () => ({
  $el: "ul",
  if: "$summaries.length && $showSummaries"
})), fy = /* @__PURE__ */ ne("message", () => ({
  $el: "li",
  for: ["summary", "$summaries"],
  attrs: {
    key: "$summary.key",
    "data-message-type": "$summary.type"
  }
})), my = /* @__PURE__ */ ne("summaryHeader", () => ({
  $el: "h2",
  attrs: {
    id: "$id"
  }
})), vy = /* @__PURE__ */ ne("messageLink", () => ({
  $el: "a",
  attrs: {
    id: "$summary.key",
    href: '$: "#" + $summary.id',
    onClick: "$jumpLink"
  }
}));
uy(
  cy(
    my("$summaryHeader"),
    dy(fy(vy("$summary.message")))
  )
);
jh();
Ui();
function py({
  container: e,
  button: t,
  popoverState: n
}) {
  const a = E(!0), r = E(!0), s = () => {
    if (!t.value || !e.value) return;
    const i = t.value.getBoundingClientRect();
    e.value.style.setProperty(
      "--anchor-bottom",
      `${i.bottom}px`
    ), e.value.style.setProperty(
      "--anchor-right",
      `${i.right}px`
    );
  };
  return he(() => {
    a.value = typeof HTMLElement.prototype.showPopover == "function", r.value = CSS.supports(
      "inset-block-start: anchor(bottom)"
    ), a.value || ra(e, () => {
      n.value = "closed";
    }), r.value || (s(), window.addEventListener("resize", s));
  }), je(() => {
    window.removeEventListener("resize", s);
  }), {
    supportsPopoverApi: a,
    supportsAnchorPositioning: r
  };
}
const hy = ["data-popover-fallback", "data-popover-state"], yy = ["popovertarget"], gy = ["id"], by = { class: "ds-nav-popover__scroll" }, ky = {
  key: 0,
  class: "ds-nav-popover__filter"
}, _y = {
  key: 1,
  class: "ds-nav-popover__list"
}, wy = ["href", "target"], $y = /* @__PURE__ */ j({
  __name: "ds-nav-popover",
  props: {
    autoFocusFilter: { type: Boolean, default: !0 },
    item: {}
  },
  setup(e) {
    const t = e, n = E("closed"), a = E(""), r = E(), s = E(), i = x(() => `ds-nav-popover__button--${n.value}`), l = x(() => t.item.children.filter(
      (v) => v.text.toLowerCase().indexOf(a.value.toLowerCase()) > -1 || v.textAlternative && v.textAlternative?.toLowerCase().indexOf(a.value.toLowerCase()) > -1
    )), o = async (v) => {
      n.value = v.newState;
    }, { supportsPopoverApi: u } = py({
      container: r,
      button: s,
      popoverState: n
    }), c = () => {
      u.value || (n.value = n.value === "open" ? "closed" : "open");
    };
    return (v, h) => (f(), C("div", {
      ref_key: "container",
      ref: r,
      class: "ds-nav-popover",
      "data-popover-fallback": D(u) ? void 0 : !0,
      "data-popover-state": D(u) ? void 0 : n.value,
      "data-testid": "popover-container"
    }, [
      O("button", ke(e.item.attributes, {
        ref_key: "button",
        ref: s,
        class: ["ds-nav-popover__button", i.value],
        popovertarget: `popover-${e.item.itemId}`,
        type: "button",
        onClick: c
      }), [
        e.item.iconName ? (f(), F(ie, {
          key: 0,
          "icon-name": e.item.iconName,
          size: "xs"
        }, null, 8, ["icon-name"])) : A("", !0),
        V(Q, {
          "text-type": "label-sm",
          "html-element": "span"
        }, {
          default: H(() => [
            G(q(e.item.text), 1)
          ]),
          _: 1
        }),
        V(ie, {
          class: "ds-nav-popover__button-icon",
          "icon-name": "button-chevron-down",
          size: "xs"
        })
      ], 16, yy),
      O("div", {
        id: `popover-${e.item.itemId}`,
        "data-testid": "popover",
        popover: "auto",
        class: "ds-nav-popover__popover",
        onBeforetoggle: o
      }, [
        O("div", by, [
          e.item.filterEnabled ? (f(), C("div", ky, [
            V(D(Zi), {
              modelValue: a.value,
              "onUpdate:modelValue": h[0] || (h[0] = (m) => a.value = m),
              type: "search",
              "prefix-icon": "search",
              placeholder: e.item.filterPlaceholder,
              autofocus: e.autoFocusFilter
            }, null, 8, ["modelValue", "placeholder", "autofocus"])
          ])) : A("", !0),
          l.value.length ? (f(), C("ul", _y, [
            (f(!0), C(le, null, ve(l.value, (m) => (f(), C("li", {
              key: m.itemId,
              class: "ds-nav-popover__item"
            }, [
              O("a", {
                class: Y([
                  "ds-nav-popover__link",
                  m.isActive ? "ds-nav-popover__link--active" : ""
                ]),
                href: m.linkUrl,
                target: m.linkTarget
              }, [
                V(Q, {
                  class: "ds-nav-popover__link-text",
                  "html-element": "span",
                  "text-type": "label-md"
                }, {
                  default: H(() => [
                    G(q(m.text), 1)
                  ]),
                  _: 2
                }, 1024)
              ], 10, wy)
            ]))), 128))
          ])) : e.item.filterNoResultsLabel ? (f(), F(Q, {
            key: 2,
            class: "ds-nav-popover__no-results",
            "html-element": "div",
            "text-type": "label-sm"
          }, {
            default: H(() => [
              G(q(e.item.filterNoResultsLabel), 1)
            ]),
            _: 1
          })) : A("", !0)
        ])
      ], 40, gy)
    ], 8, hy));
  }
}), xy = ["aria-label"], Iy = {
  key: 0,
  class: "ds-nav-service__list"
}, Sy = ["href"], Wb = /* @__PURE__ */ j({
  __name: "ds-nav-service",
  props: {
    ariaLabel: { default: "Service navigation" },
    autoFocusFilter: { type: Boolean, default: !0 },
    items: {}
  },
  setup(e) {
    const t = E(!1), { isMobile: n } = Be();
    return he(() => {
      t.value = !0;
    }), (a, r) => t.value && !D(n) ? (f(), C("nav", {
      key: 0,
      class: "ds-nav-service",
      "aria-label": e.ariaLabel
    }, [
      e.items && e.items.length ? (f(), C("ul", Iy, [
        (f(!0), C(le, null, ve(e.items, (s) => (f(), C("li", {
          key: s.itemId,
          class: "ds-nav-service__item"
        }, [
          s.type === "service" ? (f(), C("a", ke({
            key: 0,
            ref_for: !0
          }, s.attributes, {
            class: "ds-nav-service__link",
            href: s.linkUrl
          }), [
            s.iconName ? (f(), F(ie, {
              key: 0,
              "icon-name": s.iconName,
              size: "xs"
            }, null, 8, ["icon-name"])) : A("", !0),
            V(Q, {
              "text-type": "label-sm",
              "html-element": "span"
            }, {
              default: H(() => [
                G(q(s.text), 1)
              ]),
              _: 2
            }, 1024)
          ], 16, Sy)) : s.type === "popover" ? (f(), F($y, {
            key: 1,
            "auto-focus-filter": e.autoFocusFilter,
            item: s
          }, null, 8, ["auto-focus-filter", "item"])) : A("", !0)
        ]))), 128))
      ])) : A("", !0)
    ], 8, xy)) : ue(a.$slots, "default", { key: 1 });
  }
}), Ty = { class: "ds-underscore" }, Py = /* @__PURE__ */ j({
  __name: "ds-underscore",
  setup(e) {
    return (t, n) => (f(), C("span", Ty));
  }
}), Cy = ["innerHTML"], Ub = /* @__PURE__ */ j({
  __name: "ds-page-header",
  props: {
    title: {},
    text: {}
  },
  setup(e) {
    return (t, n) => (f(), F(ta, {
      "padding-bottom": "close",
      class: "ds-page-header"
    }, {
      default: H(() => [
        V(Q, {
          class: "ds-page-header__title",
          "text-style": "medium",
          "text-type": "heading-8xl",
          "html-element": "h1"
        }, {
          default: H(() => [
            G(q(e.title), 1),
            V(Py)
          ]),
          _: 1
        }),
        e.text ? (f(), F(Q, {
          key: 0,
          class: "ds-page-header__text",
          "text-type": "heading-xl"
        }, {
          default: H(() => [
            O("span", { innerHTML: e.text }, null, 8, Cy)
          ]),
          _: 1
        })) : A("", !0)
      ]),
      _: 1
    }));
  }
}), Ey = {
  key: 0,
  class: "ds-pagination"
}, Ay = ["aria-label"], My = { class: "ds-pagination__list" }, Ly = { class: "ds-visually-hidden" }, Oy = {
  key: 1,
  class: "ds-pagination__truncator"
}, Ot = 1, Ny = 2, gs = "...", Kb = /* @__PURE__ */ j({
  __name: "ds-pagination",
  props: {
    currentPage: { default: 1 },
    pageSize: { default: 10 },
    totalResults: {},
    labelNext: { default: "Next" },
    labelPage: { default: "page" },
    labelPagination: { default: "Pagination" },
    labelPrevious: { default: "Previous" },
    labelResults: { default: "{startRange} - {endRange} of {total} results" },
    navigationHandler: { type: Function, default: void 0 },
    navigationPreventDefault: { type: Boolean, default: !0 },
    urlStructure: { default: window.location.pathname + "?page={page}" }
  },
  setup(e) {
    const t = e;
    if (typeof t.totalResults != "number" || typeof t.pageSize != "number" || typeof t.currentPage != "number")
      throw new Error(
        "Ensure you're using number type values for totalResults, pageSize and currentPage"
      );
    const n = (g) => {
      t.navigationPreventDefault && g.preventDefault();
    }, a = (g) => g > 0 && g <= y.value, r = (g, $) => {
      if (n(g), a($)) {
        if (t.navigationHandler)
          try {
            t.navigationHandler($);
          } catch (S) {
            console.error(S, "Error calling navigationHandler");
            return;
          }
        o.value = $;
      }
    }, s = (g) => {
      r(g, u.value - 1);
    }, i = (g) => {
      r(g, u.value + 1);
    };
    let l = !1;
    const o = E(t.currentPage);
    ce(
      () => t.currentPage,
      (g) => {
        o.value = g;
      },
      { immediate: !0 }
    );
    const u = x(() => o.value < Ot ? Ot : o.value > y.value ? y.value : o.value), c = x(() => u.value > Ot ? u.value - 1 : Ot), v = x(() => u.value < y.value ? u.value + 1 : y.value), h = x(
      () => t.pageSize * (u.value - 1) + 1
    ), m = x(
      () => t.pageSize * u.value < t.totalResults ? t.pageSize * u.value : t.totalResults
    ), p = x(
      () => `${t.labelResults.replace("{startRange}", h.value.toString()).replace("{endRange}", m.value.toString()).replace("{total}", t.totalResults.toString())}`
    ), y = x(() => Math.ceil(t.totalResults / t.pageSize));
    let b = x(() => _.value ? 5 : 9);
    const { isMobile: _ } = Be(), P = (g, $, S, L, B) => {
      for (B = Number(Math.min(B, L)); g.length < B; ) {
        const N = $ - S, d = $ + S;
        N >= Ot && g.unshift(N), d <= L && g.length < B && g.push(d), S++;
      }
      return g;
    }, I = (g, $, S) => {
      if ($ < S) return g;
      const L = [...g];
      return L[0] = Ot, L[L.length - 1] = $, L[1] !== Ny && (L[1] = gs), L[L.length - 2] !== $ - 1 && (L[L.length - 2] = gs), L;
    }, k = (g, $, S) => I(
      P(
        [g],
        g,
        1,
        $,
        S
      ),
      $,
      S
    ), T = x(() => k(
      u.value,
      y.value,
      b.value
    ));
    return l = !0, (g, $) => e.totalResults && y.value > 1 ? (f(), C("div", Ey, [
      D(l) ? A("", !0) : ue(g.$slots, "default", { key: 0 }),
      D(l) ? (f(), C("nav", {
        key: 1,
        "aria-label": e.labelPagination,
        class: "ds-pagination__nav"
      }, [
        V(Ie, {
          "icon-name": "button-chevron-left",
          "aria-label": e.labelPrevious,
          "click-handler": s,
          disabled: u.value === 1,
          href: e.urlStructure.replace(
            "{page}",
            c.value.toString()
          ),
          size: "sm",
          variant: "secondary"
        }, null, 8, ["aria-label", "disabled", "href"]),
        O("ul", My, [
          (f(!0), C(le, null, ve(T.value, (S, L) => (f(), C("li", {
            key: typeof S == "number" ? S : `trunc-${L}`
          }, [
            typeof S == "number" ? (f(), F(Ce, {
              key: 0,
              class: "ds-pagination__num",
              "aria-current": S === u.value ? !0 : null,
              padding: "padding-compact",
              selected: S === u.value,
              href: e.urlStructure.replace("{page}", S.toString()),
              variant: "link",
              onClick: (B) => r(B, S)
            }, {
              default: H(() => [
                O("span", Ly, q(e.labelPage), 1),
                G(" " + q(S), 1)
              ]),
              _: 2
            }, 1032, ["aria-current", "selected", "href", "onClick"])) : A("", !0),
            S === "..." ? (f(), C("div", Oy, " … ")) : A("", !0)
          ]))), 128))
        ]),
        V(Ie, {
          "icon-name": "button-chevron-right",
          "aria-label": e.labelNext,
          "click-handler": i,
          disabled: u.value === y.value,
          href: e.urlStructure.replace("{page}", v.value.toString()),
          size: "sm",
          variant: "secondary"
        }, null, 8, ["aria-label", "disabled", "href"])
      ], 8, Ay)) : A("", !0),
      V(Q, {
        "aria-live": "polite",
        "html-element": "div",
        "text-type": "label-sm",
        class: "ds-pagination__results"
      }, {
        default: H(() => [
          G(q(p.value), 1)
        ]),
        _: 1
      })
    ])) : A("", !0);
  }
}), By = {
  key: 0,
  class: "ds-progress-dots",
  "aria-hidden": "true"
}, Gb = /* @__PURE__ */ j({
  __name: "ds-progress-dots",
  props: {
    numberOfItems: {},
    activeIndex: { default: 0 }
  },
  setup(e) {
    return (t, n) => e.numberOfItems > 1 ? (f(), C("div", By, [
      (f(!0), C(le, null, ve(e.numberOfItems, (a, r) => (f(), C("div", {
        key: r,
        class: Y([
          "ds-progress-dots__dot",
          e.activeIndex === r ? "ds-progress-dots__dot--active" : void 0
        ])
      }, null, 2))), 128))
    ])) : A("", !0);
  }
}), Dy = ["aria-label", "disabled"], Fy = ["id", "min", "max", "disabled", "aria-label", "value"], Ry = ["aria-label", "disabled"], Yb = /* @__PURE__ */ j({
  __name: "ds-quantity-selector",
  props: {
    background: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    outline: { type: Boolean, default: !0 },
    min: { default: 0 },
    max: { default: 99 },
    debounceDuration: { default: 200 },
    modelValue: {},
    id: {},
    ariaLabelInput: {},
    ariaLabelDecreaseQuantity: {},
    ariaLabelIncreaseQuantity: {}
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    const n = e, a = t, r = E(null), s = x(() => ({
      "ds-quantity-selector": !0,
      "ds-quantity-selector--background": n.background,
      "ds-quantity-selector--disabled": n.disabled,
      "ds-quantity-selector--outline": n.outline
    })), i = () => {
      c(n.modelValue - 1);
    }, l = () => {
      c(n.modelValue + 1);
    }, o = (v) => {
      const h = v.target, m = Number(h.value.replace(/\D/g, "")), p = parseInt(m.toString(), 10);
      c(p);
    }, u = /* @__PURE__ */ tr((v) => {
      a("change", v);
    }, n.debounceDuration), c = (v) => {
      const h = Math.max(
        n.min,
        Math.min(n.max, v || n.min)
      );
      r.value !== null && h !== v && (r.value.value = `${h}`), a("update:modelValue", h), u(h);
    };
    return (v, h) => (f(), C("div", {
      class: Y(s.value)
    }, [
      O("button", {
        "aria-label": e.ariaLabelDecreaseQuantity,
        class: "ds-quantity-selector__button ds-quantity-selector__button--decrease",
        disabled: e.modelValue <= e.min || e.disabled,
        type: "button",
        onClick: gt(i, ["prevent"])
      }, [
        V(ie, { "icon-name": "subtract" })
      ], 8, Dy),
      O("input", {
        id: e.id,
        ref_key: "inputEl",
        ref: r,
        min: e.min,
        max: e.max,
        step: "1",
        class: "ds-quantity-selector__input",
        disabled: e.disabled,
        "aria-label": e.ariaLabelInput,
        "aria-live": "polite",
        type: "number",
        autocomplete: "off",
        value: e.modelValue,
        onInput: o
      }, null, 40, Fy),
      O("button", {
        "aria-label": e.ariaLabelIncreaseQuantity,
        class: "ds-quantity-selector__button ds-quantity-selector__button--increase",
        disabled: e.modelValue >= e.max || e.disabled,
        type: "button",
        onClick: gt(l, ["prevent"])
      }, [
        V(ie, { "icon-name": "add" })
      ], 8, Ry)
    ], 2));
  }
}), Hy = {
  class: "ds-scroll-progress-bar",
  "aria-hidden": "true"
}, Qb = /* @__PURE__ */ j({
  __name: "ds-scroll-progress-bar",
  props: {
    scrollContainerRef: {}
  },
  setup(e) {
    const t = e, n = E(0), a = E(0), r = E(0), s = x(
      () => r.value / a.value
    );
    let i = new ResizeObserver(() => {
      l(), o();
    });
    const l = () => {
      a.value = t.scrollContainerRef?.scrollWidth ?? 0, r.value = t.scrollContainerRef?.clientWidth ?? 0;
    }, o = () => {
      t.scrollContainerRef && (n.value = Math.abs(t.scrollContainerRef.scrollLeft) ?? 0);
    }, u = /* @__PURE__ */ Qs(
      () => {
        o();
      },
      100,
      !0
    );
    ce(
      () => t.scrollContainerRef,
      (h, m) => {
        m && m.removeEventListener("scroll", () => {
          u();
        }), h && (i.observe(h), h.addEventListener(
          "scroll",
          () => {
            u();
          },
          {
            passive: !0
          }
        ));
      },
      { immediate: !0 }
    ), je(() => {
      t.scrollContainerRef && t.scrollContainerRef.removeEventListener("scroll", () => {
        u();
      });
    });
    const c = x(() => {
      if (!t.scrollContainerRef || s.value === 1) return 0;
      let h = Math.min(
        n.value / a.value + s.value,
        1
      );
      return h > 0.98 ? 1 : h;
    }), v = x(() => ({
      "--progress-scale-factor": c.value.toString()
    }));
    return (h, m) => (f(), C("div", Hy, [
      O("div", {
        style: Te(v.value),
        class: "ds-scroll-progress-bar__bar"
      }, null, 4)
    ]));
  }
}), Vy = ["aria-hidden", "aria-live", "aria-label"], zy = {
  class: "ds-spinner__content",
  "aria-hidden": "true"
}, jy = ["innerHTML"], Xb = /* @__PURE__ */ j({
  __name: "ds-spinner",
  props: {
    accessibilityLabel: { default: "Loading" },
    accessibilityLabelCompleted: { default: "Completed" },
    displayMode: { default: "default" },
    label: { default: null },
    status: { default: "hidden" }
  },
  setup(e) {
    const t = e, n = E(null), a = x(() => t.status === "loading" ? t.label && t.label.trim() !== "" ? t.label : t.accessibilityLabel : t.status === "completed" ? t.accessibilityLabelCompleted : "");
    return (r, s) => (f(), C(le, null, [
      O("output", {
        class: "ds-spinner-status",
        "aria-hidden": e.status === "hidden",
        "aria-live": e.status === "loading" ? "assertive" : "polite",
        "aria-label": a.value
      }, null, 8, Vy),
      e.status === "loading" ? (f(), C("div", {
        key: 0,
        class: Y(["ds-spinner", e.displayMode === "solid" ? "--solid" : null])
      }, [
        O("div", zy, [
          V(Ls),
          e.label ? (f(), F(Q, {
            key: 0,
            "html-element": "p",
            "text-style": "medium",
            "text-type": "heading-md",
            class: "ds-spinner__label"
          }, {
            default: H(() => [
              O("span", {
                ref_key: "textLabel",
                ref: n,
                innerHTML: e.label
              }, null, 8, jy)
            ]),
            _: 1
          })) : A("", !0)
        ])
      ], 2)) : A("", !0)
    ], 64));
  }
}), qy = (e) => /^[+-]?\d+(\.\d+)?$/.test(`${e}`), Va = (e) => qy(e) ? `${e}px` : typeof e > "u" ? "auto" : e, ua = /* @__PURE__ */ j({
  __name: "ds-skeleton-element",
  props: {
    additionalClasses: { default: "" },
    aspectRatio: {},
    height: {},
    width: {}
  },
  setup(e) {
    const t = e, n = x(() => {
      let a = {};
      return t.height && (a = {
        ...a,
        "--skeleton-height": `${Va(t.height)}`
      }), t.width && (a = {
        ...a,
        "--skeleton-width": `${Va(t.width)}`
      }), t.aspectRatio && (a = {
        ...a,
        "--skeleton-aspect-ratio": `${t.aspectRatio}`
      }), a;
    });
    return (a, r) => (f(), C("div", {
      class: Y(["ds-skeleton-element", e.additionalClasses]),
      style: Te(n.value)
    }, null, 6));
  }
}), Zb = /* @__PURE__ */ j({
  __name: "ds-skeleton-box",
  props: {
    additionalClasses: { default: "" },
    aspectRatio: {},
    height: {},
    presetHeight: {},
    width: {}
  },
  setup(e) {
    const t = e, n = () => {
      switch (t.presetHeight) {
        case "small":
          return 56;
        case "medium":
          return 88;
        case "large":
          return 124;
        case "full":
          return 215;
        default:
          return;
      }
    }, a = x(() => t.height ? t.height : n());
    return (r, s) => (f(), F(ua, {
      class: Y(["ds-skeleton-box", e.additionalClasses]),
      "additional-classes": e.additionalClasses,
      "aspect-ratio": e.aspectRatio,
      height: a.value,
      width: e.width
    }, null, 8, ["class", "additional-classes", "aspect-ratio", "height", "width"]));
  }
}), Jb = /* @__PURE__ */ j({
  __name: "ds-skeleton-button",
  props: {
    additionalClasses: { default: "" },
    height: {},
    presetHeight: {},
    width: {}
  },
  setup(e) {
    const t = e, n = () => {
      switch (t.presetHeight) {
        case "small":
        case "icon-small":
          return 34;
        case "medium":
        case "icon-medium":
          return 46;
        default:
          return;
      }
    }, a = x(() => {
      if (t.presetHeight === "icon-medium" || t.presetHeight === "icon-small")
        return 1;
    }), r = x(() => t.height ? t.height : n()), s = x(() => {
      if (t.width) return t.width;
      if (t.presetHeight === "icon-medium" || t.presetHeight === "icon-small")
        return "auto";
    });
    return (i, l) => (f(), F(ua, {
      class: Y(["ds-skeleton-button", e.additionalClasses]),
      "additional-classes": e.additionalClasses,
      "aspect-ratio": a.value,
      height: r.value,
      width: s.value
    }, null, 8, ["class", "additional-classes", "aspect-ratio", "height", "width"]));
  }
}), ek = /* @__PURE__ */ j({
  __name: "ds-skeleton-circle",
  props: {
    additionalClasses: { default: "" },
    diameter: {},
    presetDiameter: {}
  },
  setup(e) {
    const t = e, n = () => {
      switch (t.presetDiameter) {
        case "small":
          return 24;
        case "medium":
          return 40;
        case "large":
          return 72;
        default:
          return;
      }
    }, a = x(() => t.diameter ? t.diameter : n());
    return (r, s) => (f(), F(ua, {
      class: Y(["ds-skeleton-circle", e.additionalClasses]),
      "aspect-ratio": 1,
      height: a.value,
      width: a.value
    }, null, 8, ["class", "height", "width"]));
  }
}), Ji = {
  elevation: "default",
  padding: "none"
}, el = /* @__PURE__ */ j({
  __name: "ds-surface",
  props: /* @__PURE__ */ As({
    elevation: {},
    padding: {}
  }, {
    ...Ji
  }),
  setup(e) {
    const t = e, n = x(() => `ds-surface--${t.elevation}`), a = x(() => `ds-surface--pad-${t.padding}`);
    return (r, s) => (f(), C("div", {
      class: Y(["ds-surface", [n.value, a.value]])
    }, [
      ue(r.$slots, "default")
    ], 2));
  }
}), tk = /* @__PURE__ */ j({
  __name: "ds-skeleton-surface",
  props: /* @__PURE__ */ As({
    elevation: {},
    padding: {}
  }, {
    ...Ji
  }),
  setup(e) {
    const t = e;
    return (n, a) => (f(), F(el, ke({ class: "ds-skeleton-surface" }, t), {
      default: H(() => [
        ue(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), nk = /* @__PURE__ */ j({
  __name: "ds-skeleton-text-line",
  props: {
    additionalClasses: { default: "" },
    height: {},
    presetHeight: {},
    width: { default: "100%" }
  },
  setup(e) {
    const t = e, n = () => {
      switch (t.presetHeight) {
        case "small":
          return 12;
        case "medium":
          return 16;
        case "large":
          return 24;
        default:
          return;
      }
    }, a = x(() => t.height ? t.height : n());
    return (r, s) => (f(), F(ua, {
      class: Y(["ds-skeleton-text", e.additionalClasses]),
      "additional-classes": e.additionalClasses,
      height: a.value,
      width: e.width
    }, null, 8, ["class", "additional-classes", "height", "width"]));
  }
}), ak = /* @__PURE__ */ j({
  __name: "ds-skeleton-wrapper",
  setup(e) {
    const t = E(null);
    let n = E(t?.value?.offsetWidth);
    Hn(t, (r) => {
      const s = r[0];
      s && (n.value = s.contentRect.width);
    });
    const a = x(() => typeof n.value < "u" ? {
      "--skeleton-container-width": `${Va(n.value)}`
    } : {});
    return (r, s) => (f(), C("div", {
      ref_key: "container",
      ref: t,
      class: "ds-skeleton",
      style: Te(a.value),
      "data-testid": "skeleton",
      "aria-hidden": "true"
    }, [
      ue(r.$slots, "default")
    ], 4));
  }
}), Wy = ["innerHTML"], Uy = ["innerHTML"], Ky = /* @__PURE__ */ j({
  __name: "ds-fact",
  props: {
    brandIconName: {},
    stat: {},
    text: {},
    variant: { default: "default" }
  },
  setup(e) {
    return (t, n) => (f(), C("article", {
      class: Y(["ds-fact", `ds-fact--${e.variant}`])
    }, [
      e.stat ? (f(), F(Q, {
        key: 0,
        class: "ds-fact__stat",
        "html-element": "h3",
        "text-type": "heading-4xl",
        "text-style": "regular"
      }, {
        default: H(() => [
          O("span", { innerHTML: e.stat }, null, 8, Wy)
        ]),
        _: 1
      })) : A("", !0),
      e.brandIconName ? (f(), F(Os, {
        key: 1,
        class: "ds-fact__icon",
        "icon-name": e.brandIconName,
        size: "sm",
        mode: e.variant
      }, null, 8, ["icon-name", "mode"])) : A("", !0),
      V(Q, {
        class: "ds-fact__text",
        "html-element": "p",
        "text-type": "body-xs",
        "text-style": "regular"
      }, {
        default: H(() => [
          O("span", { innerHTML: e.text }, null, 8, Uy)
        ]),
        _: 1
      })
    ], 2));
  }
}), Gy = ["src", "alt"], tl = /* @__PURE__ */ j({
  __name: "ds-sticky-media",
  props: {
    stackingIndex: {},
    isActive: { type: Boolean },
    imageAlt: {},
    imageSrc: {},
    mediaFocalPoint: { default: "center" }
  },
  setup(e) {
    const t = e, n = x(() => {
      const a = [];
      return t.mediaFocalPoint !== "center" && a.push(`--object-position: ${t.mediaFocalPoint};`), a;
    });
    return (a, r) => (f(), C("div", {
      class: Y(["ds-sticky-media", { "is-visible": e.isActive }]),
      style: Te({
        zIndex: `${e.stackingIndex}`
      })
    }, [
      e.imageSrc ? (f(), C("img", {
        key: 0,
        class: "ds-sticky-media__image",
        src: e.imageSrc,
        alt: e.imageAlt,
        style: Te(n.value)
      }, null, 12, Gy)) : A("", !0)
    ], 6));
  }
}), Yy = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  "2xl": 1400
}, Qy = (e = ["sm", "md", "lg", "xl", "2xl"]) => {
  const t = yt(
    {}
  ), n = {}, a = {};
  return he(() => {
    e.forEach((r) => {
      const s = Yy[r], i = window.matchMedia(`(min-width: ${s}px)`);
      n[r] = i, t[r] = i.matches;
      const l = (o) => {
        t[r] = o.matches;
      };
      a[r] = l, i.addEventListener("change", l);
    });
  }), je(() => {
    e.forEach((r) => {
      const s = n[r], i = a[r];
      s && i && s.removeEventListener("change", i);
    });
  }), t;
}, Xy = { class: "ds-sticky-panel__content" }, Zy = { class: "ds-sticky-panel__content-top" }, Jy = {
  key: 0,
  class: "ds-sticky-panel__content-bottom"
}, eg = "button-external-link", tg = "button-navigate-forward", ng = /* @__PURE__ */ j({
  __name: "ds-sticky-panel",
  props: {
    activeBgColour: {},
    activeIndex: {},
    bgColour: {},
    facts: {},
    index: { default: 0 },
    linkIsExternal: { type: Boolean, default: !1 },
    linkText: {},
    linkUrl: {},
    numberOfPanels: { default: 0 },
    mediaFocalPoint: { default: "center" },
    tag: {},
    title: {},
    text: {},
    image: {},
    imageAlt: {}
  },
  setup(e) {
    const t = e, n = Qy(["xl"]), a = x(() => t.linkIsExternal ? eg : tg), r = x(() => n.xl ? t.activeBgColour === "inverse" ? "inverse" : "default" : t.bgColour === "inverse" ? "inverse" : "default"), s = x(() => n.xl ? t.activeBgColour === "inverse" ? "link-inverted" : "link" : t.bgColour === "inverse" ? "link-inverted" : "link"), i = x(() => {
      const u = [];
      return t.activeIndex === t.index && u.push("ds-sticky-panel--active"), u.push(`ds-sticky-panel--bg-${t.bgColour}`), u;
    }), l = x(() => t.index), o = x(() => t.numberOfPanels - t.index);
    return (u, c) => (f(), F(ta, {
      class: Y(["ds-sticky-panel", i.value]),
      style: Te({
        zIndex: `${l.value}`
      })
    }, {
      default: H(() => [
        O("div", Xy, [
          O("div", Zy, [
            D(n).xl ? A("", !0) : (f(), F(tl, {
              key: 0,
              "image-alt": e.imageAlt,
              "image-src": e.image,
              "is-active": !0,
              "stacking-index": o.value,
              "media-focal-point": e.mediaFocalPoint
            }, null, 8, ["image-alt", "image-src", "stacking-index", "media-focal-point"])),
            e.tag ? (f(), F(Xs, {
              key: 1,
              class: "ds-sticky-panel__tag",
              text: e.tag
            }, null, 8, ["text"])) : A("", !0),
            V(Q, {
              class: "ds-sticky-panel__title",
              "html-element": "h2",
              "text-type": "heading-5xl",
              "text-style": "medium"
            }, {
              default: H(() => [
                G(q(e.title), 1)
              ]),
              _: 1
            }),
            V(Q, {
              class: "ds-sticky-panel__text",
              "text-type": "body-md",
              "text-style": "regular"
            }, {
              default: H(() => [
                G(q(e.text), 1)
              ]),
              _: 1
            }),
            e.linkText ? (f(), F(Ce, {
              key: 2,
              variant: s.value,
              href: e.linkUrl,
              "icon-end": a.value,
              target: e.linkIsExternal ? "_blank" : void 0
            }, {
              default: H(() => [
                G(q(e.linkText), 1)
              ]),
              _: 1
            }, 8, ["variant", "href", "icon-end", "target"])) : A("", !0)
          ]),
          e.facts?.length ? (f(), C("div", Jy, [
            (f(!0), C(le, null, ve(e.facts, (v) => (f(), F(Ky, {
              key: v.text,
              stat: v.stat,
              "brand-icon-name": v.brandIconName,
              variant: r.value,
              text: v.text
            }, null, 8, ["stat", "brand-icon-name", "variant", "text"]))), 128))
          ])) : A("", !0)
        ])
      ]),
      _: 1
    }, 8, ["class", "style"]));
  }
}), ag = {
  key: 0,
  class: "ds-sticky-panels__media"
}, rg = 0.1, sg = 0.8, rk = /* @__PURE__ */ j({
  __name: "ds-sticky-panels",
  props: {
    panels: { default: () => [] },
    scrollSnap: { default: "mandatory" },
    stickyHeaderOffset: { default: 0 }
  },
  setup(e) {
    const t = e, { isMobile: n } = Be(), { isMobile: a } = Be(1200), r = E(null), s = E(null), i = E(null), l = E([]), o = E(0), u = E(!1), c = E(!1), v = E(!1), h = x(
      () => u.value && c.value && v.value
    ), { directions: m } = ar(window), p = ["inverse", "decorative-2-subtle", "decorative-3-muted"], y = x(() => p[o.value % p.length]), b = x(() => !m.bottom && o.value === 0 || !m.top && o.value === l.value.length - 1 ? !1 : h.value), _ = x(() => {
      const S = [`ds-sticky-panels--bg-${y.value}`];
      return b.value && !a.value && S.push("ds-sticky-panels--active"), t.scrollSnap && !a.value && S.push(`ds-sticky-panels--scroll-snap-${t.scrollSnap}`), S;
    }), P = (S, L) => {
      const B = S?.$el ?? S;
      l.value[L] = B instanceof HTMLElement ? B : null;
    }, I = (S) => {
      const L = S.getBoundingClientRect();
      if (L.height <= 0) return 0;
      const B = Math.min(L.bottom, window.innerHeight) - Math.max(L.top, 0);
      return Math.max(0, B / L.height);
    }, k = () => l.value.reduce(
      (S, L, B) => {
        if (!L) return S;
        const N = I(L);
        return N >= rg && N > S.ratio ? { ratio: N, index: B, panel: L } : S;
      },
      {
        ratio: 0,
        index: o.value,
        panel: null
      }
    ), T = () => {
      const { index: S, panel: L } = k();
      S !== o.value && (o.value = S), L?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, g = window.matchMedia("(min-width: 1200px)"), $ = (S) => {
      S.matches && T();
    };
    return he(() => {
      s.value && Dt(
        s,
        ([S]) => {
          S && (u.value = !S.isIntersecting);
        },
        { threshold: [0] }
      ), i.value && Dt(
        i,
        ([S]) => {
          S && (c.value = !S.isIntersecting);
        },
        { threshold: [0] }
      ), r.value && Dt(
        r,
        ([S]) => {
          S && (v.value = S.isIntersecting);
        },
        { threshold: [0] }
      ), l.value.forEach((S, L) => {
        S && Dt(
          S,
          ([B]) => {
            h.value && B && B.isIntersecting && (o.value = L);
          },
          { threshold: sg }
        );
      }), g.addEventListener("change", $);
    }), je(() => {
      g.removeEventListener("change", $);
    }), ce(a, async (S) => {
      S === !1 && await Ze(() => {
        T();
      });
    }), ce(b, () => {
      u.value === !1 && c.value === !0 && (o.value = 0), c.value === !1 && u.value === !0 && (o.value = l.value.length - 1);
    }), (S, L) => (f(), C("div", {
      ref_key: "containerRef",
      ref: r,
      class: Y(["ds-sticky-panels", _.value]),
      style: Te(`--sticky-header-offset: ${e.stickyHeaderOffset}px`)
    }, [
      O("div", {
        ref_key: "bgPanelTopRef",
        ref: s,
        class: "ds-sticky-panels__bg-top"
      }, null, 512),
      V(ta, { class: "ds-sticky-panels__bg" }, {
        default: H(() => [
          (f(), C(le, null, ve(p, (B, N) => O("div", {
            key: `${B}-${N}`,
            class: Y(["ds-sticky-panels__bg-layer", { "is-visible": N === o.value }]),
            style: Te({ backgroundColor: `var(--ds-color-bg-${B})` })
          }, null, 6)), 64)),
          D(n) ? A("", !0) : (f(), C("div", ag, [
            (f(!0), C(le, null, ve(e.panels, (B, N) => (f(), F(tl, {
              key: B.image,
              "is-active": o.value === N,
              "image-alt": B.imageAlt,
              "image-src": B.image,
              "stacking-index": e.panels.length - N,
              "media-focal-point": B.mediaFocalPoint
            }, null, 8, ["is-active", "image-alt", "image-src", "stacking-index", "media-focal-point"]))), 128))
          ]))
        ]),
        _: 1
      }),
      (f(!0), C(le, null, ve(e.panels, (B, N) => (f(), F(ng, {
        key: B.title,
        ref_for: !0,
        ref: (d) => P(d, N),
        "active-index": o.value,
        "active-bg-colour": y.value,
        "bg-colour": p[N % p.length],
        facts: B.facts,
        "inline-media": D(n),
        "link-is-external": B.linkIsExternal,
        "link-text": B.linkText,
        "link-url": B.linkUrl,
        "media-focal-point": B.mediaFocalPoint,
        tag: B.tag,
        title: B.title,
        text: B.text,
        image: B.image,
        "image-alt": B.imageAlt,
        index: N,
        "number-of-panels": e.panels.length,
        class: Y({ "is-above": N < o.value })
      }, null, 8, ["active-index", "active-bg-colour", "bg-colour", "facts", "inline-media", "link-is-external", "link-text", "link-url", "media-focal-point", "tag", "title", "text", "image", "image-alt", "index", "number-of-panels", "class"]))), 128)),
      O("div", {
        ref_key: "bgPanelBottomRef",
        ref: i,
        class: "ds-sticky-panels__bg-bottom"
      }, null, 512)
    ], 6));
  }
}), sk = /* @__PURE__ */ j({
  __name: "ds-table",
  props: {
    caption: {},
    hideCaption: { type: Boolean, default: !1 },
    width: { default: "auto" }
  },
  emits: ["table-processing-error"],
  setup(e, { emit: t }) {
    const n = e, a = t, r = E(!1), s = E(0), i = x(() => {
      const U = [];
      return U.push(n.width === "full" ? "ds-table--full" : "ds-table--auto"), r.value && U.push("ds-table--row-headers"), n.hideCaption && U.push("ds-table--hide-caption"), U.push(
        s.value < 3 ? "ds-table--responsive-simple" : "ds-table--responsive-stacked"
      ), U;
    }), l = E(null);
    let o = null, u = null, c = null, v = null, h, m = null, p, y = null, b = null, _ = null, P = null, I, k = null, T = null, g = [];
    We(() => {
      const U = l.value?.querySelector(".ds-table__caption");
      U && (U.innerHTML = n.caption ?? "");
    });
    const S = ["class", "style", ...[
      "align",
      "bgcolor",
      "border",
      "cellpadding",
      "cellspacing",
      "frame",
      "rules",
      "summary",
      "width"
    ]], L = /* @__PURE__ */ new Set([
      "vertical-align",
      "text-align",
      "font-weight",
      "font-style"
    ]);
    he(() => {
      if (l.value)
        try {
          if (B(), !v) return;
          K(), X(), it(), w(), l.value.replaceChild(
            c,
            u
          ), s.value = l.value.querySelectorAll("thead > tr > th").length;
        } catch (U) {
          console.error(
            "Failed to process table, rendering original markup.",
            U
          ), a("table-processing-error", U);
        }
    });
    const B = () => {
      if (o = document.createDocumentFragment(), !l.value) return;
      const { original: U, clone: te } = N(l.value);
      u = U, c = te, !(!c || !o) && (o.appendChild(c), d(o));
    }, N = (U) => {
      const te = U.querySelector("table"), _e = te ? te.cloneNode(!0) : null;
      return { original: te ?? null, clone: _e };
    }, d = (U) => {
      v = U.querySelector("table"), h = U.querySelector("thead"), y = U.querySelector("tbody"), P = U.querySelectorAll("tr"), I = U.querySelectorAll("th"), k = U.querySelectorAll("td"), _ = U.querySelectorAll("colgroup"), b = U.querySelectorAll("col"), m = U.querySelector("tfoot"), p = U.querySelector("caption"), T = U.querySelectorAll("p"), g = [
        v,
        h,
        y,
        m,
        p,
        ...P ?? [],
        ...I ?? [],
        ...k ?? [],
        ..._ ?? [],
        ...b ?? [],
        ...T ?? []
      ];
    }, w = () => {
      M(), z(), R(), W(), re();
    }, M = () => {
      v?.classList.add("ds-table__table");
    }, z = () => {
      if (!h) return;
      const U = h.querySelectorAll("th");
      for (const te of U)
        te.classList.add("ds-text-heading-xl", "ds-text--medium");
    }, R = () => {
      const U = y?.querySelectorAll("th");
      if (!(!U || U.length === 0)) {
        for (const te of U)
          te.classList.add("ds-text-body-md", "ds-text--medium");
        r.value = !0;
      }
    }, W = () => {
      if (k)
        for (const U of k)
          U.classList.add("ds-text-body-md", "ds-text--regular");
    }, re = () => {
      p && p.classList.add("ds-table__caption", "ds-text-heading-xl");
    }, K = () => {
      const U = g.filter(
        (te) => te instanceof Element
      );
      for (const te of U)
        ee(te);
    }, ee = (U) => {
      oe(U), Se(U);
    }, oe = (U) => {
      const te = U.getAttribute("style");
      if (!te) return;
      U.removeAttribute("style");
      const _e = se(te);
      _e && U.setAttribute("style", _e);
    }, se = (U) => {
      const te = [], _e = pe(U);
      for (const [De, Pe] of _e) {
        const nt = De.trim();
        if (L.has(nt)) {
          const At = Pe?.trim?.() ?? Pe;
          te.push(`${nt}: ${At}`);
        }
      }
      return te.join("; ");
    }, pe = (U) => {
      const te = /* @__PURE__ */ new Map();
      for (const _e of U.split(";")) {
        const De = _e.trim();
        if (!De) continue;
        const Pe = De.indexOf(":");
        if (Pe === -1) continue;
        const nt = De.slice(0, Pe).trim(), At = De.slice(Pe + 1).trim();
        nt && te.set(nt, At);
      }
      return te;
    }, Se = (U) => {
      for (const te of S)
        te !== "style" && U.removeAttribute(te);
    }, X = () => {
      fe(), tt(), ye();
    }, Z = (U) => {
      const te = document.createElement("th");
      te.innerHTML = U.innerHTML, U.replaceWith(te);
    }, fe = () => {
      const U = v?.querySelector(
        "tr:first-child:has(td strong), tr:first-child:has(td b)"
      );
      if (U) {
        const _e = U.querySelectorAll("td");
        for (const De of _e) Z(De);
      }
      const te = v?.querySelectorAll(
        "td:first-child:has(strong, b)"
      );
      if (te)
        for (const _e of te) Z(_e);
    }, ye = () => {
      n.caption && (p || (p = v?.createCaption()), p && (p.innerHTML = n.caption));
    }, tt = () => {
      if (h) return;
      const U = v?.querySelector("tr:first-child:has(th)");
      !v || !U || (h = v.createTHead(), h.appendChild(U), I = v.querySelectorAll("th"));
    }, it = () => {
      en(), ma(), Sn();
    }, en = () => {
      const U = h?.querySelectorAll("th");
      if (U)
        for (const te of U) te.scope = "col";
    }, ma = () => {
      const U = y?.querySelectorAll("th");
      if (U)
        for (const te of U) te.scope = "row";
    }, Sn = () => {
      const U = va();
      if (U.length === 0) return;
      const te = y?.querySelectorAll("tr");
      if (te)
        for (const _e of te) pa(_e, U);
    }, va = () => {
      const U = h?.querySelectorAll("th");
      return !U || U.length === 0 ? [] : Array.from(U, (te) => te.textContent ?? "");
    }, pa = (U, te) => {
      const _e = U.children;
      let De = 0;
      for (const Pe of Array.from(_e))
        Pe.dataset.colHeader = te[De] ?? "", De += 1;
    };
    return (U, te) => (f(), C("div", {
      ref_key: "table",
      ref: l,
      class: Y(["ds-table", i.value])
    }, [
      ue(U.$slots, "default")
    ], 2));
  }
}), ig = ["id", "aria-labelledby"], lg = /* @__PURE__ */ j({
  __name: "ds-tab",
  props: {
    name: {},
    id: {}
  },
  setup(e) {
    const t = e, n = J("activeTab"), a = x(() => t.id === n?.value);
    return (r, s) => we((f(), C("div", {
      id: e.id,
      "aria-labelledby": `${e.id}-button`,
      role: "tabpanel",
      class: "ds-tab-panel"
    }, [
      ue(r.$slots, "default")
    ], 8, ig)), [
      [$e, a.value]
    ]);
  }
}), ca = (e) => {
  document.getElementById(e)?.focus();
}, og = (e) => {
  const t = `${e?.dataset?.nextId}`;
  ca(t);
}, ug = (e) => {
  const t = `${e?.dataset?.prevId}`;
  ca(t);
}, cg = (e) => {
  const t = `${e?.dataset?.lastId}`;
  ca(t);
}, dg = (e) => {
  const t = `${e?.dataset?.firstId}`;
  ca(t);
}, fg = {
  ArrowUp: ug,
  ArrowDown: og,
  Home: dg,
  End: cg
}, bs = (e) => {
  const t = fg[e.key];
  if (t) {
    const n = document.activeElement;
    t(n), e.stopPropagation(), e.preventDefault();
  }
}, mg = /* @__PURE__ */ j({
  __name: "ds-tabs-menu",
  props: {
    accessibleButtonLabel: {},
    hiddenItems: {},
    setActive: {}
  },
  setup(e) {
    const t = E(null);
    ra(t, () => l.value = !1);
    const n = e, a = ht("tab-menu"), r = () => {
      l.value = !l.value;
    }, s = (u) => {
      typeof u < "u" && (l.value = !1, n.setActive(u));
    }, i = x(
      () => l.value ? "ds-tabs-menu--active" : null
    ), l = E(!1), o = x(() => {
      const u = [];
      return n.hiddenItems && n.hiddenItems.forEach((c) => {
        const v = {
          id: `${c?.id}-hidden`,
          panelId: c?.dataset?.id,
          text: c?.dataset.label
        };
        u.push(v);
      }), u;
    });
    return (u, c) => (f(), C("div", {
      ref_key: "menu",
      ref: t,
      class: Y(["ds-tabs-menu", i.value])
    }, [
      V(Ie, {
        "aria-haspopup": "",
        "aria-expanded": l.value,
        "aria-controls": D(a),
        "aria-label": e.accessibleButtonLabel,
        "click-handler": r,
        "data-next-id": o.value[0]?.id,
        size: "sm",
        variant: "ghost",
        "icon-name": "button-more",
        type: "button",
        onKeydown: D(bs)
      }, null, 8, ["aria-expanded", "aria-controls", "aria-label", "data-next-id", "onKeydown"]),
      V(el, {
        id: D(a),
        class: "ds-tabs-menu__content",
        elevation: "overlay",
        padding: "popover",
        role: "menu"
      }, {
        default: H(() => [
          (f(!0), C(le, null, ve(o.value, (v, h) => (f(), F(Ce, {
            id: `${v.id}`,
            key: v.id,
            "data-next-id": o.value[(h + 1) % o.value.length]?.id,
            "data-prev-id": o.value[(h + o.value?.length - 1) % o.value?.length]?.id,
            "data-last-id": o.value[o.value.length - 1]?.id,
            "data-first-id": o.value[0]?.id,
            "data-index": h,
            role: "menuitem",
            variant: "link-neutral",
            onClick: (m) => s(v?.panelId),
            onKeydown: D(bs)
          }, {
            default: H(() => [
              G(q(v.text), 1)
            ]),
            _: 2
          }, 1032, ["id", "data-next-id", "data-prev-id", "data-last-id", "data-first-id", "data-index", "onClick", "onKeydown"]))), 128))
        ]),
        _: 1
      }, 8, ["id"])
    ], 2));
  }
}), da = (e) => {
  document.getElementById(e)?.focus();
}, vg = (e) => {
  const t = `${e?.dataset?.nextId}-button`;
  da(t);
}, pg = (e) => {
  const t = `${e?.dataset?.prevId}-button`;
  da(t);
}, hg = (e) => {
  const t = `${e?.dataset?.lastId}-button`;
  da(t);
}, yg = (e) => {
  const t = `${e?.dataset?.firstId}-button`;
  da(t);
}, gg = {
  ArrowLeft: pg,
  ArrowRight: vg,
  Home: yg,
  End: hg
}, ks = (e) => {
  const t = gg[e.key];
  if (t) {
    const n = document.activeElement;
    t(n), e.stopPropagation(), e.preventDefault();
  }
};
function bg(e, t, n) {
  let a = null;
  he(() => {
    a = new IntersectionObserver(
      (r) => {
        r.forEach((s) => {
          s.intersectionRatio < 1 ? n(s.target.id, !1) : n(s.target.id, !0);
        });
      },
      {
        root: t.value,
        threshold: [0, 1]
      }
    ), e.value.forEach((r) => {
      a?.observe(r);
    });
  }), je(() => {
    a?.disconnect();
  });
}
function kg(e, t, n) {
  const a = (o, u = !0) => {
    const c = s(e, o);
    u ? (l(t, c), i(n, o)) : (l(n, c), i(t, o)), n.value.sort(r), t.value.sort(r);
  }, r = (o, u) => Number(o.dataset.index) - Number(u.dataset.index), s = (o, u) => o.value.find((c) => c?.id === u), i = (o, u) => {
    const c = o.value.findIndex((v) => v?.id === u);
    c > -1 && o.value.splice(c, 1);
  }, l = (o, u) => {
    u && !o.value.includes(u) && o.value.push(u);
  };
  return {
    moveItemById: a
  };
}
const _g = {
  key: 0,
  class: "ds-tabs__nav-wrapper"
}, wg = ["id", "data-next-id", "data-prev-id", "data-last-id", "data-first-id", "data-index", "data-label", "data-id", "aria-controls", "aria-selected", "tabIndex", "onClick"], $g = {
  key: 1,
  class: "ds-tabs__panels"
}, xg = {
  key: 2,
  class: "ds-tabs__panels"
}, Ig = ["innerHTML"], ik = /* @__PURE__ */ j({
  __name: "ds-tabs",
  props: {
    overflowMenuButtonLabel: {},
    tabs: {}
  },
  setup(e) {
    const t = e, n = pl(), a = (N) => typeof N.type == "symbol" && Array.isArray(N.children), r = (N) => typeof N.type == "object" && "props" in N && !!N.props?.id && !!N.props?.name, s = (N) => N.flatMap((d) => i(d)), i = (N) => N?.type ? a(N) ? s(N.children) : r(N) ? [
      {
        id: N.props.id,
        name: N.props.name,
        content: N
        // Preserve the full VNode
      }
    ] : [] : [], l = x(() => {
      if (!n.default) return [];
      const N = n.default();
      return s(N);
    }), o = x(() => t.tabs && t.tabs.length > 0 ? t.tabs : l.value), u = () => {
      if (!T.value) return;
      const N = document.getElementById(`${y.value}-button`);
      N && N.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center"
      });
    }, c = (N) => {
      N instanceof HTMLElement && !v.value.includes(N) && v.value.push(N), N instanceof HTMLElement && N.id === `${y.value}-button` && (_.value = N);
    }, v = E([]), h = E([]), m = E([]), p = x(() => o.value.map((N) => ({
      id: N.id,
      name: N.name
    }))), y = E(""), b = E(null), _ = E(null), P = Fr(b, { threshold: 0 }), I = Fr(_, {
      scrollTarget: b,
      threshold: 1
    }), { moveItemById: k } = kg(v, h, m);
    bg(v, b, k);
    const T = x(() => m.value.length > 0), g = x(
      () => T.value ? "ds-tabs--overflow" : null
    ), $ = (N, d, w) => {
      const M = [];
      return N === d && M.push("ds-tab--active"), w.find((z) => z.id === `${N}-button`) && M.push("ds-tab--hidden"), M;
    }, S = (N) => {
      y.value = N, k(y.value, !0), u();
    };
    ge("activeTab", y);
    const L = x(() => o.value.length > 0), B = x(() => o.value.length > 1);
    return We(() => {
      !y.value && p.value.length > 0 && (y.value = p.value[0]?.id ?? "");
    }), ce([T, P, I], () => {
      T.value && P.value && !I.value && _.value && Ze(() => {
        _.value.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center"
        });
      });
    }), (N, d) => L.value ? (f(), C("div", {
      key: 0,
      class: Y(["ds-tabs", g.value])
    }, [
      B.value ? (f(), C("div", _g, [
        O("div", {
          ref_key: "tablist",
          ref: b,
          class: "ds-tabs__nav",
          role: "tablist"
        }, [
          (f(!0), C(le, null, ve(p.value, ({ name: w, id: M }, z) => (f(), C("button", {
            id: `${M}-button`,
            key: `${M}-button`,
            ref_for: !0,
            ref: (R) => {
              c(R), M === y.value && R && _.value && "value" in _.value && (_.value.value = R);
            },
            "data-next-id": p.value[(z + 1) % p.value.length]?.id,
            "data-prev-id": p.value[(z + p.value.length - 1) % p.value.length]?.id,
            "data-last-id": p.value[p.value.length - 1]?.id,
            "data-first-id": p.value[0]?.id,
            "data-index": z,
            "data-label": w,
            "data-id": M,
            class: Y(["ds-tab", $(M, y.value, m.value)]),
            "aria-controls": M,
            "aria-selected": M === y.value,
            tabIndex: M !== y.value ? "-1" : void 0,
            role: "tab",
            onClick: (R) => S(M),
            onKeydown: d[0] || (d[0] = //@ts-ignore
            (...R) => D(ks) && D(ks)(...R))
          }, [
            V(Q, {
              class: "ds-tab__text",
              "html-element": "span",
              "text-style": "medium",
              "text-type": "label-md"
            }, {
              default: H(() => [
                G(q(w), 1)
              ]),
              _: 2
            }, 1024)
          ], 42, wg))), 128))
        ], 512),
        T.value ? (f(), F(mg, {
          key: 0,
          "accessible-button-label": e.overflowMenuButtonLabel,
          "hidden-items": m.value,
          "set-active": S
        }, null, 8, ["accessible-button-label", "hidden-items"])) : A("", !0)
      ])) : A("", !0),
      l.value && l.value.length ? (f(), C("div", $g, [
        ue(N.$slots, "default")
      ])) : (f(), C("div", xg, [
        (f(!0), C(le, null, ve(e.tabs, (w) => (f(), F(lg, {
          id: w.id,
          key: w.id,
          name: w.name
        }, {
          default: H(() => [
            O("div", {
              innerHTML: w.content
            }, null, 8, Ig)
          ]),
          _: 2
        }, 1032, ["id", "name"]))), 128))
      ]))
    ], 2)) : A("", !0);
  }
}), Sg = ["innerHTML"], Tg = /* @__PURE__ */ j({
  __name: "ds-glyph",
  props: {
    glyph: {},
    size: { default: "inherit" }
  },
  setup(e) {
    const t = e, n = {
      "left-double-quote": "&ldquo;",
      underscore: "&lowbar;"
    }, a = x(() => {
      const s = n[t.glyph];
      return s || (console.error(`Glyph "${t.glyph}" not found in glyphMap.`), "");
    }), r = x(() => {
      const s = [`ds-glyph--${t.glyph}`];
      return t.size !== "inherit" && s.push(`ds-glyph--${t.size}`), s;
    });
    return (s, i) => (f(), C("span", {
      class: Y(["ds-glyph", r.value]),
      innerHTML: a.value
    }, null, 10, Sg));
  }
}), Pg = { class: "ds-testimonial__image-wrapper" }, Cg = ["src", "alt"], Eg = { class: "ds-testimonial__content" }, Ag = { class: "ds-testimonial__quote-wrapper" }, Mg = { class: "ds-testimonial__quote" }, lk = /* @__PURE__ */ j({
  __name: "ds-testimonial",
  props: {
    imageAltText: {},
    imageUrl: {},
    order: { default: "default" },
    testimonialText: {},
    testimonialName: {},
    testimonialRole: {},
    testimonialProduct: {}
  },
  setup(e) {
    const t = e, n = x(() => {
      let r = [];
      return t.testimonialRole && r.push(t.testimonialRole), t.testimonialProduct && r.push(t.testimonialProduct), r.join(" | ");
    }), a = x(() => {
      const r = [];
      return t.order !== "default" && r.push(`ds-testimonial--order-${t.order}`), r;
    });
    return (r, s) => (f(), F(Fc, {
      "columns-md": 2,
      class: Y(["ds-testimonial", a.value])
    }, {
      default: H(() => [
        O("div", Pg, [
          O("img", {
            class: "ds-testimonial__image",
            src: e.imageUrl,
            alt: e.imageAltText
          }, null, 8, Cg)
        ]),
        O("figure", Eg, [
          O("div", Ag, [
            O("blockquote", Mg, [
              V(Q, {
                "html-element": "q",
                "text-type": "heading-4xl",
                class: "ds-testimonial__text"
              }, {
                default: H(() => [
                  G(q(e.testimonialText), 1)
                ]),
                _: 1
              })
            ])
          ]),
          O("figcaption", null, [
            e.testimonialName ? (f(), F(Q, {
              key: 0,
              "html-element": "p",
              "text-type": "body-md",
              "text-style": "medium",
              class: "ds-testimonial__name"
            }, {
              default: H(() => [
                G(q(e.testimonialName), 1),
                V(Tg, { glyph: "underscore" })
              ]),
              _: 1
            })) : A("", !0),
            n.value ? (f(), F(Q, {
              key: 1,
              "html-element": "p",
              "text-type": "body-md",
              "text-style": "regular",
              class: "ds-testimonial__role"
            }, {
              default: H(() => [
                G(q(n.value), 1)
              ]),
              _: 1
            })) : A("", !0)
          ])
        ])
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Lg = {
  key: 0,
  role: "alert",
  class: "ds-toast__inner"
}, Og = { class: "ds-toast__content" }, Ng = {
  key: 3,
  class: "ds-toast__countdown-track"
}, ok = /* @__PURE__ */ j({
  __name: "ds-toast",
  props: {
    actionText: {},
    actionFn: {},
    closeButtonAriaLabel: { default: "Close" },
    closeOnActionClick: { type: Boolean, default: !0 },
    description: {},
    showIcon: { type: Boolean, default: !0 },
    showCountdown: { type: Boolean, default: !1 },
    timeout: { default: 0 },
    variant: { default: "default" }
  },
  setup(e) {
    const t = e, n = (m) => {
      t.actionFn && (t.actionFn(m), t.closeOnActionClick && v());
    }, a = E(!1), r = E(t.timeout), s = E(!1), i = E(null), l = E(!1), o = x(() => {
      const m = ["ds-toast"];
      return m.push(`ds-toast--${t.variant}`), s.value === !1 && a.value === !1 && m.push("ds-toast--initial"), t.showCountdown && m.push("ds-toast--countdown"), l.value ? m.push("ds-toast--multiline") : m.push("ds-toast--singleline"), m;
    });
    let u = 0, c = 0;
    const v = () => {
      a.value = !1, u = window.setTimeout(() => {
        h();
      }, 500);
    }, h = () => {
      s.value = !0;
    };
    return he(() => {
      a.value = !0;
      const m = Number(r.value) + 1100;
      r.value > 0 && (c = window.setTimeout(() => {
        v();
      }, m));
    }), je(() => {
      window.clearTimeout(u), window.clearTimeout(c);
    }), ce(a, async () => {
      if (l.value === !0) return;
      await Ze();
      const m = i.value;
      m && m.scrollHeight > m.offsetHeight && (l.value = !0);
    }), (m, p) => s.value ? A("", !0) : (f(), C("div", {
      key: 0,
      class: Y(o.value),
      "data-testid": "toast"
    }, [
      V(rt, {
        class: "ds-toast__transition",
        name: "toast",
        "enter-from-class": "toast-enter-from",
        "enter-to-class": "toast-enter-to",
        "leave-from-class": "toast-leave-from",
        "leave-to-class": "toast-leave-to"
      }, {
        default: H(() => [
          a.value ? (f(), C("div", Lg, [
            e.showIcon ? (f(), F(ie, {
              key: 0,
              class: "ds-toast__icon",
              "icon-name": "information-circle",
              size: "md"
            })) : A("", !0),
            O("div", Og, [
              e.description ? (f(), F(Q, {
                key: 0,
                "html-element": "div",
                "text-type": "body-lg",
                "text-style": "regular",
                class: "ds-toast__description"
              }, {
                default: H(() => [
                  O("div", {
                    ref_key: "textElem",
                    ref: i
                  }, q(e.description), 513)
                ]),
                _: 1
              })) : A("", !0)
            ]),
            e.actionText ? (f(), F(Ce, {
              key: 1,
              "click-handler": n,
              size: "sm",
              variant: "functional"
            }, {
              default: H(() => [
                G(q(e.actionText), 1)
              ]),
              _: 1
            })) : A("", !0),
            A("", !0),
            e.showCountdown ? (f(), C("div", Ng, [
              O("div", {
                class: "ds-toast__countdown-bar",
                style: Te({ animationDuration: `${r.value / 1e3}s` })
              }, null, 4)
            ])) : A("", !0)
          ])) : A("", !0)
        ]),
        _: 1
      })
    ], 2));
  }
}), Bg = ["data-show"], Dg = ["aria-label"], Fg = ["role"], Rg = ["innerHTML"], Hg = ["href", "target"], uk = /* @__PURE__ */ j({
  __name: "ds-toggletip",
  props: {
    accessibleButtonLabel: {},
    iconName: { default: "information-circle" },
    iconSize: { default: "md" },
    linkTarget: {},
    linkText: {},
    linkUrl: {},
    placement: { default: "auto" },
    strategy: { default: "absolute" },
    text: {},
    title: {},
    titleElement: { default: "h3" }
  },
  setup(e) {
    const t = e, n = E(null), a = E(null), r = E(null);
    ra(n, () => {
      i.value = !1;
    });
    const { toggle: s, isOpen: i } = qs({
      targetNode: a,
      tooltipNode: r,
      placement: t.placement,
      strategy: t.strategy
    }), l = x(() => i.value ? "status" : void 0);
    return (o, u) => (f(), C("div", {
      ref_key: "container",
      ref: n,
      class: "ds-tooltip",
      "data-show": D(i)
    }, [
      e.iconName ? (f(), C("button", {
        key: 0,
        ref_key: "target",
        ref: a,
        class: "ds-tooltip__target",
        "aria-label": e.accessibleButtonLabel,
        onClick: u[0] || (u[0] = //@ts-ignore
        (...c) => D(s) && D(s)(...c))
      }, [
        V(ie, {
          "icon-name": e.iconName,
          size: e.iconSize
        }, null, 8, ["icon-name", "size"])
      ], 8, Dg)) : A("", !0),
      O("div", {
        ref_key: "tooltip",
        ref: r,
        class: "ds-tooltip__tooltip"
      }, [
        O("div", {
          class: "ds-tooltip__content",
          role: l.value
        }, [
          e.title ? (f(), F(vn(e.titleElement), {
            key: 0,
            class: "ds-tooltip__title"
          }, {
            default: H(() => [
              G(q(e.title), 1)
            ]),
            _: 1
          })) : A("", !0),
          V(Q, {
            "text-type": "label-sm",
            "html-element": "div"
          }, {
            default: H(() => [
              O("div", { innerHTML: e.text }, null, 8, Rg)
            ]),
            _: 1
          }),
          e.linkText && e.linkUrl ? (f(), C("a", {
            key: 1,
            class: "ds-tooltip__link",
            href: e.linkUrl,
            target: e.linkTarget
          }, q(e.linkText), 9, Hg)) : A("", !0)
        ], 8, Fg),
        u[1] || (u[1] = O("div", {
          class: "ds-tooltip__arrow",
          "data-popper-arrow": ""
        }, null, -1))
      ], 512)
    ], 8, Bg));
  }
});
/*! @vimeo/player v2.30.0 | (c) 2025 Vimeo | MIT License | https://github.com/vimeo/player.js */
function Vg(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var a, r, s, i, l = [], o = !0, u = !1;
    try {
      if (s = (n = n.call(e)).next, t !== 0) for (; !(o = (a = s.call(n)).done) && (l.push(a.value), l.length !== t); o = !0) ;
    } catch (c) {
      u = !0, r = c;
    } finally {
      try {
        if (!o && n.return != null && (i = n.return(), Object(i) !== i)) return;
      } finally {
        if (u) throw r;
      }
    }
    return l;
  }
}
function _s(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function ws(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _s(Object(n), !0).forEach(function(a) {
      Nn(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _s(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function Ee() {
  Ee = function() {
    return e;
  };
  var e = {}, t = Object.prototype, n = t.hasOwnProperty, a = Object.defineProperty || function(d, w, M) {
    d[w] = M.value;
  }, r = typeof Symbol == "function" ? Symbol : {}, s = r.iterator || "@@iterator", i = r.asyncIterator || "@@asyncIterator", l = r.toStringTag || "@@toStringTag";
  function o(d, w, M) {
    return Object.defineProperty(d, w, {
      value: M,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), d[w];
  }
  try {
    o({}, "");
  } catch {
    o = function(w, M, z) {
      return w[M] = z;
    };
  }
  function u(d, w, M, z) {
    var R = w && w.prototype instanceof h ? w : h, W = Object.create(R.prototype), re = new L(z || []);
    return a(W, "_invoke", {
      value: T(d, M, re)
    }), W;
  }
  function c(d, w, M) {
    try {
      return {
        type: "normal",
        arg: d.call(w, M)
      };
    } catch (z) {
      return {
        type: "throw",
        arg: z
      };
    }
  }
  e.wrap = u;
  var v = {};
  function h() {
  }
  function m() {
  }
  function p() {
  }
  var y = {};
  o(y, s, function() {
    return this;
  });
  var b = Object.getPrototypeOf, _ = b && b(b(B([])));
  _ && _ !== t && n.call(_, s) && (y = _);
  var P = p.prototype = h.prototype = Object.create(y);
  function I(d) {
    ["next", "throw", "return"].forEach(function(w) {
      o(d, w, function(M) {
        return this._invoke(w, M);
      });
    });
  }
  function k(d, w) {
    function M(R, W, re, K) {
      var ee = c(d[R], d, W);
      if (ee.type !== "throw") {
        var oe = ee.arg, se = oe.value;
        return se && typeof se == "object" && n.call(se, "__await") ? w.resolve(se.__await).then(function(pe) {
          M("next", pe, re, K);
        }, function(pe) {
          M("throw", pe, re, K);
        }) : w.resolve(se).then(function(pe) {
          oe.value = pe, re(oe);
        }, function(pe) {
          return M("throw", pe, re, K);
        });
      }
      K(ee.arg);
    }
    var z;
    a(this, "_invoke", {
      value: function(R, W) {
        function re() {
          return new w(function(K, ee) {
            M(R, W, K, ee);
          });
        }
        return z = z ? z.then(re, re) : re();
      }
    });
  }
  function T(d, w, M) {
    var z = "suspendedStart";
    return function(R, W) {
      if (z === "executing") throw new Error("Generator is already running");
      if (z === "completed") {
        if (R === "throw") throw W;
        return N();
      }
      for (M.method = R, M.arg = W; ; ) {
        var re = M.delegate;
        if (re) {
          var K = g(re, M);
          if (K) {
            if (K === v) continue;
            return K;
          }
        }
        if (M.method === "next") M.sent = M._sent = M.arg;
        else if (M.method === "throw") {
          if (z === "suspendedStart") throw z = "completed", M.arg;
          M.dispatchException(M.arg);
        } else M.method === "return" && M.abrupt("return", M.arg);
        z = "executing";
        var ee = c(d, w, M);
        if (ee.type === "normal") {
          if (z = M.done ? "completed" : "suspendedYield", ee.arg === v) continue;
          return {
            value: ee.arg,
            done: M.done
          };
        }
        ee.type === "throw" && (z = "completed", M.method = "throw", M.arg = ee.arg);
      }
    };
  }
  function g(d, w) {
    var M = w.method, z = d.iterator[M];
    if (z === void 0) return w.delegate = null, M === "throw" && d.iterator.return && (w.method = "return", w.arg = void 0, g(d, w), w.method === "throw") || M !== "return" && (w.method = "throw", w.arg = new TypeError("The iterator does not provide a '" + M + "' method")), v;
    var R = c(z, d.iterator, w.arg);
    if (R.type === "throw") return w.method = "throw", w.arg = R.arg, w.delegate = null, v;
    var W = R.arg;
    return W ? W.done ? (w[d.resultName] = W.value, w.next = d.nextLoc, w.method !== "return" && (w.method = "next", w.arg = void 0), w.delegate = null, v) : W : (w.method = "throw", w.arg = new TypeError("iterator result is not an object"), w.delegate = null, v);
  }
  function $(d) {
    var w = {
      tryLoc: d[0]
    };
    1 in d && (w.catchLoc = d[1]), 2 in d && (w.finallyLoc = d[2], w.afterLoc = d[3]), this.tryEntries.push(w);
  }
  function S(d) {
    var w = d.completion || {};
    w.type = "normal", delete w.arg, d.completion = w;
  }
  function L(d) {
    this.tryEntries = [{
      tryLoc: "root"
    }], d.forEach($, this), this.reset(!0);
  }
  function B(d) {
    if (d) {
      var w = d[s];
      if (w) return w.call(d);
      if (typeof d.next == "function") return d;
      if (!isNaN(d.length)) {
        var M = -1, z = function R() {
          for (; ++M < d.length; ) if (n.call(d, M)) return R.value = d[M], R.done = !1, R;
          return R.value = void 0, R.done = !0, R;
        };
        return z.next = z;
      }
    }
    return {
      next: N
    };
  }
  function N() {
    return {
      value: void 0,
      done: !0
    };
  }
  return m.prototype = p, a(P, "constructor", {
    value: p,
    configurable: !0
  }), a(p, "constructor", {
    value: m,
    configurable: !0
  }), m.displayName = o(p, l, "GeneratorFunction"), e.isGeneratorFunction = function(d) {
    var w = typeof d == "function" && d.constructor;
    return !!w && (w === m || (w.displayName || w.name) === "GeneratorFunction");
  }, e.mark = function(d) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(d, p) : (d.__proto__ = p, o(d, l, "GeneratorFunction")), d.prototype = Object.create(P), d;
  }, e.awrap = function(d) {
    return {
      __await: d
    };
  }, I(k.prototype), o(k.prototype, i, function() {
    return this;
  }), e.AsyncIterator = k, e.async = function(d, w, M, z, R) {
    R === void 0 && (R = Promise);
    var W = new k(u(d, w, M, z), R);
    return e.isGeneratorFunction(w) ? W : W.next().then(function(re) {
      return re.done ? re.value : W.next();
    });
  }, I(P), o(P, l, "Generator"), o(P, s, function() {
    return this;
  }), o(P, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(d) {
    var w = Object(d), M = [];
    for (var z in w) M.push(z);
    return M.reverse(), function R() {
      for (; M.length; ) {
        var W = M.pop();
        if (W in w) return R.value = W, R.done = !1, R;
      }
      return R.done = !0, R;
    };
  }, e.values = B, L.prototype = {
    constructor: L,
    reset: function(d) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(S), !d) for (var w in this) w.charAt(0) === "t" && n.call(this, w) && !isNaN(+w.slice(1)) && (this[w] = void 0);
    },
    stop: function() {
      this.done = !0;
      var d = this.tryEntries[0].completion;
      if (d.type === "throw") throw d.arg;
      return this.rval;
    },
    dispatchException: function(d) {
      if (this.done) throw d;
      var w = this;
      function M(ee, oe) {
        return W.type = "throw", W.arg = d, w.next = ee, oe && (w.method = "next", w.arg = void 0), !!oe;
      }
      for (var z = this.tryEntries.length - 1; z >= 0; --z) {
        var R = this.tryEntries[z], W = R.completion;
        if (R.tryLoc === "root") return M("end");
        if (R.tryLoc <= this.prev) {
          var re = n.call(R, "catchLoc"), K = n.call(R, "finallyLoc");
          if (re && K) {
            if (this.prev < R.catchLoc) return M(R.catchLoc, !0);
            if (this.prev < R.finallyLoc) return M(R.finallyLoc);
          } else if (re) {
            if (this.prev < R.catchLoc) return M(R.catchLoc, !0);
          } else {
            if (!K) throw new Error("try statement without catch or finally");
            if (this.prev < R.finallyLoc) return M(R.finallyLoc);
          }
        }
      }
    },
    abrupt: function(d, w) {
      for (var M = this.tryEntries.length - 1; M >= 0; --M) {
        var z = this.tryEntries[M];
        if (z.tryLoc <= this.prev && n.call(z, "finallyLoc") && this.prev < z.finallyLoc) {
          var R = z;
          break;
        }
      }
      R && (d === "break" || d === "continue") && R.tryLoc <= w && w <= R.finallyLoc && (R = null);
      var W = R ? R.completion : {};
      return W.type = d, W.arg = w, R ? (this.method = "next", this.next = R.finallyLoc, v) : this.complete(W);
    },
    complete: function(d, w) {
      if (d.type === "throw") throw d.arg;
      return d.type === "break" || d.type === "continue" ? this.next = d.arg : d.type === "return" ? (this.rval = this.arg = d.arg, this.method = "return", this.next = "end") : d.type === "normal" && w && (this.next = w), v;
    },
    finish: function(d) {
      for (var w = this.tryEntries.length - 1; w >= 0; --w) {
        var M = this.tryEntries[w];
        if (M.finallyLoc === d) return this.complete(M.completion, M.afterLoc), S(M), v;
      }
    },
    catch: function(d) {
      for (var w = this.tryEntries.length - 1; w >= 0; --w) {
        var M = this.tryEntries[w];
        if (M.tryLoc === d) {
          var z = M.completion;
          if (z.type === "throw") {
            var R = z.arg;
            S(M);
          }
          return R;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(d, w, M) {
      return this.delegate = {
        iterator: B(d),
        resultName: w,
        nextLoc: M
      }, this.method === "next" && (this.arg = void 0), v;
    }
  }, e;
}
function $s(e, t, n, a, r, s, i) {
  try {
    var l = e[s](i), o = l.value;
  } catch (u) {
    n(u);
    return;
  }
  l.done ? t(o) : Promise.resolve(o).then(a, r);
}
function It(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(a, r) {
      var s = e.apply(t, n);
      function i(o) {
        $s(s, a, r, i, l, "next", o);
      }
      function l(o) {
        $s(s, a, r, i, l, "throw", o);
      }
      i(void 0);
    });
  };
}
function nl(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function xs(e, t) {
  for (var n = 0; n < t.length; n++) {
    var a = t[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, sl(a.key), a);
  }
}
function al(e, t, n) {
  return t && xs(e.prototype, t), n && xs(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Nn(e, t, n) {
  return t = sl(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function zg(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && bn(e, t);
}
function gn(e) {
  return gn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, gn(e);
}
function bn(e, t) {
  return bn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, r) {
    return a.__proto__ = r, a;
  }, bn(e, t);
}
function rl() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Bn(e, t, n) {
  return rl() ? Bn = Reflect.construct.bind() : Bn = function(r, s, i) {
    var l = [null];
    l.push.apply(l, s);
    var o = Function.bind.apply(r, l), u = new o();
    return i && bn(u, i.prototype), u;
  }, Bn.apply(null, arguments);
}
function jg(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function za(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return za = function(a) {
    if (a === null || !jg(a)) return a;
    if (typeof a != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(a)) return t.get(a);
      t.set(a, r);
    }
    function r() {
      return Bn(a, arguments, gn(this).constructor);
    }
    return r.prototype = Object.create(a.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), bn(r, a);
  }, za(e);
}
function Dn(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function qg(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Dn(e);
}
function Wg(e) {
  var t = rl();
  return function() {
    var a = gn(e), r;
    if (t) {
      var s = gn(this).constructor;
      r = Reflect.construct(a, arguments, s);
    } else
      r = a.apply(this, arguments);
    return qg(this, r);
  };
}
function Ug(e, t) {
  return Kg(e) || Vg(e, t) || Gg(e, t) || Yg();
}
function Kg(e) {
  if (Array.isArray(e)) return e;
}
function Gg(e, t) {
  if (e) {
    if (typeof e == "string") return Is(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Is(e, t);
  }
}
function Is(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, a = new Array(t); n < t; n++) a[n] = e[n];
  return a;
}
function Yg() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Qg(e, t) {
  if (typeof e != "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(e, t);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function sl(e) {
  var t = Qg(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var Xg = typeof global < "u" && {}.toString.call(global) === "[object global]", Zg = typeof Bun < "u", Jg = typeof Deno < "u", il = Xg || Zg || Jg;
function Ss(e, t) {
  return e.indexOf(t.toLowerCase()) === 0 ? e : "".concat(t.toLowerCase()).concat(e.substr(0, 1).toUpperCase()).concat(e.substr(1));
}
function eb(e) {
  return !!(e && e.nodeType === 1 && "nodeName" in e && e.ownerDocument && e.ownerDocument.defaultView);
}
function tb(e) {
  return !isNaN(parseFloat(e)) && isFinite(e) && Math.floor(e) == e;
}
function ct(e) {
  return /^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))(?=$|\/)/.test(e);
}
function ll(e) {
  var t = /^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))\/video\/\d+/;
  return t.test(e);
}
function nb(e) {
  for (var t = (e || "").match(/^(?:https?:)?(?:\/\/)?([^/?]+)/), n = (t && t[1] || "").replace("player.", ""), a = [".videoji.hk", ".vimeo.work", ".videoji.cn"], r = 0, s = a; r < s.length; r++) {
    var i = s[r];
    if (n.endsWith(i))
      return n;
  }
  return "vimeo.com";
}
function ol() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.id, n = e.url, a = t || n;
  if (!a)
    throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
  if (tb(a))
    return "https://vimeo.com/".concat(a);
  if (ct(a))
    return a.replace("http:", "https:");
  throw t ? new TypeError("“".concat(t, "” is not a valid video id.")) : new TypeError("“".concat(a, "” is not a vimeo.com url."));
}
var Ts = function(t, n, a) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "addEventListener", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "removeEventListener", i = typeof n == "string" ? [n] : n;
  return i.forEach(function(l) {
    t[r](l, a);
  }), {
    cancel: function() {
      return i.forEach(function(o) {
        return t[s](o, a);
      });
    }
  };
};
function fa(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document;
  if (!e || !t || typeof t.querySelectorAll != "function")
    return null;
  for (var n = t.querySelectorAll("iframe"), a = 0; a < n.length; a++)
    if (n[a] && n[a].contentWindow === e)
      return n[a];
  return null;
}
var ab = typeof Array.prototype.indexOf < "u", rb = typeof window < "u" && typeof window.postMessage < "u";
if (!il && (!ab || !rb))
  throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
var qt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function sb(e, t) {
  return t = { exports: {} }, e(t, t.exports), t.exports;
}
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */
(function(e) {
  if (e.WeakMap)
    return;
  var t = Object.prototype.hasOwnProperty, n = Object.defineProperty && (function() {
    try {
      return Object.defineProperty({}, "x", {
        value: 1
      }).x === 1;
    } catch {
    }
  })(), a = function(s, i, l) {
    n ? Object.defineProperty(s, i, {
      configurable: !0,
      writable: !0,
      value: l
    }) : s[i] = l;
  };
  e.WeakMap = (function() {
    function s() {
      if (this === void 0)
        throw new TypeError("Constructor WeakMap requires 'new'");
      if (a(this, "_id", l("_WeakMap")), arguments.length > 0)
        throw new TypeError("WeakMap iterable is not supported");
    }
    a(s.prototype, "delete", function(u) {
      if (i(this, "delete"), !r(u))
        return !1;
      var c = u[this._id];
      return c && c[0] === u ? (delete u[this._id], !0) : !1;
    }), a(s.prototype, "get", function(u) {
      if (i(this, "get"), !!r(u)) {
        var c = u[this._id];
        if (c && c[0] === u)
          return c[1];
      }
    }), a(s.prototype, "has", function(u) {
      if (i(this, "has"), !r(u))
        return !1;
      var c = u[this._id];
      return !!(c && c[0] === u);
    }), a(s.prototype, "set", function(u, c) {
      if (i(this, "set"), !r(u))
        throw new TypeError("Invalid value used as weak map key");
      var v = u[this._id];
      return v && v[0] === u ? (v[1] = c, this) : (a(u, this._id, [u, c]), this);
    });
    function i(u, c) {
      if (!r(u) || !t.call(u, "_id"))
        throw new TypeError(c + " method called on incompatible receiver " + typeof u);
    }
    function l(u) {
      return u + "_" + o() + "." + o();
    }
    function o() {
      return Math.random().toString().substring(2);
    }
    return a(s, "_polyfill", !0), s;
  })();
  function r(s) {
    return Object(s) === s;
  }
})(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : qt);
var qe = sb(function(e) {
  /*! Native Promise Only
      v0.8.1 (c) Kyle Simpson
      MIT License: http://getify.mit-license.org
  */
  (function(n, a, r) {
    a[n] = a[n] || r(), e.exports && (e.exports = a[n]);
  })("Promise", qt, function() {
    var n, a, r, s = Object.prototype.toString, i = typeof setImmediate < "u" ? function(I) {
      return setImmediate(I);
    } : setTimeout;
    try {
      Object.defineProperty({}, "x", {}), n = function(I, k, T, g) {
        return Object.defineProperty(I, k, {
          value: T,
          writable: !0,
          configurable: g !== !1
        });
      };
    } catch {
      n = function(k, T, g) {
        return k[T] = g, k;
      };
    }
    r = /* @__PURE__ */ (function() {
      var I, k, T;
      function g($, S) {
        this.fn = $, this.self = S, this.next = void 0;
      }
      return {
        add: function(S, L) {
          T = new g(S, L), k ? k.next = T : I = T, k = T, T = void 0;
        },
        drain: function() {
          var S = I;
          for (I = k = a = void 0; S; )
            S.fn.call(S.self), S = S.next;
        }
      };
    })();
    function l(P, I) {
      r.add(P, I), a || (a = i(r.drain));
    }
    function o(P) {
      var I, k = typeof P;
      return P != null && (k == "object" || k == "function") && (I = P.then), typeof I == "function" ? I : !1;
    }
    function u() {
      for (var P = 0; P < this.chain.length; P++)
        c(this, this.state === 1 ? this.chain[P].success : this.chain[P].failure, this.chain[P]);
      this.chain.length = 0;
    }
    function c(P, I, k) {
      var T, g;
      try {
        I === !1 ? k.reject(P.msg) : (I === !0 ? T = P.msg : T = I.call(void 0, P.msg), T === k.promise ? k.reject(TypeError("Promise-chain cycle")) : (g = o(T)) ? g.call(T, k.resolve, k.reject) : k.resolve(T));
      } catch ($) {
        k.reject($);
      }
    }
    function v(P) {
      var I, k = this;
      if (!k.triggered) {
        k.triggered = !0, k.def && (k = k.def);
        try {
          (I = o(P)) ? l(function() {
            var T = new p(k);
            try {
              I.call(P, function() {
                v.apply(T, arguments);
              }, function() {
                h.apply(T, arguments);
              });
            } catch (g) {
              h.call(T, g);
            }
          }) : (k.msg = P, k.state = 1, k.chain.length > 0 && l(u, k));
        } catch (T) {
          h.call(new p(k), T);
        }
      }
    }
    function h(P) {
      var I = this;
      I.triggered || (I.triggered = !0, I.def && (I = I.def), I.msg = P, I.state = 2, I.chain.length > 0 && l(u, I));
    }
    function m(P, I, k, T) {
      for (var g = 0; g < I.length; g++)
        (function(S) {
          P.resolve(I[S]).then(function(B) {
            k(S, B);
          }, T);
        })(g);
    }
    function p(P) {
      this.def = P, this.triggered = !1;
    }
    function y(P) {
      this.promise = P, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
    }
    function b(P) {
      if (typeof P != "function")
        throw TypeError("Not a function");
      if (this.__NPO__ !== 0)
        throw TypeError("Not a promise");
      this.__NPO__ = 1;
      var I = new y(this);
      this.then = function(T, g) {
        var $ = {
          success: typeof T == "function" ? T : !0,
          failure: typeof g == "function" ? g : !1
        };
        return $.promise = new this.constructor(function(L, B) {
          if (typeof L != "function" || typeof B != "function")
            throw TypeError("Not a function");
          $.resolve = L, $.reject = B;
        }), I.chain.push($), I.state !== 0 && l(u, I), $.promise;
      }, this.catch = function(T) {
        return this.then(void 0, T);
      };
      try {
        P.call(void 0, function(T) {
          v.call(I, T);
        }, function(T) {
          h.call(I, T);
        });
      } catch (k) {
        h.call(I, k);
      }
    }
    var _ = n(
      {},
      "constructor",
      b,
      /*configurable=*/
      !1
    );
    return b.prototype = _, n(
      _,
      "__NPO__",
      0,
      /*configurable=*/
      !1
    ), n(b, "resolve", function(I) {
      var k = this;
      return I && typeof I == "object" && I.__NPO__ === 1 ? I : new k(function(g, $) {
        if (typeof g != "function" || typeof $ != "function")
          throw TypeError("Not a function");
        g(I);
      });
    }), n(b, "reject", function(I) {
      return new this(function(T, g) {
        if (typeof T != "function" || typeof g != "function")
          throw TypeError("Not a function");
        g(I);
      });
    }), n(b, "all", function(I) {
      var k = this;
      return s.call(I) != "[object Array]" ? k.reject(TypeError("Not an array")) : I.length === 0 ? k.resolve([]) : new k(function(g, $) {
        if (typeof g != "function" || typeof $ != "function")
          throw TypeError("Not a function");
        var S = I.length, L = Array(S), B = 0;
        m(k, I, function(d, w) {
          L[d] = w, ++B === S && g(L);
        }, $);
      });
    }), n(b, "race", function(I) {
      var k = this;
      return s.call(I) != "[object Array]" ? k.reject(TypeError("Not an array")) : new k(function(g, $) {
        if (typeof g != "function" || typeof $ != "function")
          throw TypeError("Not a function");
        m(k, I, function(L, B) {
          g(B);
        }, $);
      });
    }), b;
  });
}), dt = /* @__PURE__ */ new WeakMap();
function rn(e, t, n) {
  var a = dt.get(e.element) || {};
  t in a || (a[t] = []), a[t].push(n), dt.set(e.element, a);
}
function Zn(e, t) {
  var n = dt.get(e.element) || {};
  return n[t] || [];
}
function Jn(e, t, n) {
  var a = dt.get(e.element) || {};
  if (!a[t])
    return !0;
  if (!n)
    return a[t] = [], dt.set(e.element, a), !0;
  var r = a[t].indexOf(n);
  return r !== -1 && a[t].splice(r, 1), dt.set(e.element, a), a[t] && a[t].length === 0;
}
function ib(e, t) {
  var n = Zn(e, t);
  if (n.length < 1)
    return !1;
  var a = n.shift();
  return Jn(e, t, a), a;
}
function lb(e, t) {
  var n = dt.get(e);
  dt.set(t, n), dt.delete(e);
}
function In(e) {
  if (typeof e == "string")
    try {
      e = JSON.parse(e);
    } catch (t) {
      return console.warn(t), {};
    }
  return e;
}
function xt(e, t, n) {
  if (!(!e.element.contentWindow || !e.element.contentWindow.postMessage)) {
    var a = {
      method: t
    };
    n !== void 0 && (a.value = n);
    var r = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
    r >= 8 && r < 10 && (a = JSON.stringify(a)), e.element.contentWindow.postMessage(a, e.origin);
  }
}
function ob(e, t) {
  t = In(t);
  var n = [], a;
  if (t.event) {
    if (t.event === "error") {
      var r = Zn(e, t.data.method);
      r.forEach(function(i) {
        var l = new Error(t.data.message);
        l.name = t.data.name, i.reject(l), Jn(e, t.data.method, i);
      });
    }
    n = Zn(e, "event:".concat(t.event)), a = t.data;
  } else if (t.method) {
    var s = ib(e, t.method);
    s && (n.push(s), a = t.value);
  }
  n.forEach(function(i) {
    try {
      if (typeof i == "function") {
        i.call(e, a);
        return;
      }
      i.resolve(a);
    } catch {
    }
  });
}
var ub = ["airplay", "audio_tracks", "audiotrack", "autopause", "autoplay", "background", "byline", "cc", "chapter_id", "chapters", "chromecast", "color", "colors", "controls", "dnt", "end_time", "fullscreen", "height", "id", "initial_quality", "interactive_params", "keyboard", "loop", "maxheight", "max_quality", "maxwidth", "min_quality", "muted", "play_button_position", "playsinline", "portrait", "preload", "progress_bar", "quality", "quality_selector", "responsive", "skipping_forward", "speed", "start_time", "texttrack", "thumbnail_id", "title", "transcript", "transparent", "unmute_button", "url", "vimeo_logo", "volume", "watch_full_video", "width"];
function ul(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return ub.reduce(function(n, a) {
    var r = e.getAttribute("data-vimeo-".concat(a));
    return (r || r === "") && (n[a] = r === "" ? 1 : r), n;
  }, t);
}
function _r(e, t) {
  var n = e.html;
  if (!t)
    throw new TypeError("An element must be provided");
  if (t.getAttribute("data-vimeo-initialized") !== null)
    return t.querySelector("iframe");
  var a = document.createElement("div");
  return a.innerHTML = n, t.appendChild(a.firstChild), t.setAttribute("data-vimeo-initialized", "true"), t.querySelector("iframe");
}
function cl(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0;
  return new Promise(function(a, r) {
    if (!ct(e))
      throw new TypeError("“".concat(e, "” is not a vimeo.com url."));
    var s = nb(e), i = "https://".concat(s, "/api/oembed.json?url=").concat(encodeURIComponent(e));
    for (var l in t)
      t.hasOwnProperty(l) && (i += "&".concat(l, "=").concat(encodeURIComponent(t[l])));
    var o = "XDomainRequest" in window ? new XDomainRequest() : new XMLHttpRequest();
    o.open("GET", i, !0), o.onload = function() {
      if (o.status === 404) {
        r(new Error("“".concat(e, "” was not found.")));
        return;
      }
      if (o.status === 403) {
        r(new Error("“".concat(e, "” is not embeddable.")));
        return;
      }
      try {
        var u = JSON.parse(o.responseText);
        if (u.domain_status_code === 403) {
          _r(u, n), r(new Error("“".concat(e, "” is not embeddable.")));
          return;
        }
        a(u);
      } catch (c) {
        r(c);
      }
    }, o.onerror = function() {
      var u = o.status ? " (".concat(o.status, ")") : "";
      r(new Error("There was an error fetching the embed code from Vimeo".concat(u, ".")));
    }, o.send();
  });
}
function cb() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, t = [].slice.call(e.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")), n = function(r) {
    "console" in window && console.error && console.error("There was an error creating an embed: ".concat(r));
  };
  t.forEach(function(a) {
    try {
      if (a.getAttribute("data-vimeo-defer") !== null)
        return;
      var r = ul(a), s = ol(r);
      cl(s, r, a).then(function(i) {
        return _r(i, a);
      }).catch(n);
    } catch (i) {
      n(i);
    }
  });
}
function db() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoPlayerResizeEmbeds_) {
    window.VimeoPlayerResizeEmbeds_ = !0;
    var t = function(a) {
      if (ct(a.origin) && !(!a.data || a.data.event !== "spacechange")) {
        var r = a.source ? fa(a.source, e) : null;
        if (r) {
          var s = r.parentElement;
          s.style.paddingBottom = "".concat(a.data.data[0].bottom, "px");
        }
      }
    };
    window.addEventListener("message", t);
  }
}
function fb() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoSeoMetadataAppended) {
    window.VimeoSeoMetadataAppended = !0;
    var t = function(a) {
      if (ct(a.origin)) {
        var r = In(a.data);
        if (!(!r || r.event !== "ready")) {
          var s = a.source ? fa(a.source, e) : null;
          if (s && ll(s.src)) {
            var i = new wr(s);
            i.callMethod("appendVideoMetadata", window.location.href);
          }
        }
      }
    };
    window.addEventListener("message", t);
  }
}
function mb() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoCheckedUrlTimeParam) {
    window.VimeoCheckedUrlTimeParam = !0;
    var t = function(r) {
      "console" in window && console.error && console.error("There was an error getting video Id: ".concat(r));
    }, n = function(r) {
      if (ct(r.origin)) {
        var s = In(r.data);
        if (!(!s || s.event !== "ready")) {
          var i = r.source ? fa(r.source, e) : null;
          if (i && ll(i.src)) {
            var l = new wr(i);
            l.getVideoId().then(function(o) {
              var u = new RegExp("[?&]vimeo_t_".concat(o, "=([^&#]*)")).exec(window.location.href);
              if (u && u[1]) {
                var c = decodeURI(u[1]);
                l.setCurrentTime(c);
              }
            }).catch(t);
          }
        }
      }
    };
    window.addEventListener("message", n);
  }
}
function vb() {
  if (!window.VimeoDRMEmbedsUpdated) {
    window.VimeoDRMEmbedsUpdated = !0;
    var e = function(n) {
      if (ct(n.origin)) {
        var a = In(n.data);
        if (!(!a || a.event !== "drminitfailed")) {
          var r = n.source ? fa(n.source) : null;
          if (r) {
            var s = r.getAttribute("allow") || "", i = s.includes("encrypted-media");
            if (!i) {
              r.setAttribute("allow", "".concat(s, "; encrypted-media"));
              var l = new URL(r.getAttribute("src"));
              l.searchParams.set("forcereload", "drm"), r.setAttribute("src", l.toString());
              return;
            }
          }
        }
      }
    };
    window.addEventListener("message", e);
  }
}
function pb() {
  var e = (function() {
    for (var a, r = [
      ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
      // New WebKit
      ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
      // Old WebKit
      ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
      ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
      ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]
    ], s = 0, i = r.length, l = {}; s < i; s++)
      if (a = r[s], a && a[1] in document) {
        for (s = 0; s < a.length; s++)
          l[r[0][s]] = a[s];
        return l;
      }
    return !1;
  })(), t = {
    fullscreenchange: e.fullscreenchange,
    fullscreenerror: e.fullscreenerror
  }, n = {
    request: function(r) {
      return new Promise(function(s, i) {
        var l = function u() {
          n.off("fullscreenchange", u), s();
        };
        n.on("fullscreenchange", l), r = r || document.documentElement;
        var o = r[e.requestFullscreen]();
        o instanceof Promise && o.then(l).catch(i);
      });
    },
    exit: function() {
      return new Promise(function(r, s) {
        if (!n.isFullscreen) {
          r();
          return;
        }
        var i = function o() {
          n.off("fullscreenchange", o), r();
        };
        n.on("fullscreenchange", i);
        var l = document[e.exitFullscreen]();
        l instanceof Promise && l.then(i).catch(s);
      });
    },
    on: function(r, s) {
      var i = t[r];
      i && document.addEventListener(i, s);
    },
    off: function(r, s) {
      var i = t[r];
      i && document.removeEventListener(i, s);
    }
  };
  return Object.defineProperties(n, {
    isFullscreen: {
      get: function() {
        return !!document[e.fullscreenElement];
      }
    },
    element: {
      enumerable: !0,
      get: function() {
        return document[e.fullscreenElement];
      }
    },
    isEnabled: {
      enumerable: !0,
      get: function() {
        return !!document[e.fullscreenEnabled];
      }
    }
  }), n;
}
var hb = {
  role: "viewer",
  autoPlayMuted: !0,
  allowedDrift: 0.3,
  maxAllowedDrift: 1,
  minCheckInterval: 0.1,
  maxRateAdjustment: 0.2,
  maxTimeToCatchUp: 1
}, yb = /* @__PURE__ */ (function(e) {
  zg(n, e);
  var t = Wg(n);
  function n(a, r) {
    var s, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l = arguments.length > 3 ? arguments[3] : void 0;
    return nl(this, n), s = t.call(this), Nn(Dn(s), "logger", void 0), Nn(Dn(s), "speedAdjustment", 0), Nn(Dn(s), "adjustSpeed", /* @__PURE__ */ (function() {
      var o = It(/* @__PURE__ */ Ee().mark(function u(c, v) {
        var h;
        return Ee().wrap(function(p) {
          for (; ; ) switch (p.prev = p.next) {
            case 0:
              if (s.speedAdjustment !== v) {
                p.next = 2;
                break;
              }
              return p.abrupt("return");
            case 2:
              return p.next = 4, c.getPlaybackRate();
            case 4:
              return p.t0 = p.sent, p.t1 = s.speedAdjustment, p.t2 = p.t0 - p.t1, p.t3 = v, h = p.t2 + p.t3, s.log("New playbackRate:  ".concat(h)), p.next = 12, c.setPlaybackRate(h);
            case 12:
              s.speedAdjustment = v;
            case 13:
            case "end":
              return p.stop();
          }
        }, u);
      }));
      return function(u, c) {
        return o.apply(this, arguments);
      };
    })()), s.logger = l, s.init(r, a, ws(ws({}, hb), i)), s;
  }
  return al(n, [{
    key: "disconnect",
    value: function() {
      this.dispatchEvent(new Event("disconnect"));
    }
    /**
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "init",
    value: (function() {
      var a = It(/* @__PURE__ */ Ee().mark(function s(i, l, o) {
        var u = this, c, v, h;
        return Ee().wrap(function(p) {
          for (; ; ) switch (p.prev = p.next) {
            case 0:
              return p.next = 2, this.waitForTOReadyState(i, "open");
            case 2:
              if (o.role !== "viewer") {
                p.next = 10;
                break;
              }
              return p.next = 5, this.updatePlayer(i, l, o);
            case 5:
              c = Ts(i, "change", function() {
                return u.updatePlayer(i, l, o);
              }), v = this.maintainPlaybackPosition(i, l, o), this.addEventListener("disconnect", function() {
                v.cancel(), c.cancel();
              }), p.next = 14;
              break;
            case 10:
              return p.next = 12, this.updateTimingObject(i, l);
            case 12:
              h = Ts(l, ["seeked", "play", "pause", "ratechange"], function() {
                return u.updateTimingObject(i, l);
              }, "on", "off"), this.addEventListener("disconnect", function() {
                return h.cancel();
              });
            case 14:
            case "end":
              return p.stop();
          }
        }, s, this);
      }));
      function r(s, i, l) {
        return a.apply(this, arguments);
      }
      return r;
    })()
    /**
     * Sets the TimingObject's state to reflect that of the player
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @return {Promise<void>}
     */
  }, {
    key: "updateTimingObject",
    value: (function() {
      var a = It(/* @__PURE__ */ Ee().mark(function s(i, l) {
        var o, u, c, v, h;
        return Ee().wrap(function(p) {
          for (; ; ) switch (p.prev = p.next) {
            case 0:
              return p.next = 2, Promise.all([l.getCurrentTime(), l.getPaused(), l.getPlaybackRate()]);
            case 2:
              o = p.sent, u = Ug(o, 3), c = u[0], v = u[1], h = u[2], i.update({
                position: c,
                velocity: v ? 0 : h
              });
            case 8:
            case "end":
              return p.stop();
          }
        }, s);
      }));
      function r(s, i) {
        return a.apply(this, arguments);
      }
      return r;
    })()
    /**
     * Sets the player's timing state to reflect that of the TimingObject
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "updatePlayer",
    value: (function() {
      var a = It(/* @__PURE__ */ Ee().mark(function s(i, l, o) {
        var u, c, v;
        return Ee().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              if (u = i.query(), c = u.position, v = u.velocity, typeof c == "number" && l.setCurrentTime(c), typeof v != "number") {
                m.next = 25;
                break;
              }
              if (v !== 0) {
                m.next = 11;
                break;
              }
              return m.next = 6, l.getPaused();
            case 6:
              if (m.t0 = m.sent, m.t0 !== !1) {
                m.next = 9;
                break;
              }
              l.pause();
            case 9:
              m.next = 25;
              break;
            case 11:
              if (!(v > 0)) {
                m.next = 25;
                break;
              }
              return m.next = 14, l.getPaused();
            case 14:
              if (m.t1 = m.sent, m.t1 !== !0) {
                m.next = 19;
                break;
              }
              return m.next = 18, l.play().catch(/* @__PURE__ */ (function() {
                var p = It(/* @__PURE__ */ Ee().mark(function y(b) {
                  return Ee().wrap(function(P) {
                    for (; ; ) switch (P.prev = P.next) {
                      case 0:
                        if (!(b.name === "NotAllowedError" && o.autoPlayMuted)) {
                          P.next = 5;
                          break;
                        }
                        return P.next = 3, l.setMuted(!0);
                      case 3:
                        return P.next = 5, l.play().catch(function(I) {
                          return console.error("Couldn't play the video from TimingSrcConnector. Error:", I);
                        });
                      case 5:
                      case "end":
                        return P.stop();
                    }
                  }, y);
                }));
                return function(y) {
                  return p.apply(this, arguments);
                };
              })());
            case 18:
              this.updatePlayer(i, l, o);
            case 19:
              return m.next = 21, l.getPlaybackRate();
            case 21:
              if (m.t2 = m.sent, m.t3 = v, m.t2 === m.t3) {
                m.next = 25;
                break;
              }
              l.setPlaybackRate(v);
            case 25:
            case "end":
              return m.stop();
          }
        }, s, this);
      }));
      function r(s, i, l) {
        return a.apply(this, arguments);
      }
      return r;
    })()
    /**
     * Since video players do not play with 100% time precision, we need to closely monitor
     * our player to be sure it remains in sync with the TimingObject.
     *
     * If out of sync, we use the current conditions and the options provided to determine
     * whether to re-sync via setting currentTime or adjusting the playbackRate
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {{cancel: (function(): void)}}
     */
  }, {
    key: "maintainPlaybackPosition",
    value: function(r, s, i) {
      var l = this, o = i.allowedDrift, u = i.maxAllowedDrift, c = i.minCheckInterval, v = i.maxRateAdjustment, h = i.maxTimeToCatchUp, m = Math.min(h, Math.max(c, u)) * 1e3, p = /* @__PURE__ */ (function() {
        var b = It(/* @__PURE__ */ Ee().mark(function _() {
          var P, I, k, T, g;
          return Ee().wrap(function(S) {
            for (; ; ) switch (S.prev = S.next) {
              case 0:
                if (S.t0 = r.query().velocity === 0, S.t0) {
                  S.next = 6;
                  break;
                }
                return S.next = 4, s.getPaused();
              case 4:
                S.t1 = S.sent, S.t0 = S.t1 === !0;
              case 6:
                if (!S.t0) {
                  S.next = 8;
                  break;
                }
                return S.abrupt("return");
              case 8:
                return S.t2 = r.query().position, S.next = 11, s.getCurrentTime();
              case 11:
                if (S.t3 = S.sent, P = S.t2 - S.t3, I = Math.abs(P), l.log("Drift: ".concat(P)), !(I > u)) {
                  S.next = 22;
                  break;
                }
                return S.next = 18, l.adjustSpeed(s, 0);
              case 18:
                s.setCurrentTime(r.query().position), l.log("Resync by currentTime"), S.next = 29;
                break;
              case 22:
                if (!(I > o)) {
                  S.next = 29;
                  break;
                }
                return k = I / h, T = v, g = k < T ? (T - k) / 2 : T, S.next = 28, l.adjustSpeed(s, g * Math.sign(P));
              case 28:
                l.log("Resync by playbackRate");
              case 29:
              case "end":
                return S.stop();
            }
          }, _);
        }));
        return function() {
          return b.apply(this, arguments);
        };
      })(), y = setInterval(function() {
        return p();
      }, m);
      return {
        cancel: function() {
          return clearInterval(y);
        }
      };
    }
    /**
     * @param {string} msg
     */
  }, {
    key: "log",
    value: function(r) {
      var s;
      (s = this.logger) === null || s === void 0 || s.call(this, "TimingSrcConnector: ".concat(r));
    }
  }, {
    key: "waitForTOReadyState",
    value: (
      /**
       * @param {TimingObject} timingObject
       * @param {TConnectionState} state
       * @return {Promise<void>}
       */
      function(r, s) {
        return new Promise(function(i) {
          var l = function o() {
            r.readyState === s ? i() : r.addEventListener("readystatechange", o, {
              once: !0
            });
          };
          l();
        });
      }
    )
  }]), n;
})(/* @__PURE__ */ za(EventTarget)), Nt = /* @__PURE__ */ new WeakMap(), Sa = /* @__PURE__ */ new WeakMap(), Ne = {}, wr = /* @__PURE__ */ (function() {
  function e(t) {
    var n = this, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (nl(this, e), window.jQuery && t instanceof jQuery && (t.length > 1 && window.console && console.warn && console.warn("A jQuery object with multiple elements was passed, using the first element."), t = t[0]), typeof document < "u" && typeof t == "string" && (t = document.getElementById(t)), !eb(t))
      throw new TypeError("You must pass either a valid element or a valid id.");
    if (t.nodeName !== "IFRAME") {
      var r = t.querySelector("iframe");
      r && (t = r);
    }
    if (t.nodeName === "IFRAME" && !ct(t.getAttribute("src") || ""))
      throw new Error("The player element passed isn’t a Vimeo embed.");
    if (Nt.has(t))
      return Nt.get(t);
    this._window = t.ownerDocument.defaultView, this.element = t, this.origin = "*";
    var s = new qe(function(l, o) {
      if (n._onMessage = function(v) {
        if (!(!ct(v.origin) || n.element.contentWindow !== v.source)) {
          n.origin === "*" && (n.origin = v.origin);
          var h = In(v.data), m = h && h.event === "error", p = m && h.data && h.data.method === "ready";
          if (p) {
            var y = new Error(h.data.message);
            y.name = h.data.name, o(y);
            return;
          }
          var b = h && h.event === "ready", _ = h && h.method === "ping";
          if (b || _) {
            n.element.setAttribute("data-ready", "true"), l();
            return;
          }
          ob(n, h);
        }
      }, n._window.addEventListener("message", n._onMessage), n.element.nodeName !== "IFRAME") {
        var u = ul(t, a), c = ol(u);
        cl(c, u, t).then(function(v) {
          var h = _r(v, t);
          return n.element = h, n._originalElement = t, lb(t, h), Nt.set(n.element, n), v;
        }).catch(o);
      }
    });
    if (Sa.set(this, s), Nt.set(this.element, this), this.element.nodeName === "IFRAME" && xt(this, "ping"), Ne.isEnabled) {
      var i = function() {
        return Ne.exit();
      };
      this.fullscreenchangeHandler = function() {
        Ne.isFullscreen ? rn(n, "event:exitFullscreen", i) : Jn(n, "event:exitFullscreen", i), n.ready().then(function() {
          xt(n, "fullscreenchange", Ne.isFullscreen);
        });
      }, Ne.on("fullscreenchange", this.fullscreenchangeHandler);
    }
    return this;
  }
  return al(e, [{
    key: "callMethod",
    value: (
      /**
       * Get a promise for a method.
       *
       * @param {string} name The API method to call.
       * @param {...(string|number|object|Array)} args Arguments to send via postMessage.
       * @return {Promise}
       */
      function(n) {
        for (var a = this, r = arguments.length, s = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
          s[i - 1] = arguments[i];
        if (n == null)
          throw new TypeError("You must pass a method name.");
        return new qe(function(l, o) {
          return a.ready().then(function() {
            rn(a, n, {
              resolve: l,
              reject: o
            }), s.length === 0 ? s = {} : s.length === 1 && (s = s[0]), xt(a, n, s);
          }).catch(o);
        });
      }
    )
    /**
     * Get a promise for the value of a player property.
     *
     * @param {string} name The property name
     * @return {Promise}
     */
  }, {
    key: "get",
    value: function(n) {
      var a = this;
      return new qe(function(r, s) {
        return n = Ss(n, "get"), a.ready().then(function() {
          rn(a, n, {
            resolve: r,
            reject: s
          }), xt(a, n);
        }).catch(s);
      });
    }
    /**
     * Get a promise for setting the value of a player property.
     *
     * @param {string} name The API method to call.
     * @param {mixed} value The value to set.
     * @return {Promise}
     */
  }, {
    key: "set",
    value: function(n, a) {
      var r = this;
      return new qe(function(s, i) {
        if (n = Ss(n, "set"), a == null)
          throw new TypeError("There must be a value to set.");
        return r.ready().then(function() {
          rn(r, n, {
            resolve: s,
            reject: i
          }), xt(r, n, a);
        }).catch(i);
      });
    }
    /**
     * Add an event listener for the specified event. Will call the
     * callback with a single parameter, `data`, that contains the data for
     * that event.
     *
     * @param {string} eventName The name of the event.
     * @param {function(*)} callback The function to call when the event fires.
     * @return {void}
     */
  }, {
    key: "on",
    value: function(n, a) {
      if (!n)
        throw new TypeError("You must pass an event name.");
      if (!a)
        throw new TypeError("You must pass a callback function.");
      if (typeof a != "function")
        throw new TypeError("The callback must be a function.");
      var r = Zn(this, "event:".concat(n));
      r.length === 0 && this.callMethod("addEventListener", n).catch(function() {
      }), rn(this, "event:".concat(n), a);
    }
    /**
     * Remove an event listener for the specified event. Will remove all
     * listeners for that event if a `callback` isn’t passed, or only that
     * specific callback if it is passed.
     *
     * @param {string} eventName The name of the event.
     * @param {function} [callback] The specific callback to remove.
     * @return {void}
     */
  }, {
    key: "off",
    value: function(n, a) {
      if (!n)
        throw new TypeError("You must pass an event name.");
      if (a && typeof a != "function")
        throw new TypeError("The callback must be a function.");
      var r = Jn(this, "event:".concat(n), a);
      r && this.callMethod("removeEventListener", n).catch(function(s) {
      });
    }
    /**
     * A promise to load a new video.
     *
     * @promise LoadVideoPromise
     * @fulfill {number} The video with this id or url successfully loaded.
     * @reject {TypeError} The id was not a number.
     */
    /**
     * Load a new video into this embed. The promise will be resolved if
     * the video is successfully loaded, or it will be rejected if it could
     * not be loaded.
     *
     * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
     * @return {LoadVideoPromise}
     */
  }, {
    key: "loadVideo",
    value: function(n) {
      return this.callMethod("loadVideo", n);
    }
    /**
     * A promise to perform an action when the Player is ready.
     *
     * @todo document errors
     * @promise LoadVideoPromise
     * @fulfill {void}
     */
    /**
     * Trigger a function when the player iframe has initialized. You do not
     * need to wait for `ready` to trigger to begin adding event listeners
     * or calling other methods.
     *
     * @return {ReadyPromise}
     */
  }, {
    key: "ready",
    value: function() {
      var n = Sa.get(this) || new qe(function(a, r) {
        r(new Error("Unknown player. Probably unloaded."));
      });
      return qe.resolve(n);
    }
    /**
     * A promise to add a cue point to the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point to use for removeCuePoint.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Add a cue point to the player.
     *
     * @param {number} time The time for the cue point.
     * @param {object} [data] Arbitrary data to be returned with the cue point.
     * @return {AddCuePointPromise}
     */
  }, {
    key: "addCuePoint",
    value: function(n) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.callMethod("addCuePoint", {
        time: n,
        data: a
      });
    }
    /**
     * A promise to remove a cue point from the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point that was removed.
     * @reject {InvalidCuePoint} The cue point with the specified id was not
     *         found.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Remove a cue point from the video.
     *
     * @param {string} id The id of the cue point to remove.
     * @return {RemoveCuePointPromise}
     */
  }, {
    key: "removeCuePoint",
    value: function(n) {
      return this.callMethod("removeCuePoint", n);
    }
    /**
     * A representation of a text track on a video.
     *
     * @typedef {Object} VimeoTextTrack
     * @property {string} language The ISO language code.
     * @property {string} kind The kind of track it is (captions or subtitles).
     * @property {string} label The human‐readable label for the track.
     */
    /**
     * A promise to enable a text track.
     *
     * @promise EnableTextTrackPromise
     * @fulfill {VimeoTextTrack} The text track that was enabled.
     * @reject {InvalidTrackLanguageError} No track was available with the
     *         specified language.
     * @reject {InvalidTrackError} No track was available with the specified
     *         language and kind.
     */
    /**
     * Enable the text track with the specified language, and optionally the
     * specified kind (captions or subtitles).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {string} language The two‐letter language code.
     * @param {string} [kind] The kind of track to enable (captions or subtitles).
     * @return {EnableTextTrackPromise}
     */
  }, {
    key: "enableTextTrack",
    value: function(n, a) {
      if (!n)
        throw new TypeError("You must pass a language.");
      return this.callMethod("enableTextTrack", {
        language: n,
        kind: a
      });
    }
    /**
     * A promise to disable the active text track.
     *
     * @promise DisableTextTrackPromise
     * @fulfill {void} The track was disabled.
     */
    /**
     * Disable the currently-active text track.
     *
     * @return {DisableTextTrackPromise}
     */
  }, {
    key: "disableTextTrack",
    value: function() {
      return this.callMethod("disableTextTrack");
    }
    /** @typedef {import('../types/formats.js').VimeoAudioTrack} VimeoAudioTrack */
    /** @typedef {import('../types/formats.js').AudioLanguage} AudioLanguage */
    /** @typedef {import('../types/formats.js').AudioKind} AudioKind */
    /**
     * A promise to enable an audio track.
     *
     * @promise SelectAudioTrackPromise
     * @fulfill {VimeoAudioTrack} The audio track that was enabled.
     * @reject {NoAudioTracksError} No audio exists for the video.
     * @reject {NoAlternateAudioTracksError} No alternate audio tracks exist for the video.
     * @reject {NoMatchingAudioTrackError} No track was available with the specified
     *         language and kind.
     */
    /**
     * Enable the audio track with the specified language, and optionally the
     * specified kind (main, translation, descriptions, or commentary).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {AudioLanguage} language The two‐letter language code.
     * @param {AudioKind} [kind] The kind of track to enable (main, translation, descriptions, commentary).
     * @return {SelectAudioTrackPromise}
     */
  }, {
    key: "selectAudioTrack",
    value: function(n, a) {
      if (!n)
        throw new TypeError("You must pass a language.");
      return this.callMethod("selectAudioTrack", {
        language: n,
        kind: a
      });
    }
    /**
     * Enable the main audio track for the video.
     *
     * @return {SelectAudioTrackPromise}
     */
  }, {
    key: "selectDefaultAudioTrack",
    value: function() {
      return this.callMethod("selectDefaultAudioTrack");
    }
    /**
     * A promise to pause the video.
     *
     * @promise PausePromise
     * @fulfill {void} The video was paused.
     */
    /**
     * Pause the video if it’s playing.
     *
     * @return {PausePromise}
     */
  }, {
    key: "pause",
    value: function() {
      return this.callMethod("pause");
    }
    /**
     * A promise to play the video.
     *
     * @promise PlayPromise
     * @fulfill {void} The video was played.
     */
    /**
     * Play the video if it’s paused. **Note:** on iOS and some other
     * mobile devices, you cannot programmatically trigger play. Once the
     * viewer has tapped on the play button in the player, however, you
     * will be able to use this function.
     *
     * @return {PlayPromise}
     */
  }, {
    key: "play",
    value: function() {
      return this.callMethod("play");
    }
    /**
     * Request that the player enters fullscreen.
     * @return {Promise}
     */
  }, {
    key: "requestFullscreen",
    value: function() {
      return Ne.isEnabled ? Ne.request(this.element) : this.callMethod("requestFullscreen");
    }
    /**
     * Request that the player exits fullscreen.
     * @return {Promise}
     */
  }, {
    key: "exitFullscreen",
    value: function() {
      return Ne.isEnabled ? Ne.exit() : this.callMethod("exitFullscreen");
    }
    /**
     * Returns true if the player is currently fullscreen.
     * @return {Promise}
     */
  }, {
    key: "getFullscreen",
    value: function() {
      return Ne.isEnabled ? qe.resolve(Ne.isFullscreen) : this.get("fullscreen");
    }
    /**
     * Request that the player enters picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "requestPictureInPicture",
    value: function() {
      return this.callMethod("requestPictureInPicture");
    }
    /**
     * Request that the player exits picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "exitPictureInPicture",
    value: function() {
      return this.callMethod("exitPictureInPicture");
    }
    /**
     * Returns true if the player is currently picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "getPictureInPicture",
    value: function() {
      return this.get("pictureInPicture");
    }
    /**
     * A promise to prompt the viewer to initiate remote playback.
     *
     * @promise RemotePlaybackPromptPromise
     * @fulfill {void}
     * @reject {NotFoundError} No remote playback device is available.
     */
    /**
     * Request to prompt the user to initiate remote playback.
     *
     * @return {RemotePlaybackPromptPromise}
     */
  }, {
    key: "remotePlaybackPrompt",
    value: function() {
      return this.callMethod("remotePlaybackPrompt");
    }
    /**
     * A promise to unload the video.
     *
     * @promise UnloadPromise
     * @fulfill {void} The video was unloaded.
     */
    /**
     * Return the player to its initial state.
     *
     * @return {UnloadPromise}
     */
  }, {
    key: "unload",
    value: function() {
      return this.callMethod("unload");
    }
    /**
     * Cleanup the player and remove it from the DOM
     *
     * It won't be usable and a new one should be constructed
     *  in order to do any operations.
     *
     * @return {Promise}
     */
  }, {
    key: "destroy",
    value: function() {
      var n = this;
      return new qe(function(a) {
        if (Sa.delete(n), Nt.delete(n.element), n._originalElement && (Nt.delete(n._originalElement), n._originalElement.removeAttribute("data-vimeo-initialized")), n.element && n.element.nodeName === "IFRAME" && n.element.parentNode && (n.element.parentNode.parentNode && n._originalElement && n._originalElement !== n.element.parentNode ? n.element.parentNode.parentNode.removeChild(n.element.parentNode) : n.element.parentNode.removeChild(n.element)), n.element && n.element.nodeName === "DIV" && n.element.parentNode) {
          n.element.removeAttribute("data-vimeo-initialized");
          var r = n.element.querySelector("iframe");
          r && r.parentNode && (r.parentNode.parentNode && n._originalElement && n._originalElement !== r.parentNode ? r.parentNode.parentNode.removeChild(r.parentNode) : r.parentNode.removeChild(r));
        }
        n._window.removeEventListener("message", n._onMessage), Ne.isEnabled && Ne.off("fullscreenchange", n.fullscreenchangeHandler), a();
      });
    }
    /**
     * A promise to get the autopause behavior of the video.
     *
     * @promise GetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Get the autopause behavior for this player.
     *
     * @return {GetAutopausePromise}
     */
  }, {
    key: "getAutopause",
    value: function() {
      return this.get("autopause");
    }
    /**
     * A promise to set the autopause behavior of the video.
     *
     * @promise SetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Enable or disable the autopause behavior of this player.
     *
     * By default, when another video is played in the same browser, this
     * player will automatically pause. Unless you have a specific reason
     * for doing so, we recommend that you leave autopause set to the
     * default (`true`).
     *
     * @param {boolean} autopause
     * @return {SetAutopausePromise}
     */
  }, {
    key: "setAutopause",
    value: function(n) {
      return this.set("autopause", n);
    }
    /**
     * A promise to get the buffered property of the video.
     *
     * @promise GetBufferedPromise
     * @fulfill {Array} Buffered Timeranges converted to an Array.
     */
    /**
     * Get the buffered property of the video.
     *
     * @return {GetBufferedPromise}
     */
  }, {
    key: "getBuffered",
    value: function() {
      return this.get("buffered");
    }
    /**
     * @typedef {Object} CameraProperties
     * @prop {number} props.yaw - Number between 0 and 360.
     * @prop {number} props.pitch - Number between -90 and 90.
     * @prop {number} props.roll - Number between -180 and 180.
     * @prop {number} props.fov - The field of view in degrees.
     */
    /**
     * A promise to get the camera properties of the player.
     *
     * @promise GetCameraPromise
     * @fulfill {CameraProperties} The camera properties.
     */
    /**
     * For 360° videos get the camera properties for this player.
     *
     * @return {GetCameraPromise}
     */
  }, {
    key: "getCameraProps",
    value: function() {
      return this.get("cameraProps");
    }
    /**
     * A promise to set the camera properties of the player.
     *
     * @promise SetCameraPromise
     * @fulfill {Object} The camera was successfully set.
     * @reject {RangeError} The range was out of bounds.
     */
    /**
     * For 360° videos set the camera properties for this player.
     *
     * @param {CameraProperties} camera The camera properties
     * @return {SetCameraPromise}
     */
  }, {
    key: "setCameraProps",
    value: function(n) {
      return this.set("cameraProps", n);
    }
    /**
     * A representation of a chapter.
     *
     * @typedef {Object} VimeoChapter
     * @property {number} startTime The start time of the chapter.
     * @property {object} title The title of the chapter.
     * @property {number} index The place in the order of Chapters. Starts at 1.
     */
    /**
     * A promise to get chapters for the video.
     *
     * @promise GetChaptersPromise
     * @fulfill {VimeoChapter[]} The chapters for the video.
     */
    /**
     * Get an array of all the chapters for the video.
     *
     * @return {GetChaptersPromise}
     */
  }, {
    key: "getChapters",
    value: function() {
      return this.get("chapters");
    }
    /**
     * A promise to get the currently active chapter.
     *
     * @promise GetCurrentChaptersPromise
     * @fulfill {VimeoChapter|undefined} The current chapter for the video.
     */
    /**
     * Get the currently active chapter for the video.
     *
     * @return {GetCurrentChaptersPromise}
     */
  }, {
    key: "getCurrentChapter",
    value: function() {
      return this.get("currentChapter");
    }
    /**
     * A promise to get the accent color of the player.
     *
     * @promise GetColorPromise
     * @fulfill {string} The hex color of the player.
     */
    /**
     * Get the accent color for this player. Note this is deprecated in place of `getColorTwo`.
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColor",
    value: function() {
      return this.get("color");
    }
    /**
     * A promise to get all colors for the player in an array.
     *
     * @promise GetColorsPromise
     * @fulfill {string[]} The hex colors of the player.
     */
    /**
     * Get all the colors for this player in an array: [colorOne, colorTwo, colorThree, colorFour]
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColors",
    value: function() {
      return qe.all([this.get("colorOne"), this.get("colorTwo"), this.get("colorThree"), this.get("colorFour")]);
    }
    /**
     * A promise to set the accent color of the player.
     *
     * @promise SetColorPromise
     * @fulfill {string} The color was successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the accent color of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * Note this is deprecated in place of `setColorTwo`.
     *
     * @param {string} color The hex or rgb color string to set.
     * @return {SetColorPromise}
     */
  }, {
    key: "setColor",
    value: function(n) {
      return this.set("color", n);
    }
    /**
     * A promise to set all colors for the player.
     *
     * @promise SetColorsPromise
     * @fulfill {string[]} The colors were successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the colors of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * The colors should be passed in as an array: [colorOne, colorTwo, colorThree, colorFour].
     * If a color should not be set, the index in the array can be left as null.
     *
     * @param {string[]} colors Array of the hex or rgb color strings to set.
     * @return {SetColorsPromise}
     */
  }, {
    key: "setColors",
    value: function(n) {
      if (!Array.isArray(n))
        return new qe(function(s, i) {
          return i(new TypeError("Argument must be an array."));
        });
      var a = new qe(function(s) {
        return s(null);
      }), r = [n[0] ? this.set("colorOne", n[0]) : a, n[1] ? this.set("colorTwo", n[1]) : a, n[2] ? this.set("colorThree", n[2]) : a, n[3] ? this.set("colorFour", n[3]) : a];
      return qe.all(r);
    }
    /**
     * A representation of a cue point.
     *
     * @typedef {Object} VimeoCuePoint
     * @property {number} time The time of the cue point.
     * @property {object} data The data passed when adding the cue point.
     * @property {string} id The unique id for use with removeCuePoint.
     */
    /**
     * A promise to get the cue points of a video.
     *
     * @promise GetCuePointsPromise
     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Get an array of the cue points added to the video.
     *
     * @return {GetCuePointsPromise}
     */
  }, {
    key: "getCuePoints",
    value: function() {
      return this.get("cuePoints");
    }
    /**
     * A promise to get the current time of the video.
     *
     * @promise GetCurrentTimePromise
     * @fulfill {number} The current time in seconds.
     */
    /**
     * Get the current playback position in seconds.
     *
     * @return {GetCurrentTimePromise}
     */
  }, {
    key: "getCurrentTime",
    value: function() {
      return this.get("currentTime");
    }
    /**
     * A promise to set the current time of the video.
     *
     * @promise SetCurrentTimePromise
     * @fulfill {number} The actual current time that was set.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     */
    /**
     * Set the current playback position in seconds. If the player was
     * paused, it will remain paused. Likewise, if the player was playing,
     * it will resume playing once the video has buffered.
     *
     * You can provide an accurate time and the player will attempt to seek
     * to as close to that time as possible. The exact time will be the
     * fulfilled value of the promise.
     *
     * @param {number} currentTime
     * @return {SetCurrentTimePromise}
     */
  }, {
    key: "setCurrentTime",
    value: function(n) {
      return this.set("currentTime", n);
    }
    /**
     * A promise to get the duration of the video.
     *
     * @promise GetDurationPromise
     * @fulfill {number} The duration in seconds.
     */
    /**
     * Get the duration of the video in seconds. It will be rounded to the
     * nearest second before playback begins, and to the nearest thousandth
     * of a second after playback begins.
     *
     * @return {GetDurationPromise}
     */
  }, {
    key: "getDuration",
    value: function() {
      return this.get("duration");
    }
    /**
     * A promise to get the ended state of the video.
     *
     * @promise GetEndedPromise
     * @fulfill {boolean} Whether or not the video has ended.
     */
    /**
     * Get the ended state of the video. The video has ended if
     * `currentTime === duration`.
     *
     * @return {GetEndedPromise}
     */
  }, {
    key: "getEnded",
    value: function() {
      return this.get("ended");
    }
    /**
     * A promise to get the loop state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the player is set to loop.
     */
    /**
     * Get the loop state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getLoop",
    value: function() {
      return this.get("loop");
    }
    /**
     * A promise to set the loop state of the player.
     *
     * @promise SetLoopPromise
     * @fulfill {boolean} The loop state that was set.
     */
    /**
     * Set the loop state of the player. When set to `true`, the player
     * will start over immediately once playback ends.
     *
     * @param {boolean} loop
     * @return {SetLoopPromise}
     */
  }, {
    key: "setLoop",
    value: function(n) {
      return this.set("loop", n);
    }
    /**
     * A promise to set the muted state of the player.
     *
     * @promise SetMutedPromise
     * @fulfill {boolean} The muted state that was set.
     */
    /**
     * Set the muted state of the player. When set to `true`, the player
     * volume will be muted.
     *
     * @param {boolean} muted
     * @return {SetMutedPromise}
     */
  }, {
    key: "setMuted",
    value: function(n) {
      return this.set("muted", n);
    }
    /**
     * A promise to get the muted state of the player.
     *
     * @promise GetMutedPromise
     * @fulfill {boolean} Whether or not the player is muted.
     */
    /**
     * Get the muted state of the player.
     *
     * @return {GetMutedPromise}
     */
  }, {
    key: "getMuted",
    value: function() {
      return this.get("muted");
    }
    /**
     * A promise to get the paused state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the video is paused.
     */
    /**
     * Get the paused state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getPaused",
    value: function() {
      return this.get("paused");
    }
    /**
     * A promise to get the playback rate of the player.
     *
     * @promise GetPlaybackRatePromise
     * @fulfill {number} The playback rate of the player on a scale from 0 to 2.
     */
    /**
     * Get the playback rate of the player on a scale from `0` to `2`.
     *
     * @return {GetPlaybackRatePromise}
     */
  }, {
    key: "getPlaybackRate",
    value: function() {
      return this.get("playbackRate");
    }
    /**
     * A promise to set the playbackrate of the player.
     *
     * @promise SetPlaybackRatePromise
     * @fulfill {number} The playback rate was set.
     * @reject {RangeError} The playback rate was less than 0 or greater than 2.
     */
    /**
     * Set the playback rate of the player on a scale from `0` to `2`. When set
     * via the API, the playback rate will not be synchronized to other
     * players or stored as the viewer's preference.
     *
     * @param {number} playbackRate
     * @return {SetPlaybackRatePromise}
     */
  }, {
    key: "setPlaybackRate",
    value: function(n) {
      return this.set("playbackRate", n);
    }
    /**
     * A promise to get the played property of the video.
     *
     * @promise GetPlayedPromise
     * @fulfill {Array} Played Timeranges converted to an Array.
     */
    /**
     * Get the played property of the video.
     *
     * @return {GetPlayedPromise}
     */
  }, {
    key: "getPlayed",
    value: function() {
      return this.get("played");
    }
    /**
     * A promise to get the qualities available of the current video.
     *
     * @promise GetQualitiesPromise
     * @fulfill {Array} The qualities of the video.
     */
    /**
     * Get the qualities of the current video.
     *
     * @return {GetQualitiesPromise}
     */
  }, {
    key: "getQualities",
    value: function() {
      return this.get("qualities");
    }
    /**
     * A promise to get the current set quality of the video.
     *
     * @promise GetQualityPromise
     * @fulfill {string} The current set quality.
     */
    /**
     * Get the current set quality of the video.
     *
     * @return {GetQualityPromise}
     */
  }, {
    key: "getQuality",
    value: function() {
      return this.get("quality");
    }
    /**
     * A promise to set the video quality.
     *
     * @promise SetQualityPromise
     * @fulfill {number} The quality was set.
     * @reject {RangeError} The quality is not available.
     */
    /**
     * Set a video quality.
     *
     * @param {string} quality
     * @return {SetQualityPromise}
     */
  }, {
    key: "setQuality",
    value: function(n) {
      return this.set("quality", n);
    }
    /**
     * A promise to get the remote playback availability.
     *
     * @promise RemotePlaybackAvailabilityPromise
     * @fulfill {boolean} Whether remote playback is available.
     */
    /**
     * Get the availability of remote playback.
     *
     * @return {RemotePlaybackAvailabilityPromise}
     */
  }, {
    key: "getRemotePlaybackAvailability",
    value: function() {
      return this.get("remotePlaybackAvailability");
    }
    /**
     * A promise to get the current remote playback state.
     *
     * @promise RemotePlaybackStatePromise
     * @fulfill {string} The state of the remote playback: connecting, connected, or disconnected.
     */
    /**
     * Get the current remote playback state.
     *
     * @return {RemotePlaybackStatePromise}
     */
  }, {
    key: "getRemotePlaybackState",
    value: function() {
      return this.get("remotePlaybackState");
    }
    /**
     * A promise to get the seekable property of the video.
     *
     * @promise GetSeekablePromise
     * @fulfill {Array} Seekable Timeranges converted to an Array.
     */
    /**
     * Get the seekable property of the video.
     *
     * @return {GetSeekablePromise}
     */
  }, {
    key: "getSeekable",
    value: function() {
      return this.get("seekable");
    }
    /**
     * A promise to get the seeking property of the player.
     *
     * @promise GetSeekingPromise
     * @fulfill {boolean} Whether or not the player is currently seeking.
     */
    /**
     * Get if the player is currently seeking.
     *
     * @return {GetSeekingPromise}
     */
  }, {
    key: "getSeeking",
    value: function() {
      return this.get("seeking");
    }
    /**
     * A promise to get the text tracks of a video.
     *
     * @promise GetTextTracksPromise
     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
     */
    /**
     * Get an array of the text tracks that exist for the video.
     *
     * @return {GetTextTracksPromise}
     */
  }, {
    key: "getTextTracks",
    value: function() {
      return this.get("textTracks");
    }
    /**
     * A promise to get the audio tracks of a video.
     *
     * @promise GetAudioTracksPromise
     * @fulfill {VimeoAudioTrack[]} The audio tracks associated with the video.
     */
    /**
     * Get an array of the audio tracks that exist for the video.
     *
     * @return {GetAudioTracksPromise}
     */
  }, {
    key: "getAudioTracks",
    value: function() {
      return this.get("audioTracks");
    }
    /**
     * A promise to get the enabled audio track of a video.
     *
     * @promise GetAudioTrackPromise
     * @fulfill {VimeoAudioTrack} The enabled audio track.
     */
    /**
     * Get the enabled audio track for a video.
     *
     * @return {GetAudioTrackPromise}
     */
  }, {
    key: "getEnabledAudioTrack",
    value: function() {
      return this.get("enabledAudioTrack");
    }
    /**
     * Get the main audio track for a video.
     *
     * @return {GetAudioTrackPromise}
     */
  }, {
    key: "getDefaultAudioTrack",
    value: function() {
      return this.get("defaultAudioTrack");
    }
    /**
     * A promise to get the embed code for the video.
     *
     * @promise GetVideoEmbedCodePromise
     * @fulfill {string} The `<iframe>` embed code for the video.
     */
    /**
     * Get the `<iframe>` embed code for the video.
     *
     * @return {GetVideoEmbedCodePromise}
     */
  }, {
    key: "getVideoEmbedCode",
    value: function() {
      return this.get("videoEmbedCode");
    }
    /**
     * A promise to get the id of the video.
     *
     * @promise GetVideoIdPromise
     * @fulfill {number} The id of the video.
     */
    /**
     * Get the id of the video.
     *
     * @return {GetVideoIdPromise}
     */
  }, {
    key: "getVideoId",
    value: function() {
      return this.get("videoId");
    }
    /**
     * A promise to get the title of the video.
     *
     * @promise GetVideoTitlePromise
     * @fulfill {number} The title of the video.
     */
    /**
     * Get the title of the video.
     *
     * @return {GetVideoTitlePromise}
     */
  }, {
    key: "getVideoTitle",
    value: function() {
      return this.get("videoTitle");
    }
    /**
     * A promise to get the native width of the video.
     *
     * @promise GetVideoWidthPromise
     * @fulfill {number} The native width of the video.
     */
    /**
     * Get the native width of the currently‐playing video. The width of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoWidthPromise}
     */
  }, {
    key: "getVideoWidth",
    value: function() {
      return this.get("videoWidth");
    }
    /**
     * A promise to get the native height of the video.
     *
     * @promise GetVideoHeightPromise
     * @fulfill {number} The native height of the video.
     */
    /**
     * Get the native height of the currently‐playing video. The height of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoHeightPromise}
     */
  }, {
    key: "getVideoHeight",
    value: function() {
      return this.get("videoHeight");
    }
    /**
     * A promise to get the vimeo.com url for the video.
     *
     * @promise GetVideoUrlPromise
     * @fulfill {number} The vimeo.com url for the video.
     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
     */
    /**
     * Get the vimeo.com url for the video.
     *
     * @return {GetVideoUrlPromise}
     */
  }, {
    key: "getVideoUrl",
    value: function() {
      return this.get("videoUrl");
    }
    /**
     * A promise to get the volume level of the player.
     *
     * @promise GetVolumePromise
     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
     */
    /**
     * Get the current volume level of the player on a scale from `0` to `1`.
     *
     * Most mobile devices do not support an independent volume from the
     * system volume. In those cases, this method will always return `1`.
     *
     * @return {GetVolumePromise}
     */
  }, {
    key: "getVolume",
    value: function() {
      return this.get("volume");
    }
    /**
     * A promise to set the volume level of the player.
     *
     * @promise SetVolumePromise
     * @fulfill {number} The volume was set.
     * @reject {RangeError} The volume was less than 0 or greater than 1.
     */
    /**
     * Set the volume of the player on a scale from `0` to `1`. When set
     * via the API, the volume level will not be synchronized to other
     * players or stored as the viewer’s preference.
     *
     * Most mobile devices do not support setting the volume. An error will
     * *not* be triggered in that situation.
     *
     * @param {number} volume
     * @return {SetVolumePromise}
     */
  }, {
    key: "setVolume",
    value: function(n) {
      return this.set("volume", n);
    }
    /** @typedef {import('timing-object').ITimingObject} TimingObject */
    /** @typedef {import('./lib/timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
    /** @typedef {import('./lib/timing-src-connector').TimingSrcConnector} TimingSrcConnector */
    /**
     * Connects a TimingObject to the video player (https://webtiming.github.io/timingobject/)
     *
     * @param {TimingObject} timingObject
     * @param {TimingSrcConnectorOptions} options
     *
     * @return {Promise<TimingSrcConnector>}
     */
  }, {
    key: "setTimingSrc",
    value: (function() {
      var t = It(/* @__PURE__ */ Ee().mark(function a(r, s) {
        var i = this, l;
        return Ee().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if (r) {
                u.next = 2;
                break;
              }
              throw new TypeError("A Timing Object must be provided.");
            case 2:
              return u.next = 4, this.ready();
            case 4:
              return l = new yb(this, r, s), xt(this, "notifyTimingObjectConnect"), l.addEventListener("disconnect", function() {
                return xt(i, "notifyTimingObjectDisconnect");
              }), u.abrupt("return", l);
            case 8:
            case "end":
              return u.stop();
          }
        }, a, this);
      }));
      function n(a, r) {
        return t.apply(this, arguments);
      }
      return n;
    })()
  }], [{
    key: "isVimeoUrl",
    value: function(n) {
      return ct(n);
    }
  }]), e;
})();
il || (Ne = pb(), cb(), db(), fb(), mb(), vb());
function gb(e) {
  var t = e.player, n = e.event, a = e.emit;
  t.on(n, function(r) {
    return a(n, r, t);
  });
}
var bb = ["play", "playing", "pause", "ended", "timeupdate", "progress", "seeking", "seeked", "texttrackchange", "chapterchange", "cuechange", "cuepoint", "volumechange", "playbackratechange", "bufferstart", "bufferend", "error", "loaded", "durationchange", "fullscreenchange", "qualitychange", "camerachange", "resize"], ja = {
  name: "VimeoPlayer",
  props: {
    playerHeight: {
      type: Number,
      default: 320
    },
    playerWidth: {
      type: Number,
      default: 640
    },
    options: {
      type: Object,
      default: function() {
        return {};
      }
    },
    videoId: {
      type: String,
      default: ""
    },
    videoUrl: {
      type: String,
      default: ""
    },
    loop: {
      type: Boolean,
      default: !1
    },
    autoplay: {
      type: Boolean,
      default: !1
    },
    controls: {
      type: Boolean,
      default: !0
    },
    eventsToEmit: {
      type: Array,
      default: function() {
        return bb;
      }
    }
  },
  setup: function(t, n) {
    var a = n.emit, r, s = E(null), i = hl(t), l = i.videoId, o = i.videoUrl;
    !t.videoId && !t.videoUrl && console.warn("[VueVimeoPlayer: You mist provide at least a videoId or a videoUrl prop]");
    var u = function(_) {
      var P = _.id, I = _.url, k = {
        width: t.playerWidth,
        height: t.playerHeight,
        loop: t.loop,
        autoplay: t.autoplay,
        controls: t.controls
      };
      return D(I) && (k.url = D(I)), D(P) && (k.id = D(P)), Object.assign(k, t.options);
    }, c = function() {
      return r.play();
    }, v = function() {
      return r.pause();
    }, h = function() {
      return r.setVolume(0);
    }, m = function() {
      var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.5;
      return r.setVolume(_);
    }, p = function() {
      r.ready().then(function() {
        a("ready", r);
      }).catch(function(_) {
        a("error", _, r);
      }), t.eventsToEmit.forEach(function(_) {
        return gb({
          player: r,
          event: _,
          emit: a
        });
      });
    };
    he(function() {
      r = new wr(s.value, u({
        id: t.videoId,
        url: t.videoUrl
      })), p();
    }), je(function() {
      return r.unload();
    }), ce(l, function(b) {
      return r.loadVideo(u({
        id: b
      }));
    }), ce(o, function(b) {
      return r.loadVideo(u({
        url: b
      }));
    }), ce(Es(t, "controls"), function() {
      return r.loadVideo(u({
        url: o,
        id: l
      }));
    });
    var y = function(_) {
      return r.loadVideo(u({
        id: _
      }));
    };
    return {
      update: y,
      play: c,
      pause: v,
      mute: h,
      unmute: m,
      elementRef: s,
      player: r
    };
  }
}, kb = {
  ref: "elementRef"
};
function _b(e, t, n, a, r, s) {
  return f(), C(
    "div",
    kb,
    null,
    512
    /* NEED_PATCH */
  );
}
ja.render = _b;
const wb = ["data-state"], $b = { class: "ds-video-takeover__container" }, xb = ["inert"], Ib = { class: "ds-video-takeover__testimonial" }, Sb = ["inert"], Tb = ["src"], Pb = ["inert"], ck = /* @__PURE__ */ j({
  __name: "ds-video-takeover",
  props: {
    ariaLabelPlay: { default: "Play" },
    ariaLabelPause: { default: "Pause" },
    ariaLabelClose: { default: "Close" },
    buttonText: {},
    posterImageSrc: {},
    quoteName: {},
    quoteRole: {},
    quoteText: {},
    videoFullVimeoUrl: {},
    videoBgVimeoUrl: {}
  },
  setup(e) {
    const t = E(null), n = E(!1), a = E(!1), r = E(null), s = E(null), i = E(!1), l = E(!1), o = E("bg"), u = E(
      null
    ), c = E("play"), v = E(0), h = E("pause"), m = E(!1), p = (K, ee, oe, se) => {
      const pe = [];
      return K && pe.push("ds-video-takeover__video-wrapper--ready"), ee === oe && pe.push("ds-video-takeover__video-wrapper--active"), se && pe.push("ds-video-takeover__video-wrapper--hide-poster"), pe;
    }, y = x(
      () => p(
        l.value,
        "bg",
        o.value,
        m.value
      )
    ), b = x(
      () => p(
        i.value,
        "full",
        o.value,
        m.value
      )
    ), _ = () => {
      i.value = !0;
    }, P = async () => {
      l.value = !0;
    }, I = () => {
      m.value === !1 && (m.value = !0);
    }, k = [];
    let T = !1;
    const g = async () => {
      if (!T) {
        T = !0;
        try {
          for (; k.length > 0; ) {
            const K = k.shift();
            if (!K) break;
            await K();
          }
        } catch (K) {
          console.error("Action failed", K);
        } finally {
          T = !1;
        }
      }
    }, $ = (K) => {
      k.push(K), g();
    };
    he(() => {
      window.addEventListener("keydown", re);
    }), qa(() => {
      window.removeEventListener("keydown", re);
    }), Dt(
      t,
      ([K]) => {
        n.value = K?.isIntersecting || !1;
      },
      { threshold: 0.75 }
    );
    const S = async (K, ee = 1e3) => new Promise((oe, se) => {
      let pe = setTimeout(() => {
        console.warn("Vimeo play() timed out"), se(new Error("Vimeo play() timed out"));
      }, ee);
      K.play().then(() => {
        clearTimeout(pe), oe();
      }).catch((Se) => {
        clearTimeout(pe), se(Se);
      });
    }), L = async (K, ee = 500) => new Promise((oe, se) => {
      let pe = setTimeout(() => {
        console.warn("Vimeo pause() timed out"), se(new Error("Vimeo pause() timed out"));
      }, ee);
      K.pause().then(() => {
        clearTimeout(pe), oe();
      }).catch((Se) => {
        clearTimeout(pe), se(Se);
      });
    }), B = async (K = !0) => {
      $(async () => {
        try {
          s.value && "play" in s.value && await S(s.value);
        } catch (ee) {
          console.error(ee);
        }
        M(!0), K && (c.value = "play");
      });
    }, N = async (K = !0) => {
      $(async () => {
        try {
          s.value && "pause" in s.value && await L(s.value);
        } catch (ee) {
          console.error(ee);
        }
        M(!1), K && (c.value = "pause");
      });
    }, d = () => {
      o.value = "full";
    }, w = (K) => {
      v.value = K.percent;
    }, M = (K) => {
      u.value?.setButtonState(K);
    }, z = async () => {
      r.value && r.value?.pause(), o.value = "bg", c.value !== "pause" && await B(!1);
    }, R = async () => {
      await N(!1), r.value?.pause(), o.value = "bg";
    }, W = async () => {
      await N(!1), r.value?.mute(), r.value?.play(), r.value?.unmute();
    }, re = (K) => {
      K.key === "Escape" && o.value === "full" && z();
    };
    return ce(n, async (K) => {
      s.value && (K ? (a.value = !0, z()) : R());
    }), ce(o, (K) => {
      K === "full" && W();
    }), (K, ee) => (f(), C("div", {
      ref_key: "takeoverRef",
      ref: t,
      class: "ds-video-takeover",
      "data-state": n.value ? "visible" : "hidden",
      "data-testid": "videotakeover"
    }, [
      V(ta, {
        background: "neutral",
        class: "ds-video-takeover__block"
      }, {
        default: H(() => [
          O("div", $b, [
            V(rt, { name: "content" }, {
              default: H(() => [
                we(O("div", {
                  class: "ds-video-takeover__content",
                  inert: o.value === "full"
                }, [
                  O("blockquote", Ib, [
                    e.quoteText ? (f(), F(Q, {
                      key: 0,
                      class: "ds-video-takeover__quote",
                      "text-style": "medium",
                      "text-type": "heading-2xl"
                    }, {
                      default: H(() => [
                        G(q(e.quoteText), 1)
                      ]),
                      _: 1
                    })) : A("", !0),
                    e.quoteName ? (f(), F(Q, {
                      key: 1,
                      class: "ds-video-takeover__name",
                      "text-style": "medium",
                      "text-type": "heading-lg"
                    }, {
                      default: H(() => [
                        G(q(e.quoteName), 1)
                      ]),
                      _: 1
                    })) : A("", !0),
                    e.quoteRole ? (f(), F(Q, {
                      key: 2,
                      class: "ds-video-takeover__role",
                      "text-type": "body-xs"
                    }, {
                      default: H(() => [
                        G(q(e.quoteRole), 1)
                      ]),
                      _: 1
                    })) : A("", !0)
                  ]),
                  V(Ce, {
                    "icon-start": "button-play",
                    variant: "primary-inverted",
                    "click-handler": d,
                    "data-testid": "watchButton"
                  }, {
                    default: H(() => [
                      G(q(e.buttonText), 1)
                    ]),
                    _: 1
                  })
                ], 8, xb), [
                  [$e, n.value && o.value === "bg"]
                ])
              ]),
              _: 1
            }),
            V(rt, { name: "content" }, {
              default: H(() => [
                e.videoBgVimeoUrl ? we((f(), F(xu, {
                  key: 0,
                  ref_key: "progressButton",
                  ref: u,
                  class: "ds-video-takeover__progress-button",
                  "aria-label-play": e.ariaLabelPlay,
                  "play-handler": (oe) => B(),
                  "aria-label-pause": e.ariaLabelPause,
                  "initial-state": h.value,
                  progress: v.value,
                  "pause-handler": (oe) => N()
                }, null, 8, ["aria-label-play", "play-handler", "aria-label-pause", "initial-state", "progress", "pause-handler"])), [
                  [$e, n.value && o.value === "bg"]
                ]) : A("", !0)
              ]),
              _: 1
            }),
            O("div", {
              class: Y(["ds-video-takeover__video-wrapper ds-video-takeover__video-wrapper--bg", y.value]),
              "data-testid": "video-wrapper-bg",
              inert: o.value === "full",
              style: Te(`--poster-img: url(${e.posterImageSrc})`)
            }, [
              ee[0] || (ee[0] = O("div", { class: "ds-video-takeover__video-overlay" }, null, -1)),
              e.videoBgVimeoUrl ? (f(), F(D(ja), {
                key: 0,
                ref_key: "vimeoBgPlayer",
                ref: s,
                "data-testid": "video-bg-player",
                tabindex: "-1",
                class: "ds-video-takeover__video",
                "video-url": `${e.videoBgVimeoUrl}`,
                options: {
                  autopause: !0,
                  autoplay: !1,
                  controls: !1,
                  dnt: !0,
                  loop: !0,
                  muted: !0
                },
                onReady: P,
                onPlaying: I,
                onTimeupdate: w
              }, null, 8, ["video-url"])) : A("", !0),
              e.posterImageSrc ? (f(), C("img", {
                key: 1,
                class: "ds-video-takeover__poster-img",
                src: e.posterImageSrc,
                alt: ""
              }, null, 8, Tb)) : A("", !0)
            ], 14, Sb),
            O("div", {
              class: Y(["ds-video-takeover__video-wrapper ds-video-takeover__video-wrapper--full", b.value]),
              "data-testid": "video-wrapper-full",
              inert: o.value === "bg"
            }, [
              V(Ie, {
                class: "ds-video-takeover__close",
                "click-handler": z,
                "aria-label": e.ariaLabelClose,
                "icon-name": "button-close",
                variant: "ghost-inverted"
              }, null, 8, ["aria-label"]),
              V(D(ja), {
                ref_key: "vimeoPlayer",
                ref: r,
                class: "ds-video-takeover__vimeo",
                "video-url": `${e.videoFullVimeoUrl}`,
                options: {
                  autopause: !0,
                  background: !1,
                  controls: !0,
                  dnt: !0,
                  loop: !1,
                  muted: !0,
                  autoplay: !1
                },
                onReady: _
              }, null, 8, ["video-url"])
            ], 10, Pb)
          ])
        ]),
        _: 1
      })
    ], 8, wb));
  }
}), dk = [
  "accept",
  "capture",
  "labelAddFilesButton",
  "labelDropFiles",
  "labelRemove",
  "labelTapToAdd",
  "listMode",
  "maxFileSize",
  "multiple",
  "validationMessageFileSize",
  "validationMessageDuplicate",
  "validationMessageType"
];
export {
  Eb as DsAccordion,
  Ab as DsAccordionItem,
  Tl as DsAlert,
  Mb as DsArticleBlock,
  El as DsBadge,
  Lb as DsBanner,
  Nb as DsBannerLg,
  Ob as DsBannerMd,
  Lb as DsBannerSm,
  Bb as DsBannerXl,
  ta as DsBlock,
  Os as DsBrandIcon,
  Db as DsBreadcrumb,
  Ce as DsButton,
  Ws as DsButtonGroup,
  Fb as DsButtonPlay,
  xu as DsButtonPlayProgress,
  Rb as DsCardAction,
  Hb as DsCardProduct,
  Vb as DsCarousel,
  zb as DsDialog,
  jb as DsFileUpload,
  Fc as DsGrid,
  qb as DsHeader,
  ie as DsIcon,
  cc as DsIconAttention,
  Ie as DsIconButton,
  hc as DsModal,
  Wb as DsNavService,
  Ub as DsPageHeader,
  Kb as DsPagination,
  Gb as DsProgressDots,
  Yb as DsQuantitySelector,
  Qb as DsScrollProgressBar,
  Zb as DsSkeletonBox,
  Jb as DsSkeletonButton,
  ek as DsSkeletonCircle,
  tk as DsSkeletonSurface,
  nk as DsSkeletonTextLine,
  ak as DsSkeletonWrapper,
  Xb as DsSpinner,
  rk as DsStickyPanels,
  lg as DsTab,
  sk as DsTable,
  ik as DsTabs,
  Xs as DsTag,
  lk as DsTestimonial,
  Q as DsText,
  ok as DsToast,
  uk as DsToggletip,
  vu as DsTooltip,
  Py as DsUnderscore,
  ck as DsVideoTakeover,
  Be as dsUseIsMobile,
  ht as dsUseUniqueId,
  dk as fkFileUploadProps
};
